
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired472"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired472"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("g4Ykb", function(module, exports) {

$parcel$export(module.exports, "F", function () { return (parcelRequire("gkCmd")).default; });
$parcel$export(module.exports, "T", function () { return (parcelRequire("enjLN")).default; });
$parcel$export(module.exports, "__", function () { return (parcelRequire("AVvPi")).default; });
$parcel$export(module.exports, "add", function () { return (parcelRequire("kC3eS")).default; });
$parcel$export(module.exports, "addIndex", function () { return (parcelRequire("dvIel")).default; });
$parcel$export(module.exports, "adjust", function () { return (parcelRequire("lHQV2")).default; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("fs01P")).default; });
$parcel$export(module.exports, "allPass", function () { return (parcelRequire("bKc8Z")).default; });
$parcel$export(module.exports, "always", function () { return (parcelRequire("cdVZD")).default; });
$parcel$export(module.exports, "and", function () { return (parcelRequire("jWdy6")).default; });
$parcel$export(module.exports, "any", function () { return (parcelRequire("d86m6")).default; });
$parcel$export(module.exports, "anyPass", function () { return (parcelRequire("4qtNZ")).default; });
$parcel$export(module.exports, "ap", function () { return (parcelRequire("7C2CH")).default; });
$parcel$export(module.exports, "aperture", function () { return (parcelRequire("2VAJy")).default; });
$parcel$export(module.exports, "append", function () { return (parcelRequire("aj4Qz")).default; });
$parcel$export(module.exports, "apply", function () { return (parcelRequire("384ED")).default; });
$parcel$export(module.exports, "applySpec", function () { return (parcelRequire("e5ZI9")).default; });
$parcel$export(module.exports, "applyTo", function () { return (parcelRequire("eO2XQ")).default; });
$parcel$export(module.exports, "ascend", function () { return (parcelRequire("dNFxY")).default; });
$parcel$export(module.exports, "assoc", function () { return (parcelRequire("ia2wh")).default; });
$parcel$export(module.exports, "assocPath", function () { return (parcelRequire("2xece")).default; });
$parcel$export(module.exports, "binary", function () { return (parcelRequire("6bPFN")).default; });
$parcel$export(module.exports, "bind", function () { return (parcelRequire("2K8fC")).default; });
$parcel$export(module.exports, "both", function () { return (parcelRequire("gi6wV")).default; });
$parcel$export(module.exports, "call", function () { return (parcelRequire("3QQ7c")).default; });
$parcel$export(module.exports, "chain", function () { return (parcelRequire("5wd4K")).default; });
$parcel$export(module.exports, "clamp", function () { return (parcelRequire("3pfA9")).default; });
$parcel$export(module.exports, "clone", function () { return (parcelRequire("805u5")).default; });
$parcel$export(module.exports, "comparator", function () { return (parcelRequire("1LQXj")).default; });
$parcel$export(module.exports, "complement", function () { return (parcelRequire("fm6cm")).default; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("d8dol")).default; });
$parcel$export(module.exports, "composeK", function () { return (parcelRequire("iVx4O")).default; });
$parcel$export(module.exports, "composeP", function () { return (parcelRequire("OHYL4")).default; });
$parcel$export(module.exports, "composeWith", function () { return (parcelRequire("coMhf")).default; });
$parcel$export(module.exports, "concat", function () { return (parcelRequire("g8SbF")).default; });
$parcel$export(module.exports, "cond", function () { return (parcelRequire("dixPr")).default; });
$parcel$export(module.exports, "construct", function () { return (parcelRequire("4gCyA")).default; });
$parcel$export(module.exports, "constructN", function () { return (parcelRequire("j83TC")).default; });
$parcel$export(module.exports, "contains", function () { return (parcelRequire("iIHod")).default; });
$parcel$export(module.exports, "converge", function () { return (parcelRequire("6s1r9")).default; });
$parcel$export(module.exports, "countBy", function () { return (parcelRequire("8MEAE")).default; });
$parcel$export(module.exports, "curry", function () { return (parcelRequire("iB6UK")).default; });
$parcel$export(module.exports, "curryN", function () { return (parcelRequire("dB93a")).default; });
$parcel$export(module.exports, "dec", function () { return (parcelRequire("bSXWI")).default; });
$parcel$export(module.exports, "defaultTo", function () { return (parcelRequire("iGZmr")).default; });
$parcel$export(module.exports, "descend", function () { return (parcelRequire("4NHaj")).default; });
$parcel$export(module.exports, "difference", function () { return (parcelRequire("7LULv")).default; });
$parcel$export(module.exports, "differenceWith", function () { return (parcelRequire("2GKxo")).default; });
$parcel$export(module.exports, "dissoc", function () { return (parcelRequire("3Vwc5")).default; });
$parcel$export(module.exports, "dissocPath", function () { return (parcelRequire("lVVvb")).default; });
$parcel$export(module.exports, "divide", function () { return (parcelRequire("drXm2")).default; });
$parcel$export(module.exports, "drop", function () { return (parcelRequire("lDPLu")).default; });
$parcel$export(module.exports, "dropLast", function () { return (parcelRequire("kVl95")).default; });
$parcel$export(module.exports, "dropLastWhile", function () { return (parcelRequire("bY7W0")).default; });
$parcel$export(module.exports, "dropRepeats", function () { return (parcelRequire("pPH2r")).default; });
$parcel$export(module.exports, "dropRepeatsWith", function () { return (parcelRequire("vn7Nf")).default; });
$parcel$export(module.exports, "dropWhile", function () { return (parcelRequire("7lWY7")).default; });
$parcel$export(module.exports, "either", function () { return (parcelRequire("3j7JT")).default; });
$parcel$export(module.exports, "empty", function () { return (parcelRequire("cRpaA")).default; });
$parcel$export(module.exports, "endsWith", function () { return (parcelRequire("7PbZc")).default; });
$parcel$export(module.exports, "eqBy", function () { return (parcelRequire("j3Zb9")).default; });
$parcel$export(module.exports, "eqProps", function () { return (parcelRequire("jT0Gm")).default; });
$parcel$export(module.exports, "equals", function () { return (parcelRequire("g5jN3")).default; });
$parcel$export(module.exports, "evolve", function () { return (parcelRequire("674jx")).default; });
$parcel$export(module.exports, "filter", function () { return (parcelRequire("r0sUa")).default; });
$parcel$export(module.exports, "find", function () { return (parcelRequire("gkBGB")).default; });
$parcel$export(module.exports, "findIndex", function () { return (parcelRequire("3jqGz")).default; });
$parcel$export(module.exports, "findLast", function () { return (parcelRequire("jxRbq")).default; });
$parcel$export(module.exports, "findLastIndex", function () { return (parcelRequire("iYCjF")).default; });
$parcel$export(module.exports, "flatten", function () { return (parcelRequire("kOgyX")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("d071Y")).default; });
$parcel$export(module.exports, "forEach", function () { return (parcelRequire("5ANkI")).default; });
$parcel$export(module.exports, "forEachObjIndexed", function () { return (parcelRequire("g6nS1")).default; });
$parcel$export(module.exports, "fromPairs", function () { return (parcelRequire("cxJv1")).default; });
$parcel$export(module.exports, "groupBy", function () { return (parcelRequire("3FNE0")).default; });
$parcel$export(module.exports, "groupWith", function () { return (parcelRequire("jLKIV")).default; });
$parcel$export(module.exports, "gt", function () { return (parcelRequire("eiA2o")).default; });
$parcel$export(module.exports, "gte", function () { return (parcelRequire("lDBZe")).default; });
$parcel$export(module.exports, "has", function () { return (parcelRequire("aTDBn")).default; });
$parcel$export(module.exports, "hasIn", function () { return (parcelRequire("j9bAE")).default; });
$parcel$export(module.exports, "hasPath", function () { return (parcelRequire("cIL3W")).default; });
$parcel$export(module.exports, "head", function () { return (parcelRequire("4C86y")).default; });
$parcel$export(module.exports, "identical", function () { return (parcelRequire("felhC")).default; });
$parcel$export(module.exports, "identity", function () { return (parcelRequire("6PHwe")).default; });
$parcel$export(module.exports, "ifElse", function () { return (parcelRequire("6Ocs1")).default; });
$parcel$export(module.exports, "inc", function () { return (parcelRequire("6TjHh")).default; });
$parcel$export(module.exports, "includes", function () { return (parcelRequire("fM2wD")).default; });
$parcel$export(module.exports, "indexBy", function () { return (parcelRequire("7gakV")).default; });
$parcel$export(module.exports, "indexOf", function () { return (parcelRequire("fziiz")).default; });
$parcel$export(module.exports, "init", function () { return (parcelRequire("km41b")).default; });
$parcel$export(module.exports, "innerJoin", function () { return (parcelRequire("6stXh")).default; });
$parcel$export(module.exports, "insert", function () { return (parcelRequire("8DoXL")).default; });
$parcel$export(module.exports, "insertAll", function () { return (parcelRequire("jXRj8")).default; });
$parcel$export(module.exports, "intersection", function () { return (parcelRequire("jwOLA")).default; });
$parcel$export(module.exports, "intersperse", function () { return (parcelRequire("goatN")).default; });
$parcel$export(module.exports, "into", function () { return (parcelRequire("hj43t")).default; });
$parcel$export(module.exports, "invert", function () { return (parcelRequire("fuQ9l")).default; });
$parcel$export(module.exports, "invertObj", function () { return (parcelRequire("dma4s")).default; });
$parcel$export(module.exports, "invoker", function () { return (parcelRequire("leUBm")).default; });
$parcel$export(module.exports, "is", function () { return (parcelRequire("IrzWh")).default; });
$parcel$export(module.exports, "isEmpty", function () { return (parcelRequire("7DKgw")).default; });
$parcel$export(module.exports, "isNil", function () { return (parcelRequire("1FHr3")).default; });
$parcel$export(module.exports, "join", function () { return (parcelRequire("bDm6l")).default; });
$parcel$export(module.exports, "juxt", function () { return (parcelRequire("65fIr")).default; });
$parcel$export(module.exports, "keys", function () { return (parcelRequire("aD5Zr")).default; });
$parcel$export(module.exports, "keysIn", function () { return (parcelRequire("3Lu42")).default; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("6uiOQ")).default; });
$parcel$export(module.exports, "lastIndexOf", function () { return (parcelRequire("8v5dU")).default; });
$parcel$export(module.exports, "length", function () { return (parcelRequire("bHf4t")).default; });
$parcel$export(module.exports, "lens", function () { return (parcelRequire("1hAFT")).default; });
$parcel$export(module.exports, "lensIndex", function () { return (parcelRequire("gRmZR")).default; });
$parcel$export(module.exports, "lensPath", function () { return (parcelRequire("kDmJv")).default; });
$parcel$export(module.exports, "lensProp", function () { return (parcelRequire("hGE4K")).default; });
$parcel$export(module.exports, "lift", function () { return (parcelRequire("d2uSX")).default; });
$parcel$export(module.exports, "liftN", function () { return (parcelRequire("bWt4H")).default; });
$parcel$export(module.exports, "lt", function () { return (parcelRequire("jh4AG")).default; });
$parcel$export(module.exports, "lte", function () { return (parcelRequire("hZash")).default; });
$parcel$export(module.exports, "map", function () { return (parcelRequire("kuJWW")).default; });
$parcel$export(module.exports, "mapAccum", function () { return (parcelRequire("harnj")).default; });
$parcel$export(module.exports, "mapAccumRight", function () { return (parcelRequire("922rx")).default; });
$parcel$export(module.exports, "mapObjIndexed", function () { return (parcelRequire("1494U")).default; });
$parcel$export(module.exports, "match", function () { return (parcelRequire("hBjhv")).default; });
$parcel$export(module.exports, "mathMod", function () { return (parcelRequire("iD3EP")).default; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("8pKul")).default; });
$parcel$export(module.exports, "maxBy", function () { return (parcelRequire("5ZSTi")).default; });
$parcel$export(module.exports, "mean", function () { return (parcelRequire("do69M")).default; });
$parcel$export(module.exports, "median", function () { return (parcelRequire("hPLSb")).default; });
$parcel$export(module.exports, "memoizeWith", function () { return (parcelRequire("9MC4H")).default; });
$parcel$export(module.exports, "merge", function () { return (parcelRequire("5RNYG")).default; });
$parcel$export(module.exports, "mergeAll", function () { return (parcelRequire("fnNWC")).default; });
$parcel$export(module.exports, "mergeDeepLeft", function () { return (parcelRequire("eefGy")).default; });
$parcel$export(module.exports, "mergeDeepRight", function () { return (parcelRequire("4yaFX")).default; });
$parcel$export(module.exports, "mergeDeepWith", function () { return (parcelRequire("cPTrL")).default; });
$parcel$export(module.exports, "mergeDeepWithKey", function () { return (parcelRequire("gksJU")).default; });
$parcel$export(module.exports, "mergeLeft", function () { return (parcelRequire("cQaLB")).default; });
$parcel$export(module.exports, "mergeRight", function () { return (parcelRequire("lod0K")).default; });
$parcel$export(module.exports, "mergeWith", function () { return (parcelRequire("eXGRz")).default; });
$parcel$export(module.exports, "mergeWithKey", function () { return (parcelRequire("4owU2")).default; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("6mfeR")).default; });
$parcel$export(module.exports, "minBy", function () { return (parcelRequire("3vlNT")).default; });
$parcel$export(module.exports, "modulo", function () { return (parcelRequire("5Lrx9")).default; });
$parcel$export(module.exports, "move", function () { return (parcelRequire("beYcP")).default; });
$parcel$export(module.exports, "multiply", function () { return (parcelRequire("jxBpQ")).default; });
$parcel$export(module.exports, "nAry", function () { return (parcelRequire("51mxt")).default; });
$parcel$export(module.exports, "negate", function () { return (parcelRequire("kpOgx")).default; });
$parcel$export(module.exports, "none", function () { return (parcelRequire("dKdDy")).default; });
$parcel$export(module.exports, "not", function () { return (parcelRequire("7WniO")).default; });
$parcel$export(module.exports, "nth", function () { return (parcelRequire("am2mP")).default; });
$parcel$export(module.exports, "nthArg", function () { return (parcelRequire("karPh")).default; });
$parcel$export(module.exports, "o", function () { return (parcelRequire("9dbDS")).default; });
$parcel$export(module.exports, "objOf", function () { return (parcelRequire("gJOtP")).default; });
$parcel$export(module.exports, "of", function () { return (parcelRequire("2Bayo")).default; });
$parcel$export(module.exports, "omit", function () { return (parcelRequire("1DcDw")).default; });
$parcel$export(module.exports, "once", function () { return (parcelRequire("iVfxC")).default; });
$parcel$export(module.exports, "or", function () { return (parcelRequire("hDBEN")).default; });
$parcel$export(module.exports, "otherwise", function () { return (parcelRequire("7IqMt")).default; });
$parcel$export(module.exports, "over", function () { return (parcelRequire("9Qgld")).default; });
$parcel$export(module.exports, "pair", function () { return (parcelRequire("kW4Kt")).default; });
$parcel$export(module.exports, "partial", function () { return (parcelRequire("7FSiY")).default; });
$parcel$export(module.exports, "partialRight", function () { return (parcelRequire("7tJhL")).default; });
$parcel$export(module.exports, "partition", function () { return (parcelRequire("aCAF2")).default; });
$parcel$export(module.exports, "path", function () { return (parcelRequire("6W9Xk")).default; });
$parcel$export(module.exports, "pathEq", function () { return (parcelRequire("628nw")).default; });
$parcel$export(module.exports, "pathOr", function () { return (parcelRequire("32TYw")).default; });
$parcel$export(module.exports, "pathSatisfies", function () { return (parcelRequire("gISCw")).default; });
$parcel$export(module.exports, "pick", function () { return (parcelRequire("jBKqu")).default; });
$parcel$export(module.exports, "pickAll", function () { return (parcelRequire("cW3Sn")).default; });
$parcel$export(module.exports, "pickBy", function () { return (parcelRequire("4tVS1")).default; });
$parcel$export(module.exports, "pipe", function () { return (parcelRequire("10F1K")).default; });
$parcel$export(module.exports, "pipeK", function () { return (parcelRequire("hoTp7")).default; });
$parcel$export(module.exports, "pipeP", function () { return (parcelRequire("d71dy")).default; });
$parcel$export(module.exports, "pipeWith", function () { return (parcelRequire("598cz")).default; });
$parcel$export(module.exports, "pluck", function () { return (parcelRequire("2NZ7I")).default; });
$parcel$export(module.exports, "prepend", function () { return (parcelRequire("edCYc")).default; });
$parcel$export(module.exports, "product", function () { return (parcelRequire("egyKK")).default; });
$parcel$export(module.exports, "project", function () { return (parcelRequire("8MsNq")).default; });
$parcel$export(module.exports, "prop", function () { return (parcelRequire("iOjwE")).default; });
$parcel$export(module.exports, "propEq", function () { return (parcelRequire("3e6vr")).default; });
$parcel$export(module.exports, "propIs", function () { return (parcelRequire("5fanY")).default; });
$parcel$export(module.exports, "propOr", function () { return (parcelRequire("5fdvW")).default; });
$parcel$export(module.exports, "propSatisfies", function () { return (parcelRequire("ebdBM")).default; });
$parcel$export(module.exports, "props", function () { return (parcelRequire("jZtDt")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("949T3")).default; });
$parcel$export(module.exports, "reduce", function () { return (parcelRequire("9Zbrv")).default; });
$parcel$export(module.exports, "reduceBy", function () { return (parcelRequire("6SR5o")).default; });
$parcel$export(module.exports, "reduceRight", function () { return (parcelRequire("jLvnw")).default; });
$parcel$export(module.exports, "reduceWhile", function () { return (parcelRequire("14dgF")).default; });
$parcel$export(module.exports, "reduced", function () { return (parcelRequire("8va4b")).default; });
$parcel$export(module.exports, "reject", function () { return (parcelRequire("2m6Qn")).default; });
$parcel$export(module.exports, "remove", function () { return (parcelRequire("bGNEx")).default; });
$parcel$export(module.exports, "repeat", function () { return (parcelRequire("l1XZv")).default; });
$parcel$export(module.exports, "replace", function () { return (parcelRequire("bfPoN")).default; });
$parcel$export(module.exports, "reverse", function () { return (parcelRequire("cSdZE")).default; });
$parcel$export(module.exports, "scan", function () { return (parcelRequire("bBITo")).default; });
$parcel$export(module.exports, "sequence", function () { return (parcelRequire("8UQ63")).default; });
$parcel$export(module.exports, "set", function () { return (parcelRequire("gGnsI")).default; });
$parcel$export(module.exports, "slice", function () { return (parcelRequire("5KOxr")).default; });
$parcel$export(module.exports, "sort", function () { return (parcelRequire("3OmdN")).default; });
$parcel$export(module.exports, "sortBy", function () { return (parcelRequire("bKeUG")).default; });
$parcel$export(module.exports, "sortWith", function () { return (parcelRequire("13iLV")).default; });
$parcel$export(module.exports, "split", function () { return (parcelRequire("lgeR0")).default; });
$parcel$export(module.exports, "splitAt", function () { return (parcelRequire("efULQ")).default; });
$parcel$export(module.exports, "splitEvery", function () { return (parcelRequire("6MKSH")).default; });
$parcel$export(module.exports, "splitWhen", function () { return (parcelRequire("WPSOy")).default; });
$parcel$export(module.exports, "startsWith", function () { return (parcelRequire("7rZKC")).default; });
$parcel$export(module.exports, "subtract", function () { return (parcelRequire("gfOB4")).default; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("kisLA")).default; });
$parcel$export(module.exports, "symmetricDifference", function () { return (parcelRequire("i8hfO")).default; });
$parcel$export(module.exports, "symmetricDifferenceWith", function () { return (parcelRequire("iGfVM")).default; });
$parcel$export(module.exports, "tail", function () { return (parcelRequire("g0wyi")).default; });
$parcel$export(module.exports, "take", function () { return (parcelRequire("2NnQ3")).default; });
$parcel$export(module.exports, "takeLast", function () { return (parcelRequire("cwLO0")).default; });
$parcel$export(module.exports, "takeLastWhile", function () { return (parcelRequire("aDjpA")).default; });
$parcel$export(module.exports, "takeWhile", function () { return (parcelRequire("3u2Mq")).default; });
$parcel$export(module.exports, "tap", function () { return (parcelRequire("eMmfs")).default; });
$parcel$export(module.exports, "test", function () { return (parcelRequire("jDyZf")).default; });
$parcel$export(module.exports, "then", function () { return (parcelRequire("fui7z")).default; });
$parcel$export(module.exports, "times", function () { return (parcelRequire("fcFPY")).default; });
$parcel$export(module.exports, "toLower", function () { return (parcelRequire("exIhL")).default; });
$parcel$export(module.exports, "toPairs", function () { return (parcelRequire("ev3xd")).default; });
$parcel$export(module.exports, "toPairsIn", function () { return (parcelRequire("iY6ea")).default; });
$parcel$export(module.exports, "toString", function () { return (parcelRequire("g2qM6")).default; });
$parcel$export(module.exports, "toUpper", function () { return (parcelRequire("iWdU6")).default; });
$parcel$export(module.exports, "transduce", function () { return (parcelRequire("eDxPj")).default; });
$parcel$export(module.exports, "transpose", function () { return (parcelRequire("bqbCh")).default; });
$parcel$export(module.exports, "traverse", function () { return (parcelRequire("iUNOD")).default; });
$parcel$export(module.exports, "trim", function () { return (parcelRequire("6WR5E")).default; });
$parcel$export(module.exports, "tryCatch", function () { return (parcelRequire("lCAvK")).default; });
$parcel$export(module.exports, "type", function () { return (parcelRequire("6wxQA")).default; });
$parcel$export(module.exports, "unapply", function () { return (parcelRequire("bBRxi")).default; });
$parcel$export(module.exports, "unary", function () { return (parcelRequire("6Loxk")).default; });
$parcel$export(module.exports, "uncurryN", function () { return (parcelRequire("3IVFf")).default; });
$parcel$export(module.exports, "unfold", function () { return (parcelRequire("5tulw")).default; });
$parcel$export(module.exports, "union", function () { return (parcelRequire("fS9mq")).default; });
$parcel$export(module.exports, "unionWith", function () { return (parcelRequire("3nZNT")).default; });
$parcel$export(module.exports, "uniq", function () { return (parcelRequire("7bi4H")).default; });
$parcel$export(module.exports, "uniqBy", function () { return (parcelRequire("bO5h9")).default; });
$parcel$export(module.exports, "uniqWith", function () { return (parcelRequire("ehShu")).default; });
$parcel$export(module.exports, "unless", function () { return (parcelRequire("fyXYP")).default; });
$parcel$export(module.exports, "unnest", function () { return (parcelRequire("7PFNx")).default; });
$parcel$export(module.exports, "until", function () { return (parcelRequire("2S00s")).default; });
$parcel$export(module.exports, "update", function () { return (parcelRequire("kgy7l")).default; });
$parcel$export(module.exports, "useWith", function () { return (parcelRequire("eu8tn")).default; });
$parcel$export(module.exports, "values", function () { return (parcelRequire("aWkCB")).default; });
$parcel$export(module.exports, "valuesIn", function () { return (parcelRequire("1kT3U")).default; });
$parcel$export(module.exports, "view", function () { return (parcelRequire("bTuJn")).default; });
$parcel$export(module.exports, "when", function () { return (parcelRequire("7Dogi")).default; });
$parcel$export(module.exports, "where", function () { return (parcelRequire("a2qh2")).default; });
$parcel$export(module.exports, "whereEq", function () { return (parcelRequire("3G9aT")).default; });
$parcel$export(module.exports, "without", function () { return (parcelRequire("8BqOk")).default; });
$parcel$export(module.exports, "xprod", function () { return (parcelRequire("dQoDX")).default; });
$parcel$export(module.exports, "zip", function () { return (parcelRequire("ij5yn")).default; });
$parcel$export(module.exports, "zipObj", function () { return (parcelRequire("bTYI5")).default; });
$parcel$export(module.exports, "zipWith", function () { return (parcelRequire("6gOf8")).default; });
$parcel$export(module.exports, "thunkify", function () { return (parcelRequire("bxtlX")).default; });

var $gkCmd = parcelRequire("gkCmd");

var $enjLN = parcelRequire("enjLN");

var $AVvPi = parcelRequire("AVvPi");

var $kC3eS = parcelRequire("kC3eS");

var $dvIel = parcelRequire("dvIel");

var $lHQV2 = parcelRequire("lHQV2");

var $fs01P = parcelRequire("fs01P");

var $bKc8Z = parcelRequire("bKc8Z");

var $cdVZD = parcelRequire("cdVZD");

var $jWdy6 = parcelRequire("jWdy6");

var $d86m6 = parcelRequire("d86m6");

var $4qtNZ = parcelRequire("4qtNZ");

var $7C2CH = parcelRequire("7C2CH");

var $2VAJy = parcelRequire("2VAJy");

var $aj4Qz = parcelRequire("aj4Qz");

var $384ED = parcelRequire("384ED");

var $e5ZI9 = parcelRequire("e5ZI9");

var $eO2XQ = parcelRequire("eO2XQ");

var $dNFxY = parcelRequire("dNFxY");

var $ia2wh = parcelRequire("ia2wh");

var $2xece = parcelRequire("2xece");

var $6bPFN = parcelRequire("6bPFN");

var $2K8fC = parcelRequire("2K8fC");

var $gi6wV = parcelRequire("gi6wV");

var $3QQ7c = parcelRequire("3QQ7c");

var $5wd4K = parcelRequire("5wd4K");

var $3pfA9 = parcelRequire("3pfA9");

var $805u5 = parcelRequire("805u5");

var $1LQXj = parcelRequire("1LQXj");

var $fm6cm = parcelRequire("fm6cm");

var $d8dol = parcelRequire("d8dol");

var $iVx4O = parcelRequire("iVx4O");

var $OHYL4 = parcelRequire("OHYL4");

var $coMhf = parcelRequire("coMhf");

var $g8SbF = parcelRequire("g8SbF");

var $dixPr = parcelRequire("dixPr");

var $4gCyA = parcelRequire("4gCyA");

var $j83TC = parcelRequire("j83TC");

var $iIHod = parcelRequire("iIHod");

var $6s1r9 = parcelRequire("6s1r9");

var $8MEAE = parcelRequire("8MEAE");

var $iB6UK = parcelRequire("iB6UK");

var $dB93a = parcelRequire("dB93a");

var $bSXWI = parcelRequire("bSXWI");

var $iGZmr = parcelRequire("iGZmr");

var $4NHaj = parcelRequire("4NHaj");

var $7LULv = parcelRequire("7LULv");

var $2GKxo = parcelRequire("2GKxo");

var $3Vwc5 = parcelRequire("3Vwc5");

var $lVVvb = parcelRequire("lVVvb");

var $drXm2 = parcelRequire("drXm2");

var $lDPLu = parcelRequire("lDPLu");

var $kVl95 = parcelRequire("kVl95");

var $bY7W0 = parcelRequire("bY7W0");

var $pPH2r = parcelRequire("pPH2r");

var $vn7Nf = parcelRequire("vn7Nf");

var $7lWY7 = parcelRequire("7lWY7");

var $3j7JT = parcelRequire("3j7JT");

var $cRpaA = parcelRequire("cRpaA");

var $7PbZc = parcelRequire("7PbZc");

var $j3Zb9 = parcelRequire("j3Zb9");

var $jT0Gm = parcelRequire("jT0Gm");

var $g5jN3 = parcelRequire("g5jN3");

var $674jx = parcelRequire("674jx");

var $r0sUa = parcelRequire("r0sUa");

var $gkBGB = parcelRequire("gkBGB");

var $3jqGz = parcelRequire("3jqGz");

var $jxRbq = parcelRequire("jxRbq");

var $iYCjF = parcelRequire("iYCjF");

var $kOgyX = parcelRequire("kOgyX");

var $d071Y = parcelRequire("d071Y");

var $5ANkI = parcelRequire("5ANkI");

var $g6nS1 = parcelRequire("g6nS1");

var $cxJv1 = parcelRequire("cxJv1");

var $3FNE0 = parcelRequire("3FNE0");

var $jLKIV = parcelRequire("jLKIV");

var $eiA2o = parcelRequire("eiA2o");

var $lDBZe = parcelRequire("lDBZe");

var $aTDBn = parcelRequire("aTDBn");

var $j9bAE = parcelRequire("j9bAE");

var $cIL3W = parcelRequire("cIL3W");

var $4C86y = parcelRequire("4C86y");

var $felhC = parcelRequire("felhC");

var $6PHwe = parcelRequire("6PHwe");

var $6Ocs1 = parcelRequire("6Ocs1");

var $6TjHh = parcelRequire("6TjHh");

var $fM2wD = parcelRequire("fM2wD");

var $7gakV = parcelRequire("7gakV");

var $fziiz = parcelRequire("fziiz");

var $km41b = parcelRequire("km41b");

var $6stXh = parcelRequire("6stXh");

var $8DoXL = parcelRequire("8DoXL");

var $jXRj8 = parcelRequire("jXRj8");

var $jwOLA = parcelRequire("jwOLA");

var $goatN = parcelRequire("goatN");

var $hj43t = parcelRequire("hj43t");

var $fuQ9l = parcelRequire("fuQ9l");

var $dma4s = parcelRequire("dma4s");

var $leUBm = parcelRequire("leUBm");

var $IrzWh = parcelRequire("IrzWh");

var $7DKgw = parcelRequire("7DKgw");

var $1FHr3 = parcelRequire("1FHr3");

var $bDm6l = parcelRequire("bDm6l");

var $65fIr = parcelRequire("65fIr");

var $aD5Zr = parcelRequire("aD5Zr");

var $3Lu42 = parcelRequire("3Lu42");

var $6uiOQ = parcelRequire("6uiOQ");

var $8v5dU = parcelRequire("8v5dU");

var $bHf4t = parcelRequire("bHf4t");

var $1hAFT = parcelRequire("1hAFT");

var $gRmZR = parcelRequire("gRmZR");

var $kDmJv = parcelRequire("kDmJv");

var $hGE4K = parcelRequire("hGE4K");

var $d2uSX = parcelRequire("d2uSX");

var $bWt4H = parcelRequire("bWt4H");

var $jh4AG = parcelRequire("jh4AG");

var $hZash = parcelRequire("hZash");

var $kuJWW = parcelRequire("kuJWW");

var $harnj = parcelRequire("harnj");

var $922rx = parcelRequire("922rx");

var $1494U = parcelRequire("1494U");

var $hBjhv = parcelRequire("hBjhv");

var $iD3EP = parcelRequire("iD3EP");

var $8pKul = parcelRequire("8pKul");

var $5ZSTi = parcelRequire("5ZSTi");

var $do69M = parcelRequire("do69M");

var $hPLSb = parcelRequire("hPLSb");

var $9MC4H = parcelRequire("9MC4H");

var $5RNYG = parcelRequire("5RNYG");

var $fnNWC = parcelRequire("fnNWC");

var $eefGy = parcelRequire("eefGy");

var $4yaFX = parcelRequire("4yaFX");

var $cPTrL = parcelRequire("cPTrL");

var $gksJU = parcelRequire("gksJU");

var $cQaLB = parcelRequire("cQaLB");

var $lod0K = parcelRequire("lod0K");

var $eXGRz = parcelRequire("eXGRz");

var $4owU2 = parcelRequire("4owU2");

var $6mfeR = parcelRequire("6mfeR");

var $3vlNT = parcelRequire("3vlNT");

var $5Lrx9 = parcelRequire("5Lrx9");

var $beYcP = parcelRequire("beYcP");

var $jxBpQ = parcelRequire("jxBpQ");

var $51mxt = parcelRequire("51mxt");

var $kpOgx = parcelRequire("kpOgx");

var $dKdDy = parcelRequire("dKdDy");

var $7WniO = parcelRequire("7WniO");

var $am2mP = parcelRequire("am2mP");

var $karPh = parcelRequire("karPh");

var $9dbDS = parcelRequire("9dbDS");

var $gJOtP = parcelRequire("gJOtP");

var $2Bayo = parcelRequire("2Bayo");

var $1DcDw = parcelRequire("1DcDw");

var $iVfxC = parcelRequire("iVfxC");

var $hDBEN = parcelRequire("hDBEN");

var $7IqMt = parcelRequire("7IqMt");

var $9Qgld = parcelRequire("9Qgld");

var $kW4Kt = parcelRequire("kW4Kt");

var $7FSiY = parcelRequire("7FSiY");

var $7tJhL = parcelRequire("7tJhL");

var $aCAF2 = parcelRequire("aCAF2");

var $6W9Xk = parcelRequire("6W9Xk");

var $628nw = parcelRequire("628nw");

var $32TYw = parcelRequire("32TYw");

var $gISCw = parcelRequire("gISCw");

var $jBKqu = parcelRequire("jBKqu");

var $cW3Sn = parcelRequire("cW3Sn");

var $4tVS1 = parcelRequire("4tVS1");

var $10F1K = parcelRequire("10F1K");

var $hoTp7 = parcelRequire("hoTp7");

var $d71dy = parcelRequire("d71dy");

var $598cz = parcelRequire("598cz");

var $2NZ7I = parcelRequire("2NZ7I");

var $edCYc = parcelRequire("edCYc");

var $egyKK = parcelRequire("egyKK");

var $8MsNq = parcelRequire("8MsNq");

var $iOjwE = parcelRequire("iOjwE");

var $3e6vr = parcelRequire("3e6vr");

var $5fanY = parcelRequire("5fanY");

var $5fdvW = parcelRequire("5fdvW");

var $ebdBM = parcelRequire("ebdBM");

var $jZtDt = parcelRequire("jZtDt");

var $949T3 = parcelRequire("949T3");

var $9Zbrv = parcelRequire("9Zbrv");

var $6SR5o = parcelRequire("6SR5o");

var $jLvnw = parcelRequire("jLvnw");

var $14dgF = parcelRequire("14dgF");

var $8va4b = parcelRequire("8va4b");

var $2m6Qn = parcelRequire("2m6Qn");

var $bGNEx = parcelRequire("bGNEx");

var $l1XZv = parcelRequire("l1XZv");

var $bfPoN = parcelRequire("bfPoN");

var $cSdZE = parcelRequire("cSdZE");

var $bBITo = parcelRequire("bBITo");

var $8UQ63 = parcelRequire("8UQ63");

var $gGnsI = parcelRequire("gGnsI");

var $5KOxr = parcelRequire("5KOxr");

var $3OmdN = parcelRequire("3OmdN");

var $bKeUG = parcelRequire("bKeUG");

var $13iLV = parcelRequire("13iLV");

var $lgeR0 = parcelRequire("lgeR0");

var $efULQ = parcelRequire("efULQ");

var $6MKSH = parcelRequire("6MKSH");

var $WPSOy = parcelRequire("WPSOy");

var $7rZKC = parcelRequire("7rZKC");

var $gfOB4 = parcelRequire("gfOB4");

var $kisLA = parcelRequire("kisLA");

var $i8hfO = parcelRequire("i8hfO");

var $iGfVM = parcelRequire("iGfVM");

var $g0wyi = parcelRequire("g0wyi");

var $2NnQ3 = parcelRequire("2NnQ3");

var $cwLO0 = parcelRequire("cwLO0");

var $aDjpA = parcelRequire("aDjpA");

var $3u2Mq = parcelRequire("3u2Mq");

var $eMmfs = parcelRequire("eMmfs");

var $jDyZf = parcelRequire("jDyZf");

var $fui7z = parcelRequire("fui7z");

var $fcFPY = parcelRequire("fcFPY");

var $exIhL = parcelRequire("exIhL");

var $ev3xd = parcelRequire("ev3xd");

var $iY6ea = parcelRequire("iY6ea");

var $g2qM6 = parcelRequire("g2qM6");

var $iWdU6 = parcelRequire("iWdU6");

var $eDxPj = parcelRequire("eDxPj");

var $bqbCh = parcelRequire("bqbCh");

var $iUNOD = parcelRequire("iUNOD");

var $6WR5E = parcelRequire("6WR5E");

var $lCAvK = parcelRequire("lCAvK");

var $6wxQA = parcelRequire("6wxQA");

var $bBRxi = parcelRequire("bBRxi");

var $6Loxk = parcelRequire("6Loxk");

var $3IVFf = parcelRequire("3IVFf");

var $5tulw = parcelRequire("5tulw");

var $fS9mq = parcelRequire("fS9mq");

var $3nZNT = parcelRequire("3nZNT");

var $7bi4H = parcelRequire("7bi4H");

var $bO5h9 = parcelRequire("bO5h9");

var $ehShu = parcelRequire("ehShu");

var $fyXYP = parcelRequire("fyXYP");

var $7PFNx = parcelRequire("7PFNx");

var $2S00s = parcelRequire("2S00s");

var $kgy7l = parcelRequire("kgy7l");

var $eu8tn = parcelRequire("eu8tn");

var $aWkCB = parcelRequire("aWkCB");

var $1kT3U = parcelRequire("1kT3U");

var $bTuJn = parcelRequire("bTuJn");

var $7Dogi = parcelRequire("7Dogi");

var $a2qh2 = parcelRequire("a2qh2");

var $3G9aT = parcelRequire("3G9aT");

var $8BqOk = parcelRequire("8BqOk");

var $dQoDX = parcelRequire("dQoDX");

var $ij5yn = parcelRequire("ij5yn");

var $bTYI5 = parcelRequire("bTYI5");

var $6gOf8 = parcelRequire("6gOf8");

var $bxtlX = parcelRequire("bxtlX");

});
parcelRegister("gkCmd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be3c44954cbd1a40$export$2e2bcd8739ae039; });
/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.T
 * @example
 *
 *      R.F(); //=> false
 */ var $be3c44954cbd1a40$var$F = function() {
    return false;
};
var $be3c44954cbd1a40$export$2e2bcd8739ae039 = $be3c44954cbd1a40$var$F;

});

parcelRegister("enjLN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7728c965a9c3ff1$export$2e2bcd8739ae039; });
/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */ var $a7728c965a9c3ff1$var$T = function() {
    return true;
};
var $a7728c965a9c3ff1$export$2e2bcd8739ae039 = $a7728c965a9c3ff1$var$T;

});

parcelRegister("AVvPi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06eff9a88b5c2eb9$export$2e2bcd8739ae039; });
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */ var $06eff9a88b5c2eb9$export$2e2bcd8739ae039 = {
    "@@functional/placeholder": true
};

});

parcelRegister("kC3eS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f019de71e8a06f52$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var $f019de71e8a06f52$var$add = /*#__PURE__*/ (0, $7SxCN.default)(function add(a, b) {
    return Number(a) + Number(b);
});
var $f019de71e8a06f52$export$2e2bcd8739ae039 = $f019de71e8a06f52$var$add;

});
parcelRegister("7SxCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bc7a8bc494b0aa9$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $5ZRsy = parcelRequire("5ZRsy");
function $5bc7a8bc494b0aa9$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $5ZRsy.default)(a) ? f2 : (0, $1t1xO.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(b) ? f2 : (0, $5ZRsy.default)(a) ? (0, $1t1xO.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $5ZRsy.default)(b) ? (0, $1t1xO.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});
parcelRegister("1t1xO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1119b291707c3284$export$2e2bcd8739ae039; });

var $5ZRsy = parcelRequire("5ZRsy");
function $1119b291707c3284$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $5ZRsy.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("5ZRsy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45dc1e3851ea45b5$export$2e2bcd8739ae039; });
function $45dc1e3851ea45b5$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}

});




parcelRegister("dvIel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d607ad6ce1a2566$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $1t1xO = parcelRequire("1t1xO");

var $dB93a = parcelRequire("dB93a");
/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> ((a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var $9d607ad6ce1a2566$var$addIndex = /*#__PURE__*/ (0, $1t1xO.default)(function addIndex(fn) {
    return (0, $dB93a.default)(fn.length, function() {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, $aikTT.default)(arguments, [
                idx,
                list
            ]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
var $9d607ad6ce1a2566$export$2e2bcd8739ae039 = $9d607ad6ce1a2566$var$addIndex;

});
parcelRegister("aikTT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77ebcc3f4af9905b$export$2e2bcd8739ae039; });
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ function $77ebcc3f4af9905b$export$2e2bcd8739ae039(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("dB93a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e65c03c0b3b4a25$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $1t1xO = parcelRequire("1t1xO");

var $7SxCN = parcelRequire("7SxCN");

var $7bssI = parcelRequire("7bssI");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $9e65c03c0b3b4a25$var$curryN = /*#__PURE__*/ (0, $7SxCN.default)(function curryN(length, fn) {
    if (length === 1) return (0, $1t1xO.default)(fn);
    return (0, $fTxyT.default)(length, (0, $7bssI.default)(length, [], fn));
});
var $9e65c03c0b3b4a25$export$2e2bcd8739ae039 = $9e65c03c0b3b4a25$var$curryN;

});
parcelRegister("fTxyT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b92606b8e25b6843$export$2e2bcd8739ae039; });
function $b92606b8e25b6843$export$2e2bcd8739ae039(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}

});

parcelRegister("7bssI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53afa373fbec91db$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $5ZRsy = parcelRequire("5ZRsy");
function $53afa373fbec91db$export$2e2bcd8739ae039(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, $5ZRsy.default)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, $5ZRsy.default)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, $fTxyT.default)(left, $53afa373fbec91db$export$2e2bcd8739ae039(length, combined, fn));
    };
}

});



parcelRegister("lHQV2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcd6a9bca4955925$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $jS880 = parcelRequire("jS880");
/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */ var $fcd6a9bca4955925$var$adjust = /*#__PURE__*/ (0, $jS880.default)(function adjust(idx, fn, list) {
    if (idx >= list.length || idx < -list.length) return list;
    var start = idx < 0 ? list.length : 0;
    var _idx = start + idx;
    var _list = (0, $aikTT.default)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
var $fcd6a9bca4955925$export$2e2bcd8739ae039 = $fcd6a9bca4955925$var$adjust;

});
parcelRegister("jS880", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7795d8db44cc84b$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $7SxCN = parcelRequire("7SxCN");

var $5ZRsy = parcelRequire("5ZRsy");
function $e7795d8db44cc84b$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $5ZRsy.default)(a) ? f3 : (0, $7SxCN.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(b) ? f3 : (0, $5ZRsy.default)(a) ? (0, $7SxCN.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $5ZRsy.default)(b) ? (0, $7SxCN.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $1t1xO.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(b) && (0, $5ZRsy.default)(c) ? f3 : (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(b) ? (0, $7SxCN.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(c) ? (0, $7SxCN.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $5ZRsy.default)(b) && (0, $5ZRsy.default)(c) ? (0, $7SxCN.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $5ZRsy.default)(a) ? (0, $1t1xO.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $5ZRsy.default)(b) ? (0, $1t1xO.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $5ZRsy.default)(c) ? (0, $1t1xO.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});


parcelRegister("fs01P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f97e37d6ab2dee$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $iQ5NL = parcelRequire("iQ5NL");
/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var $b3f97e37d6ab2dee$var$all = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "all"
], (0, $iQ5NL.default), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
var $b3f97e37d6ab2dee$export$2e2bcd8739ae039 = $b3f97e37d6ab2dee$var$all;

});
parcelRegister("jVVlM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e82fd3c19264968c$export$2e2bcd8739ae039; });

var $3RBKV = parcelRequire("3RBKV");

var $ljSpW = parcelRequire("ljSpW");
function $e82fd3c19264968c$export$2e2bcd8739ae039(methodNames, xf, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!(0, $3RBKV.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, args);
                idx += 1;
            }
            if ((0, $ljSpW.default)(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

});
parcelRegister("3RBKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d039bdca17f43bf$export$2e2bcd8739ae039; });
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $2d039bdca17f43bf$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};

});

parcelRegister("ljSpW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f855957a4a9612bf$export$2e2bcd8739ae039; });
function $f855957a4a9612bf$export$2e2bcd8739ae039(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}

});


parcelRegister("iQ5NL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db71956d1f1729d2$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $02x5o = parcelRequire("02x5o");

var $a6y2L = parcelRequire("a6y2L");
var $db71956d1f1729d2$var$XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XAll.prototype["@@transducer/result"] = function(result) {
        if (this.all) result = this.xf["@@transducer/step"](result, true);
        return this.xf["@@transducer/result"](result);
    };
    XAll.prototype["@@transducer/step"] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, $02x5o.default)(this.xf["@@transducer/step"](result, false));
        }
        return result;
    };
    return XAll;
}();
var $db71956d1f1729d2$var$_xall = /*#__PURE__*/ (0, $7SxCN.default)(function _xall(f, xf) {
    return new $db71956d1f1729d2$var$XAll(f, xf);
});
var $db71956d1f1729d2$export$2e2bcd8739ae039 = $db71956d1f1729d2$var$_xall;

});
parcelRegister("02x5o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0079da3350b7af31$export$2e2bcd8739ae039; });
function $0079da3350b7af31$export$2e2bcd8739ae039(x) {
    return x && x["@@transducer/reduced"] ? x : {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}

});

parcelRegister("a6y2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75b4df47bddaba3e$export$2e2bcd8739ae039; });
var $75b4df47bddaba3e$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};

});



parcelRegister("bKc8Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88cd691dec1de35f$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $dB93a = parcelRequire("dB93a");

var $8pKul = parcelRequire("8pKul");

var $2NZ7I = parcelRequire("2NZ7I");

var $9Zbrv = parcelRequire("9Zbrv");
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var $88cd691dec1de35f$var$allPass = /*#__PURE__*/ (0, $1t1xO.default)(function allPass(preds) {
    return (0, $dB93a.default)((0, $9Zbrv.default)((0, $8pKul.default), 0, (0, $2NZ7I.default)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
var $88cd691dec1de35f$export$2e2bcd8739ae039 = $88cd691dec1de35f$var$allPass;

});
parcelRegister("8pKul", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6204b82ba19ab48a$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var $6204b82ba19ab48a$var$max = /*#__PURE__*/ (0, $7SxCN.default)(function max(a, b) {
    return b > a ? b : a;
});
var $6204b82ba19ab48a$export$2e2bcd8739ae039 = $6204b82ba19ab48a$var$max;

});

parcelRegister("2NZ7I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20af923c068efeea$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $kuJWW = parcelRequire("kuJWW");

var $iOjwE = parcelRequire("iOjwE");
/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var $20af923c068efeea$var$pluck = /*#__PURE__*/ (0, $7SxCN.default)(function pluck(p, list) {
    return (0, $kuJWW.default)((0, $iOjwE.default)(p), list);
});
var $20af923c068efeea$export$2e2bcd8739ae039 = $20af923c068efeea$var$pluck;

});
parcelRegister("kuJWW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeba40a83c1af2c4$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $j5PpZ = parcelRequire("j5PpZ");

var $kwaQ3 = parcelRequire("kwaQ3");

var $2NJJi = parcelRequire("2NJJi");

var $dB93a = parcelRequire("dB93a");

var $aD5Zr = parcelRequire("aD5Zr");
/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $eeba40a83c1af2c4$var$map = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "fantasy-land/map",
    "map"
], (0, $2NJJi.default), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case "[object Function]":
            return (0, $dB93a.default)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case "[object Object]":
            return (0, $kwaQ3.default)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, $aD5Zr.default)(functor));
        default:
            return (0, $j5PpZ.default)(fn, functor);
    }
}));
var $eeba40a83c1af2c4$export$2e2bcd8739ae039 = $eeba40a83c1af2c4$var$map;

});
parcelRegister("j5PpZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de665e827334f055$export$2e2bcd8739ae039; });
function $de665e827334f055$export$2e2bcd8739ae039(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}

});

parcelRegister("kwaQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeff341e2e828e35$export$2e2bcd8739ae039; });

var $fl2xG = parcelRequire("fl2xG");

var $6DG1C = parcelRequire("6DG1C");

var $2K8fC = parcelRequire("2K8fC");
function $eeff341e2e828e35$var$_arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}
function $eeff341e2e828e35$var$_iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function $eeff341e2e828e35$var$_methodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]((0, $2K8fC.default)(xf["@@transducer/step"], xf), acc));
}
var $eeff341e2e828e35$var$symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function $eeff341e2e828e35$export$2e2bcd8739ae039(fn, acc, list) {
    if (typeof fn === "function") fn = (0, $6DG1C.default)(fn);
    if ((0, $fl2xG.default)(list)) return $eeff341e2e828e35$var$_arrayReduce(fn, acc, list);
    if (typeof list["fantasy-land/reduce"] === "function") return $eeff341e2e828e35$var$_methodReduce(fn, acc, list, "fantasy-land/reduce");
    if (list[$eeff341e2e828e35$var$symIterator] != null) return $eeff341e2e828e35$var$_iterableReduce(fn, acc, list[$eeff341e2e828e35$var$symIterator]());
    if (typeof list.next === "function") return $eeff341e2e828e35$var$_iterableReduce(fn, acc, list);
    if (typeof list.reduce === "function") return $eeff341e2e828e35$var$_methodReduce(fn, acc, list, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
}

});
parcelRegister("fl2xG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2aaca034408573f$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $3RBKV = parcelRequire("3RBKV");

var $k2UUn = parcelRequire("k2UUn");
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */ var $b2aaca034408573f$var$_isArrayLike = /*#__PURE__*/ (0, $1t1xO.default)(function isArrayLike(x) {
    if ((0, $3RBKV.default)(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ((0, $k2UUn.default)(x)) return false;
    if (x.nodeType === 1) return !!x.length;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var $b2aaca034408573f$export$2e2bcd8739ae039 = $b2aaca034408573f$var$_isArrayLike;

});
parcelRegister("k2UUn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9802355e9a971f3$export$2e2bcd8739ae039; });
function $e9802355e9a971f3$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}

});


parcelRegister("6DG1C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d56fbe3ec82dcda$export$2e2bcd8739ae039; });
var $4d56fbe3ec82dcda$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $4d56fbe3ec82dcda$export$2e2bcd8739ae039(fn) {
    return new $4d56fbe3ec82dcda$var$XWrap(fn);
}

});

parcelRegister("2K8fC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ff6471db06bc0ba$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $1ff6471db06bc0ba$var$bind = /*#__PURE__*/ (0, $7SxCN.default)(function bind(fn, thisObj) {
    return (0, $fTxyT.default)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
var $1ff6471db06bc0ba$export$2e2bcd8739ae039 = $1ff6471db06bc0ba$var$bind;

});


parcelRegister("2NJJi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20a3a1533f900427$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $20a3a1533f900427$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XMap.prototype["@@transducer/result"] = (0, $a6y2L.default).result;
    XMap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, this.f(input));
    };
    return XMap;
}();
var $20a3a1533f900427$var$_xmap = /*#__PURE__*/ (0, $7SxCN.default)(function _xmap(f, xf) {
    return new $20a3a1533f900427$var$XMap(f, xf);
});
var $20a3a1533f900427$export$2e2bcd8739ae039 = $20a3a1533f900427$var$_xmap;

});

parcelRegister("aD5Zr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bd231648493210b$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $bKOTe = parcelRequire("bKOTe");

var $4Xe8k = parcelRequire("4Xe8k");
// cover IE < 9 keys issues
var $7bd231648493210b$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $7bd231648493210b$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
];
// Safari bug
var $7bd231648493210b$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $7bd231648493210b$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $7bd231648493210b$var$keys = typeof Object.keys === "function" && !$7bd231648493210b$var$hasArgsEnumBug ? /*#__PURE__*/ (0, $1t1xO.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, $1t1xO.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $7bd231648493210b$var$hasArgsEnumBug && (0, $4Xe8k.default)(obj);
    for(prop in obj)if ((0, $bKOTe.default)(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($7bd231648493210b$var$hasEnumBug) {
        nIdx = $7bd231648493210b$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $7bd231648493210b$var$nonEnumerableProps[nIdx];
            if ((0, $bKOTe.default)(prop, obj) && !$7bd231648493210b$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
var $7bd231648493210b$export$2e2bcd8739ae039 = $7bd231648493210b$var$keys;

});
parcelRegister("bKOTe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88eb77390bd89c62$export$2e2bcd8739ae039; });
function $88eb77390bd89c62$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

parcelRegister("4Xe8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39b7a2b3276535bb$export$2e2bcd8739ae039; });

var $bKOTe = parcelRequire("bKOTe");
var $39b7a2b3276535bb$var$toString = Object.prototype.toString;
var $39b7a2b3276535bb$var$_isArguments = /*#__PURE__*/ function() {
    return $39b7a2b3276535bb$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $39b7a2b3276535bb$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return (0, $bKOTe.default)("callee", x);
    };
}();
var $39b7a2b3276535bb$export$2e2bcd8739ae039 = $39b7a2b3276535bb$var$_isArguments;

});



parcelRegister("iOjwE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db1c0ae5df507421$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $6W9Xk = parcelRequire("6W9Xk");
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var $db1c0ae5df507421$var$prop = /*#__PURE__*/ (0, $7SxCN.default)(function prop(p, obj) {
    return (0, $6W9Xk.default)([
        p
    ], obj);
});
var $db1c0ae5df507421$export$2e2bcd8739ae039 = $db1c0ae5df507421$var$prop;

});
parcelRegister("6W9Xk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50cfe1e3236edffe$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */ var $50cfe1e3236edffe$var$path = /*#__PURE__*/ (0, $7SxCN.default)(function path(paths, obj) {
    var val = obj;
    var idx = 0;
    while(idx < paths.length){
        if (val == null) return;
        val = val[paths[idx]];
        idx += 1;
    }
    return val;
});
var $50cfe1e3236edffe$export$2e2bcd8739ae039 = $50cfe1e3236edffe$var$path;

});



parcelRegister("9Zbrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7452afdb416c43f8$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $kwaQ3 = parcelRequire("kwaQ3");
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $7452afdb416c43f8$var$reduce = /*#__PURE__*/ (0, $jS880.default)((0, $kwaQ3.default));
var $7452afdb416c43f8$export$2e2bcd8739ae039 = $7452afdb416c43f8$var$reduce;

});


parcelRegister("cdVZD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e63af234d14ba1a$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var $8e63af234d14ba1a$var$always = /*#__PURE__*/ (0, $1t1xO.default)(function always(val) {
    return function() {
        return val;
    };
});
var $8e63af234d14ba1a$export$2e2bcd8739ae039 = $8e63af234d14ba1a$var$always;

});

parcelRegister("jWdy6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e83df1add25442cb$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */ var $e83df1add25442cb$var$and = /*#__PURE__*/ (0, $7SxCN.default)(function and(a, b) {
    return a && b;
});
var $e83df1add25442cb$export$2e2bcd8739ae039 = $e83df1add25442cb$var$and;

});

parcelRegister("d86m6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98f0f3c4f07b45c4$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $eSVQU = parcelRequire("eSVQU");
/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var $98f0f3c4f07b45c4$var$any = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "any"
], (0, $eSVQU.default), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
var $98f0f3c4f07b45c4$export$2e2bcd8739ae039 = $98f0f3c4f07b45c4$var$any;

});
parcelRegister("eSVQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad62fc19e10ee0c1$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $02x5o = parcelRequire("02x5o");

var $a6y2L = parcelRequire("a6y2L");
var $ad62fc19e10ee0c1$var$XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XAny.prototype["@@transducer/result"] = function(result) {
        if (!this.any) result = this.xf["@@transducer/step"](result, false);
        return this.xf["@@transducer/result"](result);
    };
    XAny.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, $02x5o.default)(this.xf["@@transducer/step"](result, true));
        }
        return result;
    };
    return XAny;
}();
var $ad62fc19e10ee0c1$var$_xany = /*#__PURE__*/ (0, $7SxCN.default)(function _xany(f, xf) {
    return new $ad62fc19e10ee0c1$var$XAny(f, xf);
});
var $ad62fc19e10ee0c1$export$2e2bcd8739ae039 = $ad62fc19e10ee0c1$var$_xany;

});


parcelRegister("4qtNZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3390b5d7de574bcf$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $dB93a = parcelRequire("dB93a");

var $8pKul = parcelRequire("8pKul");

var $2NZ7I = parcelRequire("2NZ7I");

var $9Zbrv = parcelRequire("9Zbrv");
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var $3390b5d7de574bcf$var$anyPass = /*#__PURE__*/ (0, $1t1xO.default)(function anyPass(preds) {
    return (0, $dB93a.default)((0, $9Zbrv.default)((0, $8pKul.default), 0, (0, $2NZ7I.default)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
var $3390b5d7de574bcf$export$2e2bcd8739ae039 = $3390b5d7de574bcf$var$anyPass;

});

parcelRegister("7C2CH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58ae1df029b78e7c$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $7SxCN = parcelRequire("7SxCN");

var $kwaQ3 = parcelRequire("kwaQ3");

var $kuJWW = parcelRequire("kuJWW");
/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var $58ae1df029b78e7c$var$ap = /*#__PURE__*/ (0, $7SxCN.default)(function ap(applyF, applyX) {
    return typeof applyX["fantasy-land/ap"] === "function" ? applyX["fantasy-land/ap"](applyF) : typeof applyF.ap === "function" ? applyF.ap(applyX) : typeof applyF === "function" ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, $kwaQ3.default)(function(acc, f) {
        return (0, $aikTT.default)(acc, (0, $kuJWW.default)(f, applyX));
    }, [], applyF);
});
var $58ae1df029b78e7c$export$2e2bcd8739ae039 = $58ae1df029b78e7c$var$ap;

});

parcelRegister("2VAJy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $221d662d8cac9deb$export$2e2bcd8739ae039; });

var $jVwDB = parcelRequire("jVwDB");

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $j2XiZ = parcelRequire("j2XiZ");
/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */ var $221d662d8cac9deb$var$aperture = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([], (0, $j2XiZ.default), (0, $jVwDB.default)));
var $221d662d8cac9deb$export$2e2bcd8739ae039 = $221d662d8cac9deb$var$aperture;

});
parcelRegister("jVwDB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e81ca85952250262$export$2e2bcd8739ae039; });
function $e81ca85952250262$export$2e2bcd8739ae039(n, list) {
    var idx = 0;
    var limit = list.length - (n - 1);
    var acc = new Array(limit >= 0 ? limit : 0);
    while(idx < limit){
        acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
        idx += 1;
    }
    return acc;
}

});

parcelRegister("j2XiZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dddc3506049f0649$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $dddc3506049f0649$var$XAperture = /*#__PURE__*/ function() {
    function XAperture(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XAperture.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XAperture.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XAperture.prototype["@@transducer/step"] = function(result, input) {
        this.store(input);
        return this.full ? this.xf["@@transducer/step"](result, this.getCopy()) : result;
    };
    XAperture.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    XAperture.prototype.getCopy = function() {
        return (0, $aikTT.default)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
    };
    return XAperture;
}();
var $dddc3506049f0649$var$_xaperture = /*#__PURE__*/ (0, $7SxCN.default)(function _xaperture(n, xf) {
    return new $dddc3506049f0649$var$XAperture(n, xf);
});
var $dddc3506049f0649$export$2e2bcd8739ae039 = $dddc3506049f0649$var$_xaperture;

});


parcelRegister("aj4Qz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $780f703f2778694a$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var $780f703f2778694a$var$append = /*#__PURE__*/ (0, $7SxCN.default)(function append(el, list) {
    return (0, $aikTT.default)(list, [
        el
    ]);
});
var $780f703f2778694a$export$2e2bcd8739ae039 = $780f703f2778694a$var$append;

});

parcelRegister("384ED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2475babd9d8dcc62$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var $2475babd9d8dcc62$var$apply = /*#__PURE__*/ (0, $7SxCN.default)(function apply(fn, args) {
    return fn.apply(this, args);
});
var $2475babd9d8dcc62$export$2e2bcd8739ae039 = $2475babd9d8dcc62$var$apply;

});

parcelRegister("e5ZI9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a43166d6d0f7f4ee$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $384ED = parcelRequire("384ED");

var $dB93a = parcelRequire("dB93a");

var $8pKul = parcelRequire("8pKul");

var $2NZ7I = parcelRequire("2NZ7I");

var $9Zbrv = parcelRequire("9Zbrv");

var $aD5Zr = parcelRequire("aD5Zr");

var $aWkCB = parcelRequire("aWkCB");
// Use custom mapValues function to avoid issues with specs that include a "map" key and R.map
// delegating calls to .map
function $a43166d6d0f7f4ee$var$mapValues(fn, obj) {
    return (0, $aD5Zr.default)(obj).reduce(function(acc, key) {
        acc[key] = fn(obj[key]);
        return acc;
    }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var $a43166d6d0f7f4ee$var$applySpec = /*#__PURE__*/ (0, $1t1xO.default)(function applySpec(spec) {
    spec = $a43166d6d0f7f4ee$var$mapValues(function(v) {
        return typeof v == "function" ? v : applySpec(v);
    }, spec);
    return (0, $dB93a.default)((0, $9Zbrv.default)((0, $8pKul.default), 0, (0, $2NZ7I.default)("length", (0, $aWkCB.default)(spec))), function() {
        var args = arguments;
        return $a43166d6d0f7f4ee$var$mapValues(function(f) {
            return (0, $384ED.default)(f, args);
        }, spec);
    });
});
var $a43166d6d0f7f4ee$export$2e2bcd8739ae039 = $a43166d6d0f7f4ee$var$applySpec;

});
parcelRegister("aWkCB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $020e2ebaafa140d3$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $aD5Zr = parcelRequire("aD5Zr");
/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var $020e2ebaafa140d3$var$values = /*#__PURE__*/ (0, $1t1xO.default)(function values(obj) {
    var props = (0, $aD5Zr.default)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
var $020e2ebaafa140d3$export$2e2bcd8739ae039 = $020e2ebaafa140d3$var$values;

});


parcelRegister("eO2XQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac7808daade2acb2$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Takes a value and applies a function to it.
 *
 * This function is also known as the `thrush` combinator.
 *
 * @func
 * @memberOf R
 * @since v0.25.0
 * @category Function
 * @sig a -> (a -> b) -> b
 * @param {*} x The value
 * @param {Function} f The function to apply
 * @return {*} The result of applying `f` to `x`
 * @example
 *
 *      const t42 = R.applyTo(42);
 *      t42(R.identity); //=> 42
 *      t42(R.add(1)); //=> 43
 */ var $ac7808daade2acb2$var$applyTo = /*#__PURE__*/ (0, $7SxCN.default)(function applyTo(x, f) {
    return f(x);
});
var $ac7808daade2acb2$export$2e2bcd8739ae039 = $ac7808daade2acb2$var$applyTo;

});

parcelRegister("dNFxY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0c014520ff1521d$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      const byAge = R.ascend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByYoungestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $a0c014520ff1521d$var$ascend = /*#__PURE__*/ (0, $jS880.default)(function ascend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
});
var $a0c014520ff1521d$export$2e2bcd8739ae039 = $a0c014520ff1521d$var$ascend;

});

parcelRegister("ia2wh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d38b1d7ec30b4cc6$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var $d38b1d7ec30b4cc6$var$assoc = /*#__PURE__*/ (0, $jS880.default)(function assoc(prop, val, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
});
var $d38b1d7ec30b4cc6$export$2e2bcd8739ae039 = $d38b1d7ec30b4cc6$var$assoc;

});

parcelRegister("2xece", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d89aceb744d3614$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $bKOTe = parcelRequire("bKOTe");

var $3RBKV = parcelRequire("3RBKV");

var $1XKTG = parcelRequire("1XKTG");

var $ia2wh = parcelRequire("ia2wh");

var $1FHr3 = parcelRequire("1FHr3");
/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var $1d89aceb744d3614$var$assocPath = /*#__PURE__*/ (0, $jS880.default)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, $1FHr3.default)(obj) && (0, $bKOTe.default)(idx, obj) ? obj[idx] : (0, $1XKTG.default)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    if ((0, $1XKTG.default)(idx) && (0, $3RBKV.default)(obj)) {
        var arr = [].concat(obj);
        arr[idx] = val;
        return arr;
    } else return (0, $ia2wh.default)(idx, val, obj);
});
var $1d89aceb744d3614$export$2e2bcd8739ae039 = $1d89aceb744d3614$var$assocPath;

});
parcelRegister("1XKTG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16dfade75a60b17d$export$2e2bcd8739ae039; });
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $16dfade75a60b17d$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

});

parcelRegister("1FHr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $137b501e3ff61b75$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var $137b501e3ff61b75$var$isNil = /*#__PURE__*/ (0, $1t1xO.default)(function isNil(x) {
    return x == null;
});
var $137b501e3ff61b75$export$2e2bcd8739ae039 = $137b501e3ff61b75$var$isNil;

});


parcelRegister("6bPFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $481bda5e73a94543$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $51mxt = parcelRequire("51mxt");
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      const takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      const takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */ var $481bda5e73a94543$var$binary = /*#__PURE__*/ (0, $1t1xO.default)(function binary(fn) {
    return (0, $51mxt.default)(2, fn);
});
var $481bda5e73a94543$export$2e2bcd8739ae039 = $481bda5e73a94543$var$binary;

});
parcelRegister("51mxt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a7e87844ea63781$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      const takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */ var $3a7e87844ea63781$var$nAry = /*#__PURE__*/ (0, $7SxCN.default)(function nAry(n, fn) {
    switch(n){
        case 0:
            return function() {
                return fn.call(this);
            };
        case 1:
            return function(a0) {
                return fn.call(this, a0);
            };
        case 2:
            return function(a0, a1) {
                return fn.call(this, a0, a1);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.call(this, a0, a1, a2);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.call(this, a0, a1, a2, a3);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.call(this, a0, a1, a2, a3, a4);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.call(this, a0, a1, a2, a3, a4, a5);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            };
        default:
            throw new Error("First argument to nAry must be a non-negative integer no greater than ten");
    }
});
var $3a7e87844ea63781$export$2e2bcd8739ae039 = $3a7e87844ea63781$var$nAry;

});


parcelRegister("gi6wV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdc36488d7f1425c$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $73EUu = parcelRequire("73EUu");

var $jWdy6 = parcelRequire("jWdy6");

var $d2uSX = parcelRequire("d2uSX");
/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */ var $bdc36488d7f1425c$var$both = /*#__PURE__*/ (0, $7SxCN.default)(function both(f, g) {
    return (0, $73EUu.default)(f) ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
    } : (0, $d2uSX.default)((0, $jWdy6.default))(f, g);
});
var $bdc36488d7f1425c$export$2e2bcd8739ae039 = $bdc36488d7f1425c$var$both;

});
parcelRegister("73EUu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52388c18ea030e9e$export$2e2bcd8739ae039; });
function $52388c18ea030e9e$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Function]";
}

});

parcelRegister("d2uSX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97e36b70d21dd970$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $bWt4H = parcelRequire("bWt4H");
/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */ var $97e36b70d21dd970$var$lift = /*#__PURE__*/ (0, $1t1xO.default)(function lift(fn) {
    return (0, $bWt4H.default)(fn.length, fn);
});
var $97e36b70d21dd970$export$2e2bcd8739ae039 = $97e36b70d21dd970$var$lift;

});
parcelRegister("bWt4H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b1baa26315250af$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $kwaQ3 = parcelRequire("kwaQ3");

var $7C2CH = parcelRequire("7C2CH");

var $dB93a = parcelRequire("dB93a");

var $kuJWW = parcelRequire("kuJWW");
/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var $8b1baa26315250af$var$liftN = /*#__PURE__*/ (0, $7SxCN.default)(function liftN(arity, fn) {
    var lifted = (0, $dB93a.default)(arity, fn);
    return (0, $dB93a.default)(arity, function() {
        return (0, $kwaQ3.default)((0, $7C2CH.default), (0, $kuJWW.default)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
var $8b1baa26315250af$export$2e2bcd8739ae039 = $8b1baa26315250af$var$liftN;

});



parcelRegister("3QQ7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cdea76982142116$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      const format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var $2cdea76982142116$var$call = /*#__PURE__*/ (0, $iB6UK.default)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
var $2cdea76982142116$export$2e2bcd8739ae039 = $2cdea76982142116$var$call;

});
parcelRegister("iB6UK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8a10bb9a75db244$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $dB93a = parcelRequire("dB93a");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $d8a10bb9a75db244$var$curry = /*#__PURE__*/ (0, $1t1xO.default)(function curry(fn) {
    return (0, $dB93a.default)(fn.length, fn);
});
var $d8a10bb9a75db244$export$2e2bcd8739ae039 = $d8a10bb9a75db244$var$curry;

});


parcelRegister("5wd4K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $404a156d8184580f$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $91Beo = parcelRequire("91Beo");

var $bXb4D = parcelRequire("bXb4D");

var $kuJWW = parcelRequire("kuJWW");
/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var $404a156d8184580f$var$chain = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "fantasy-land/chain",
    "chain"
], (0, $bXb4D.default), function chain(fn, monad) {
    if (typeof monad === "function") return function(x) {
        return fn(monad(x))(x);
    };
    return (0, $91Beo.default)(false)((0, $kuJWW.default)(fn, monad));
}));
var $404a156d8184580f$export$2e2bcd8739ae039 = $404a156d8184580f$var$chain;

});
parcelRegister("91Beo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69211660636da41c$export$2e2bcd8739ae039; });

var $fl2xG = parcelRequire("fl2xG");
function $69211660636da41c$export$2e2bcd8739ae039(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, $fl2xG.default)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}

});

parcelRegister("bXb4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b3dcb6a0d2445ed$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $74t9q = parcelRequire("74t9q");

var $kuJWW = parcelRequire("kuJWW");
var $8b3dcb6a0d2445ed$var$_xchain = /*#__PURE__*/ (0, $7SxCN.default)(function _xchain(f, xf) {
    return (0, $kuJWW.default)(f, (0, $74t9q.default)(xf));
});
var $8b3dcb6a0d2445ed$export$2e2bcd8739ae039 = $8b3dcb6a0d2445ed$var$_xchain;

});
parcelRegister("74t9q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $525f84ee45c00ccb$export$2e2bcd8739ae039; });

var $nmNDK = parcelRequire("nmNDK");

var $fl2xG = parcelRequire("fl2xG");

var $kwaQ3 = parcelRequire("kwaQ3");

var $a6y2L = parcelRequire("a6y2L");
var $525f84ee45c00ccb$var$preservingReduced = function(xf) {
    return {
        "@@transducer/init": (0, $a6y2L.default).init,
        "@@transducer/result": function(result) {
            return xf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            var ret = xf["@@transducer/step"](result, input);
            return ret["@@transducer/reduced"] ? (0, $nmNDK.default)(ret) : ret;
        }
    };
};
var $525f84ee45c00ccb$var$_flatCat = function _xcat(xf) {
    var rxf = $525f84ee45c00ccb$var$preservingReduced(xf);
    return {
        "@@transducer/init": (0, $a6y2L.default).init,
        "@@transducer/result": function(result) {
            return rxf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            return !(0, $fl2xG.default)(input) ? (0, $kwaQ3.default)(rxf, result, [
                input
            ]) : (0, $kwaQ3.default)(rxf, result, input);
        }
    };
};
var $525f84ee45c00ccb$export$2e2bcd8739ae039 = $525f84ee45c00ccb$var$_flatCat;

});
parcelRegister("nmNDK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0463d5a1c2709be6$export$2e2bcd8739ae039; });
function $0463d5a1c2709be6$export$2e2bcd8739ae039(x) {
    return {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}

});




parcelRegister("3pfA9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27afcb26e2edec90$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */ var $27afcb26e2edec90$var$clamp = /*#__PURE__*/ (0, $jS880.default)(function clamp(min, max, value) {
    if (min > max) throw new Error("min must not be greater than max in clamp(min, max, value)");
    return value < min ? min : value > max ? max : value;
});
var $27afcb26e2edec90$export$2e2bcd8739ae039 = $27afcb26e2edec90$var$clamp;

});

parcelRegister("805u5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d3293da545595c4$export$2e2bcd8739ae039; });

var $l3PlA = parcelRequire("l3PlA");

var $1t1xO = parcelRequire("1t1xO");
/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var $5d3293da545595c4$var$clone = /*#__PURE__*/ (0, $1t1xO.default)(function clone(value) {
    return value != null && typeof value.clone === "function" ? value.clone() : (0, $l3PlA.default)(value, [], [], true);
});
var $5d3293da545595c4$export$2e2bcd8739ae039 = $5d3293da545595c4$var$clone;

});
parcelRegister("l3PlA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f551b53ecb369187$export$2e2bcd8739ae039; });

var $3Uy6P = parcelRequire("3Uy6P");

var $6wxQA = parcelRequire("6wxQA");
function $f551b53ecb369187$export$2e2bcd8739ae039(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
        var len = refFrom.length;
        var idx = 0;
        while(idx < len){
            if (value === refFrom[idx]) return refTo[idx];
            idx += 1;
        }
        refFrom[idx + 1] = value;
        refTo[idx + 1] = copiedValue;
        for(var key in value)copiedValue[key] = deep ? $f551b53ecb369187$export$2e2bcd8739ae039(value[key], refFrom, refTo, true) : value[key];
        return copiedValue;
    };
    switch((0, $6wxQA.default)(value)){
        case "Object":
            return copy({});
        case "Array":
            return copy([]);
        case "Date":
            return new Date(value.valueOf());
        case "RegExp":
            return (0, $3Uy6P.default)(value);
        default:
            return value;
    }
}

});
parcelRegister("3Uy6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d910f6d3e8cbb17$export$2e2bcd8739ae039; });
function $2d910f6d3e8cbb17$export$2e2bcd8739ae039(pattern) {
    return new RegExp(pattern.source, (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : ""));
}

});

parcelRegister("6wxQA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bfffc9135d5e302$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $4bfffc9135d5e302$var$type = /*#__PURE__*/ (0, $1t1xO.default)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var $4bfffc9135d5e302$export$2e2bcd8739ae039 = $4bfffc9135d5e302$var$type;

});



parcelRegister("1LQXj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14a34219769a9210$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $14a34219769a9210$var$comparator = /*#__PURE__*/ (0, $1t1xO.default)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
var $14a34219769a9210$export$2e2bcd8739ae039 = $14a34219769a9210$var$comparator;

});

parcelRegister("fm6cm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2ddb7f6dd218313$export$2e2bcd8739ae039; });

var $d2uSX = parcelRequire("d2uSX");

var $7WniO = parcelRequire("7WniO");
/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var $b2ddb7f6dd218313$var$complement = /*#__PURE__*/ (0, $d2uSX.default)((0, $7WniO.default));
var $b2ddb7f6dd218313$export$2e2bcd8739ae039 = $b2ddb7f6dd218313$var$complement;

});
parcelRegister("7WniO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c800688ba668440$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var $5c800688ba668440$var$not = /*#__PURE__*/ (0, $1t1xO.default)(function not(a) {
    return !a;
});
var $5c800688ba668440$export$2e2bcd8739ae039 = $5c800688ba668440$var$not;

});


parcelRegister("d8dol", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98f66900c8aaac5b$export$2e2bcd8739ae039; });

var $10F1K = parcelRequire("10F1K");

var $cSdZE = parcelRequire("cSdZE");
function $98f66900c8aaac5b$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("compose requires at least one argument");
    return (0, $10F1K.default).apply(this, (0, $cSdZE.default)(arguments));
}

});
parcelRegister("10F1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc59dad427e50d1$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $nSzOQ = parcelRequire("nSzOQ");

var $9Zbrv = parcelRequire("9Zbrv");

var $g0wyi = parcelRequire("g0wyi");
function $0bc59dad427e50d1$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return (0, $fTxyT.default)(arguments[0].length, (0, $9Zbrv.default)((0, $nSzOQ.default), arguments[0], (0, $g0wyi.default)(arguments)));
}

});
parcelRegister("nSzOQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $047c7be6062fb0ab$export$2e2bcd8739ae039; });
function $047c7be6062fb0ab$export$2e2bcd8739ae039(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}

});

parcelRegister("g0wyi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba75e59f86286cec$export$2e2bcd8739ae039; });

var $e4DWS = parcelRequire("e4DWS");

var $1t1xO = parcelRequire("1t1xO");

var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $ba75e59f86286cec$var$tail = /*#__PURE__*/ (0, $1t1xO.default)(/*#__PURE__*/ (0, $e4DWS.default)("tail", /*#__PURE__*/ (0, $5KOxr.default)(1, Infinity)));
var $ba75e59f86286cec$export$2e2bcd8739ae039 = $ba75e59f86286cec$var$tail;

});
parcelRegister("e4DWS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3f06d6355efa679$export$2e2bcd8739ae039; });

var $3RBKV = parcelRequire("3RBKV");
function $a3f06d6355efa679$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $3RBKV.default)(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

});

parcelRegister("5KOxr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4308737fb8a829dd$export$2e2bcd8739ae039; });

var $e4DWS = parcelRequire("e4DWS");

var $jS880 = parcelRequire("jS880");
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $4308737fb8a829dd$var$slice = /*#__PURE__*/ (0, $jS880.default)(/*#__PURE__*/ (0, $e4DWS.default)("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $4308737fb8a829dd$export$2e2bcd8739ae039 = $4308737fb8a829dd$var$slice;

});



parcelRegister("cSdZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95f561f65fac8c60$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $k2UUn = parcelRequire("k2UUn");
/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var $95f561f65fac8c60$var$reverse = /*#__PURE__*/ (0, $1t1xO.default)(function reverse(list) {
    return (0, $k2UUn.default)(list) ? list.split("").reverse().join("") : Array.prototype.slice.call(list, 0).reverse();
});
var $95f561f65fac8c60$export$2e2bcd8739ae039 = $95f561f65fac8c60$var$reverse;

});


parcelRegister("iVx4O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc7735313275e0ee$export$2e2bcd8739ae039; });

var $5wd4K = parcelRequire("5wd4K");

var $d8dol = parcelRequire("d8dol");

var $kuJWW = parcelRequire("kuJWW");
function $dc7735313275e0ee$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("composeK requires at least one argument");
    var init = Array.prototype.slice.call(arguments);
    var last = init.pop();
    return (0, $d8dol.default)((0, $d8dol.default).apply(this, (0, $kuJWW.default)((0, $5wd4K.default), init)), last);
}

});

parcelRegister("OHYL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0986c8ef131b4211$export$2e2bcd8739ae039; });

var $d71dy = parcelRequire("d71dy");

var $cSdZE = parcelRequire("cSdZE");
function $0986c8ef131b4211$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("composeP requires at least one argument");
    return (0, $d71dy.default).apply(this, (0, $cSdZE.default)(arguments));
}

});
parcelRegister("d71dy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98bcdf9e647e5f4d$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $fAwXk = parcelRequire("fAwXk");

var $9Zbrv = parcelRequire("9Zbrv");

var $g0wyi = parcelRequire("g0wyi");
function $98bcdf9e647e5f4d$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipeP requires at least one argument");
    return (0, $fTxyT.default)(arguments[0].length, (0, $9Zbrv.default)((0, $fAwXk.default), arguments[0], (0, $g0wyi.default)(arguments)));
}

});
parcelRegister("fAwXk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b593c82ed54e0a17$export$2e2bcd8739ae039; });
function $b593c82ed54e0a17$export$2e2bcd8739ae039(f, g) {
    return function() {
        var ctx = this;
        return f.apply(ctx, arguments).then(function(x) {
            return g.call(ctx, x);
        });
    };
}

});



parcelRegister("coMhf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $906d2cc7133e4a0e$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $598cz = parcelRequire("598cz");

var $cSdZE = parcelRequire("cSdZE");
/**
 * Performs right-to-left function composition using transforming function. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, f(i, ...args)))
 */ var $906d2cc7133e4a0e$var$composeWith = /*#__PURE__*/ (0, $7SxCN.default)(function composeWith(xf, list) {
    return (0, $598cz.default).apply(this, [
        xf,
        (0, $cSdZE.default)(list)
    ]);
});
var $906d2cc7133e4a0e$export$2e2bcd8739ae039 = $906d2cc7133e4a0e$var$composeWith;

});
parcelRegister("598cz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bf427b457b1043f$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $7SxCN = parcelRequire("7SxCN");

var $4C86y = parcelRequire("4C86y");

var $kwaQ3 = parcelRequire("kwaQ3");

var $g0wyi = parcelRequire("g0wyi");

var $6PHwe = parcelRequire("6PHwe");
/**
 * Performs left-to-right function composition using transforming function. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, f(g, ...args)))
 */ var $3bf427b457b1043f$var$pipeWith = /*#__PURE__*/ (0, $7SxCN.default)(function pipeWith(xf, list) {
    if (list.length <= 0) return 0, $6PHwe.default;
    var headList = (0, $4C86y.default)(list);
    var tailList = (0, $g0wyi.default)(list);
    return (0, $fTxyT.default)(headList.length, function() {
        return (0, $kwaQ3.default)(function(result, f) {
            return xf.call(this, f, result);
        }, headList.apply(this, arguments), tailList);
    });
});
var $3bf427b457b1043f$export$2e2bcd8739ae039 = $3bf427b457b1043f$var$pipeWith;

});
parcelRegister("4C86y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35c0ff6f91c4dae0$export$2e2bcd8739ae039; });

var $am2mP = parcelRequire("am2mP");
/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var $35c0ff6f91c4dae0$var$head = /*#__PURE__*/ (0, $am2mP.default)(0);
var $35c0ff6f91c4dae0$export$2e2bcd8739ae039 = $35c0ff6f91c4dae0$var$head;

});
parcelRegister("am2mP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $789dcb83ae130e07$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $k2UUn = parcelRequire("k2UUn");
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var $789dcb83ae130e07$var$nth = /*#__PURE__*/ (0, $7SxCN.default)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $k2UUn.default)(list) ? list.charAt(idx) : list[idx];
});
var $789dcb83ae130e07$export$2e2bcd8739ae039 = $789dcb83ae130e07$var$nth;

});


parcelRegister("6PHwe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f99436f72054941$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $kRggf = parcelRequire("kRggf");
/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var $4f99436f72054941$var$identity = /*#__PURE__*/ (0, $1t1xO.default)((0, $kRggf.default));
var $4f99436f72054941$export$2e2bcd8739ae039 = $4f99436f72054941$var$identity;

});
parcelRegister("kRggf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2f55f01782be410$export$2e2bcd8739ae039; });
function $f2f55f01782be410$export$2e2bcd8739ae039(x) {
    return x;
}

});




parcelRegister("g8SbF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc076d26ac1675e1$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $3RBKV = parcelRequire("3RBKV");

var $73EUu = parcelRequire("73EUu");

var $k2UUn = parcelRequire("k2UUn");

var $g2qM6 = parcelRequire("g2qM6");
/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var $bc076d26ac1675e1$var$concat = /*#__PURE__*/ (0, $7SxCN.default)(function concat(a, b) {
    if ((0, $3RBKV.default)(a)) {
        if ((0, $3RBKV.default)(b)) return a.concat(b);
        throw new TypeError((0, $g2qM6.default)(b) + " is not an array");
    }
    if ((0, $k2UUn.default)(a)) {
        if ((0, $k2UUn.default)(b)) return a + b;
        throw new TypeError((0, $g2qM6.default)(b) + " is not a string");
    }
    if (a != null && (0, $73EUu.default)(a["fantasy-land/concat"])) return a["fantasy-land/concat"](b);
    if (a != null && (0, $73EUu.default)(a.concat)) return a.concat(b);
    throw new TypeError((0, $g2qM6.default)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
var $bc076d26ac1675e1$export$2e2bcd8739ae039 = $bc076d26ac1675e1$var$concat;

});
parcelRegister("g2qM6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bad19a2637b95cc5$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $8n7mI = parcelRequire("8n7mI");
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var $bad19a2637b95cc5$var$toString = /*#__PURE__*/ (0, $1t1xO.default)(function toString(val) {
    return (0, $8n7mI.default)(val, []);
});
var $bad19a2637b95cc5$export$2e2bcd8739ae039 = $bad19a2637b95cc5$var$toString;

});
parcelRegister("8n7mI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61862f56e8e76c96$export$2e2bcd8739ae039; });

var $4f6Vj = parcelRequire("4f6Vj");

var $j5PpZ = parcelRequire("j5PpZ");

var $jL97B = parcelRequire("jL97B");

var $iPM3N = parcelRequire("iPM3N");

var $aD5Zr = parcelRequire("aD5Zr");

var $2m6Qn = parcelRequire("2m6Qn");
function $61862f56e8e76c96$export$2e2bcd8739ae039(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, $4f6Vj.default)(y, xs) ? "<Circular>" : $61862f56e8e76c96$export$2e2bcd8739ae039(y, xs);
    };
    //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, $j5PpZ.default)(function(k) {
            return (0, $jL97B.default)(k) + ": " + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + (0, $j5PpZ.default)(recur, x).join(", ") + "))";
        case "[object Array]":
            return "[" + (0, $j5PpZ.default)(recur, x).concat(mapPairs(x, (0, $2m6Qn.default)(function(k) {
                return /^\d+$/.test(k);
            }, (0, $aD5Zr.default)(x)))).join(", ") + "]";
        case "[object Boolean]":
            return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : (0, $jL97B.default)((0, $iPM3N.default)(x))) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
        case "[object String]":
            return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : (0, $jL97B.default)(x);
        case "[object Undefined]":
            return "undefined";
        default:
            if (typeof x.toString === "function") {
                var repr = x.toString();
                if (repr !== "[object Object]") return repr;
            }
            return "{" + mapPairs(x, (0, $aD5Zr.default)(x)).join(", ") + "}";
    }
}

});
parcelRegister("4f6Vj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $316deeff7459867f$export$2e2bcd8739ae039; });

var $cydSV = parcelRequire("cydSV");
function $316deeff7459867f$export$2e2bcd8739ae039(a, list) {
    return (0, $cydSV.default)(list, a, 0) >= 0;
}

});
parcelRegister("cydSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92336e3dbd59ce7b$export$2e2bcd8739ae039; });

var $g5jN3 = parcelRequire("g5jN3");
function $92336e3dbd59ce7b$export$2e2bcd8739ae039(list, a, idx) {
    var inf, item;
    // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === "function") switch(typeof a){
        case "number":
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === "number" && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            }
            // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case "string":
        case "boolean":
        case "function":
        case "undefined":
            return list.indexOf(a, idx);
        case "object":
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
    // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, $g5jN3.default)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}

});
parcelRegister("g5jN3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb5c76e6a1c0ede6$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $3FbHq = parcelRequire("3FbHq");
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $bb5c76e6a1c0ede6$var$equals = /*#__PURE__*/ (0, $7SxCN.default)(function equals(a, b) {
    return (0, $3FbHq.default)(a, b, [], []);
});
var $bb5c76e6a1c0ede6$export$2e2bcd8739ae039 = $bb5c76e6a1c0ede6$var$equals;

});
parcelRegister("3FbHq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aae46b50a5bf9ed$export$2e2bcd8739ae039; });

var $l8jvl = parcelRequire("l8jvl");

var $fzpVf = parcelRequire("fzpVf");

var $8Rqmh = parcelRequire("8Rqmh");

var $bKOTe = parcelRequire("bKOTe");

var $fDReJ = parcelRequire("fDReJ");

var $aD5Zr = parcelRequire("aD5Zr");

var $6wxQA = parcelRequire("6wxQA");
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $2aae46b50a5bf9ed$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $l8jvl.default)(aIterator);
    var b = (0, $l8jvl.default)(bIterator);
    function eq(_a, _b) {
        return $2aae46b50a5bf9ed$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    }
    // if *a* array contains any element that is not included in *b*
    return !(0, $fzpVf.default)(function(b, aItem) {
        return !(0, $fzpVf.default)(eq, aItem, b);
    }, b, a);
}
function $2aae46b50a5bf9ed$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $fDReJ.default)(a, b)) return true;
    var typeA = (0, $6wxQA.default)(a);
    if (typeA !== (0, $6wxQA.default)(b)) return false;
    if (a == null || b == null) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && (0, $8Rqmh.default)(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && (0, $fDReJ.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!(0, $fDReJ.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return $2aae46b50a5bf9ed$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return $2aae46b50a5bf9ed$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $aD5Zr.default)(a);
    if (keysA.length !== (0, $aD5Zr.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $bKOTe.default)(key, b) && $2aae46b50a5bf9ed$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

});
parcelRegister("l8jvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f629798414e95cd0$export$2e2bcd8739ae039; });
function $f629798414e95cd0$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

});

parcelRegister("fzpVf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b55e3b901f047f20$export$2e2bcd8739ae039; });
function $b55e3b901f047f20$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

});

parcelRegister("8Rqmh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6737b82bd7305540$export$2e2bcd8739ae039; });
function $6737b82bd7305540$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}

});

parcelRegister("fDReJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b633cb31cdb25bcb$export$2e2bcd8739ae039; });
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $b633cb31cdb25bcb$var$_objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var $b633cb31cdb25bcb$export$2e2bcd8739ae039 = typeof Object.is === "function" ? Object.is : $b633cb31cdb25bcb$var$_objectIs;

});





parcelRegister("jL97B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6297b7408cbabc0$export$2e2bcd8739ae039; });
function $e6297b7408cbabc0$export$2e2bcd8739ae039(s) {
    var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b") // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}

});

parcelRegister("iPM3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db62453296ddf01c$export$2e2bcd8739ae039; });
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var $db62453296ddf01c$var$pad = function pad(n) {
    return (n < 10 ? "0" : "") + n;
};
var $db62453296ddf01c$var$_toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + "-" + $db62453296ddf01c$var$pad(d.getUTCMonth() + 1) + "-" + $db62453296ddf01c$var$pad(d.getUTCDate()) + "T" + $db62453296ddf01c$var$pad(d.getUTCHours()) + ":" + $db62453296ddf01c$var$pad(d.getUTCMinutes()) + ":" + $db62453296ddf01c$var$pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + "Z";
};
var $db62453296ddf01c$export$2e2bcd8739ae039 = $db62453296ddf01c$var$_toISOString;

});

parcelRegister("2m6Qn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b72f1e2ce8a2a5c$export$2e2bcd8739ae039; });

var $2G1lM = parcelRequire("2G1lM");

var $7SxCN = parcelRequire("7SxCN");

var $r0sUa = parcelRequire("r0sUa");
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $1b72f1e2ce8a2a5c$var$reject = /*#__PURE__*/ (0, $7SxCN.default)(function reject(pred, filterable) {
    return (0, $r0sUa.default)((0, $2G1lM.default)(pred), filterable);
});
var $1b72f1e2ce8a2a5c$export$2e2bcd8739ae039 = $1b72f1e2ce8a2a5c$var$reject;

});
parcelRegister("2G1lM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f308d2c1fa8bdbd$export$2e2bcd8739ae039; });
function $1f308d2c1fa8bdbd$export$2e2bcd8739ae039(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}

});

parcelRegister("r0sUa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0512e21c9d88d410$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $dzixe = parcelRequire("dzixe");

var $89mmD = parcelRequire("89mmD");

var $kwaQ3 = parcelRequire("kwaQ3");

var $1jAoy = parcelRequire("1jAoy");

var $aD5Zr = parcelRequire("aD5Zr");
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $0512e21c9d88d410$var$filter = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "filter"
], (0, $1jAoy.default), function(pred, filterable) {
    return (0, $89mmD.default)(filterable) ? (0, $kwaQ3.default)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, $aD5Zr.default)(filterable)) : // else
    (0, $dzixe.default)(pred, filterable);
}));
var $0512e21c9d88d410$export$2e2bcd8739ae039 = $0512e21c9d88d410$var$filter;

});
parcelRegister("dzixe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e0cebe40b946a96$export$2e2bcd8739ae039; });
function $9e0cebe40b946a96$export$2e2bcd8739ae039(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("89mmD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ef083029079931f$export$2e2bcd8739ae039; });
function $5ef083029079931f$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}

});

parcelRegister("1jAoy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f53cc1d32387337$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $0f53cc1d32387337$var$XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XFilter.prototype["@@transducer/result"] = (0, $a6y2L.default).result;
    XFilter.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XFilter;
}();
var $0f53cc1d32387337$var$_xfilter = /*#__PURE__*/ (0, $7SxCN.default)(function _xfilter(f, xf) {
    return new $0f53cc1d32387337$var$XFilter(f, xf);
});
var $0f53cc1d32387337$export$2e2bcd8739ae039 = $0f53cc1d32387337$var$_xfilter;

});






parcelRegister("dixPr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ae7328027a816a6$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $1t1xO = parcelRequire("1t1xO");

var $kuJWW = parcelRequire("kuJWW");

var $8pKul = parcelRequire("8pKul");

var $9Zbrv = parcelRequire("9Zbrv");
/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var $9ae7328027a816a6$var$cond = /*#__PURE__*/ (0, $1t1xO.default)(function cond(pairs) {
    var arity = (0, $9Zbrv.default)((0, $8pKul.default), 0, (0, $kuJWW.default)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, $fTxyT.default)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
var $9ae7328027a816a6$export$2e2bcd8739ae039 = $9ae7328027a816a6$var$cond;

});

parcelRegister("4gCyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31b6909fdd42254a$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $j83TC = parcelRequire("j83TC");
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      const AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      const animalTypes = ["Lion", "Tiger", "Bear"];
 *      const animalSighting = R.invoker(0, 'sighting');
 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */ var $31b6909fdd42254a$var$construct = /*#__PURE__*/ (0, $1t1xO.default)(function construct(Fn) {
    return (0, $j83TC.default)(Fn.length, Fn);
});
var $31b6909fdd42254a$export$2e2bcd8739ae039 = $31b6909fdd42254a$var$construct;

});
parcelRegister("j83TC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ded1c958242888d8$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $iB6UK = parcelRequire("iB6UK");

var $51mxt = parcelRequire("51mxt");
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      const ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */ var $ded1c958242888d8$var$constructN = /*#__PURE__*/ (0, $7SxCN.default)(function constructN(n, Fn) {
    if (n > 10) throw new Error("Constructor with greater than ten arguments");
    if (n === 0) return function() {
        return new Fn();
    };
    return (0, $iB6UK.default)((0, $51mxt.default)(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
        switch(arguments.length){
            case 1:
                return new Fn($0);
            case 2:
                return new Fn($0, $1);
            case 3:
                return new Fn($0, $1, $2);
            case 4:
                return new Fn($0, $1, $2, $3);
            case 5:
                return new Fn($0, $1, $2, $3, $4);
            case 6:
                return new Fn($0, $1, $2, $3, $4, $5);
            case 7:
                return new Fn($0, $1, $2, $3, $4, $5, $6);
            case 8:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
            case 9:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
            case 10:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
        }
    }));
});
var $ded1c958242888d8$export$2e2bcd8739ae039 = $ded1c958242888d8$var$constructN;

});


parcelRegister("iIHod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da0dfe4dba3b612f$export$2e2bcd8739ae039; });

var $4f6Vj = parcelRequire("4f6Vj");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.includes
 * @deprecated since v0.26.0
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 *      R.contains('ba', 'banana'); //=>true
 */ var $da0dfe4dba3b612f$var$contains = /*#__PURE__*/ (0, $7SxCN.default)((0, $4f6Vj.default));
var $da0dfe4dba3b612f$export$2e2bcd8739ae039 = $da0dfe4dba3b612f$var$contains;

});

parcelRegister("6s1r9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b2678ecd0196288$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $j5PpZ = parcelRequire("j5PpZ");

var $dB93a = parcelRequire("dB93a");

var $8pKul = parcelRequire("8pKul");

var $2NZ7I = parcelRequire("2NZ7I");

var $9Zbrv = parcelRequire("9Zbrv");
/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var $4b2678ecd0196288$var$converge = /*#__PURE__*/ (0, $7SxCN.default)(function converge(after, fns) {
    return (0, $dB93a.default)((0, $9Zbrv.default)((0, $8pKul.default), 0, (0, $2NZ7I.default)("length", fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, $j5PpZ.default)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
var $4b2678ecd0196288$export$2e2bcd8739ae039 = $4b2678ecd0196288$var$converge;

});

parcelRegister("8MEAE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66524acae191e92a$export$2e2bcd8739ae039; });

var $6SR5o = parcelRequire("6SR5o");
/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var $66524acae191e92a$var$countBy = /*#__PURE__*/ (0, $6SR5o.default)(function(acc, elem) {
    return acc + 1;
}, 0);
var $66524acae191e92a$export$2e2bcd8739ae039 = $66524acae191e92a$var$countBy;

});
parcelRegister("6SR5o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5030f6fa9c4aba5d$export$2e2bcd8739ae039; });

var $7bssI = parcelRequire("7bssI");

var $jVVlM = parcelRequire("jVVlM");

var $bKOTe = parcelRequire("bKOTe");

var $kwaQ3 = parcelRequire("kwaQ3");

var $6dDEk = parcelRequire("6dDEk");
/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */ var $5030f6fa9c4aba5d$var$reduceBy = /*#__PURE__*/ (0, $7bssI.default)(4, [], /*#__PURE__*/ (0, $jVVlM.default)([], (0, $6dDEk.default), function reduceBy(valueFn, valueAcc, keyFn, list) {
    return (0, $kwaQ3.default)(function(acc, elt) {
        var key = keyFn(elt);
        acc[key] = valueFn((0, $bKOTe.default)(key, acc) ? acc[key] : valueAcc, elt);
        return acc;
    }, {}, list);
}));
var $5030f6fa9c4aba5d$export$2e2bcd8739ae039 = $5030f6fa9c4aba5d$var$reduceBy;

});
parcelRegister("6dDEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4872b68b3ceecede$export$2e2bcd8739ae039; });

var $7bssI = parcelRequire("7bssI");

var $bKOTe = parcelRequire("bKOTe");

var $a6y2L = parcelRequire("a6y2L");
var $4872b68b3ceecede$var$XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XReduceBy.prototype["@@transducer/result"] = function(result) {
        var key;
        for(key in this.inputs)if ((0, $bKOTe.default)(key, this.inputs)) {
            result = this.xf["@@transducer/step"](result, this.inputs[key]);
            if (result["@@transducer/reduced"]) {
                result = result["@@transducer/value"];
                break;
            }
        }
        this.inputs = null;
        return this.xf["@@transducer/result"](result);
    };
    XReduceBy.prototype["@@transducer/step"] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            this.valueAcc
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
var $4872b68b3ceecede$var$_xreduceBy = /*#__PURE__*/ (0, $7bssI.default)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
    return new $4872b68b3ceecede$var$XReduceBy(valueFn, valueAcc, keyFn, xf);
});
var $4872b68b3ceecede$export$2e2bcd8739ae039 = $4872b68b3ceecede$var$_xreduceBy;

});



parcelRegister("bSXWI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a733cded38a9e49$export$2e2bcd8739ae039; });

var $kC3eS = parcelRequire("kC3eS");
/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */ var $8a733cded38a9e49$var$dec = /*#__PURE__*/ (0, $kC3eS.default)(-1);
var $8a733cded38a9e49$export$2e2bcd8739ae039 = $8a733cded38a9e49$var$dec;

});

parcelRegister("iGZmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9bbbf3f37bc8daa$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var $d9bbbf3f37bc8daa$var$defaultTo = /*#__PURE__*/ (0, $7SxCN.default)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
var $d9bbbf3f37bc8daa$export$2e2bcd8739ae039 = $d9bbbf3f37bc8daa$var$defaultTo;

});

parcelRegister("4NHaj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37ed38c5bc90598d$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */ var $37ed38c5bc90598d$var$descend = /*#__PURE__*/ (0, $jS880.default)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
var $37ed38c5bc90598d$export$2e2bcd8739ae039 = $37ed38c5bc90598d$var$descend;

});

parcelRegister("7LULv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a88f499f8de57e0$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $bbz10 = parcelRequire("bbz10");
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var $5a88f499f8de57e0$var$difference = /*#__PURE__*/ (0, $7SxCN.default)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new (0, $bbz10.default)();
    for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
    while(idx < firstLen){
        if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
var $5a88f499f8de57e0$export$2e2bcd8739ae039 = $5a88f499f8de57e0$var$difference;

});
parcelRegister("bbz10", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $824be21b4d2b0b08$export$2e2bcd8739ae039; });

var $4f6Vj = parcelRequire("4f6Vj");
var $824be21b4d2b0b08$var$_Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === "function" ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !$824be21b4d2b0b08$var$hasOrAdd(item, true, this);
    };
    //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return $824be21b4d2b0b08$var$hasOrAdd(item, false, this);
    };
    //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function $824be21b4d2b0b08$var$hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch(type){
        case "string":
        case "number":
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items["-0"]) return true;
                else {
                    if (shouldAdd) set._items["-0"] = true;
                    return false;
                }
            }
            // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case "boolean":
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case "function":
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, $4f6Vj.default)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case "undefined":
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case "object":
            if (item === null) {
                if (!set._items["null"]) {
                    if (shouldAdd) set._items["null"] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            }
            // scan through all previously applied items
            if (!(0, $4f6Vj.default)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
}
var // A simple Set type that honours R.equals semantics
$824be21b4d2b0b08$export$2e2bcd8739ae039 = $824be21b4d2b0b08$var$_Set;

});


parcelRegister("2GKxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f539a638986d66f$export$2e2bcd8739ae039; });

var $fzpVf = parcelRequire("fzpVf");

var $jS880 = parcelRequire("jS880");
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */ var $1f539a638986d66f$var$differenceWith = /*#__PURE__*/ (0, $jS880.default)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, $fzpVf.default)(pred, first[idx], second) && !(0, $fzpVf.default)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
var $1f539a638986d66f$export$2e2bcd8739ae039 = $1f539a638986d66f$var$differenceWith;

});

parcelRegister("3Vwc5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dbfaafe7349f01f$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var $2dbfaafe7349f01f$var$dissoc = /*#__PURE__*/ (0, $7SxCN.default)(function dissoc(prop, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
});
var $2dbfaafe7349f01f$export$2e2bcd8739ae039 = $2dbfaafe7349f01f$var$dissoc;

});

parcelRegister("lVVvb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff7b86861b570ccd$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $1XKTG = parcelRequire("1XKTG");

var $3RBKV = parcelRequire("3RBKV");

var $ia2wh = parcelRequire("ia2wh");

var $3Vwc5 = parcelRequire("3Vwc5");

var $bGNEx = parcelRequire("bGNEx");

var $kgy7l = parcelRequire("kgy7l");
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var $ff7b86861b570ccd$var$dissocPath = /*#__PURE__*/ (0, $7SxCN.default)(function dissocPath(path, obj) {
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, $1XKTG.default)(path[0]) && (0, $3RBKV.default)(obj) ? (0, $bGNEx.default)(path[0], 1, obj) : (0, $3Vwc5.default)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return obj;
            else if ((0, $1XKTG.default)(head) && (0, $3RBKV.default)(obj)) return (0, $kgy7l.default)(head, dissocPath(tail, obj[head]), obj);
            else return (0, $ia2wh.default)(head, dissocPath(tail, obj[head]), obj);
    }
});
var $ff7b86861b570ccd$export$2e2bcd8739ae039 = $ff7b86861b570ccd$var$dissocPath;

});
parcelRegister("bGNEx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $882a21f30d217790$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var $882a21f30d217790$var$remove = /*#__PURE__*/ (0, $jS880.default)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
var $882a21f30d217790$export$2e2bcd8739ae039 = $882a21f30d217790$var$remove;

});

parcelRegister("kgy7l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec0fc44412296678$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $lHQV2 = parcelRequire("lHQV2");

var $cdVZD = parcelRequire("cdVZD");
/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var $ec0fc44412296678$var$update = /*#__PURE__*/ (0, $jS880.default)(function update(idx, x, list) {
    return (0, $lHQV2.default)(idx, (0, $cdVZD.default)(x), list);
});
var $ec0fc44412296678$export$2e2bcd8739ae039 = $ec0fc44412296678$var$update;

});


parcelRegister("drXm2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cabd68d1ebc95a5$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var $9cabd68d1ebc95a5$var$divide = /*#__PURE__*/ (0, $7SxCN.default)(function divide(a, b) {
    return a / b;
});
var $9cabd68d1ebc95a5$export$2e2bcd8739ae039 = $9cabd68d1ebc95a5$var$divide;

});

parcelRegister("lDPLu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc1564f0616b33f5$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $3GoDw = parcelRequire("3GoDw");

var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var $fc1564f0616b33f5$var$drop = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "drop"
], (0, $3GoDw.default), function drop(n, xs) {
    return (0, $5KOxr.default)(Math.max(0, n), Infinity, xs);
}));
var $fc1564f0616b33f5$export$2e2bcd8739ae039 = $fc1564f0616b33f5$var$drop;

});
parcelRegister("3GoDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ae8679dac435b42$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $2ae8679dac435b42$var$XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XDrop.prototype["@@transducer/result"] = (0, $a6y2L.default).result;
    XDrop.prototype["@@transducer/step"] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDrop;
}();
var $2ae8679dac435b42$var$_xdrop = /*#__PURE__*/ (0, $7SxCN.default)(function _xdrop(n, xf) {
    return new $2ae8679dac435b42$var$XDrop(n, xf);
});
var $2ae8679dac435b42$export$2e2bcd8739ae039 = $2ae8679dac435b42$var$_xdrop;

});


parcelRegister("kVl95", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3b9889469bc17a1$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $4q2zm = parcelRequire("4q2zm");

var $jQNGB = parcelRequire("jQNGB");
/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */ var $f3b9889469bc17a1$var$dropLast = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([], (0, $jQNGB.default), (0, $4q2zm.default)));
var $f3b9889469bc17a1$export$2e2bcd8739ae039 = $f3b9889469bc17a1$var$dropLast;

});
parcelRegister("4q2zm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $337b955319f04381$export$2e2bcd8739ae039; });

var $2NnQ3 = parcelRequire("2NnQ3");
function $337b955319f04381$export$2e2bcd8739ae039(n, xs) {
    return (0, $2NnQ3.default)(n < xs.length ? xs.length - n : 0, xs);
}

});
parcelRegister("2NnQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2092a6321d126114$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $893xf = parcelRequire("893xf");

var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var $2092a6321d126114$var$take = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "take"
], (0, $893xf.default), function take(n, xs) {
    return (0, $5KOxr.default)(0, n < 0 ? Infinity : n, xs);
}));
var $2092a6321d126114$export$2e2bcd8739ae039 = $2092a6321d126114$var$take;

});
parcelRegister("893xf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ee1e801e2e5e157$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $02x5o = parcelRequire("02x5o");

var $a6y2L = parcelRequire("a6y2L");
var $5ee1e801e2e5e157$var$XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XTake.prototype["@@transducer/result"] = (0, $a6y2L.default).result;
    XTake.prototype["@@transducer/step"] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf["@@transducer/step"](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, $02x5o.default)(ret) : ret;
    };
    return XTake;
}();
var $5ee1e801e2e5e157$var$_xtake = /*#__PURE__*/ (0, $7SxCN.default)(function _xtake(n, xf) {
    return new $5ee1e801e2e5e157$var$XTake(n, xf);
});
var $5ee1e801e2e5e157$export$2e2bcd8739ae039 = $5ee1e801e2e5e157$var$_xtake;

});



parcelRegister("jQNGB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7396a47af249d52$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $e7396a47af249d52$var$XDropLast = /*#__PURE__*/ function() {
    function XDropLast(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XDropLast.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XDropLast.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.full) result = this.xf["@@transducer/step"](result, this.acc[this.pos]);
        this.store(input);
        return result;
    };
    XDropLast.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    return XDropLast;
}();
var $e7396a47af249d52$var$_xdropLast = /*#__PURE__*/ (0, $7SxCN.default)(function _xdropLast(n, xf) {
    return new $e7396a47af249d52$var$XDropLast(n, xf);
});
var $e7396a47af249d52$export$2e2bcd8739ae039 = $e7396a47af249d52$var$_xdropLast;

});


parcelRegister("bY7W0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b6b73f6399d6de4$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $8NDVH = parcelRequire("8NDVH");

var $bJNSl = parcelRequire("bJNSl");
/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */ var $8b6b73f6399d6de4$var$dropLastWhile = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([], (0, $bJNSl.default), (0, $8NDVH.default)));
var $8b6b73f6399d6de4$export$2e2bcd8739ae039 = $8b6b73f6399d6de4$var$dropLastWhile;

});
parcelRegister("8NDVH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6681df887f936cad$export$2e2bcd8739ae039; });

var $5KOxr = parcelRequire("5KOxr");
function $6681df887f936cad$export$2e2bcd8739ae039(pred, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && pred(xs[idx]))idx -= 1;
    return (0, $5KOxr.default)(0, idx + 1, xs);
}

});

parcelRegister("bJNSl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88ba95f0aa909cee$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $kwaQ3 = parcelRequire("kwaQ3");

var $a6y2L = parcelRequire("a6y2L");
var $88ba95f0aa909cee$var$XDropLastWhile = /*#__PURE__*/ function() {
    function XDropLastWhile(fn, xf) {
        this.f = fn;
        this.retained = [];
        this.xf = xf;
    }
    XDropLastWhile.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XDropLastWhile.prototype["@@transducer/result"] = function(result) {
        this.retained = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLastWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.retain(result, input) : this.flush(result, input);
    };
    XDropLastWhile.prototype.flush = function(result, input) {
        result = (0, $kwaQ3.default)(this.xf["@@transducer/step"], result, this.retained);
        this.retained = [];
        return this.xf["@@transducer/step"](result, input);
    };
    XDropLastWhile.prototype.retain = function(result, input) {
        this.retained.push(input);
        return result;
    };
    return XDropLastWhile;
}();
var $88ba95f0aa909cee$var$_xdropLastWhile = /*#__PURE__*/ (0, $7SxCN.default)(function _xdropLastWhile(fn, xf) {
    return new $88ba95f0aa909cee$var$XDropLastWhile(fn, xf);
});
var $88ba95f0aa909cee$export$2e2bcd8739ae039 = $88ba95f0aa909cee$var$_xdropLastWhile;

});


parcelRegister("pPH2r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04da6f19b34d18b2$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $jVVlM = parcelRequire("jVVlM");

var $31B0C = parcelRequire("31B0C");

var $vn7Nf = parcelRequire("vn7Nf");

var $g5jN3 = parcelRequire("g5jN3");
/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */ var $04da6f19b34d18b2$var$dropRepeats = /*#__PURE__*/ (0, $1t1xO.default)(/*#__PURE__*/ (0, $jVVlM.default)([], /*#__PURE__*/ (0, $31B0C.default)((0, $g5jN3.default)), /*#__PURE__*/ (0, $vn7Nf.default)((0, $g5jN3.default))));
var $04da6f19b34d18b2$export$2e2bcd8739ae039 = $04da6f19b34d18b2$var$dropRepeats;

});
parcelRegister("31B0C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $233e2c4a9cb334d0$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $233e2c4a9cb334d0$var$XDropRepeatsWith = /*#__PURE__*/ function() {
    function XDropRepeatsWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.lastValue = undefined;
        this.seenFirstValue = false;
    }
    XDropRepeatsWith.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XDropRepeatsWith.prototype["@@transducer/result"] = (0, $a6y2L.default).result;
    XDropRepeatsWith.prototype["@@transducer/step"] = function(result, input) {
        var sameAsLast = false;
        if (!this.seenFirstValue) this.seenFirstValue = true;
        else if (this.pred(this.lastValue, input)) sameAsLast = true;
        this.lastValue = input;
        return sameAsLast ? result : this.xf["@@transducer/step"](result, input);
    };
    return XDropRepeatsWith;
}();
var $233e2c4a9cb334d0$var$_xdropRepeatsWith = /*#__PURE__*/ (0, $7SxCN.default)(function _xdropRepeatsWith(pred, xf) {
    return new $233e2c4a9cb334d0$var$XDropRepeatsWith(pred, xf);
});
var $233e2c4a9cb334d0$export$2e2bcd8739ae039 = $233e2c4a9cb334d0$var$_xdropRepeatsWith;

});

parcelRegister("vn7Nf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05e4d572be1db82f$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $31B0C = parcelRequire("31B0C");

var $6uiOQ = parcelRequire("6uiOQ");
/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */ var $05e4d572be1db82f$var$dropRepeatsWith = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([], (0, $31B0C.default), function dropRepeatsWith(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
        result[0] = list[0];
        while(idx < len){
            if (!pred((0, $6uiOQ.default)(result), list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
    }
    return result;
}));
var $05e4d572be1db82f$export$2e2bcd8739ae039 = $05e4d572be1db82f$var$dropRepeatsWith;

});
parcelRegister("6uiOQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b94247aa033ec20$export$2e2bcd8739ae039; });

var $am2mP = parcelRequire("am2mP");
/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var $4b94247aa033ec20$var$last = /*#__PURE__*/ (0, $am2mP.default)(-1);
var $4b94247aa033ec20$export$2e2bcd8739ae039 = $4b94247aa033ec20$var$last;

});



parcelRegister("7lWY7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a83c85ebb36cf2$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $gbOgl = parcelRequire("gbOgl");

var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */ var $55a83c85ebb36cf2$var$dropWhile = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "dropWhile"
], (0, $gbOgl.default), function dropWhile(pred, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && pred(xs[idx]))idx += 1;
    return (0, $5KOxr.default)(idx, Infinity, xs);
}));
var $55a83c85ebb36cf2$export$2e2bcd8739ae039 = $55a83c85ebb36cf2$var$dropWhile;

});
parcelRegister("gbOgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc94a98b8e335be7$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $bc94a98b8e335be7$var$XDropWhile = /*#__PURE__*/ function() {
    function XDropWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XDropWhile.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XDropWhile.prototype["@@transducer/result"] = (0, $a6y2L.default).result;
    XDropWhile.prototype["@@transducer/step"] = function(result, input) {
        if (this.f) {
            if (this.f(input)) return result;
            this.f = null;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDropWhile;
}();
var $bc94a98b8e335be7$var$_xdropWhile = /*#__PURE__*/ (0, $7SxCN.default)(function _xdropWhile(f, xf) {
    return new $bc94a98b8e335be7$var$XDropWhile(f, xf);
});
var $bc94a98b8e335be7$export$2e2bcd8739ae039 = $bc94a98b8e335be7$var$_xdropWhile;

});


parcelRegister("3j7JT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2689264ba6e1f423$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $73EUu = parcelRequire("73EUu");

var $d2uSX = parcelRequire("d2uSX");

var $hDBEN = parcelRequire("hDBEN");
/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */ var $2689264ba6e1f423$var$either = /*#__PURE__*/ (0, $7SxCN.default)(function either(f, g) {
    return (0, $73EUu.default)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, $d2uSX.default)((0, $hDBEN.default))(f, g);
});
var $2689264ba6e1f423$export$2e2bcd8739ae039 = $2689264ba6e1f423$var$either;

});
parcelRegister("hDBEN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd734a16b38a9022$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var $cd734a16b38a9022$var$or = /*#__PURE__*/ (0, $7SxCN.default)(function or(a, b) {
    return a || b;
});
var $cd734a16b38a9022$export$2e2bcd8739ae039 = $cd734a16b38a9022$var$or;

});


parcelRegister("cRpaA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95cdf578cb9f0fb4$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $4Xe8k = parcelRequire("4Xe8k");

var $3RBKV = parcelRequire("3RBKV");

var $89mmD = parcelRequire("89mmD");

var $k2UUn = parcelRequire("k2UUn");
/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */ var $95cdf578cb9f0fb4$var$empty = /*#__PURE__*/ (0, $1t1xO.default)(function empty(x) {
    return x != null && typeof x["fantasy-land/empty"] === "function" ? x["fantasy-land/empty"]() : x != null && x.constructor != null && typeof x.constructor["fantasy-land/empty"] === "function" ? x.constructor["fantasy-land/empty"]() : x != null && typeof x.empty === "function" ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === "function" ? x.constructor.empty() : (0, $3RBKV.default)(x) ? [] : (0, $k2UUn.default)(x) ? "" : (0, $89mmD.default)(x) ? {} : (0, $4Xe8k.default)(x) ? function() {
        return arguments;
    }() : void 0 // else
    ;
});
var $95cdf578cb9f0fb4$export$2e2bcd8739ae039 = $95cdf578cb9f0fb4$var$empty;

});

parcelRegister("7PbZc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b269805945f9106$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $g5jN3 = parcelRequire("g5jN3");

var $cwLO0 = parcelRequire("cwLO0");
/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $5b269805945f9106$var$endsWith = /*#__PURE__*/ (0, $7SxCN.default)(function(suffix, list) {
    return (0, $g5jN3.default)((0, $cwLO0.default)(suffix.length, list), suffix);
});
var $5b269805945f9106$export$2e2bcd8739ae039 = $5b269805945f9106$var$endsWith;

});
parcelRegister("cwLO0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91ed8e6648f9796f$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $lDPLu = parcelRequire("lDPLu");
/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var $91ed8e6648f9796f$var$takeLast = /*#__PURE__*/ (0, $7SxCN.default)(function takeLast(n, xs) {
    return (0, $lDPLu.default)(n >= 0 ? xs.length - n : 0, xs);
});
var $91ed8e6648f9796f$export$2e2bcd8739ae039 = $91ed8e6648f9796f$var$takeLast;

});


parcelRegister("j3Zb9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de0dc0fdc2fca6b0$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $g5jN3 = parcelRequire("g5jN3");
/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */ var $de0dc0fdc2fca6b0$var$eqBy = /*#__PURE__*/ (0, $jS880.default)(function eqBy(f, x, y) {
    return (0, $g5jN3.default)(f(x), f(y));
});
var $de0dc0fdc2fca6b0$export$2e2bcd8739ae039 = $de0dc0fdc2fca6b0$var$eqBy;

});

parcelRegister("jT0Gm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7a3aede200ee572$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $g5jN3 = parcelRequire("g5jN3");
/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var $e7a3aede200ee572$var$eqProps = /*#__PURE__*/ (0, $jS880.default)(function eqProps(prop, obj1, obj2) {
    return (0, $g5jN3.default)(obj1[prop], obj2[prop]);
});
var $e7a3aede200ee572$export$2e2bcd8739ae039 = $e7a3aede200ee572$var$eqProps;

});

parcelRegister("674jx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4736be36c022d5fa$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var $4736be36c022d5fa$var$evolve = /*#__PURE__*/ (0, $7SxCN.default)(function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === "function" ? transformation(object[key]) : transformation && type === "object" ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
var $4736be36c022d5fa$export$2e2bcd8739ae039 = $4736be36c022d5fa$var$evolve;

});

parcelRegister("gkBGB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be3bbf4aff7ab2d2$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $71yPq = parcelRequire("71yPq");
/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var $be3bbf4aff7ab2d2$var$find = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "find"
], (0, $71yPq.default), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
var $be3bbf4aff7ab2d2$export$2e2bcd8739ae039 = $be3bbf4aff7ab2d2$var$find;

});
parcelRegister("71yPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51d3a49480b820d4$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $02x5o = parcelRequire("02x5o");

var $a6y2L = parcelRequire("a6y2L");
var $51d3a49480b820d4$var$XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XFind.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, void 0);
        return this.xf["@@transducer/result"](result);
    };
    XFind.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, $02x5o.default)(this.xf["@@transducer/step"](result, input));
        }
        return result;
    };
    return XFind;
}();
var $51d3a49480b820d4$var$_xfind = /*#__PURE__*/ (0, $7SxCN.default)(function _xfind(f, xf) {
    return new $51d3a49480b820d4$var$XFind(f, xf);
});
var $51d3a49480b820d4$export$2e2bcd8739ae039 = $51d3a49480b820d4$var$_xfind;

});


parcelRegister("3jqGz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2697d8ac56f54dea$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $exhGS = parcelRequire("exhGS");
/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $2697d8ac56f54dea$var$findIndex = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([], (0, $exhGS.default), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
var $2697d8ac56f54dea$export$2e2bcd8739ae039 = $2697d8ac56f54dea$var$findIndex;

});
parcelRegister("exhGS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a951dec0f6f8924c$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $02x5o = parcelRequire("02x5o");

var $a6y2L = parcelRequire("a6y2L");
var $a951dec0f6f8924c$var$XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XFindIndex.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, -1);
        return this.xf["@@transducer/result"](result);
    };
    XFindIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, $02x5o.default)(this.xf["@@transducer/step"](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
var $a951dec0f6f8924c$var$_xfindIndex = /*#__PURE__*/ (0, $7SxCN.default)(function _xfindIndex(f, xf) {
    return new $a951dec0f6f8924c$var$XFindIndex(f, xf);
});
var $a951dec0f6f8924c$export$2e2bcd8739ae039 = $a951dec0f6f8924c$var$_xfindIndex;

});


parcelRegister("jxRbq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3aa5a79a55b640e$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $3PQBm = parcelRequire("3PQBm");
/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var $e3aa5a79a55b640e$var$findLast = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([], (0, $3PQBm.default), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
var $e3aa5a79a55b640e$export$2e2bcd8739ae039 = $e3aa5a79a55b640e$var$findLast;

});
parcelRegister("3PQBm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2caef016d72a3a6d$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $2caef016d72a3a6d$var$XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XFindLast.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.last));
    };
    XFindLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
var $2caef016d72a3a6d$var$_xfindLast = /*#__PURE__*/ (0, $7SxCN.default)(function _xfindLast(f, xf) {
    return new $2caef016d72a3a6d$var$XFindLast(f, xf);
});
var $2caef016d72a3a6d$export$2e2bcd8739ae039 = $2caef016d72a3a6d$var$_xfindLast;

});


parcelRegister("iYCjF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd0b8d656563e33d$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $2kgc4 = parcelRequire("2kgc4");
/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $dd0b8d656563e33d$var$findLastIndex = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([], (0, $2kgc4.default), function findLastIndex(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return idx;
        idx -= 1;
    }
    return -1;
}));
var $dd0b8d656563e33d$export$2e2bcd8739ae039 = $dd0b8d656563e33d$var$findLastIndex;

});
parcelRegister("2kgc4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b1a02be44277aa2$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $1b1a02be44277aa2$var$XFindLastIndex = /*#__PURE__*/ function() {
    function XFindLastIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.lastIdx = -1;
    }
    XFindLastIndex.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XFindLastIndex.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.lastIdx));
    };
    XFindLastIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) this.lastIdx = this.idx;
        return result;
    };
    return XFindLastIndex;
}();
var $1b1a02be44277aa2$var$_xfindLastIndex = /*#__PURE__*/ (0, $7SxCN.default)(function _xfindLastIndex(f, xf) {
    return new $1b1a02be44277aa2$var$XFindLastIndex(f, xf);
});
var $1b1a02be44277aa2$export$2e2bcd8739ae039 = $1b1a02be44277aa2$var$_xfindLastIndex;

});


parcelRegister("kOgyX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2655336c8f34f07$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $91Beo = parcelRequire("91Beo");
/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var $f2655336c8f34f07$var$flatten = /*#__PURE__*/ (0, $1t1xO.default)(/*#__PURE__*/ (0, $91Beo.default)(true));
var $f2655336c8f34f07$export$2e2bcd8739ae039 = $f2655336c8f34f07$var$flatten;

});

parcelRegister("d071Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9770ba9f27278ec2$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $dB93a = parcelRequire("dB93a");
/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var $9770ba9f27278ec2$var$flip = /*#__PURE__*/ (0, $1t1xO.default)(function flip(fn) {
    return (0, $dB93a.default)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
var $9770ba9f27278ec2$export$2e2bcd8739ae039 = $9770ba9f27278ec2$var$flip;

});

parcelRegister("5ANkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $412695138084de1b$export$2e2bcd8739ae039; });

var $e4DWS = parcelRequire("e4DWS");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */ var $412695138084de1b$var$forEach = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $e4DWS.default)("forEach", function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while(idx < len){
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
var $412695138084de1b$export$2e2bcd8739ae039 = $412695138084de1b$var$forEach;

});

parcelRegister("g6nS1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8fb90afb79b8ce$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $aD5Zr = parcelRequire("aD5Zr");
/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var $bb8fb90afb79b8ce$var$forEachObjIndexed = /*#__PURE__*/ (0, $7SxCN.default)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, $aD5Zr.default)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
var $bb8fb90afb79b8ce$export$2e2bcd8739ae039 = $bb8fb90afb79b8ce$var$forEachObjIndexed;

});

parcelRegister("cxJv1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $921bdc4e1290d437$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var $921bdc4e1290d437$var$fromPairs = /*#__PURE__*/ (0, $1t1xO.default)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
var $921bdc4e1290d437$export$2e2bcd8739ae039 = $921bdc4e1290d437$var$fromPairs;

});

parcelRegister("3FNE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2acbb5ba886412c5$export$2e2bcd8739ae039; });

var $e4DWS = parcelRequire("e4DWS");

var $7SxCN = parcelRequire("7SxCN");

var $6SR5o = parcelRequire("6SR5o");
/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var $2acbb5ba886412c5$var$groupBy = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $e4DWS.default)("groupBy", /*#__PURE__*/ (0, $6SR5o.default)(function(acc, item) {
    if (acc == null) acc = [];
    acc.push(item);
    return acc;
}, null)));
var $2acbb5ba886412c5$export$2e2bcd8739ae039 = $2acbb5ba886412c5$var$groupBy;

});

parcelRegister("jLKIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e646a66ad5024e63$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */ var $e646a66ad5024e63$var$groupWith = /*#__PURE__*/ (0, $7SxCN.default)(function(fn, list) {
    var res = [];
    var idx = 0;
    var len = list.length;
    while(idx < len){
        var nextidx = idx + 1;
        while(nextidx < len && fn(list[nextidx - 1], list[nextidx]))nextidx += 1;
        res.push(list.slice(idx, nextidx));
        idx = nextidx;
    }
    return res;
});
var $e646a66ad5024e63$export$2e2bcd8739ae039 = $e646a66ad5024e63$var$groupWith;

});

parcelRegister("eiA2o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a68eb37395bf8a47$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var $a68eb37395bf8a47$var$gt = /*#__PURE__*/ (0, $7SxCN.default)(function gt(a, b) {
    return a > b;
});
var $a68eb37395bf8a47$export$2e2bcd8739ae039 = $a68eb37395bf8a47$var$gt;

});

parcelRegister("lDBZe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc0ab4d0c9bb36a2$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */ var $fc0ab4d0c9bb36a2$var$gte = /*#__PURE__*/ (0, $7SxCN.default)(function gte(a, b) {
    return a >= b;
});
var $fc0ab4d0c9bb36a2$export$2e2bcd8739ae039 = $fc0ab4d0c9bb36a2$var$gte;

});

parcelRegister("aTDBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eedc28b5553776a$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $cIL3W = parcelRequire("cIL3W");
/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var $7eedc28b5553776a$var$has = /*#__PURE__*/ (0, $7SxCN.default)(function has(prop, obj) {
    return (0, $cIL3W.default)([
        prop
    ], obj);
});
var $7eedc28b5553776a$export$2e2bcd8739ae039 = $7eedc28b5553776a$var$has;

});
parcelRegister("cIL3W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $942e19c048314e84$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $bKOTe = parcelRequire("bKOTe");
/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var $942e19c048314e84$var$hasPath = /*#__PURE__*/ (0, $7SxCN.default)(function hasPath(_path, obj) {
    if (_path.length === 0) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if ((0, $bKOTe.default)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
var $942e19c048314e84$export$2e2bcd8739ae039 = $942e19c048314e84$var$hasPath;

});


parcelRegister("j9bAE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df07d922b0ca7e8d$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      const square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */ var $df07d922b0ca7e8d$var$hasIn = /*#__PURE__*/ (0, $7SxCN.default)(function hasIn(prop, obj) {
    return prop in obj;
});
var $df07d922b0ca7e8d$export$2e2bcd8739ae039 = $df07d922b0ca7e8d$var$hasIn;

});

parcelRegister("felhC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b168ac3dde7a08d5$export$2e2bcd8739ae039; });

var $fDReJ = parcelRequire("fDReJ");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var $b168ac3dde7a08d5$var$identical = /*#__PURE__*/ (0, $7SxCN.default)((0, $fDReJ.default));
var $b168ac3dde7a08d5$export$2e2bcd8739ae039 = $b168ac3dde7a08d5$var$identical;

});

parcelRegister("6Ocs1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f511211afc19273$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $dB93a = parcelRequire("dB93a");
/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */ var $4f511211afc19273$var$ifElse = /*#__PURE__*/ (0, $jS880.default)(function ifElse(condition, onTrue, onFalse) {
    return (0, $dB93a.default)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
var $4f511211afc19273$export$2e2bcd8739ae039 = $4f511211afc19273$var$ifElse;

});

parcelRegister("6TjHh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5047288a248076ae$export$2e2bcd8739ae039; });

var $kC3eS = parcelRequire("kC3eS");
/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */ var $5047288a248076ae$var$inc = /*#__PURE__*/ (0, $kC3eS.default)(1);
var $5047288a248076ae$export$2e2bcd8739ae039 = $5047288a248076ae$var$inc;

});

parcelRegister("fM2wD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7bd4c38b1277e60$export$2e2bcd8739ae039; });

var $4f6Vj = parcelRequire("4f6Vj");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */ var $b7bd4c38b1277e60$var$includes = /*#__PURE__*/ (0, $7SxCN.default)((0, $4f6Vj.default));
var $b7bd4c38b1277e60$export$2e2bcd8739ae039 = $b7bd4c38b1277e60$var$includes;

});

parcelRegister("7gakV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54920ba89edae26a$export$2e2bcd8739ae039; });

var $6SR5o = parcelRequire("6SR5o");
/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var $54920ba89edae26a$var$indexBy = /*#__PURE__*/ (0, $6SR5o.default)(function(acc, elem) {
    return elem;
}, null);
var $54920ba89edae26a$export$2e2bcd8739ae039 = $54920ba89edae26a$var$indexBy;

});

parcelRegister("fziiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b558519782f8d23d$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $cydSV = parcelRequire("cydSV");

var $3RBKV = parcelRequire("3RBKV");
/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */ var $b558519782f8d23d$var$indexOf = /*#__PURE__*/ (0, $7SxCN.default)(function indexOf(target, xs) {
    return typeof xs.indexOf === "function" && !(0, $3RBKV.default)(xs) ? xs.indexOf(target) : (0, $cydSV.default)(xs, target, 0);
});
var $b558519782f8d23d$export$2e2bcd8739ae039 = $b558519782f8d23d$var$indexOf;

});

parcelRegister("km41b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed18faa229c71b72$export$2e2bcd8739ae039; });

var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */ var $ed18faa229c71b72$var$init = /*#__PURE__*/ (0, $5KOxr.default)(0, -1);
var $ed18faa229c71b72$export$2e2bcd8739ae039 = $ed18faa229c71b72$var$init;

});

parcelRegister("6stXh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b3c9813342c99ff$export$2e2bcd8739ae039; });

var $fzpVf = parcelRequire("fzpVf");

var $jS880 = parcelRequire("jS880");

var $dzixe = parcelRequire("dzixe");
/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */ var $4b3c9813342c99ff$var$innerJoin = /*#__PURE__*/ (0, $jS880.default)(function innerJoin(pred, xs, ys) {
    return (0, $dzixe.default)(function(x) {
        return (0, $fzpVf.default)(pred, x, ys);
    }, xs);
});
var $4b3c9813342c99ff$export$2e2bcd8739ae039 = $4b3c9813342c99ff$var$innerJoin;

});

parcelRegister("8DoXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6495545f3e2168b4$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var $6495545f3e2168b4$var$insert = /*#__PURE__*/ (0, $jS880.default)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
var $6495545f3e2168b4$export$2e2bcd8739ae039 = $6495545f3e2168b4$var$insert;

});

parcelRegister("jXRj8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e88ce0cce4c54ba9$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var $e88ce0cce4c54ba9$var$insertAll = /*#__PURE__*/ (0, $jS880.default)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
var $e88ce0cce4c54ba9$export$2e2bcd8739ae039 = $e88ce0cce4c54ba9$var$insertAll;

});

parcelRegister("jwOLA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e37862a4003e0682$export$2e2bcd8739ae039; });

var $4f6Vj = parcelRequire("4f6Vj");

var $7SxCN = parcelRequire("7SxCN");

var $dzixe = parcelRequire("dzixe");

var $d071Y = parcelRequire("d071Y");

var $7bi4H = parcelRequire("7bi4H");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var $e37862a4003e0682$var$intersection = /*#__PURE__*/ (0, $7SxCN.default)(function intersection(list1, list2) {
    var lookupList, filteredList;
    if (list1.length > list2.length) {
        lookupList = list1;
        filteredList = list2;
    } else {
        lookupList = list2;
        filteredList = list1;
    }
    return (0, $7bi4H.default)((0, $dzixe.default)((0, $d071Y.default)((0, $4f6Vj.default))(lookupList), filteredList));
});
var $e37862a4003e0682$export$2e2bcd8739ae039 = $e37862a4003e0682$var$intersection;

});
parcelRegister("7bi4H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53a794c0ca314ed5$export$2e2bcd8739ae039; });

var $6PHwe = parcelRequire("6PHwe");

var $bO5h9 = parcelRequire("bO5h9");
/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var $53a794c0ca314ed5$var$uniq = /*#__PURE__*/ (0, $bO5h9.default)((0, $6PHwe.default));
var $53a794c0ca314ed5$export$2e2bcd8739ae039 = $53a794c0ca314ed5$var$uniq;

});
parcelRegister("bO5h9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $898874da84038705$export$2e2bcd8739ae039; });

var $bbz10 = parcelRequire("bbz10");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var $898874da84038705$var$uniqBy = /*#__PURE__*/ (0, $7SxCN.default)(function uniqBy(fn, list) {
    var set = new (0, $bbz10.default)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
});
var $898874da84038705$export$2e2bcd8739ae039 = $898874da84038705$var$uniqBy;

});



parcelRegister("goatN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bee7044035d44079$export$2e2bcd8739ae039; });

var $e4DWS = parcelRequire("e4DWS");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var $bee7044035d44079$var$intersperse = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $e4DWS.default)("intersperse", function intersperse(separator, list) {
    var out = [];
    var idx = 0;
    var length = list.length;
    while(idx < length){
        if (idx === length - 1) out.push(list[idx]);
        else out.push(list[idx], separator);
        idx += 1;
    }
    return out;
}));
var $bee7044035d44079$export$2e2bcd8739ae039 = $bee7044035d44079$var$intersperse;

});

parcelRegister("hj43t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9975b3e1b9eb8d4$export$2e2bcd8739ae039; });

var $l3PlA = parcelRequire("l3PlA");

var $jS880 = parcelRequire("jS880");

var $ljSpW = parcelRequire("ljSpW");

var $kwaQ3 = parcelRequire("kwaQ3");

var $kemfV = parcelRequire("kemfV");
/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */ var $c9975b3e1b9eb8d4$var$into = /*#__PURE__*/ (0, $jS880.default)(function into(acc, xf, list) {
    return (0, $ljSpW.default)(acc) ? (0, $kwaQ3.default)(xf(acc), acc["@@transducer/init"](), list) : (0, $kwaQ3.default)(xf((0, $kemfV.default)(acc)), (0, $l3PlA.default)(acc, [], [], false), list);
});
var $c9975b3e1b9eb8d4$export$2e2bcd8739ae039 = $c9975b3e1b9eb8d4$var$into;

});
parcelRegister("kemfV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eba66104026c7e04$export$2e2bcd8739ae039; });

var $aLSlk = parcelRequire("aLSlk");

var $kRggf = parcelRequire("kRggf");

var $fl2xG = parcelRequire("fl2xG");

var $ljSpW = parcelRequire("ljSpW");

var $gJOtP = parcelRequire("gJOtP");
var $eba66104026c7e04$var$_stepCatArray = {
    "@@transducer/init": Array,
    "@@transducer/step": function(xs, x) {
        xs.push(x);
        return xs;
    },
    "@@transducer/result": (0, $kRggf.default)
};
var $eba66104026c7e04$var$_stepCatString = {
    "@@transducer/init": String,
    "@@transducer/step": function(a, b) {
        return a + b;
    },
    "@@transducer/result": (0, $kRggf.default)
};
var $eba66104026c7e04$var$_stepCatObject = {
    "@@transducer/init": Object,
    "@@transducer/step": function(result, input) {
        return (0, $aLSlk.default)(result, (0, $fl2xG.default)(input) ? (0, $gJOtP.default)(input[0], input[1]) : input);
    },
    "@@transducer/result": (0, $kRggf.default)
};
function $eba66104026c7e04$export$2e2bcd8739ae039(obj) {
    if ((0, $ljSpW.default)(obj)) return obj;
    if ((0, $fl2xG.default)(obj)) return $eba66104026c7e04$var$_stepCatArray;
    if (typeof obj === "string") return $eba66104026c7e04$var$_stepCatString;
    if (typeof obj === "object") return $eba66104026c7e04$var$_stepCatObject;
    throw new Error("Cannot create transformer for " + obj);
}

});
parcelRegister("aLSlk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d78728eeb34fa56$export$2e2bcd8739ae039; });

var $bKOTe = parcelRequire("bKOTe");
// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
function $7d78728eeb34fa56$var$_objectAssign(target) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, $bKOTe.default)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}
var $7d78728eeb34fa56$export$2e2bcd8739ae039 = typeof Object.assign === "function" ? Object.assign : $7d78728eeb34fa56$var$_objectAssign;

});

parcelRegister("gJOtP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2f8019748569875$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */ var $c2f8019748569875$var$objOf = /*#__PURE__*/ (0, $7SxCN.default)(function objOf(key, val) {
    var obj = {};
    obj[key] = val;
    return obj;
});
var $c2f8019748569875$export$2e2bcd8739ae039 = $c2f8019748569875$var$objOf;

});



parcelRegister("fuQ9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4821c382bf84898$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $bKOTe = parcelRequire("bKOTe");

var $aD5Zr = parcelRequire("aD5Zr");
/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */ var $b4821c382bf84898$var$invert = /*#__PURE__*/ (0, $1t1xO.default)(function invert(obj) {
    var props = (0, $aD5Zr.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        var val = obj[key];
        var list = (0, $bKOTe.default)(val, out) ? out[val] : out[val] = [];
        list[list.length] = key;
        idx += 1;
    }
    return out;
});
var $b4821c382bf84898$export$2e2bcd8739ae039 = $b4821c382bf84898$var$invert;

});

parcelRegister("dma4s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b952454e0c09699$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $aD5Zr = parcelRequire("aD5Zr");
/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var $9b952454e0c09699$var$invertObj = /*#__PURE__*/ (0, $1t1xO.default)(function invertObj(obj) {
    var props = (0, $aD5Zr.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
var $9b952454e0c09699$export$2e2bcd8739ae039 = $9b952454e0c09699$var$invertObj;

});

parcelRegister("leUBm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f766cfb0d864fc63$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $73EUu = parcelRequire("73EUu");

var $dB93a = parcelRequire("dB93a");

var $g2qM6 = parcelRequire("g2qM6");
/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var $f766cfb0d864fc63$var$invoker = /*#__PURE__*/ (0, $7SxCN.default)(function invoker(arity, method) {
    return (0, $dB93a.default)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, $73EUu.default)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, $g2qM6.default)(target) + ' does not have a method named "' + method + '"');
    });
});
var $f766cfb0d864fc63$export$2e2bcd8739ae039 = $f766cfb0d864fc63$var$invoker;

});

parcelRegister("IrzWh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $085980b9125d5a68$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var $085980b9125d5a68$var$is = /*#__PURE__*/ (0, $7SxCN.default)(function is(Ctor, val) {
    return val != null && val.constructor === Ctor || val instanceof Ctor;
});
var $085980b9125d5a68$export$2e2bcd8739ae039 = $085980b9125d5a68$var$is;

});

parcelRegister("7DKgw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59001049593e892a$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $cRpaA = parcelRequire("cRpaA");

var $g5jN3 = parcelRequire("g5jN3");
/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */ var $59001049593e892a$var$isEmpty = /*#__PURE__*/ (0, $1t1xO.default)(function isEmpty(x) {
    return x != null && (0, $g5jN3.default)(x, (0, $cRpaA.default)(x));
});
var $59001049593e892a$export$2e2bcd8739ae039 = $59001049593e892a$var$isEmpty;

});

parcelRegister("bDm6l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87847b15a1658ceb$export$2e2bcd8739ae039; });

var $leUBm = parcelRequire("leUBm");
/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var $87847b15a1658ceb$var$join = /*#__PURE__*/ (0, $leUBm.default)(1, "join");
var $87847b15a1658ceb$export$2e2bcd8739ae039 = $87847b15a1658ceb$var$join;

});

parcelRegister("65fIr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46df668603f5774e$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $6s1r9 = parcelRequire("6s1r9");
/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var $46df668603f5774e$var$juxt = /*#__PURE__*/ (0, $1t1xO.default)(function juxt(fns) {
    return (0, $6s1r9.default)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
var $46df668603f5774e$export$2e2bcd8739ae039 = $46df668603f5774e$var$juxt;

});

parcelRegister("3Lu42", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bdd150423f4428b$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */ var $2bdd150423f4428b$var$keysIn = /*#__PURE__*/ (0, $1t1xO.default)(function keysIn(obj) {
    var prop;
    var ks = [];
    for(prop in obj)ks[ks.length] = prop;
    return ks;
});
var $2bdd150423f4428b$export$2e2bcd8739ae039 = $2bdd150423f4428b$var$keysIn;

});

parcelRegister("8v5dU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63054537b156f68e$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $3RBKV = parcelRequire("3RBKV");

var $g5jN3 = parcelRequire("g5jN3");
/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */ var $63054537b156f68e$var$lastIndexOf = /*#__PURE__*/ (0, $7SxCN.default)(function lastIndexOf(target, xs) {
    if (typeof xs.lastIndexOf === "function" && !(0, $3RBKV.default)(xs)) return xs.lastIndexOf(target);
    else {
        var idx = xs.length - 1;
        while(idx >= 0){
            if ((0, $g5jN3.default)(xs[idx], target)) return idx;
            idx -= 1;
        }
        return -1;
    }
});
var $63054537b156f68e$export$2e2bcd8739ae039 = $63054537b156f68e$var$lastIndexOf;

});

parcelRegister("bHf4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $883f66af709c58f9$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $iRj9w = parcelRequire("iRj9w");
/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var $883f66af709c58f9$var$length = /*#__PURE__*/ (0, $1t1xO.default)(function length(list) {
    return list != null && (0, $iRj9w.default)(list.length) ? list.length : NaN;
});
var $883f66af709c58f9$export$2e2bcd8739ae039 = $883f66af709c58f9$var$length;

});
parcelRegister("iRj9w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbac088bf7e0bf22$export$2e2bcd8739ae039; });
function $dbac088bf7e0bf22$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Number]";
}

});


parcelRegister("1hAFT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ef3d3cc214c5868$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $kuJWW = parcelRequire("kuJWW");
/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $0ef3d3cc214c5868$var$lens = /*#__PURE__*/ (0, $7SxCN.default)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, $kuJWW.default)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
var $0ef3d3cc214c5868$export$2e2bcd8739ae039 = $0ef3d3cc214c5868$var$lens;

});

parcelRegister("gRmZR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4636f40da13225e$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $1hAFT = parcelRequire("1hAFT");

var $am2mP = parcelRequire("am2mP");

var $kgy7l = parcelRequire("kgy7l");
/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var $c4636f40da13225e$var$lensIndex = /*#__PURE__*/ (0, $1t1xO.default)(function lensIndex(n) {
    return (0, $1hAFT.default)((0, $am2mP.default)(n), (0, $kgy7l.default)(n));
});
var $c4636f40da13225e$export$2e2bcd8739ae039 = $c4636f40da13225e$var$lensIndex;

});

parcelRegister("kDmJv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03e06792699a478a$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $2xece = parcelRequire("2xece");

var $1hAFT = parcelRequire("1hAFT");

var $6W9Xk = parcelRequire("6W9Xk");
/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */ var $03e06792699a478a$var$lensPath = /*#__PURE__*/ (0, $1t1xO.default)(function lensPath(p) {
    return (0, $1hAFT.default)((0, $6W9Xk.default)(p), (0, $2xece.default)(p));
});
var $03e06792699a478a$export$2e2bcd8739ae039 = $03e06792699a478a$var$lensPath;

});

parcelRegister("hGE4K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce05721023eb443a$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $ia2wh = parcelRequire("ia2wh");

var $1hAFT = parcelRequire("1hAFT");

var $iOjwE = parcelRequire("iOjwE");
/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $ce05721023eb443a$var$lensProp = /*#__PURE__*/ (0, $1t1xO.default)(function lensProp(k) {
    return (0, $1hAFT.default)((0, $iOjwE.default)(k), (0, $ia2wh.default)(k));
});
var $ce05721023eb443a$export$2e2bcd8739ae039 = $ce05721023eb443a$var$lensProp;

});

parcelRegister("jh4AG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0832a775c482209$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var $e0832a775c482209$var$lt = /*#__PURE__*/ (0, $7SxCN.default)(function lt(a, b) {
    return a < b;
});
var $e0832a775c482209$export$2e2bcd8739ae039 = $e0832a775c482209$var$lt;

});

parcelRegister("hZash", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1803e5447a6867d$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var $d1803e5447a6867d$var$lte = /*#__PURE__*/ (0, $7SxCN.default)(function lte(a, b) {
    return a <= b;
});
var $d1803e5447a6867d$export$2e2bcd8739ae039 = $d1803e5447a6867d$var$lte;

});

parcelRegister("harnj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7f89aefbb30a63b$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.scan, R.addIndex, R.mapAccumRight
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */ var $c7f89aefbb30a63b$var$mapAccum = /*#__PURE__*/ (0, $jS880.default)(function mapAccum(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx < len){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx += 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $c7f89aefbb30a63b$export$2e2bcd8739ae039 = $c7f89aefbb30a63b$var$mapAccum;

});

parcelRegister("922rx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $693632208370ae85$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [b + a, b + a];
 *
 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   f(f(f(a, d)[0], c)[0], b)[0],
 *   [
 *     f(a, d)[1],
 *     f(f(a, d)[0], c)[1],
 *     f(f(f(a, d)[0], c)[0], b)[1]
 *   ]
 * ]
 */ var $693632208370ae85$var$mapAccumRight = /*#__PURE__*/ (0, $jS880.default)(function mapAccumRight(fn, acc, list) {
    var idx = list.length - 1;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx >= 0){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx -= 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $693632208370ae85$export$2e2bcd8739ae039 = $693632208370ae85$var$mapAccumRight;

});

parcelRegister("1494U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c6d34e5ebf48b37$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $kwaQ3 = parcelRequire("kwaQ3");

var $aD5Zr = parcelRequire("aD5Zr");
/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var $0c6d34e5ebf48b37$var$mapObjIndexed = /*#__PURE__*/ (0, $7SxCN.default)(function mapObjIndexed(fn, obj) {
    return (0, $kwaQ3.default)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, $aD5Zr.default)(obj));
});
var $0c6d34e5ebf48b37$export$2e2bcd8739ae039 = $0c6d34e5ebf48b37$var$mapObjIndexed;

});

parcelRegister("hBjhv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd04d93bbfa3cb82$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */ var $cd04d93bbfa3cb82$var$match = /*#__PURE__*/ (0, $7SxCN.default)(function match(rx, str) {
    return str.match(rx) || [];
});
var $cd04d93bbfa3cb82$export$2e2bcd8739ae039 = $cd04d93bbfa3cb82$var$match;

});

parcelRegister("iD3EP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8feb4d1fbfc3875$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $1XKTG = parcelRequire("1XKTG");
/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */ var $d8feb4d1fbfc3875$var$mathMod = /*#__PURE__*/ (0, $7SxCN.default)(function mathMod(m, p) {
    if (!(0, $1XKTG.default)(m)) return NaN;
    if (!(0, $1XKTG.default)(p) || p < 1) return NaN;
    return (m % p + p) % p;
});
var $d8feb4d1fbfc3875$export$2e2bcd8739ae039 = $d8feb4d1fbfc3875$var$mathMod;

});

parcelRegister("5ZSTi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45dd3a7606822cc5$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */ var $45dd3a7606822cc5$var$maxBy = /*#__PURE__*/ (0, $jS880.default)(function maxBy(f, a, b) {
    return f(b) > f(a) ? b : a;
});
var $45dd3a7606822cc5$export$2e2bcd8739ae039 = $45dd3a7606822cc5$var$maxBy;

});

parcelRegister("do69M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bf24ad60709b0d8$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $kisLA = parcelRequire("kisLA");
/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */ var $9bf24ad60709b0d8$var$mean = /*#__PURE__*/ (0, $1t1xO.default)(function mean(list) {
    return (0, $kisLA.default)(list) / list.length;
});
var $9bf24ad60709b0d8$export$2e2bcd8739ae039 = $9bf24ad60709b0d8$var$mean;

});
parcelRegister("kisLA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec6bcd8055bff467$export$2e2bcd8739ae039; });

var $kC3eS = parcelRequire("kC3eS");

var $9Zbrv = parcelRequire("9Zbrv");
/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var $ec6bcd8055bff467$var$sum = /*#__PURE__*/ (0, $9Zbrv.default)((0, $kC3eS.default), 0);
var $ec6bcd8055bff467$export$2e2bcd8739ae039 = $ec6bcd8055bff467$var$sum;

});


parcelRegister("hPLSb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfbc55a8481b6e99$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $do69M = parcelRequire("do69M");
/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */ var $cfbc55a8481b6e99$var$median = /*#__PURE__*/ (0, $1t1xO.default)(function median(list) {
    var len = list.length;
    if (len === 0) return NaN;
    var width = 2 - len % 2;
    var idx = (len - width) / 2;
    return (0, $do69M.default)(Array.prototype.slice.call(list, 0).sort(function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }).slice(idx, idx + width));
});
var $cfbc55a8481b6e99$export$2e2bcd8739ae039 = $cfbc55a8481b6e99$var$median;

});

parcelRegister("9MC4H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71f6219784bdddd5$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $7SxCN = parcelRequire("7SxCN");

var $bKOTe = parcelRequire("bKOTe");
/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */ var $71f6219784bdddd5$var$memoizeWith = /*#__PURE__*/ (0, $7SxCN.default)(function memoizeWith(mFn, fn) {
    var cache = {};
    return (0, $fTxyT.default)(fn.length, function() {
        var key = mFn.apply(this, arguments);
        if (!(0, $bKOTe.default)(key, cache)) cache[key] = fn.apply(this, arguments);
        return cache[key];
    });
});
var $71f6219784bdddd5$export$2e2bcd8739ae039 = $71f6219784bdddd5$var$memoizeWith;

});

parcelRegister("5RNYG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4458ab8ad9cce495$export$2e2bcd8739ae039; });

var $aLSlk = parcelRequire("aLSlk");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @deprecated
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.merge({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge(a, b) = {...a, ...b}
 */ var $4458ab8ad9cce495$var$merge = /*#__PURE__*/ (0, $7SxCN.default)(function merge(l, r) {
    return (0, $aLSlk.default)({}, l, r);
});
var $4458ab8ad9cce495$export$2e2bcd8739ae039 = $4458ab8ad9cce495$var$merge;

});

parcelRegister("fnNWC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b32fbef3e2dbed92$export$2e2bcd8739ae039; });

var $aLSlk = parcelRequire("aLSlk");

var $1t1xO = parcelRequire("1t1xO");
/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */ var $b32fbef3e2dbed92$var$mergeAll = /*#__PURE__*/ (0, $1t1xO.default)(function mergeAll(list) {
    return (0, $aLSlk.default).apply(null, [
        {}
    ].concat(list));
});
var $b32fbef3e2dbed92$export$2e2bcd8739ae039 = $b32fbef3e2dbed92$var$mergeAll;

});

parcelRegister("eefGy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5be8a4ba105bd9d$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $gksJU = parcelRequire("gksJU");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $a5be8a4ba105bd9d$var$mergeDeepLeft = /*#__PURE__*/ (0, $7SxCN.default)(function mergeDeepLeft(lObj, rObj) {
    return (0, $gksJU.default)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
var $a5be8a4ba105bd9d$export$2e2bcd8739ae039 = $a5be8a4ba105bd9d$var$mergeDeepLeft;

});
parcelRegister("gksJU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be34cea7118120e5$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $89mmD = parcelRequire("89mmD");

var $4owU2 = parcelRequire("4owU2");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $be34cea7118120e5$var$mergeDeepWithKey = /*#__PURE__*/ (0, $jS880.default)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, $4owU2.default)(function(k, lVal, rVal) {
        if ((0, $89mmD.default)(lVal) && (0, $89mmD.default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
var $be34cea7118120e5$export$2e2bcd8739ae039 = $be34cea7118120e5$var$mergeDeepWithKey;

});
parcelRegister("4owU2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3332ed23789643b8$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $bKOTe = parcelRequire("bKOTe");
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $3332ed23789643b8$var$mergeWithKey = /*#__PURE__*/ (0, $jS880.default)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    for(k in l)if ((0, $bKOTe.default)(k, l)) result[k] = (0, $bKOTe.default)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, $bKOTe.default)(k, r) && !(0, $bKOTe.default)(k, result)) result[k] = r[k];
    return result;
});
var $3332ed23789643b8$export$2e2bcd8739ae039 = $3332ed23789643b8$var$mergeWithKey;

});



parcelRegister("4yaFX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35029e6524682208$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $gksJU = parcelRequire("gksJU");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var $35029e6524682208$var$mergeDeepRight = /*#__PURE__*/ (0, $7SxCN.default)(function mergeDeepRight(lObj, rObj) {
    return (0, $gksJU.default)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
var $35029e6524682208$export$2e2bcd8739ae039 = $35029e6524682208$var$mergeDeepRight;

});

parcelRegister("cPTrL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9585420473934811$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $gksJU = parcelRequire("gksJU");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var $9585420473934811$var$mergeDeepWith = /*#__PURE__*/ (0, $jS880.default)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, $gksJU.default)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
var $9585420473934811$export$2e2bcd8739ae039 = $9585420473934811$var$mergeDeepWith;

});

parcelRegister("cQaLB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9592b16d99b3c56e$export$2e2bcd8739ae039; });

var $aLSlk = parcelRequire("aLSlk");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */ var $9592b16d99b3c56e$var$mergeLeft = /*#__PURE__*/ (0, $7SxCN.default)(function mergeLeft(l, r) {
    return (0, $aLSlk.default)({}, r, l);
});
var $9592b16d99b3c56e$export$2e2bcd8739ae039 = $9592b16d99b3c56e$var$mergeLeft;

});

parcelRegister("lod0K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f925ee92734675ae$export$2e2bcd8739ae039; });

var $aLSlk = parcelRequire("aLSlk");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */ var $f925ee92734675ae$var$mergeRight = /*#__PURE__*/ (0, $7SxCN.default)(function mergeRight(l, r) {
    return (0, $aLSlk.default)({}, l, r);
});
var $f925ee92734675ae$export$2e2bcd8739ae039 = $f925ee92734675ae$var$mergeRight;

});

parcelRegister("eXGRz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae47d31727ce0ea6$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $4owU2 = parcelRequire("4owU2");
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */ var $ae47d31727ce0ea6$var$mergeWith = /*#__PURE__*/ (0, $jS880.default)(function mergeWith(fn, l, r) {
    return (0, $4owU2.default)(function(_, _l, _r) {
        return fn(_l, _r);
    }, l, r);
});
var $ae47d31727ce0ea6$export$2e2bcd8739ae039 = $ae47d31727ce0ea6$var$mergeWith;

});

parcelRegister("6mfeR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a109e3e85af9205$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var $4a109e3e85af9205$var$min = /*#__PURE__*/ (0, $7SxCN.default)(function min(a, b) {
    return b < a ? b : a;
});
var $4a109e3e85af9205$export$2e2bcd8739ae039 = $4a109e3e85af9205$var$min;

});

parcelRegister("3vlNT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28d52e1a07ee210e$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var $28d52e1a07ee210e$var$minBy = /*#__PURE__*/ (0, $jS880.default)(function minBy(f, a, b) {
    return f(b) < f(a) ? b : a;
});
var $28d52e1a07ee210e$export$2e2bcd8739ae039 = $28d52e1a07ee210e$var$minBy;

});

parcelRegister("5Lrx9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4326b32412a4c10a$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      const isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */ var $4326b32412a4c10a$var$modulo = /*#__PURE__*/ (0, $7SxCN.default)(function modulo(a, b) {
    return a % b;
});
var $4326b32412a4c10a$export$2e2bcd8739ae039 = $4326b32412a4c10a$var$modulo;

});

parcelRegister("beYcP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82efb42d4c83c4d7$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var $82efb42d4c83c4d7$var$move = /*#__PURE__*/ (0, $jS880.default)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
var $82efb42d4c83c4d7$export$2e2bcd8739ae039 = $82efb42d4c83c4d7$var$move;

});

parcelRegister("jxBpQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03abd7373b3ca0e5$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var $03abd7373b3ca0e5$var$multiply = /*#__PURE__*/ (0, $7SxCN.default)(function multiply(a, b) {
    return a * b;
});
var $03abd7373b3ca0e5$export$2e2bcd8739ae039 = $03abd7373b3ca0e5$var$multiply;

});

parcelRegister("kpOgx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edcd222a518c057f$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */ var $edcd222a518c057f$var$negate = /*#__PURE__*/ (0, $1t1xO.default)(function negate(n) {
    return -n;
});
var $edcd222a518c057f$export$2e2bcd8739ae039 = $edcd222a518c057f$var$negate;

});

parcelRegister("dKdDy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a01a2647498efb15$export$2e2bcd8739ae039; });

var $2G1lM = parcelRequire("2G1lM");

var $7SxCN = parcelRequire("7SxCN");

var $fs01P = parcelRequire("fs01P");
/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 === 1;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */ var $a01a2647498efb15$var$none = /*#__PURE__*/ (0, $7SxCN.default)(function none(fn, input) {
    return (0, $fs01P.default)((0, $2G1lM.default)(fn), input);
});
var $a01a2647498efb15$export$2e2bcd8739ae039 = $a01a2647498efb15$var$none;

});

parcelRegister("karPh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaea537e83a84c4b$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $dB93a = parcelRequire("dB93a");

var $am2mP = parcelRequire("am2mP");
/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */ var $eaea537e83a84c4b$var$nthArg = /*#__PURE__*/ (0, $1t1xO.default)(function nthArg(n) {
    var arity = n < 0 ? 1 : n + 1;
    return (0, $dB93a.default)(arity, function() {
        return (0, $am2mP.default)(n, arguments);
    });
});
var $eaea537e83a84c4b$export$2e2bcd8739ae039 = $eaea537e83a84c4b$var$nthArg;

});

parcelRegister("9dbDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b4e5bd33eae9fe0$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
 * limited to accepting only 2 unary functions. The name o was chosen because
 * of its similarity to the mathematical composition operator ∘.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */ var $6b4e5bd33eae9fe0$var$o = /*#__PURE__*/ (0, $jS880.default)(function o(f, g, x) {
    return f(g(x));
});
var $6b4e5bd33eae9fe0$export$2e2bcd8739ae039 = $6b4e5bd33eae9fe0$var$o;

});

parcelRegister("2Bayo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e473933401e574f$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $gAZTD = parcelRequire("gAZTD");
/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */ var $1e473933401e574f$var$of = /*#__PURE__*/ (0, $1t1xO.default)((0, $gAZTD.default));
var $1e473933401e574f$export$2e2bcd8739ae039 = $1e473933401e574f$var$of;

});
parcelRegister("gAZTD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1500578447889e5$export$2e2bcd8739ae039; });
function $c1500578447889e5$export$2e2bcd8739ae039(x) {
    return [
        x
    ];
}

});


parcelRegister("1DcDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13033c48a51df7a1$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var $13033c48a51df7a1$var$omit = /*#__PURE__*/ (0, $7SxCN.default)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
var $13033c48a51df7a1$export$2e2bcd8739ae039 = $13033c48a51df7a1$var$omit;

});

parcelRegister("iVfxC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc699b06c099e638$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $1t1xO = parcelRequire("1t1xO");
/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      const addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */ var $dc699b06c099e638$var$once = /*#__PURE__*/ (0, $1t1xO.default)(function once(fn) {
    var called = false;
    var result;
    return (0, $fTxyT.default)(fn.length, function() {
        if (called) return result;
        called = true;
        result = fn.apply(this, arguments);
        return result;
    });
});
var $dc699b06c099e638$export$2e2bcd8739ae039 = $dc699b06c099e638$var$once;

});

parcelRegister("7IqMt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01731e9f3a1c3b10$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $hUfSo = parcelRequire("hUfSo");
/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.then
 * @example
 *
 *      var failedFetch = (id) => Promise.reject('bad ID');
 *      var useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' })
 *
 *      //recoverFromFailure :: String -> Promise ({firstName, lastName})
 *      var recoverFromFailure = R.pipe(
 *        failedFetch,
 *        R.otherwise(useDefault),
 *        R.then(R.pick(['firstName', 'lastName'])),
 *      );
 *      recoverFromFailure(12345).then(console.log)
 */ var $01731e9f3a1c3b10$var$otherwise = /*#__PURE__*/ (0, $7SxCN.default)(function otherwise(f, p) {
    (0, $hUfSo.default)("otherwise", p);
    return p.then(null, f);
});
var $01731e9f3a1c3b10$export$2e2bcd8739ae039 = $01731e9f3a1c3b10$var$otherwise;

});
parcelRegister("hUfSo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d093fb55cd620445$export$2e2bcd8739ae039; });

var $73EUu = parcelRequire("73EUu");

var $8n7mI = parcelRequire("8n7mI");
function $d093fb55cd620445$export$2e2bcd8739ae039(name, p) {
    if (p == null || !(0, $73EUu.default)(p.then)) throw new TypeError("`" + name + "` expected a Promise, received " + (0, $8n7mI.default)(p, []));
}

});


parcelRegister("9Qgld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72a5a568549a5d54$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
// `Identity` is a functor that holds a single value, where `map` simply
// transforms the held value with the provided function.
var $72a5a568549a5d54$var$Identity = function(x) {
    return {
        value: x,
        map: function(f) {
            return $72a5a568549a5d54$var$Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var $72a5a568549a5d54$var$over = /*#__PURE__*/ (0, $jS880.default)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return $72a5a568549a5d54$var$Identity(f(y));
    })(x).value;
});
var $72a5a568549a5d54$export$2e2bcd8739ae039 = $72a5a568549a5d54$var$over;

});

parcelRegister("kW4Kt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3dce8682185fe38$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */ var $f3dce8682185fe38$var$pair = /*#__PURE__*/ (0, $7SxCN.default)(function pair(fst, snd) {
    return [
        fst,
        snd
    ];
});
var $f3dce8682185fe38$export$2e2bcd8739ae039 = $f3dce8682185fe38$var$pair;

});

parcelRegister("7FSiY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59667c92551151c2$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $9SVU4 = parcelRequire("9SVU4");
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight, R.curry
 * @example
 *
 *      const multiply2 = (a, b) => a * b;
 *      const double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partial(greet, ['Hello']);
 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */ var $59667c92551151c2$var$partial = /*#__PURE__*/ (0, $9SVU4.default)((0, $aikTT.default));
var $59667c92551151c2$export$2e2bcd8739ae039 = $59667c92551151c2$var$partial;

});
parcelRegister("9SVU4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73261296eb038d54$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $7SxCN = parcelRequire("7SxCN");
function $73261296eb038d54$export$2e2bcd8739ae039(concat) {
    return (0, $7SxCN.default)(function(fn, args) {
        return (0, $fTxyT.default)(Math.max(0, fn.length - args.length), function() {
            return fn.apply(this, concat(args, arguments));
        });
    });
}

});


parcelRegister("7tJhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $571e5e9366cde9b0$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $9SVU4 = parcelRequire("9SVU4");

var $d071Y = parcelRequire("d071Y");
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */ var $571e5e9366cde9b0$var$partialRight = /*#__PURE__*/ (0, $9SVU4.default)(/*#__PURE__*/ (0, $d071Y.default)((0, $aikTT.default)));
var $571e5e9366cde9b0$export$2e2bcd8739ae039 = $571e5e9366cde9b0$var$partialRight;

});

parcelRegister("aCAF2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bb9e41aed762abe$export$2e2bcd8739ae039; });

var $r0sUa = parcelRequire("r0sUa");

var $65fIr = parcelRequire("65fIr");

var $2m6Qn = parcelRequire("2m6Qn");
/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var $7bb9e41aed762abe$var$partition = /*#__PURE__*/ (0, $65fIr.default)([
    (0, $r0sUa.default),
    (0, $2m6Qn.default)
]);
var $7bb9e41aed762abe$export$2e2bcd8739ae039 = $7bb9e41aed762abe$var$partition;

});

parcelRegister("628nw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46496dbc35676dcf$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $g5jN3 = parcelRequire("g5jN3");

var $6W9Xk = parcelRequire("6W9Xk");
/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var $46496dbc35676dcf$var$pathEq = /*#__PURE__*/ (0, $jS880.default)(function pathEq(_path, val, obj) {
    return (0, $g5jN3.default)((0, $6W9Xk.default)(_path, obj), val);
});
var $46496dbc35676dcf$export$2e2bcd8739ae039 = $46496dbc35676dcf$var$pathEq;

});

parcelRegister("32TYw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $237cfa7a8a4352aa$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $iGZmr = parcelRequire("iGZmr");

var $6W9Xk = parcelRequire("6W9Xk");
/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var $237cfa7a8a4352aa$var$pathOr = /*#__PURE__*/ (0, $jS880.default)(function pathOr(d, p, obj) {
    return (0, $iGZmr.default)(d, (0, $6W9Xk.default)(p, obj));
});
var $237cfa7a8a4352aa$export$2e2bcd8739ae039 = $237cfa7a8a4352aa$var$pathOr;

});

parcelRegister("gISCw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2cb1fe0a9dff280$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $6W9Xk = parcelRequire("6W9Xk");
/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 */ var $c2cb1fe0a9dff280$var$pathSatisfies = /*#__PURE__*/ (0, $jS880.default)(function pathSatisfies(pred, propPath, obj) {
    return propPath.length > 0 && pred((0, $6W9Xk.default)(propPath, obj));
});
var $c2cb1fe0a9dff280$export$2e2bcd8739ae039 = $c2cb1fe0a9dff280$var$pathSatisfies;

});

parcelRegister("jBKqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4657c4ef70c424e$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var $e4657c4ef70c424e$var$pick = /*#__PURE__*/ (0, $7SxCN.default)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
var $e4657c4ef70c424e$export$2e2bcd8739ae039 = $e4657c4ef70c424e$var$pick;

});

parcelRegister("cW3Sn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96ade886caf05266$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */ var $96ade886caf05266$var$pickAll = /*#__PURE__*/ (0, $7SxCN.default)(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        var name = names[idx];
        result[name] = obj[name];
        idx += 1;
    }
    return result;
});
var $96ade886caf05266$export$2e2bcd8739ae039 = $96ade886caf05266$var$pickAll;

});

parcelRegister("4tVS1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3436c2b0e12e3231$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var $3436c2b0e12e3231$var$pickBy = /*#__PURE__*/ (0, $7SxCN.default)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
var $3436c2b0e12e3231$export$2e2bcd8739ae039 = $3436c2b0e12e3231$var$pickBy;

});

parcelRegister("hoTp7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caafa7af5310edd8$export$2e2bcd8739ae039; });

var $iVx4O = parcelRequire("iVx4O");

var $cSdZE = parcelRequire("cSdZE");
function $caafa7af5310edd8$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipeK requires at least one argument");
    return (0, $iVx4O.default).apply(this, (0, $cSdZE.default)(arguments));
}

});

parcelRegister("edCYc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5a082351a61401a$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */ var $a5a082351a61401a$var$prepend = /*#__PURE__*/ (0, $7SxCN.default)(function prepend(el, list) {
    return (0, $aikTT.default)([
        el
    ], list);
});
var $a5a082351a61401a$export$2e2bcd8739ae039 = $a5a082351a61401a$var$prepend;

});

parcelRegister("egyKK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a62d848ee29b206b$export$2e2bcd8739ae039; });

var $jxBpQ = parcelRequire("jxBpQ");

var $9Zbrv = parcelRequire("9Zbrv");
/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */ var $a62d848ee29b206b$var$product = /*#__PURE__*/ (0, $9Zbrv.default)((0, $jxBpQ.default), 1);
var $a62d848ee29b206b$export$2e2bcd8739ae039 = $a62d848ee29b206b$var$product;

});

parcelRegister("8MsNq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $664924c1e60c3a7f$export$2e2bcd8739ae039; });

var $j5PpZ = parcelRequire("j5PpZ");

var $6PHwe = parcelRequire("6PHwe");

var $cW3Sn = parcelRequire("cW3Sn");

var $eu8tn = parcelRequire("eu8tn");
/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */ var $664924c1e60c3a7f$var$project = /*#__PURE__*/ (0, $eu8tn.default)((0, $j5PpZ.default), [
    (0, $cW3Sn.default),
    (0, $6PHwe.default)
]); // passing `identity` gives correct arity
var $664924c1e60c3a7f$export$2e2bcd8739ae039 = $664924c1e60c3a7f$var$project;

});
parcelRegister("eu8tn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8ba708880b3f6c3$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $dB93a = parcelRequire("dB93a");
/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */ var $a8ba708880b3f6c3$var$useWith = /*#__PURE__*/ (0, $7SxCN.default)(function useWith(fn, transformers) {
    return (0, $dB93a.default)(transformers.length, function() {
        var args = [];
        var idx = 0;
        while(idx < transformers.length){
            args.push(transformers[idx].call(this, arguments[idx]));
            idx += 1;
        }
        return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
    });
});
var $a8ba708880b3f6c3$export$2e2bcd8739ae039 = $a8ba708880b3f6c3$var$useWith;

});


parcelRegister("3e6vr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2597b9e224d7155a$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $g5jN3 = parcelRequire("g5jN3");
/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var $2597b9e224d7155a$var$propEq = /*#__PURE__*/ (0, $jS880.default)(function propEq(name, val, obj) {
    return (0, $g5jN3.default)(val, obj[name]);
});
var $2597b9e224d7155a$export$2e2bcd8739ae039 = $2597b9e224d7155a$var$propEq;

});

parcelRegister("5fanY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d1668d8f846484a$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $IrzWh = parcelRequire("IrzWh");
/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */ var $3d1668d8f846484a$var$propIs = /*#__PURE__*/ (0, $jS880.default)(function propIs(type, name, obj) {
    return (0, $IrzWh.default)(type, obj[name]);
});
var $3d1668d8f846484a$export$2e2bcd8739ae039 = $3d1668d8f846484a$var$propIs;

});

parcelRegister("5fdvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d18d62015a49895$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $32TYw = parcelRequire("32TYw");
/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var $3d18d62015a49895$var$propOr = /*#__PURE__*/ (0, $jS880.default)(function propOr(val, p, obj) {
    return (0, $32TYw.default)(val, [
        p
    ], obj);
});
var $3d18d62015a49895$export$2e2bcd8739ae039 = $3d18d62015a49895$var$propOr;

});

parcelRegister("ebdBM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a52ca6196861a7c2$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */ var $a52ca6196861a7c2$var$propSatisfies = /*#__PURE__*/ (0, $jS880.default)(function propSatisfies(pred, name, obj) {
    return pred(obj[name]);
});
var $a52ca6196861a7c2$export$2e2bcd8739ae039 = $a52ca6196861a7c2$var$propSatisfies;

});

parcelRegister("jZtDt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8dab3d82e120475$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var $e8dab3d82e120475$var$props = /*#__PURE__*/ (0, $7SxCN.default)(function props(ps, obj) {
    var len = ps.length;
    var out = [];
    var idx = 0;
    while(idx < len){
        out[idx] = obj[ps[idx]];
        idx += 1;
    }
    return out;
});
var $e8dab3d82e120475$export$2e2bcd8739ae039 = $e8dab3d82e120475$var$props;

});

parcelRegister("949T3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $699c2821590b6e22$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $iRj9w = parcelRequire("iRj9w");
/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var $699c2821590b6e22$var$range = /*#__PURE__*/ (0, $7SxCN.default)(function range(from, to) {
    if (!((0, $iRj9w.default)(from) && (0, $iRj9w.default)(to))) throw new TypeError("Both arguments to range must be numbers");
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
var $699c2821590b6e22$export$2e2bcd8739ae039 = $699c2821590b6e22$var$range;

});

parcelRegister("jLvnw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e63abf39a9cd0229$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */ var $e63abf39a9cd0229$var$reduceRight = /*#__PURE__*/ (0, $jS880.default)(function reduceRight(fn, acc, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        acc = fn(list[idx], acc);
        idx -= 1;
    }
    return acc;
});
var $e63abf39a9cd0229$export$2e2bcd8739ae039 = $e63abf39a9cd0229$var$reduceRight;

});

parcelRegister("14dgF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c7074e263894bb9$export$2e2bcd8739ae039; });

var $7bssI = parcelRequire("7bssI");

var $kwaQ3 = parcelRequire("kwaQ3");

var $02x5o = parcelRequire("02x5o");
/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 === 1;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */ var $0c7074e263894bb9$var$reduceWhile = /*#__PURE__*/ (0, $7bssI.default)(4, [], function _reduceWhile(pred, fn, a, list) {
    return (0, $kwaQ3.default)(function(acc, x) {
        return pred(acc, x) ? fn(acc, x) : (0, $02x5o.default)(acc);
    }, a, list);
});
var $0c7074e263894bb9$export$2e2bcd8739ae039 = $0c7074e263894bb9$var$reduceWhile;

});

parcelRegister("8va4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $630906fac1e188b9$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $02x5o = parcelRequire("02x5o");
/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is only available to the below functions:
 * - [`reduce`](#reduce)
 * - [`reduceWhile`](#reduceWhile)
 * - [`transduce`](#transduce)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.reduceWhile, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */ var $630906fac1e188b9$var$reduced = /*#__PURE__*/ (0, $1t1xO.default)((0, $02x5o.default));
var $630906fac1e188b9$export$2e2bcd8739ae039 = $630906fac1e188b9$var$reduced;

});

parcelRegister("l1XZv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4f839f224ea68da$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $cdVZD = parcelRequire("cdVZD");

var $fcFPY = parcelRequire("fcFPY");
/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var $f4f839f224ea68da$var$repeat = /*#__PURE__*/ (0, $7SxCN.default)(function repeat(value, n) {
    return (0, $fcFPY.default)((0, $cdVZD.default)(value), n);
});
var $f4f839f224ea68da$export$2e2bcd8739ae039 = $f4f839f224ea68da$var$repeat;

});
parcelRegister("fcFPY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1186e00c2b95e20$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var $b1186e00c2b95e20$var$times = /*#__PURE__*/ (0, $7SxCN.default)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError("n must be a non-negative number");
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
var $b1186e00c2b95e20$export$2e2bcd8739ae039 = $b1186e00c2b95e20$var$times;

});


parcelRegister("bfPoN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8318f73234b785b6$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var $8318f73234b785b6$var$replace = /*#__PURE__*/ (0, $jS880.default)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
var $8318f73234b785b6$export$2e2bcd8739ae039 = $8318f73234b785b6$var$replace;

});

parcelRegister("bBITo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8735f9199b9220e1$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce, R.mapAccum
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */ var $8735f9199b9220e1$var$scan = /*#__PURE__*/ (0, $jS880.default)(function scan(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [
        acc
    ];
    while(idx < len){
        acc = fn(acc, list[idx]);
        result[idx + 1] = acc;
        idx += 1;
    }
    return result;
});
var $8735f9199b9220e1$export$2e2bcd8739ae039 = $8735f9199b9220e1$var$scan;

});

parcelRegister("8UQ63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67dbf70025d127d8$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $7C2CH = parcelRequire("7C2CH");

var $kuJWW = parcelRequire("kuJWW");

var $edCYc = parcelRequire("edCYc");

var $jLvnw = parcelRequire("jLvnw");
/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */ var $67dbf70025d127d8$var$sequence = /*#__PURE__*/ (0, $7SxCN.default)(function sequence(of, traversable) {
    return typeof traversable.sequence === "function" ? traversable.sequence(of) : (0, $jLvnw.default)(function(x, acc) {
        return (0, $7C2CH.default)((0, $kuJWW.default)((0, $edCYc.default), x), acc);
    }, of([]), traversable);
});
var $67dbf70025d127d8$export$2e2bcd8739ae039 = $67dbf70025d127d8$var$sequence;

});

parcelRegister("gGnsI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c252c4a9de7c2480$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $cdVZD = parcelRequire("cdVZD");

var $9Qgld = parcelRequire("9Qgld");
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */ var $c252c4a9de7c2480$var$set = /*#__PURE__*/ (0, $jS880.default)(function set(lens, v, x) {
    return (0, $9Qgld.default)(lens, (0, $cdVZD.default)(v), x);
});
var $c252c4a9de7c2480$export$2e2bcd8739ae039 = $c252c4a9de7c2480$var$set;

});

parcelRegister("3OmdN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c6747568ff4340f$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var $2c6747568ff4340f$var$sort = /*#__PURE__*/ (0, $7SxCN.default)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
var $2c6747568ff4340f$export$2e2bcd8739ae039 = $2c6747568ff4340f$var$sort;

});

parcelRegister("bKeUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88cf8f066fd3d09d$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var $88cf8f066fd3d09d$var$sortBy = /*#__PURE__*/ (0, $7SxCN.default)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
var $88cf8f066fd3d09d$export$2e2bcd8739ae039 = $88cf8f066fd3d09d$var$sortBy;

});

parcelRegister("13iLV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c44a1ff97f8ad3a$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var $0c44a1ff97f8ad3a$var$sortWith = /*#__PURE__*/ (0, $7SxCN.default)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
var $0c44a1ff97f8ad3a$export$2e2bcd8739ae039 = $0c44a1ff97f8ad3a$var$sortWith;

});

parcelRegister("lgeR0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7a69d4871758d7b$export$2e2bcd8739ae039; });

var $leUBm = parcelRequire("leUBm");
/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var $f7a69d4871758d7b$var$split = /*#__PURE__*/ (0, $leUBm.default)(1, "split");
var $f7a69d4871758d7b$export$2e2bcd8739ae039 = $f7a69d4871758d7b$var$split;

});

parcelRegister("efULQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a60e80e084e1281e$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $bHf4t = parcelRequire("bHf4t");

var $5KOxr = parcelRequire("5KOxr");
/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */ var $a60e80e084e1281e$var$splitAt = /*#__PURE__*/ (0, $7SxCN.default)(function splitAt(index, array) {
    return [
        (0, $5KOxr.default)(0, index, array),
        (0, $5KOxr.default)(index, (0, $bHf4t.default)(array), array)
    ];
});
var $a60e80e084e1281e$export$2e2bcd8739ae039 = $a60e80e084e1281e$var$splitAt;

});

parcelRegister("6MKSH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f0b976c160825c3$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $5KOxr = parcelRequire("5KOxr");
/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */ var $4f0b976c160825c3$var$splitEvery = /*#__PURE__*/ (0, $7SxCN.default)(function splitEvery(n, list) {
    if (n <= 0) throw new Error("First argument to splitEvery must be a positive integer");
    var result = [];
    var idx = 0;
    while(idx < list.length)result.push((0, $5KOxr.default)(idx, idx += n, list));
    return result;
});
var $4f0b976c160825c3$export$2e2bcd8739ae039 = $4f0b976c160825c3$var$splitEvery;

});

parcelRegister("WPSOy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b0da9cc4d7dbf8c$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */ var $0b0da9cc4d7dbf8c$var$splitWhen = /*#__PURE__*/ (0, $7SxCN.default)(function splitWhen(pred, list) {
    var idx = 0;
    var len = list.length;
    var prefix = [];
    while(idx < len && !pred(list[idx])){
        prefix.push(list[idx]);
        idx += 1;
    }
    return [
        prefix,
        Array.prototype.slice.call(list, idx)
    ];
});
var $0b0da9cc4d7dbf8c$export$2e2bcd8739ae039 = $0b0da9cc4d7dbf8c$var$splitWhen;

});

parcelRegister("7rZKC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56caf477f41067fc$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $g5jN3 = parcelRequire("g5jN3");

var $2NnQ3 = parcelRequire("2NnQ3");
/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $56caf477f41067fc$var$startsWith = /*#__PURE__*/ (0, $7SxCN.default)(function(prefix, list) {
    return (0, $g5jN3.default)((0, $2NnQ3.default)(prefix.length, list), prefix);
});
var $56caf477f41067fc$export$2e2bcd8739ae039 = $56caf477f41067fc$var$startsWith;

});

parcelRegister("gfOB4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd554b906aa6c458$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var $bd554b906aa6c458$var$subtract = /*#__PURE__*/ (0, $7SxCN.default)(function subtract(a, b) {
    return Number(a) - Number(b);
});
var $bd554b906aa6c458$export$2e2bcd8739ae039 = $bd554b906aa6c458$var$subtract;

});

parcelRegister("i8hfO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3365ba2e7de83db$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $g8SbF = parcelRequire("g8SbF");

var $7LULv = parcelRequire("7LULv");
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var $d3365ba2e7de83db$var$symmetricDifference = /*#__PURE__*/ (0, $7SxCN.default)(function symmetricDifference(list1, list2) {
    return (0, $g8SbF.default)((0, $7LULv.default)(list1, list2), (0, $7LULv.default)(list2, list1));
});
var $d3365ba2e7de83db$export$2e2bcd8739ae039 = $d3365ba2e7de83db$var$symmetricDifference;

});

parcelRegister("iGfVM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d99881c5f603fffc$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $g8SbF = parcelRequire("g8SbF");

var $2GKxo = parcelRequire("2GKxo");
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */ var $d99881c5f603fffc$var$symmetricDifferenceWith = /*#__PURE__*/ (0, $jS880.default)(function symmetricDifferenceWith(pred, list1, list2) {
    return (0, $g8SbF.default)((0, $2GKxo.default)(pred, list1, list2), (0, $2GKxo.default)(pred, list2, list1));
});
var $d99881c5f603fffc$export$2e2bcd8739ae039 = $d99881c5f603fffc$var$symmetricDifferenceWith;

});

parcelRegister("aDjpA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bdc9aa494146858$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */ var $7bdc9aa494146858$var$takeLastWhile = /*#__PURE__*/ (0, $7SxCN.default)(function takeLastWhile(fn, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && fn(xs[idx]))idx -= 1;
    return (0, $5KOxr.default)(idx + 1, Infinity, xs);
});
var $7bdc9aa494146858$export$2e2bcd8739ae039 = $7bdc9aa494146858$var$takeLastWhile;

});

parcelRegister("3u2Mq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2896547f0b1d93f9$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $4IVoP = parcelRequire("4IVoP");

var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var $2896547f0b1d93f9$var$takeWhile = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "takeWhile"
], (0, $4IVoP.default), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, $5KOxr.default)(0, idx, xs);
}));
var $2896547f0b1d93f9$export$2e2bcd8739ae039 = $2896547f0b1d93f9$var$takeWhile;

});
parcelRegister("4IVoP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3707cbd04c47e1b7$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $02x5o = parcelRequire("02x5o");

var $a6y2L = parcelRequire("a6y2L");
var $3707cbd04c47e1b7$var$XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XTakeWhile.prototype["@@transducer/result"] = (0, $a6y2L.default).result;
    XTakeWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : (0, $02x5o.default)(result);
    };
    return XTakeWhile;
}();
var $3707cbd04c47e1b7$var$_xtakeWhile = /*#__PURE__*/ (0, $7SxCN.default)(function _xtakeWhile(f, xf) {
    return new $3707cbd04c47e1b7$var$XTakeWhile(f, xf);
});
var $3707cbd04c47e1b7$export$2e2bcd8739ae039 = $3707cbd04c47e1b7$var$_xtakeWhile;

});


parcelRegister("eMmfs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac26ce73bed1035e$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $i0xid = parcelRequire("i0xid");
/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */ var $ac26ce73bed1035e$var$tap = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([], (0, $i0xid.default), function tap(fn, x) {
    fn(x);
    return x;
}));
var $ac26ce73bed1035e$export$2e2bcd8739ae039 = $ac26ce73bed1035e$var$tap;

});
parcelRegister("i0xid", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1c20d568e2d4682$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $d1c20d568e2d4682$var$XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XTap.prototype["@@transducer/result"] = (0, $a6y2L.default).result;
    XTap.prototype["@@transducer/step"] = function(result, input) {
        this.f(input);
        return this.xf["@@transducer/step"](result, input);
    };
    return XTap;
}();
var $d1c20d568e2d4682$var$_xtap = /*#__PURE__*/ (0, $7SxCN.default)(function _xtap(f, xf) {
    return new $d1c20d568e2d4682$var$XTap(f, xf);
});
var $d1c20d568e2d4682$export$2e2bcd8739ae039 = $d1c20d568e2d4682$var$_xtap;

});


parcelRegister("jDyZf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4bccc81b18bede0$export$2e2bcd8739ae039; });

var $3Uy6P = parcelRequire("3Uy6P");

var $7SxCN = parcelRequire("7SxCN");

var $179Mw = parcelRequire("179Mw");

var $g2qM6 = parcelRequire("g2qM6");
/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var $e4bccc81b18bede0$var$test = /*#__PURE__*/ (0, $7SxCN.default)(function test(pattern, str) {
    if (!(0, $179Mw.default)(pattern)) throw new TypeError("\u2018test\u2019 requires a value of type RegExp as its first argument; received " + (0, $g2qM6.default)(pattern));
    return (0, $3Uy6P.default)(pattern).test(str);
});
var $e4bccc81b18bede0$export$2e2bcd8739ae039 = $e4bccc81b18bede0$var$test;

});
parcelRegister("179Mw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cfe08503b8d6d53$export$2e2bcd8739ae039; });
function $0cfe08503b8d6d53$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object RegExp]";
}

});


parcelRegister("fui7z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b467b6d0860d2732$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $hUfSo = parcelRequire("hUfSo");
/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      var makeQuery = (email) => ({ query: { email }});
 *
 *      //getMemberName :: String -> Promise ({firstName, lastName})
 *      var getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.then(R.pick(['firstName', 'lastName']))
 *      );
 */ var $b467b6d0860d2732$var$then = /*#__PURE__*/ (0, $7SxCN.default)(function then(f, p) {
    (0, $hUfSo.default)("then", p);
    return p.then(f);
});
var $b467b6d0860d2732$export$2e2bcd8739ae039 = $b467b6d0860d2732$var$then;

});

parcelRegister("exIhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9667ff05e6e2673$export$2e2bcd8739ae039; });

var $leUBm = parcelRequire("leUBm");
/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var $a9667ff05e6e2673$var$toLower = /*#__PURE__*/ (0, $leUBm.default)(0, "toLowerCase");
var $a9667ff05e6e2673$export$2e2bcd8739ae039 = $a9667ff05e6e2673$var$toLower;

});

parcelRegister("ev3xd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e6b3dea9f3b4aa$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $bKOTe = parcelRequire("bKOTe");
/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var $a8e6b3dea9f3b4aa$var$toPairs = /*#__PURE__*/ (0, $1t1xO.default)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, $bKOTe.default)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $a8e6b3dea9f3b4aa$export$2e2bcd8739ae039 = $a8e6b3dea9f3b4aa$var$toPairs;

});

parcelRegister("iY6ea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcf2a9387776ce07$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */ var $dcf2a9387776ce07$var$toPairsIn = /*#__PURE__*/ (0, $1t1xO.default)(function toPairsIn(obj) {
    var pairs = [];
    for(var prop in obj)pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $dcf2a9387776ce07$export$2e2bcd8739ae039 = $dcf2a9387776ce07$var$toPairsIn;

});

parcelRegister("iWdU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc986dcc9af431d1$export$2e2bcd8739ae039; });

var $leUBm = parcelRequire("leUBm");
/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var $dc986dcc9af431d1$var$toUpper = /*#__PURE__*/ (0, $leUBm.default)(0, "toUpperCase");
var $dc986dcc9af431d1$export$2e2bcd8739ae039 = $dc986dcc9af431d1$var$toUpper;

});

parcelRegister("eDxPj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa7ef27a523ac1bc$export$2e2bcd8739ae039; });

var $kwaQ3 = parcelRequire("kwaQ3");

var $6DG1C = parcelRequire("6DG1C");

var $dB93a = parcelRequire("dB93a");
/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 === 1;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */ var $aa7ef27a523ac1bc$var$transduce = /*#__PURE__*/ (0, $dB93a.default)(4, function transduce(xf, fn, acc, list) {
    return (0, $kwaQ3.default)(xf(typeof fn === "function" ? (0, $6DG1C.default)(fn) : fn), acc, list);
});
var $aa7ef27a523ac1bc$export$2e2bcd8739ae039 = $aa7ef27a523ac1bc$var$transduce;

});

parcelRegister("bqbCh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $850b222cee504b50$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */ var $850b222cee504b50$var$transpose = /*#__PURE__*/ (0, $1t1xO.default)(function transpose(outerlist) {
    var i = 0;
    var result = [];
    while(i < outerlist.length){
        var innerlist = outerlist[i];
        var j = 0;
        while(j < innerlist.length){
            if (typeof result[j] === "undefined") result[j] = [];
            result[j].push(innerlist[j]);
            j += 1;
        }
        i += 1;
    }
    return result;
});
var $850b222cee504b50$export$2e2bcd8739ae039 = $850b222cee504b50$var$transpose;

});

parcelRegister("iUNOD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc54195437ee7b06$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $kuJWW = parcelRequire("kuJWW");

var $8UQ63 = parcelRequire("8UQ63");
/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 */ var $dc54195437ee7b06$var$traverse = /*#__PURE__*/ (0, $jS880.default)(function traverse(of, f, traversable) {
    return typeof traversable["fantasy-land/traverse"] === "function" ? traversable["fantasy-land/traverse"](f, of) : (0, $8UQ63.default)(of, (0, $kuJWW.default)(f, traversable));
});
var $dc54195437ee7b06$export$2e2bcd8739ae039 = $dc54195437ee7b06$var$traverse;

});

parcelRegister("6WR5E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50f1577a65a8503a$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
var $50f1577a65a8503a$var$ws = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var $50f1577a65a8503a$var$zeroWidth = "\u200B";
var $50f1577a65a8503a$var$hasProtoTrim = typeof String.prototype.trim === "function";
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var $50f1577a65a8503a$var$trim = !$50f1577a65a8503a$var$hasProtoTrim || /*#__PURE__*/ $50f1577a65a8503a$var$ws.trim() || !/*#__PURE__*/ $50f1577a65a8503a$var$zeroWidth.trim() ? /*#__PURE__*/ (0, $1t1xO.default)(function trim(str) {
    var beginRx = new RegExp("^[" + $50f1577a65a8503a$var$ws + "][" + $50f1577a65a8503a$var$ws + "]*");
    var endRx = new RegExp("[" + $50f1577a65a8503a$var$ws + "][" + $50f1577a65a8503a$var$ws + "]*$");
    return str.replace(beginRx, "").replace(endRx, "");
}) : /*#__PURE__*/ (0, $1t1xO.default)(function trim(str) {
    return str.trim();
});
var $50f1577a65a8503a$export$2e2bcd8739ae039 = $50f1577a65a8503a$var$trim;

});

parcelRegister("lCAvK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbd977eade7de053$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $aikTT = parcelRequire("aikTT");

var $7SxCN = parcelRequire("7SxCN");
/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(() => { throw 'foo'}, R.always('catched'))('bar') // => 'catched'
 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
 `` */ var $fbd977eade7de053$var$tryCatch = /*#__PURE__*/ (0, $7SxCN.default)(function _tryCatch(tryer, catcher) {
    return (0, $fTxyT.default)(tryer.length, function() {
        try {
            return tryer.apply(this, arguments);
        } catch (e) {
            return catcher.apply(this, (0, $aikTT.default)([
                e
            ], arguments));
        }
    });
});
var $fbd977eade7de053$export$2e2bcd8739ae039 = $fbd977eade7de053$var$tryCatch;

});

parcelRegister("bBRxi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $873cad90b85bfd5c$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */ var $873cad90b85bfd5c$var$unapply = /*#__PURE__*/ (0, $1t1xO.default)(function unapply(fn) {
    return function() {
        return fn(Array.prototype.slice.call(arguments, 0));
    };
});
var $873cad90b85bfd5c$export$2e2bcd8739ae039 = $873cad90b85bfd5c$var$unapply;

});

parcelRegister("6Loxk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eca2a528c3c9441$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $51mxt = parcelRequire("51mxt");
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      const takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */ var $4eca2a528c3c9441$var$unary = /*#__PURE__*/ (0, $1t1xO.default)(function unary(fn) {
    return (0, $51mxt.default)(1, fn);
});
var $4eca2a528c3c9441$export$2e2bcd8739ae039 = $4eca2a528c3c9441$var$unary;

});

parcelRegister("3IVFf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b6236173b683ad8$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $dB93a = parcelRequire("dB93a");
/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      const addFour = a => b => c => d => a + b + c + d;
 *
 *      const uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */ var $2b6236173b683ad8$var$uncurryN = /*#__PURE__*/ (0, $7SxCN.default)(function uncurryN(depth, fn) {
    return (0, $dB93a.default)(depth, function() {
        var currentDepth = 1;
        var value = fn;
        var idx = 0;
        var endIdx;
        while(currentDepth <= depth && typeof value === "function"){
            endIdx = currentDepth === depth ? arguments.length : idx + value.length;
            value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
            currentDepth += 1;
            idx = endIdx;
        }
        return value;
    });
});
var $2b6236173b683ad8$export$2e2bcd8739ae039 = $2b6236173b683ad8$var$uncurryN;

});

parcelRegister("5tulw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fc73347a812c635$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      const f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */ var $3fc73347a812c635$var$unfold = /*#__PURE__*/ (0, $7SxCN.default)(function unfold(fn, seed) {
    var pair = fn(seed);
    var result = [];
    while(pair && pair.length){
        result[result.length] = pair[0];
        pair = fn(pair[1]);
    }
    return result;
});
var $3fc73347a812c635$export$2e2bcd8739ae039 = $3fc73347a812c635$var$unfold;

});

parcelRegister("fS9mq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8e328fc88889769$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $7SxCN = parcelRequire("7SxCN");

var $d8dol = parcelRequire("d8dol");

var $7bi4H = parcelRequire("7bi4H");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var $b8e328fc88889769$var$union = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $d8dol.default)((0, $7bi4H.default), (0, $aikTT.default)));
var $b8e328fc88889769$export$2e2bcd8739ae039 = $b8e328fc88889769$var$union;

});

parcelRegister("3nZNT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $277375fe4b05ea82$export$2e2bcd8739ae039; });

var $aikTT = parcelRequire("aikTT");

var $jS880 = parcelRequire("jS880");

var $ehShu = parcelRequire("ehShu");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */ var $277375fe4b05ea82$var$unionWith = /*#__PURE__*/ (0, $jS880.default)(function unionWith(pred, list1, list2) {
    return (0, $ehShu.default)(pred, (0, $aikTT.default)(list1, list2));
});
var $277375fe4b05ea82$export$2e2bcd8739ae039 = $277375fe4b05ea82$var$unionWith;

});
parcelRegister("ehShu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a66cc249f8e883bc$export$2e2bcd8739ae039; });

var $fzpVf = parcelRequire("fzpVf");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */ var $a66cc249f8e883bc$var$uniqWith = /*#__PURE__*/ (0, $7SxCN.default)(function uniqWith(pred, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var item;
    while(idx < len){
        item = list[idx];
        if (!(0, $fzpVf.default)(pred, item, result)) result[result.length] = item;
        idx += 1;
    }
    return result;
});
var $a66cc249f8e883bc$export$2e2bcd8739ae039 = $a66cc249f8e883bc$var$uniqWith;

});


parcelRegister("fyXYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5488ec7fb47c5d1$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when, R.cond
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */ var $b5488ec7fb47c5d1$var$unless = /*#__PURE__*/ (0, $jS880.default)(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
});
var $b5488ec7fb47c5d1$export$2e2bcd8739ae039 = $b5488ec7fb47c5d1$var$unless;

});

parcelRegister("7PFNx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b3db807d0bef66e$export$2e2bcd8739ae039; });

var $kRggf = parcelRequire("kRggf");

var $5wd4K = parcelRequire("5wd4K");
/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var $5b3db807d0bef66e$var$unnest = /*#__PURE__*/ (0, $5wd4K.default)((0, $kRggf.default));
var $5b3db807d0bef66e$export$2e2bcd8739ae039 = $5b3db807d0bef66e$var$unnest;

});

parcelRegister("2S00s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2170a128e2c133f3$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */ var $2170a128e2c133f3$var$until = /*#__PURE__*/ (0, $jS880.default)(function until(pred, fn, init) {
    var val = init;
    while(!pred(val))val = fn(val);
    return val;
});
var $2170a128e2c133f3$export$2e2bcd8739ae039 = $2170a128e2c133f3$var$until;

});

parcelRegister("1kT3U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f925ee23251634d$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var $0f925ee23251634d$var$valuesIn = /*#__PURE__*/ (0, $1t1xO.default)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
var $0f925ee23251634d$export$2e2bcd8739ae039 = $0f925ee23251634d$var$valuesIn;

});

parcelRegister("bTuJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a8cab4aa87e2dd4$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
// `Const` is a functor that effectively ignores the function given to `map`.
var $8a8cab4aa87e2dd4$var$Const = function(x) {
    return {
        value: x,
        "fantasy-land/map": function() {
            return this;
        }
    };
};
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */ var $8a8cab4aa87e2dd4$var$view = /*#__PURE__*/ (0, $7SxCN.default)(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens($8a8cab4aa87e2dd4$var$Const)(x).value;
});
var $8a8cab4aa87e2dd4$export$2e2bcd8739ae039 = $8a8cab4aa87e2dd4$var$view;

});

parcelRegister("7Dogi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58eefed053cb042f$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var $58eefed053cb042f$var$when = /*#__PURE__*/ (0, $jS880.default)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
var $58eefed053cb042f$export$2e2bcd8739ae039 = $58eefed053cb042f$var$when;

});

parcelRegister("a2qh2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74ee78bc08fd8323$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $bKOTe = parcelRequire("bKOTe");
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */ var $74ee78bc08fd8323$var$where = /*#__PURE__*/ (0, $7SxCN.default)(function where(spec, testObj) {
    for(var prop in spec){
        if ((0, $bKOTe.default)(prop, spec) && !spec[prop](testObj[prop])) return false;
    }
    return true;
});
var $74ee78bc08fd8323$export$2e2bcd8739ae039 = $74ee78bc08fd8323$var$where;

});

parcelRegister("3G9aT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2adc6941da96aa59$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $g5jN3 = parcelRequire("g5jN3");

var $kuJWW = parcelRequire("kuJWW");

var $a2qh2 = parcelRequire("a2qh2");
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */ var $2adc6941da96aa59$var$whereEq = /*#__PURE__*/ (0, $7SxCN.default)(function whereEq(spec, testObj) {
    return (0, $a2qh2.default)((0, $kuJWW.default)((0, $g5jN3.default), spec), testObj);
});
var $2adc6941da96aa59$export$2e2bcd8739ae039 = $2adc6941da96aa59$var$whereEq;

});

parcelRegister("8BqOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64369378d9a9e357$export$2e2bcd8739ae039; });

var $4f6Vj = parcelRequire("4f6Vj");

var $7SxCN = parcelRequire("7SxCN");

var $d071Y = parcelRequire("d071Y");

var $2m6Qn = parcelRequire("2m6Qn");
/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var $64369378d9a9e357$var$without = /*#__PURE__*/ (0, $7SxCN.default)(function(xs, list) {
    return (0, $2m6Qn.default)((0, $d071Y.default)((0, $4f6Vj.default))(xs), list);
});
var $64369378d9a9e357$export$2e2bcd8739ae039 = $64369378d9a9e357$var$without;

});

parcelRegister("dQoDX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1433f5f4c8d07b2$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */ var $a1433f5f4c8d07b2$var$xprod = /*#__PURE__*/ (0, $7SxCN.default)(function xprod(a, b) {
    // = xprodWith(prepend); (takes about 3 times as long...)
    var idx = 0;
    var ilen = a.length;
    var j;
    var jlen = b.length;
    var result = [];
    while(idx < ilen){
        j = 0;
        while(j < jlen){
            result[result.length] = [
                a[idx],
                b[j]
            ];
            j += 1;
        }
        idx += 1;
    }
    return result;
});
var $a1433f5f4c8d07b2$export$2e2bcd8739ae039 = $a1433f5f4c8d07b2$var$xprod;

});

parcelRegister("ij5yn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d53e4f2617269976$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */ var $d53e4f2617269976$var$zip = /*#__PURE__*/ (0, $7SxCN.default)(function zip(a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = [
            a[idx],
            b[idx]
        ];
        idx += 1;
    }
    return rv;
});
var $d53e4f2617269976$export$2e2bcd8739ae039 = $d53e4f2617269976$var$zip;

});

parcelRegister("bTYI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $023c734c92cfafb9$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");
/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */ var $023c734c92cfafb9$var$zipObj = /*#__PURE__*/ (0, $7SxCN.default)(function zipObj(keys, values) {
    var idx = 0;
    var len = Math.min(keys.length, values.length);
    var out = {};
    while(idx < len){
        out[keys[idx]] = values[idx];
        idx += 1;
    }
    return out;
});
var $023c734c92cfafb9$export$2e2bcd8739ae039 = $023c734c92cfafb9$var$zipObj;

});

parcelRegister("6gOf8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $490b35eff4ce0e0c$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");
/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      const f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */ var $490b35eff4ce0e0c$var$zipWith = /*#__PURE__*/ (0, $jS880.default)(function zipWith(fn, a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = fn(a[idx], b[idx]);
        idx += 1;
    }
    return rv;
});
var $490b35eff4ce0e0c$export$2e2bcd8739ae039 = $490b35eff4ce0e0c$var$zipWith;

});

parcelRegister("bxtlX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86698bae7061fbb3$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");

var $1t1xO = parcelRequire("1t1xO");
/**
 * Creates a thunk out of a function. A thunk delays a calculation until
 * its result is needed, providing lazy evaluation of arguments.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
 * @param {Function} fn A function to wrap in a thunk
 * @return {Function} Expects arguments for `fn` and returns a new function
 *  that, when called, applies those arguments to `fn`.
 * @see R.partial, R.partialRight
 * @example
 *
 *      R.thunkify(R.identity)(42)(); //=> 42
 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
 */ var $86698bae7061fbb3$var$thunkify = /*#__PURE__*/ (0, $1t1xO.default)(function thunkify(fn) {
    return (0, $dB93a.default)(fn.length, function createThunk() {
        var fnArgs = arguments;
        return function invokeThunk() {
            return fn.apply(this, fnArgs);
        };
    });
});
var $86698bae7061fbb3$export$2e2bcd8739ae039 = $86698bae7061fbb3$var$thunkify;

});


parcelRegister("dEow7", function(module, exports) {

$parcel$export(module.exports, "isNotUndefined", function () { return (parcelRequire("jNpFq")).default; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("8kRo3")).default; });
$parcel$export(module.exports, "isNull", function () { return (parcelRequire("5tUFs")).default; });
$parcel$export(module.exports, "isNotNull", function () { return (parcelRequire("6G8Ri")).default; });
$parcel$export(module.exports, "isNotNil", function () { return (parcelRequire("5tela")).default; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("e6sx7")).default; });
$parcel$export(module.exports, "isIterable", function () { return (parcelRequire("dZ54d")).default; });
$parcel$export(module.exports, "isEmptyArray", function () { return (parcelRequire("glFqn")).default; });
$parcel$export(module.exports, "isNotArray", function () { return (parcelRequire("5O8bC")).default; });
$parcel$export(module.exports, "isNonEmptyArray", function () { return (parcelRequire("9FoQ0")).default; });
$parcel$export(module.exports, "isBoolean", function () { return (parcelRequire("lWNtl")).default; });
$parcel$export(module.exports, "isNotBoolean", function () { return (parcelRequire("5MYMg")).default; });
$parcel$export(module.exports, "isNilOrEmpty", function () { return (parcelRequire("56nDa")).default; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("dfegI")).default; });
$parcel$export(module.exports, "isEmptyString", function () { return (parcelRequire("9ecXn")).default; });
$parcel$export(module.exports, "isNotString", function () { return (parcelRequire("5txwX")).default; });
$parcel$export(module.exports, "isNonEmptyString", function () { return (parcelRequire("eAKce")).default; });
$parcel$export(module.exports, "isArrayLike", function () { return (parcelRequire("ldL2E")).default; });
$parcel$export(module.exports, "isNotArrayLike", function () { return (parcelRequire("hUnxc")).default; });
$parcel$export(module.exports, "isGeneratorFunction", function () { return (parcelRequire("fweXm")).default; });
$parcel$export(module.exports, "isNotGeneratorFunction", function () { return (parcelRequire("axRPu")).default; });
$parcel$export(module.exports, "isAsyncFunction", function () { return (parcelRequire("6SOlc")).default; });
$parcel$export(module.exports, "isNotAsyncFunction", function () { return (parcelRequire("592rr")).default; });
$parcel$export(module.exports, "isFunction", function () { return (parcelRequire("3bTqG")).default; });
$parcel$export(module.exports, "isNotFunction", function () { return (parcelRequire("bVQiS")).default; });
$parcel$export(module.exports, "isObj", function () { return (parcelRequire("gXHlo")).default; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("gXHlo")).default; });
$parcel$export(module.exports, "isNotObj", function () { return (parcelRequire("j6MrB")).default; });
$parcel$export(module.exports, "isNotObject", function () { return (parcelRequire("j6MrB")).default; });
$parcel$export(module.exports, "isObjLike", function () { return (parcelRequire("bXZyz")).default; });
$parcel$export(module.exports, "isObjectLike", function () { return (parcelRequire("bXZyz")).default; });
$parcel$export(module.exports, "isNotObjLike", function () { return (parcelRequire("cx4Ff")).default; });
$parcel$export(module.exports, "isNotObjectLike", function () { return (parcelRequire("cx4Ff")).default; });
$parcel$export(module.exports, "isPlainObj", function () { return (parcelRequire("iI0iH")).default; });
$parcel$export(module.exports, "isPlainObject", function () { return (parcelRequire("iI0iH")).default; });
$parcel$export(module.exports, "isNotPlainObj", function () { return (parcelRequire("8QC20")).default; });
$parcel$export(module.exports, "isNotPlainObject", function () { return (parcelRequire("8QC20")).default; });
$parcel$export(module.exports, "isDate", function () { return (parcelRequire("ku47P")).default; });
$parcel$export(module.exports, "isNotDate", function () { return (parcelRequire("hGZdq")).default; });
$parcel$export(module.exports, "isValidDate", function () { return (parcelRequire("ioNpK")).default; });
$parcel$export(module.exports, "isNotValidDate", function () { return (parcelRequire("1gum4")).default; });
$parcel$export(module.exports, "isInvalidDate", function () { return (parcelRequire("1gum4")).default; });
$parcel$export(module.exports, "isNumber", function () { return (parcelRequire("3oTRA")).default; });
$parcel$export(module.exports, "isNotNumber", function () { return (parcelRequire("jAoYq")).default; });
$parcel$export(module.exports, "isPositive", function () { return (parcelRequire("iU4Dt")).default; });
$parcel$export(module.exports, "isNegative", function () { return (parcelRequire("dT8Yh")).default; });
$parcel$export(module.exports, "isPositiveZero", function () { return (parcelRequire("c5LNt")).default; });
$parcel$export(module.exports, "isNegativeZero", function () { return (parcelRequire("50VsB")).default; });
$parcel$export(module.exports, "isNotNilOrEmpty", function () { return (parcelRequire("lLbaw")).default; });
$parcel$export(module.exports, "isNonPositive", function () { return (parcelRequire("cSGIr")).default; });
$parcel$export(module.exports, "isNonNegative", function () { return (parcelRequire("j6NDQ")).default; });
$parcel$export(module.exports, "isMap", function () { return (parcelRequire("cgxHn")).default; });
$parcel$export(module.exports, "isNotMap", function () { return (parcelRequire("59E8v")).default; });
$parcel$export(module.exports, "isNaN", function () { return (parcelRequire("2pFkf")).default; });
$parcel$export(module.exports, "isNotNaN", function () { return (parcelRequire("Kqdh7")).default; });
$parcel$export(module.exports, "isFinite", function () { return (parcelRequire("6oaBx")).default; });
$parcel$export(module.exports, "isNotFinite", function () { return (parcelRequire("eaSfB")).default; });
$parcel$export(module.exports, "isInteger", function () { return (parcelRequire("ewjLt")).default; });
$parcel$export(module.exports, "isInteger32", function () { return (parcelRequire("gbVk5")).default; });
$parcel$export(module.exports, "isInt32", function () { return (parcelRequire("gbVk5")).default; });
$parcel$export(module.exports, "isNotInteger", function () { return (parcelRequire("3cPy4")).default; });
$parcel$export(module.exports, "isBigInt", function () { return (parcelRequire("j3Og3")).default; });
$parcel$export(module.exports, "isFloat", function () { return (parcelRequire("13BHH")).default; });
$parcel$export(module.exports, "isNotFloat", function () { return (parcelRequire("7TGUE")).default; });
$parcel$export(module.exports, "isValidNumber", function () { return (parcelRequire("5eGwM")).default; });
$parcel$export(module.exports, "isNotValidNumber", function () { return (parcelRequire("hQjiq")).default; });
$parcel$export(module.exports, "isOdd", function () { return (parcelRequire("aoozq")).default; });
$parcel$export(module.exports, "isEven", function () { return (parcelRequire("ac3f9")).default; });
$parcel$export(module.exports, "isPair", function () { return (parcelRequire("7wQ7L")).default; });
$parcel$export(module.exports, "isNotPair", function () { return (parcelRequire("2WMqP")).default; });
$parcel$export(module.exports, "isThenable", function () { return (parcelRequire("58WmH")).default; });
$parcel$export(module.exports, "isPromise", function () { return (parcelRequire("fsiza")).default; });
$parcel$export(module.exports, "isTrue", function () { return (parcelRequire("khZor")).default; });
$parcel$export(module.exports, "isFalse", function () { return (parcelRequire("306Ph")).default; });
$parcel$export(module.exports, "isTruthy", function () { return (parcelRequire("gKUk2")).default; });
$parcel$export(module.exports, "isFalsy", function () { return (parcelRequire("1z2ql")).default; });
$parcel$export(module.exports, "isRegExp", function () { return (parcelRequire("5Sepw")).default; });
$parcel$export(module.exports, "isNotRegExp", function () { return (parcelRequire("c9fzk")).default; });
$parcel$export(module.exports, "isSet", function () { return (parcelRequire("kQkuJ")).default; });
$parcel$export(module.exports, "isNotSet", function () { return (parcelRequire("cvlhM")).default; });
$parcel$export(module.exports, "isSparseArray", function () { return (parcelRequire("8gxm0")).default; });
$parcel$export(module.exports, "isSymbol", function () { return (parcelRequire("lya3B")).default; });
$parcel$export(module.exports, "isSafeInteger", function () { return (parcelRequire("e8T5a")).default; });
$parcel$export(module.exports, "isIndexed", function () { return (parcelRequire("iM6tT")).default; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("3nefM")).default; });
$parcel$export(module.exports, "isNaturalNumber", function () { return (parcelRequire("262QT")).default; });
$parcel$export(module.exports, "isPrimitive", function () { return (parcelRequire("1oBpa")).default; });
$parcel$export(module.exports, "isNotPrimitive", function () { return (parcelRequire("gongf")).default; });
$parcel$export(module.exports, "isSentinelValue", function () { return (parcelRequire("gbnV6")).default; });
$parcel$export(module.exports, "stubUndefined", function () { return (parcelRequire("cFBID")).default; });
$parcel$export(module.exports, "stubNull", function () { return (parcelRequire("i5Pe0")).default; });
$parcel$export(module.exports, "stubObj", function () { return (parcelRequire("aszA4")).default; });
$parcel$export(module.exports, "stubObject", function () { return (parcelRequire("aszA4")).default; });
$parcel$export(module.exports, "stubString", function () { return (parcelRequire("fC5N5")).default; });
$parcel$export(module.exports, "stubArray", function () { return (parcelRequire("efwsS")).default; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("iVGTE")).default; });
$parcel$export(module.exports, "liftFN", function () { return (parcelRequire("5S7nt")).default; });
$parcel$export(module.exports, "liftF", function () { return (parcelRequire("74Hse")).default; });
$parcel$export(module.exports, "cata", function () { return (parcelRequire("l6WlR")).default; });
$parcel$export(module.exports, "weave", function () { return (parcelRequire("fTdvD")).default; });
$parcel$export(module.exports, "weaveLazy", function () { return (parcelRequire("gNm7Y")).default; });
$parcel$export(module.exports, "curryRightN", function () { return (parcelRequire("kcVpq")).default; });
$parcel$export(module.exports, "curryRight", function () { return (parcelRequire("54Y3h")).default; });
$parcel$export(module.exports, "allP", function () { return (parcelRequire("87any")).default; });
$parcel$export(module.exports, "catchP", function () { return (parcelRequire("acskY")).default; });
$parcel$export(module.exports, "noneP", function () { return (parcelRequire("hFZDv")).default; });
$parcel$export(module.exports, "resolveP", function () { return (parcelRequire("4ee2H")).default; });
$parcel$export(module.exports, "rejectP", function () { return (parcelRequire("h2ky7")).default; });
$parcel$export(module.exports, "delayP", function () { return (parcelRequire("nQKpt")).default; });
$parcel$export(module.exports, "thenP", function () { return (parcelRequire("c0GXY")).default; });
$parcel$export(module.exports, "then", function () { return (parcelRequire("c0GXY")).default; });
$parcel$export(module.exports, "thenCatchP", function () { return (parcelRequire("2ahRB")).default; });
$parcel$export(module.exports, "allSettledP", function () { return (parcelRequire("6jLdq")).default; });
$parcel$export(module.exports, "Y", function () { return (parcelRequire("h00QP")).default; });
$parcel$export(module.exports, "seq", function () { return (parcelRequire("1PZjc")).default; });
$parcel$export(module.exports, "sequencing", function () { return (parcelRequire("1PZjc")).default; });
$parcel$export(module.exports, "dispatch", function () { return (parcelRequire("3CRmW")).default; });
$parcel$export(module.exports, "async", function () { return (parcelRequire("1Zrxr")).default; });
$parcel$export(module.exports, "anyP", function () { return (parcelRequire("7Oks5")).default; });
$parcel$export(module.exports, "firstP", function () { return (parcelRequire("7Oks5")).default; });
$parcel$export(module.exports, "lastP", function () { return (parcelRequire("4ODKn")).default; });
$parcel$export(module.exports, "fnull", function () { return (parcelRequire("3AGSj")).default; });
$parcel$export(module.exports, "mapIndexed", function () { return (parcelRequire("fsyKq")).default; });
$parcel$export(module.exports, "reduceIndexed", function () { return (parcelRequire("2DsmD")).default; });
$parcel$export(module.exports, "filterIndexed", function () { return (parcelRequire("1EZZc")).default; });
$parcel$export(module.exports, "pickIndexes", function () { return (parcelRequire("bObFg")).default; });
$parcel$export(module.exports, "list", function () { return (parcelRequire("3KuR9")).default; });
$parcel$export(module.exports, "ensureArray", function () { return (parcelRequire("93hMZ")).default; });
$parcel$export(module.exports, "concatAll", function () { return (parcelRequire("dL6Up")).default; });
$parcel$export(module.exports, "concatRight", function () { return (parcelRequire("6qh0M")).default; });
$parcel$export(module.exports, "reduceP", function () { return (parcelRequire("7jBKJ")).default; });
$parcel$export(module.exports, "reduceRightP", function () { return (parcelRequire("lc8sJ")).default; });
$parcel$export(module.exports, "sliceFrom", function () { return (parcelRequire("aim6A")).default; });
$parcel$export(module.exports, "sliceTo", function () { return (parcelRequire("bTKOy")).default; });
$parcel$export(module.exports, "omitIndexes", function () { return (parcelRequire("4CQIa")).default; });
$parcel$export(module.exports, "compact", function () { return (parcelRequire("60LWC")).default; });
$parcel$export(module.exports, "appendFlipped", function () { return (parcelRequire("hHp2k")).default; });
$parcel$export(module.exports, "contained", function () { return (parcelRequire("hCFXH")).default; });
$parcel$export(module.exports, "included", function () { return (parcelRequire("hCFXH")).default; });
$parcel$export(module.exports, "move", function () { return (parcelRequire("jLlIA")).default; });
$parcel$export(module.exports, "lengthGt", function () { return (parcelRequire("dadMr")).default; });
$parcel$export(module.exports, "lengthLt", function () { return (parcelRequire("4rOEB")).default; });
$parcel$export(module.exports, "lengthGte", function () { return (parcelRequire("2Hum2")).default; });
$parcel$export(module.exports, "lengthLte", function () { return (parcelRequire("d31Hk")).default; });
$parcel$export(module.exports, "lengthEq", function () { return (parcelRequire("2W6Rh")).default; });
$parcel$export(module.exports, "lengthNotEq", function () { return (parcelRequire("g17V5")).default; });
$parcel$export(module.exports, "allEqual", function () { return (parcelRequire("llWNQ")).default; });
$parcel$export(module.exports, "repeatStr", function () { return (parcelRequire("gvRc1")).default; });
$parcel$export(module.exports, "allIdentical", function () { return (parcelRequire("3NadV")).default; });
$parcel$export(module.exports, "allIdenticalTo", function () { return (parcelRequire("iWW6f")).default; });
$parcel$export(module.exports, "allEqualTo", function () { return (parcelRequire("54xOI")).default; });
$parcel$export(module.exports, "flattenDepth", function () { return (parcelRequire("jtqZq")).default; });
$parcel$export(module.exports, "toArray", function () { return (parcelRequire("6vx1B")).default; });
$parcel$export(module.exports, "allUnique", function () { return (parcelRequire("bxwOI")).default; });
$parcel$export(module.exports, "notAllUnique", function () { return (parcelRequire("9jEtz")).default; });
$parcel$export(module.exports, "sortByProps", function () { return (parcelRequire("etCQh")).default; });
$parcel$export(module.exports, "skipTake", function () { return (parcelRequire("lJ5Ew")).default; });
$parcel$export(module.exports, "rangeStep", function () { return (parcelRequire("bvJ91")).default; });
$parcel$export(module.exports, "findOr", function () { return (parcelRequire("a4xop")).default; });
$parcel$export(module.exports, "invoke", function () { return (parcelRequire("zd3rL")).default; });
$parcel$export(module.exports, "invokeArgs", function () { return (parcelRequire("1etMX")).default; });
$parcel$export(module.exports, "paths", function () { return (parcelRequire("h8uW6")).default; });
$parcel$export(module.exports, "renameKeys", function () { return (parcelRequire("5BXis")).default; });
$parcel$export(module.exports, "renameKeysWith", function () { return (parcelRequire("h3meP")).default; });
$parcel$export(module.exports, "renameKeyWith", function () { return (parcelRequire("7nAsU")).default; });
$parcel$export(module.exports, "copyKeys", function () { return (parcelRequire("6TSUg")).default; });
$parcel$export(module.exports, "mergeRight", function () { return (parcelRequire("7XFGY")).default; });
$parcel$export(module.exports, "mergeLeft", function () { return (parcelRequire("7XFGY")).default; });
$parcel$export(module.exports, "resetToDefault", function () { return (parcelRequire("7XFGY")).default; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("hFoHX")).default; });
$parcel$export(module.exports, "mergePaths", function () { return (parcelRequire("fcAzQ")).default; });
$parcel$export(module.exports, "mergeProp", function () { return (parcelRequire("kvLBi")).default; });
$parcel$export(module.exports, "mergePath", function () { return (parcelRequire("6sMaS")).default; });
$parcel$export(module.exports, "omitBy", function () { return (parcelRequire("cvsfr")).default; });
$parcel$export(module.exports, "pathOrLazy", function () { return (parcelRequire("guhxN")).default; });
$parcel$export(module.exports, "viewOr", function () { return (parcelRequire("dZyir")).default; });
$parcel$export(module.exports, "hasPath", function () { return (parcelRequire("2n2XG")).default; });
$parcel$export(module.exports, "spreadProp", function () { return (parcelRequire("10MZY")).default; });
$parcel$export(module.exports, "spreadPath", function () { return (parcelRequire("iMNmG")).default; });
$parcel$export(module.exports, "flattenProp", function () { return (parcelRequire("5cCu0")).default; });
$parcel$export(module.exports, "flattenPath", function () { return (parcelRequire("4gLhi")).default; });
$parcel$export(module.exports, "unzipObjWith", function () { return (parcelRequire("dbyvg")).default; });
$parcel$export(module.exports, "zipObjWith", function () { return (parcelRequire("bFD7S")).default; });
$parcel$export(module.exports, "isPrototypeOf", function () { return (parcelRequire("CpHMV")).default; });
$parcel$export(module.exports, "lensEq", function () { return (parcelRequire("4eamc")).default; });
$parcel$export(module.exports, "lensNotEq", function () { return (parcelRequire("gRumg")).default; });
$parcel$export(module.exports, "lensSatisfies", function () { return (parcelRequire("kgFFL")).default; });
$parcel$export(module.exports, "lensNotSatisfy", function () { return (parcelRequire("70lIp")).default; });
$parcel$export(module.exports, "lensTraverse", function () { return (parcelRequire("9M2BF")).default; });
$parcel$export(module.exports, "lensIso", function () { return (parcelRequire("474Ln")).default; });
$parcel$export(module.exports, "propNotEq", function () { return (parcelRequire("en3mS")).default; });
$parcel$export(module.exports, "pathNotEq", function () { return (parcelRequire("i5hPo")).default; });
$parcel$export(module.exports, "inRange", function () { return (parcelRequire("9tnVe")).default; });
$parcel$export(module.exports, "notEqual", function () { return (parcelRequire("duYb5")).default; });
$parcel$export(module.exports, "overlaps", function () { return (parcelRequire("j25wW")).default; });
$parcel$export(module.exports, "isNotEmpty", function () { return (parcelRequire("7xCIx")).default; });
$parcel$export(module.exports, "defaultWhen", function () { return (parcelRequire("9V3Lk")).default; });
$parcel$export(module.exports, "notBoth", function () { return (parcelRequire("kckpG")).default; });
$parcel$export(module.exports, "nand", function () { return (parcelRequire("gE7ET")).default; });
$parcel$export(module.exports, "neither", function () { return (parcelRequire("9hJsg")).default; });
$parcel$export(module.exports, "nor", function () { return (parcelRequire("cRO1N")).default; });
$parcel$export(module.exports, "notAllPass", function () { return (parcelRequire("e4Jnx")).default; });
$parcel$export(module.exports, "nonePass", function () { return (parcelRequire("axR6A")).default; });
$parcel$export(module.exports, "argsPass", function () { return (parcelRequire("jP8KW")).default; });
$parcel$export(module.exports, "dropArgs", function () { return (parcelRequire("csOEg")).default; });
$parcel$export(module.exports, "round", function () { return (parcelRequire("bL45h")).default; });
$parcel$export(module.exports, "ceil", function () { return (parcelRequire("ieYcH")).default; });
$parcel$export(module.exports, "divideNum", function () { return (parcelRequire("ltHaS")).default; });
$parcel$export(module.exports, "floor", function () { return (parcelRequire("bpujt")).default; });
$parcel$export(module.exports, "trunc", function () { return (parcelRequire("dwfAf")).default; });
$parcel$export(module.exports, "sign", function () { return (parcelRequire("iOlIK")).default; });
$parcel$export(module.exports, "subtractNum", function () { return (parcelRequire("isp3P")).default; });
$parcel$export(module.exports, "toInteger32", function () { return (parcelRequire("kZCME")).default; });
$parcel$export(module.exports, "toInt32", function () { return (parcelRequire("kZCME")).default; });
$parcel$export(module.exports, "toUinteger32", function () { return (parcelRequire("96bCG")).default; });
$parcel$export(module.exports, "toUint32", function () { return (parcelRequire("96bCG")).default; });
$parcel$export(module.exports, "toNumber", function () { return (parcelRequire("8gPA2")).default; });
$parcel$export(module.exports, "replaceAll", function () { return (parcelRequire("1ANUb")).default; });
$parcel$export(module.exports, "escapeRegExp", function () { return (parcelRequire("2vmc2")).default; });
$parcel$export(module.exports, "trimStart", function () { return (parcelRequire("4SKBh")).default; });
$parcel$export(module.exports, "trimLeft", function () { return (parcelRequire("4SKBh")).default; });
$parcel$export(module.exports, "trimEnd", function () { return (parcelRequire("fC8FZ")).default; });
$parcel$export(module.exports, "trimRight", function () { return (parcelRequire("fC8FZ")).default; });
$parcel$export(module.exports, "trimCharsEnd", function () { return (parcelRequire("fc4he")).default; });
$parcel$export(module.exports, "trimCharsStart", function () { return (parcelRequire("dX3zi")).default; });
$parcel$export(module.exports, "padCharsStart", function () { return (parcelRequire("4SQMs")).default; });
$parcel$export(module.exports, "padCharsEnd", function () { return (parcelRequire("Ho3cj")).default; });
$parcel$export(module.exports, "padEnd", function () { return (parcelRequire("6CMhL")).default; });
$parcel$export(module.exports, "padStart", function () { return (parcelRequire("9hurd")).default; });
$parcel$export(module.exports, "Identity", function () { return (parcelRequire("j2AbX")).default; });
/**
 * @namespace RA
 */ // Type

var $jNpFq = parcelRequire("jNpFq");

var $8kRo3 = parcelRequire("8kRo3");

var $5tUFs = parcelRequire("5tUFs");

var $6G8Ri = parcelRequire("6G8Ri");

var $5tela = parcelRequire("5tela");

var $e6sx7 = parcelRequire("e6sx7");

var $dZ54d = parcelRequire("dZ54d");

var $glFqn = parcelRequire("glFqn");

var $5O8bC = parcelRequire("5O8bC");

var $9FoQ0 = parcelRequire("9FoQ0");

var $lWNtl = parcelRequire("lWNtl");

var $5MYMg = parcelRequire("5MYMg");

var $56nDa = parcelRequire("56nDa");

var $dfegI = parcelRequire("dfegI");

var $9ecXn = parcelRequire("9ecXn");

var $5txwX = parcelRequire("5txwX");

var $eAKce = parcelRequire("eAKce");

var $ldL2E = parcelRequire("ldL2E");

var $hUnxc = parcelRequire("hUnxc");

var $fweXm = parcelRequire("fweXm");

var $axRPu = parcelRequire("axRPu");

var $6SOlc = parcelRequire("6SOlc");

var $592rr = parcelRequire("592rr");

var $3bTqG = parcelRequire("3bTqG");

var $bVQiS = parcelRequire("bVQiS");

var $gXHlo = parcelRequire("gXHlo");

var $j6MrB = parcelRequire("j6MrB");

var $bXZyz = parcelRequire("bXZyz");

var $cx4Ff = parcelRequire("cx4Ff");

var $iI0iH = parcelRequire("iI0iH");

var $8QC20 = parcelRequire("8QC20");

var $ku47P = parcelRequire("ku47P");

var $hGZdq = parcelRequire("hGZdq");

var $ioNpK = parcelRequire("ioNpK");

var $1gum4 = parcelRequire("1gum4");

var $3oTRA = parcelRequire("3oTRA");

var $jAoYq = parcelRequire("jAoYq");

var $iU4Dt = parcelRequire("iU4Dt");

var $dT8Yh = parcelRequire("dT8Yh");

var $c5LNt = parcelRequire("c5LNt");

var $50VsB = parcelRequire("50VsB");

var $lLbaw = parcelRequire("lLbaw");

var $cSGIr = parcelRequire("cSGIr");

var $j6NDQ = parcelRequire("j6NDQ");

var $cgxHn = parcelRequire("cgxHn");

var $59E8v = parcelRequire("59E8v");

var $2pFkf = parcelRequire("2pFkf");

var $Kqdh7 = parcelRequire("Kqdh7");

var $6oaBx = parcelRequire("6oaBx");

var $eaSfB = parcelRequire("eaSfB");

var $ewjLt = parcelRequire("ewjLt");

var $gbVk5 = parcelRequire("gbVk5");

var $3cPy4 = parcelRequire("3cPy4");

var $j3Og3 = parcelRequire("j3Og3");

var $13BHH = parcelRequire("13BHH");

var $7TGUE = parcelRequire("7TGUE");

var $5eGwM = parcelRequire("5eGwM");

var $hQjiq = parcelRequire("hQjiq");

var $aoozq = parcelRequire("aoozq");

var $ac3f9 = parcelRequire("ac3f9");

var $7wQ7L = parcelRequire("7wQ7L");

var $2WMqP = parcelRequire("2WMqP");

var $58WmH = parcelRequire("58WmH");

var $fsiza = parcelRequire("fsiza");

var $khZor = parcelRequire("khZor");

var $306Ph = parcelRequire("306Ph");

var $gKUk2 = parcelRequire("gKUk2");

var $1z2ql = parcelRequire("1z2ql");

var $5Sepw = parcelRequire("5Sepw");

var $c9fzk = parcelRequire("c9fzk");

var $kQkuJ = parcelRequire("kQkuJ");

var $cvlhM = parcelRequire("cvlhM");

var $8gxm0 = parcelRequire("8gxm0");

var $lya3B = parcelRequire("lya3B");

var $e8T5a = parcelRequire("e8T5a");

var $iM6tT = parcelRequire("iM6tT");

var $3nefM = parcelRequire("3nefM");

var $262QT = parcelRequire("262QT");

var $1oBpa = parcelRequire("1oBpa");

var $gongf = parcelRequire("gongf");

var $gbnV6 = parcelRequire("gbnV6");

var $cFBID = parcelRequire("cFBID");

var $i5Pe0 = parcelRequire("i5Pe0");

var $aszA4 = parcelRequire("aszA4");

var $fC5N5 = parcelRequire("fC5N5");

var $efwsS = parcelRequire("efwsS");

var $iVGTE = parcelRequire("iVGTE");

var $5S7nt = parcelRequire("5S7nt");

var $74Hse = parcelRequire("74Hse");

var $l6WlR = parcelRequire("l6WlR");

var $fTdvD = parcelRequire("fTdvD");

var $gNm7Y = parcelRequire("gNm7Y");

var $kcVpq = parcelRequire("kcVpq");

var $54Y3h = parcelRequire("54Y3h");

var $87any = parcelRequire("87any");

var $acskY = parcelRequire("acskY");

var $hFZDv = parcelRequire("hFZDv");

var $4ee2H = parcelRequire("4ee2H");

var $h2ky7 = parcelRequire("h2ky7");

var $nQKpt = parcelRequire("nQKpt");

var $c0GXY = parcelRequire("c0GXY");

var $2ahRB = parcelRequire("2ahRB");

var $6jLdq = parcelRequire("6jLdq");

var $h00QP = parcelRequire("h00QP");

var $1PZjc = parcelRequire("1PZjc");

var $3CRmW = parcelRequire("3CRmW");

var $1Zrxr = parcelRequire("1Zrxr");

var $7Oks5 = parcelRequire("7Oks5");

var $4ODKn = parcelRequire("4ODKn");

var $3AGSj = parcelRequire("3AGSj");

var $fsyKq = parcelRequire("fsyKq");

var $2DsmD = parcelRequire("2DsmD");

var $1EZZc = parcelRequire("1EZZc");

var $bObFg = parcelRequire("bObFg");

var $3KuR9 = parcelRequire("3KuR9");

var $93hMZ = parcelRequire("93hMZ");

var $dL6Up = parcelRequire("dL6Up");

var $6qh0M = parcelRequire("6qh0M");

var $7jBKJ = parcelRequire("7jBKJ");

var $lc8sJ = parcelRequire("lc8sJ");

var $aim6A = parcelRequire("aim6A");

var $bTKOy = parcelRequire("bTKOy");

var $4CQIa = parcelRequire("4CQIa");

var $60LWC = parcelRequire("60LWC");

var $hHp2k = parcelRequire("hHp2k");

var $hCFXH = parcelRequire("hCFXH");

var $jLlIA = parcelRequire("jLlIA");

var $dadMr = parcelRequire("dadMr");

var $4rOEB = parcelRequire("4rOEB");

var $2Hum2 = parcelRequire("2Hum2");

var $d31Hk = parcelRequire("d31Hk");

var $2W6Rh = parcelRequire("2W6Rh");

var $g17V5 = parcelRequire("g17V5");

var $llWNQ = parcelRequire("llWNQ");

var $gvRc1 = parcelRequire("gvRc1");

var $3NadV = parcelRequire("3NadV");

var $iWW6f = parcelRequire("iWW6f");

var $54xOI = parcelRequire("54xOI");

var $jtqZq = parcelRequire("jtqZq");

var $6vx1B = parcelRequire("6vx1B");

var $bxwOI = parcelRequire("bxwOI");

var $9jEtz = parcelRequire("9jEtz");

var $etCQh = parcelRequire("etCQh");

var $lJ5Ew = parcelRequire("lJ5Ew");

var $bvJ91 = parcelRequire("bvJ91");

var $a4xop = parcelRequire("a4xop");

var $zd3rL = parcelRequire("zd3rL");

var $1etMX = parcelRequire("1etMX");

var $h8uW6 = parcelRequire("h8uW6");

var $5BXis = parcelRequire("5BXis");

var $h3meP = parcelRequire("h3meP");

var $7nAsU = parcelRequire("7nAsU");

var $6TSUg = parcelRequire("6TSUg");

var $7XFGY = parcelRequire("7XFGY");

var $hFoHX = parcelRequire("hFoHX");

var $fcAzQ = parcelRequire("fcAzQ");

var $kvLBi = parcelRequire("kvLBi");

var $6sMaS = parcelRequire("6sMaS");

var $cvsfr = parcelRequire("cvsfr");

var $guhxN = parcelRequire("guhxN");

var $dZyir = parcelRequire("dZyir");

var $2n2XG = parcelRequire("2n2XG");

var $10MZY = parcelRequire("10MZY");

var $iMNmG = parcelRequire("iMNmG");

var $5cCu0 = parcelRequire("5cCu0");

var $4gLhi = parcelRequire("4gLhi");

var $dbyvg = parcelRequire("dbyvg");

var $bFD7S = parcelRequire("bFD7S");

var $CpHMV = parcelRequire("CpHMV");

var $4eamc = parcelRequire("4eamc");

var $gRumg = parcelRequire("gRumg");

var $kgFFL = parcelRequire("kgFFL");

var $70lIp = parcelRequire("70lIp");

var $9M2BF = parcelRequire("9M2BF");

var $474Ln = parcelRequire("474Ln");

var $en3mS = parcelRequire("en3mS");

var $i5hPo = parcelRequire("i5hPo");

var $9tnVe = parcelRequire("9tnVe");

var $duYb5 = parcelRequire("duYb5");

var $j25wW = parcelRequire("j25wW");

var $7xCIx = parcelRequire("7xCIx");

var $9V3Lk = parcelRequire("9V3Lk");

var $kckpG = parcelRequire("kckpG");

var $gE7ET = parcelRequire("gE7ET");

var $9hJsg = parcelRequire("9hJsg");

var $cRO1N = parcelRequire("cRO1N");

var $e4Jnx = parcelRequire("e4Jnx");

var $axR6A = parcelRequire("axR6A");

var $jP8KW = parcelRequire("jP8KW");

var $csOEg = parcelRequire("csOEg");

var $bL45h = parcelRequire("bL45h");

var $ieYcH = parcelRequire("ieYcH");

var $ltHaS = parcelRequire("ltHaS");

var $bpujt = parcelRequire("bpujt");

var $dwfAf = parcelRequire("dwfAf");

var $iOlIK = parcelRequire("iOlIK");

var $isp3P = parcelRequire("isp3P");

var $kZCME = parcelRequire("kZCME");

var $96bCG = parcelRequire("96bCG");

var $8gPA2 = parcelRequire("8gPA2");

var $1ANUb = parcelRequire("1ANUb");

var $2vmc2 = parcelRequire("2vmc2");

var $4SKBh = parcelRequire("4SKBh");

var $fC8FZ = parcelRequire("fC8FZ");

var $fc4he = parcelRequire("fc4he");

var $dX3zi = parcelRequire("dX3zi");

var $4SQMs = parcelRequire("4SQMs");

var $Ho3cj = parcelRequire("Ho3cj");

var $6CMhL = parcelRequire("6CMhL");

var $9hurd = parcelRequire("9hurd");

var $j2AbX = parcelRequire("j2AbX");

});
parcelRegister("jNpFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e69680e5b8bcb8d6$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $8kRo3 = parcelRequire("8kRo3");
/**
 * Checks if input value is complement `undefined`.
 *
 * @func isNotUndefined
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.0.1|v0.0.1}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isUndefined|isUndefined}
 * @example
 *
 * RA.isNotUndefined(1); //=> true
 * RA.isNotUndefined(undefined); //=> false
 * RA.isNotUndefined(null); //=> true
 */ var $e69680e5b8bcb8d6$var$isNotUndefined = (0, $fm6cm.default)((0, $8kRo3.default));
var $e69680e5b8bcb8d6$export$2e2bcd8739ae039 = $e69680e5b8bcb8d6$var$isNotUndefined;

});
parcelRegister("8kRo3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61199a87160b9221$export$2e2bcd8739ae039; });

var $g5jN3 = parcelRequire("g5jN3");

var $cFBID = parcelRequire("cFBID");
/**
 * Checks if input value is `undefined`.
 *
 * @func isUndefined
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.0.1|v0.0.1}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotUndefined|isNotUndefined}
 * @example
 *
 * RA.isUndefined(1); //=> false
 * RA.isUndefined(undefined); //=> true
 * RA.isUndefined(null); //=> false
 */ var $61199a87160b9221$var$isUndefined = (0, $g5jN3.default)((0, $cFBID.default)());
var $61199a87160b9221$export$2e2bcd8739ae039 = $61199a87160b9221$var$isUndefined;

});
parcelRegister("cFBID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93969292f9c9cce7$export$2e2bcd8739ae039; });

var $cdVZD = parcelRequire("cdVZD");
/**
 * A function that returns `undefined`.
 *
 * @func stubUndefined
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.0.0|v1.0.0}
 * @category Function
 * @sig ... -> undefined
 * @return {undefined}
 * @example
 *
 * RA.stubUndefined(); //=> undefined
 * RA.stubUndefined(1, 2, 3); //=> undefined
 */ var $93969292f9c9cce7$var$stubUndefined = (0, $cdVZD.default)(void 0); // eslint-disable-line no-void
var $93969292f9c9cce7$export$2e2bcd8739ae039 = $93969292f9c9cce7$var$stubUndefined;

});



parcelRegister("5tUFs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fdb9e367bd5a1d6$export$2e2bcd8739ae039; });

var $g5jN3 = parcelRequire("g5jN3");
/**
 * Checks if input value is `null`.
 *
 * @func isNull
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.1.0|v0.1.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotNull|isNotNull}
 * @example
 *
 * RA.isNull(1); //=> false
 * RA.isNull(undefined); //=> false
 * RA.isNull(null); //=> true
 */ var $3fdb9e367bd5a1d6$var$isNull = (0, $g5jN3.default)(null);
var $3fdb9e367bd5a1d6$export$2e2bcd8739ae039 = $3fdb9e367bd5a1d6$var$isNull;

});

parcelRegister("6G8Ri", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dcd89788f5f8f63$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $5tUFs = parcelRequire("5tUFs");
/**
 * Checks if input value is complement of `null`.
 *
 * @func isNotNull
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.1.0|v0.1.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNull|isNull}
 * @example
 *
 * RA.isNotNull(1); //=> true
 * RA.isNotNull(undefined); //=> true
 * RA.isNotNull(null); //=> false
 */ var $4dcd89788f5f8f63$var$isNotNull = (0, $fm6cm.default)((0, $5tUFs.default));
var $4dcd89788f5f8f63$export$2e2bcd8739ae039 = $4dcd89788f5f8f63$var$isNotNull;

});

parcelRegister("5tela", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fbac8e17a989d7c$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $1FHr3 = parcelRequire("1FHr3");
/**
 * Checks if input value is complement of `null` or `undefined`.
 *
 * @func isNotNil
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.3.0|v0.3.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link http://ramdajs.com/docs/#isNil|R.isNil}
 * @example
 *
 * RA.isNotNil(null); //=> false
 * RA.isNotNil(undefined); //=> false
 * RA.isNotNil(0); //=> true
 * RA.isNotNil([]); //=> true
 */ var $3fbac8e17a989d7c$var$isNotNil = (0, $fm6cm.default)((0, $1FHr3.default));
var $3fbac8e17a989d7c$export$2e2bcd8739ae039 = $3fbac8e17a989d7c$var$isNotNil;

});

parcelRegister("e6sx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a447c254a83671f6$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");

var $3bTqG = parcelRequire("3bTqG");
/**
 * Checks if input value is `Array`.
 *
 * @func isArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.3.0|v0.3.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotArray|isNotArray}
 * @example
 *
 * RA.isArray([]); //=> true
 * RA.isArray(null); //=> false
 * RA.isArray({}); //=> false
 */ var $a447c254a83671f6$var$isArray = (0, $dB93a.default)(1, (0, $3bTqG.default)(Array.isArray) ? Array.isArray : (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("Array")));
var $a447c254a83671f6$export$2e2bcd8739ae039 = $a447c254a83671f6$var$isArray;

});
parcelRegister("3bTqG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $252d654aa9b038d7$export$2e2bcd8739ae039; });

var $4qtNZ = parcelRequire("4qtNZ");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");

var $fweXm = parcelRequire("fweXm");

var $6SOlc = parcelRequire("6SOlc");
/**
 * Checks if input value is `Function`.
 *
 * @func isFunction
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotFunction|isNotFunction}, {@link RA.isAsyncFunction|isNotAsyncFunction}, {@link RA.isGeneratorFunction|isGeneratorFunction}
 * @example
 *
 * RA.isFunction(function test() { }); //=> true
 * RA.isFunction(function* test() { }); //=> true
 * RA.isFunction(async function test() { }); //=> true
 * RA.isFunction(() => {}); //=> true
 * RA.isFunction(null); //=> false
 * RA.isFunction('abc'); //=> false
 */ var $252d654aa9b038d7$var$isFunction = (0, $4qtNZ.default)([
    (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("Function")),
    (0, $fweXm.default),
    (0, $6SOlc.default)
]);
var $252d654aa9b038d7$export$2e2bcd8739ae039 = $252d654aa9b038d7$var$isFunction;

});
parcelRegister("fweXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4c5723619c2051f$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $3j7JT = parcelRequire("3j7JT");
var $gkCmd = parcelRequire("gkCmd");
var $felhC = parcelRequire("felhC");
var $IrzWh = parcelRequire("IrzWh");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
var $b4c5723619c2051f$var$GeneratorFunction = null;
var $b4c5723619c2051f$var$legacyCheck = null;
try {
    $b4c5723619c2051f$var$GeneratorFunction = new Function("return function* () {}")().constructor; // eslint-disable-line no-new-func
    $b4c5723619c2051f$var$legacyCheck = (0, $IrzWh.default)($b4c5723619c2051f$var$GeneratorFunction);
} catch (e) {
    $b4c5723619c2051f$var$legacyCheck = (0, $gkCmd.default);
}
/**
 * Checks if input value is `Generator Function`.
 *
 * @func isGeneratorFunction
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isFunction|isFunction}, {@link RA.isAsyncFunction|isAsyncFunction}, {@link RA.isNotGeneratorFunction|isNotGeneratorFunction}
 * @example
 *
 * RA.isGeneratorFunction(function* test() { }); //=> true
 * RA.isGeneratorFunction(null); //=> false
 * RA.isGeneratorFunction(function test() { }); //=> false
 * RA.isGeneratorFunction(() => {}); //=> false
 */ var $b4c5723619c2051f$var$isGeneratorFunction = (0, $dB93a.default)(1, (0, $3j7JT.default)((0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("GeneratorFunction")), $b4c5723619c2051f$var$legacyCheck));
var $b4c5723619c2051f$export$2e2bcd8739ae039 = $b4c5723619c2051f$var$isGeneratorFunction;

});

parcelRegister("6SOlc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $502ed5e1470117ae$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Checks if input value is `Async Function`.
 *
 * @func isAsyncFunction
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isFunction|isFunction}, {@link RA.isNotAsyncFunction|isNotAsyncFunction}, {@link RA.isGeneratorFunction|isGeneratorFunction}
 * @example
 *
 * RA.isAsyncFunction(async function test() { }); //=> true
 * RA.isAsyncFunction(null); //=> false
 * RA.isAsyncFunction(function test() { }); //=> false
 * RA.isAsyncFunction(() => {}); //=> false
 */ var $502ed5e1470117ae$var$isAsyncFunction = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("AsyncFunction")));
var $502ed5e1470117ae$export$2e2bcd8739ae039 = $502ed5e1470117ae$var$isAsyncFunction;

});



parcelRegister("dZ54d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2e4e70dab7ec251$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $j9bAE = parcelRequire("j9bAE");

var $3bTqG = parcelRequire("3bTqG");
/**
 * Checks whether the passed value is iterable.
 *
 * @func isIterable
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.18.0|v2.18.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#The_iterable_protocol}
 * @return {boolean}
 * @example
 *
 * RA.isIterable(['arrays', 'are', 'iterable']); //=> true
 * RA.isIterable('strings are iterable, too'); //=> true
 * RA.isIterable((function* () {})()); //=> true (generator objects are both iterable and iterators)
 *
 * RA.isIterable({}); //=> false
 * RA.isIterable(-0); //=> false
 * RA.isIterable(null); //=> false
 * RA.isIterable(undefined); //=> false
 */ var $a2e4e70dab7ec251$var$isIterable = (0, $dB93a.default)(1, function(val) {
    if (typeof Symbol === "undefined") return false;
    return (0, $j9bAE.default)(Symbol.iterator, Object(val)) && (0, $3bTqG.default)(val[Symbol.iterator]);
});
var $a2e4e70dab7ec251$export$2e2bcd8739ae039 = $a2e4e70dab7ec251$var$isIterable;

});

parcelRegister("glFqn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be6ebd8485507fd8$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $7DKgw = parcelRequire("7DKgw");

var $e6sx7 = parcelRequire("e6sx7");
/**
 * Checks if input value is an empty `Array`.
 *
 * @func isEmptyArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.4.0|v2.4.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotEmptyArray|isNotEmptyArray}
 * @example
 *
 * RA.isEmptyArray([]); // => true
 * RA.isEmptyArray([42]); // => false
 * RA.isEmptyArray({}); // => false
 * RA.isEmptyArray(null); // => false
 * RA.isEmptyArray(undefined); // => false
 * RA.isEmptyArray(42); // => false
 * RA.isEmptyArray('42'); // => false
 */ var $be6ebd8485507fd8$var$isEmptyArray = (0, $gi6wV.default)((0, $e6sx7.default), (0, $7DKgw.default));
var $be6ebd8485507fd8$export$2e2bcd8739ae039 = $be6ebd8485507fd8$var$isEmptyArray;

});

parcelRegister("5O8bC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43a7f8e4e25cef3a$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $e6sx7 = parcelRequire("e6sx7");
/**
 * Checks if input value is complement of `Array`
 *
 * @func isNotArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.3.0|v0.3.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isArray|isArray}
 * @example
 *
 * RA.isNotArray([]); //=> false
 * RA.isNotArray(null); //=> true
 * RA.isNotArray({}); //=> true
 */ var $43a7f8e4e25cef3a$var$isNotArray = (0, $fm6cm.default)((0, $e6sx7.default));
var $43a7f8e4e25cef3a$export$2e2bcd8739ae039 = $43a7f8e4e25cef3a$var$isNotArray;

});

parcelRegister("9FoQ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $709b35adb2e68602$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");

var $7xCIx = parcelRequire("7xCIx");

var $e6sx7 = parcelRequire("e6sx7");
/**
 * Checks if input value is not an empty `Array`.
 *
 * @func isNonEmptyArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.4.0|v2.4.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isEmptyArray|isEmptyArray}
 * @example
 *
 * RA.isNonEmptyArray([42]); // => true
 * RA.isNonEmptyArray([]); // => false
 * RA.isNonEmptyArray({}); // => false
 * RA.isNonEmptyArray(null); // => false
 * RA.isNonEmptyArray(undefined); // => false
 * RA.isNonEmptyArray(42); // => false
 * RA.isNonEmptyArray('42'); // => false
 */ var $709b35adb2e68602$var$isNonEmptyArray = (0, $gi6wV.default)((0, $e6sx7.default), (0, $7xCIx.default));
var $709b35adb2e68602$export$2e2bcd8739ae039 = $709b35adb2e68602$var$isNonEmptyArray;

});
parcelRegister("7xCIx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57d9a5ea5edc039b$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $7DKgw = parcelRequire("7DKgw");
/**
 * Returns true if the given value is not its type's empty value; `false` otherwise.
 *
 * @func isNotEmpty
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.4.0|v0.4.0}
 * @category Logic
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link http://ramdajs.com/docs/#isEmpty|R.isEmpty}
 * @example
 *
 * RA.isNotEmpty([1, 2, 3]); //=> true
 * RA.isNotEmpty([]); //=> false
 * RA.isNotEmpty(''); //=> false
 * RA.isNotEmpty(null); //=> true
 * RA.isNotEmpty(undefined): //=> true
 * RA.isNotEmpty({}); //=> false
 * RA.isNotEmpty({length: 0}); //=> true
 */ var $57d9a5ea5edc039b$var$isNotEmpty = (0, $fm6cm.default)((0, $7DKgw.default));
var $57d9a5ea5edc039b$export$2e2bcd8739ae039 = $57d9a5ea5edc039b$var$isNotEmpty;

});


parcelRegister("lWNtl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffa563ee5f2b556a$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Checks if input value is `Boolean`.
 *
 * @func isBoolean
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.3.0|v0.3.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotBoolean|isNotBoolean}
 * @example
 *
 * RA.isBoolean(false); //=> true
 * RA.isBoolean(true); //=> true
 * RA.isBoolean(null); //=> false
 */ var $ffa563ee5f2b556a$var$isBoolean = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("Boolean")));
var $ffa563ee5f2b556a$export$2e2bcd8739ae039 = $ffa563ee5f2b556a$var$isBoolean;

});

parcelRegister("5MYMg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $437094960e9003ae$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $lWNtl = parcelRequire("lWNtl");
/**
 * Checks if input value is complement of `Boolean`.
 *
 * @func isNotBoolean
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.3.0|v0.3.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isBoolean|isBoolean}
 * @example
 *
 * RA.isNotBoolean(false); //=> false
 * RA.isNotBoolean(true); //=> false
 * RA.isNotBoolean(null); //=> true
 */ var $437094960e9003ae$var$isNotBoolean = (0, $fm6cm.default)((0, $lWNtl.default));
var $437094960e9003ae$export$2e2bcd8739ae039 = $437094960e9003ae$var$isNotBoolean;

});

parcelRegister("56nDa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b6fd7dd73f4f24c$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $3j7JT = parcelRequire("3j7JT");
var $7DKgw = parcelRequire("7DKgw");
var $1FHr3 = parcelRequire("1FHr3");
/**
 * Returns `true` if the given value is its type's empty value, `null` or `undefined`.
 *
 * @func isNilOrEmpty
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.4.0|v0.4.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link http://ramdajs.com/docs/#isEmpty|R.isEmpty}, {@link http://ramdajs.com/docs/#isNil|R.isNil}
 * @example
 *
 * RA.isNilOrEmpty([1, 2, 3]); //=> false
 * RA.isNilOrEmpty([]); //=> true
 * RA.isNilOrEmpty(''); //=> true
 * RA.isNilOrEmpty(null); //=> true
 * RA.isNilOrEmpty(undefined): //=> true
 * RA.isNilOrEmpty({}); //=> true
 * RA.isNilOrEmpty({length: 0}); //=> false
 */ var $3b6fd7dd73f4f24c$var$isNilOrEmpty = (0, $dB93a.default)(1, (0, $3j7JT.default)((0, $1FHr3.default), (0, $7DKgw.default)));
var $3b6fd7dd73f4f24c$export$2e2bcd8739ae039 = $3b6fd7dd73f4f24c$var$isNilOrEmpty;

});

parcelRegister("dfegI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $027d0733ae7e8d37$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Checks if input value is `String`.
 *
 * @func isString
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.4.0|v0.4.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotString|isNotString}
 * @example
 *
 * RA.isString('abc'); //=> true
 * RA.isString(1); //=> false
 */ var $027d0733ae7e8d37$var$isString = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("String")));
var $027d0733ae7e8d37$export$2e2bcd8739ae039 = $027d0733ae7e8d37$var$isString;

});

parcelRegister("9ecXn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b7f78d068ac2fd1$export$2e2bcd8739ae039; });

var $g5jN3 = parcelRequire("g5jN3");
/**
 * Checks if input value is an empty `String`.
 *
 * @func isEmptyString
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.4.0|v2.4.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotEmptyString|isNotEmptyString}
 * @example
 *
 * RA.isEmptyString(''); // => true
 * RA.isEmptyString('42'); // => false
 * RA.isEmptyString(new String('42')); // => false
 * RA.isEmptyString(new String('')); // => false
 * RA.isEmptyString([42]); // => false
 * RA.isEmptyString({}); // => false
 * RA.isEmptyString(null); // => false
 * RA.isEmptyString(undefined); // => false
 * RA.isEmptyString(42); // => false
 */ var $6b7f78d068ac2fd1$var$isEmptyString = (0, $g5jN3.default)("");
var $6b7f78d068ac2fd1$export$2e2bcd8739ae039 = $6b7f78d068ac2fd1$var$isEmptyString;

});

parcelRegister("5txwX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fc9aba5c5be66dd$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $dfegI = parcelRequire("dfegI");
/**
 * Checks if input value is complement of `String`.
 *
 * @func isNotString
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.4.0|v0.4.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isString|isString}
 * @example
 *
 * RA.isNotString('abc'); //=> false
 * RA.isNotString(1); //=> true
 */ var $3fc9aba5c5be66dd$var$isNotString = (0, $fm6cm.default)((0, $dfegI.default));
var $3fc9aba5c5be66dd$export$2e2bcd8739ae039 = $3fc9aba5c5be66dd$var$isNotString;

});

parcelRegister("eAKce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9f8431977c8cba6$export$2e2bcd8739ae039; });

var $bKc8Z = parcelRequire("bKc8Z");

var $dfegI = parcelRequire("dfegI");

var $j6MrB = parcelRequire("j6MrB");

var $7xCIx = parcelRequire("7xCIx");
/**
 * Checks if input value is not an empty `String`.
 *
 * @func isNonEmptyString
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.4.0|v2.4.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isEmptyString|isEmptyString}
 * @example
 *
 * RA.isNonEmptyString('42'); // => true
 * RA.isNonEmptyString(''); // => false
 * RA.isNonEmptyString(new String('42')); // => false
 * RA.isNonEmptyString(new String('')); // => false
 * RA.isNonEmptyString([42]); // => false
 * RA.isNonEmptyString({}); // => false
 * RA.isNonEmptyString(null); // => false
 * RA.isNonEmptyString(undefined); // => false
 * RA.isNonEmptyString(42); // => false
 */ var $a9f8431977c8cba6$var$isNonEmptyString = (0, $bKc8Z.default)([
    (0, $dfegI.default),
    (0, $j6MrB.default),
    (0, $7xCIx.default)
]);
var $a9f8431977c8cba6$export$2e2bcd8739ae039 = $a9f8431977c8cba6$var$isNonEmptyString;

});
parcelRegister("j6MrB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de9427d901ae1444$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $gXHlo = parcelRequire("gXHlo");
/* eslint-disable max-len */ /**
 * Checks if input value is complement of language type of `Object`.
 *
 * @func isNotObj
 * @aliases isNotObject
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isObj|isObj}, {@link RA.isObjLike|isObjLike}, {@link RA.isPlainObj|isPlainObj}
 * @example
 *
 * RA.isNotObj({}); //=> false
 * RA.isNotObj([]); //=> false
 * RA.isNotObj(() => {}); //=> false
 * RA.isNotObj(null); //=> true
 * RA.isNotObj(undefined); //=> true
 */ /* eslint-enable max-len */ var $de9427d901ae1444$var$isNotObj = (0, $fm6cm.default)((0, $gXHlo.default));
var $de9427d901ae1444$export$2e2bcd8739ae039 = $de9427d901ae1444$var$isNotObj;

});
parcelRegister("gXHlo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c593c73e8df43d13$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");
var $3j7JT = parcelRequire("3j7JT");

var $6G8Ri = parcelRequire("6G8Ri");

var $3bTqG = parcelRequire("3bTqG");

var $31Wrd = parcelRequire("31Wrd");
/* eslint-disable max-len */ /**
 * Checks if input value is language type of `Object`.
 *
 * @func isObj
 * @aliases isObject
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotObj|isNotObj}, {@link RA.isObjLike|isObjLike}, {@link RA.isPlainObj|isPlainObj}
 * @example
 *
 * RA.isObj({}); //=> true
 * RA.isObj([]); //=> true
 * RA.isObj(() => {}); //=> true
 * RA.isObj(null); //=> false
 * RA.isObj(undefined); //=> false
 */ /* eslint-enable max-len */ var $c593c73e8df43d13$var$isObj = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $6G8Ri.default), (0, $3j7JT.default)((0, $31Wrd.default), (0, $3bTqG.default))));
var $c593c73e8df43d13$export$2e2bcd8739ae039 = $c593c73e8df43d13$var$isObj;

});
parcelRegister("31Wrd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $234ecba7cdf1e2a6$export$2e2bcd8739ae039; });
function $234ecba7cdf1e2a6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $234ecba7cdf1e2a6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $234ecba7cdf1e2a6$var$_typeof(obj);
}
var $234ecba7cdf1e2a6$var$isOfTypeObject = function isOfTypeObject(val) {
    return $234ecba7cdf1e2a6$var$_typeof(val) === "object";
};
var $234ecba7cdf1e2a6$export$2e2bcd8739ae039 = $234ecba7cdf1e2a6$var$isOfTypeObject;

});




parcelRegister("ldL2E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f72f4d680deb1b70$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $aTDBn = parcelRequire("aTDBn");

var $e6sx7 = parcelRequire("e6sx7");

var $dfegI = parcelRequire("dfegI");
function $f72f4d680deb1b70$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f72f4d680deb1b70$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f72f4d680deb1b70$var$_typeof(obj);
}
/* eslint-disable max-len */ /**
 * Tests whether or not an object is similar to an array.
 *
 * @func isArrayLike
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.9.0|v1.9.0}
 * @licence https://github.com/ramda/ramda/blob/master/LICENSE.txt
 * @category List
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @returns {boolean} `true` if `val` has a numeric length property and extreme indices defined; `false` otherwise.
 * @see {@link RA.isNotArrayLike|isNotArrayLike}

 * @example
 *
 * RA.isArrayLike([]); //=> true
 * RA.isArrayLike(true); //=> false
 * RA.isArrayLike({}); //=> false
 * RA.isArrayLike({length: 10}); //=> false
 * RA.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */ /* eslint-enable max-len */ var $f72f4d680deb1b70$var$isArrayLike = (0, $dB93a.default)(1, function(val) {
    if ((0, $e6sx7.default)(val)) return true;
    if (!val) return false;
    if ((0, $dfegI.default)(val)) return false;
    if ($f72f4d680deb1b70$var$_typeof(val) !== "object") return false;
    if (val.nodeType === 1) return !!val.length;
    if (val.length === 0) return true;
    if (val.length > 0) return (0, $aTDBn.default)(0, val) && (0, $aTDBn.default)(val.length - 1, val);
    return false;
});
var $f72f4d680deb1b70$export$2e2bcd8739ae039 /**
 The MIT License (MIT)

 Copyright (c) 2013-2016 Scott Sauyet and Michael Hurley

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
*/  = $f72f4d680deb1b70$var$isArrayLike;

});

parcelRegister("hUnxc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d099ec177becdbab$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $ldL2E = parcelRequire("ldL2E");
/**
 * Tests whether or not an object is similar to an array.
 *
 * @func isNotArrayLike
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isArrayLike|isArrayLike}
 * @example
 *
 * RA.isNotArrayLike([]); //=> false
 * RA.isNotArrayLike(true); //=> true
 * RA.isNotArrayLike({}); //=> true
 * RA.isNotArrayLike({length: 10}); //=> true
 * RA.isNotArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> false
 */ var $d099ec177becdbab$var$isNotArrayLike = (0, $fm6cm.default)((0, $ldL2E.default));
var $d099ec177becdbab$export$2e2bcd8739ae039 = $d099ec177becdbab$var$isNotArrayLike;

});

parcelRegister("axRPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ad6bddbd3336e18$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $fweXm = parcelRequire("fweXm");
/* eslint-disable max-len */ /**
 * Checks if input value is complement of `Generator Function`
 *
 * @func isNotGeneratorFunction
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isFunction|isFunction}, {@link RA.isAsyncFunction|isAsyncFunction}, {@link RA.isGeneratorFunction|isGeneratorFunction}
 * @example
 *
 * RA.isNotGeneratorFunction(function* test() { }); //=> false
 * RA.isNotGeneratorFunction(null); //=> true
 * RA.isNotGeneratorFunction(function test() { }); //=> true
 * RA.isNotGeneratorFunction(() => {}); //=> true
 */ /* eslint-enable max-len */ var $7ad6bddbd3336e18$var$isNotGeneratorFunction = (0, $fm6cm.default)((0, $fweXm.default));
var $7ad6bddbd3336e18$export$2e2bcd8739ae039 = $7ad6bddbd3336e18$var$isNotGeneratorFunction;

});

parcelRegister("592rr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3befafd702c1c069$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $6SOlc = parcelRequire("6SOlc");
/* eslint-disable max-len */ /**
 * Checks if input value is complement of `Async Function`
 *
 * @func isNotAsyncFunction
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isFunction|isFunction}, {@link RA.isAsyncFunction|isAsyncFunction}, {@link RA.isGeneratorFunction|isGeneratorFunction}
 * @example
 *
 * RA.isNotAsyncFunction(async function test() { }); //=> false
 * RA.isNotAsyncFunction(null); //=> true
 * RA.isNotAsyncFunction(function test() { }); //=> true
 * RA.isNotAsyncFunction(() => {}); //=> true
 */ /* eslint-enable max-len */ var $3befafd702c1c069$var$isNotAsyncFunction = (0, $fm6cm.default)((0, $6SOlc.default));
var $3befafd702c1c069$export$2e2bcd8739ae039 = $3befafd702c1c069$var$isNotAsyncFunction;

});

parcelRegister("bVQiS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8afd96fbef39edad$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $3bTqG = parcelRequire("3bTqG");
/* eslint-disable max-len */ /**
 * Checks if input value is complement of `Function`.
 *
 * @func isNotFunction
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isFunction|isFunction}, {@link RA.isAsyncFunction|isNotAsyncFunction}, {@link RA.isGeneratorFunction|isGeneratorFunction}
 * @example
 *
 * RA.isNotFunction(function test() { }); //=> false
 * RA.isNotFunction(function* test() { }); //=> false
 * RA.isNotFunction(async function test() { }); //=> false
 * RA.isNotFunction(() => {}); //=> false
 * RA.isNotFunction(null); //=> true
 * RA.isNotFunction('abc'); //=> true
 */ /* eslint-enable max-len */ var $8afd96fbef39edad$var$isNotFunction = (0, $fm6cm.default)((0, $3bTqG.default));
var $8afd96fbef39edad$export$2e2bcd8739ae039 = $8afd96fbef39edad$var$isNotFunction;

});

parcelRegister("bXZyz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b64f44092cf27a0$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");

var $6G8Ri = parcelRequire("6G8Ri");

var $31Wrd = parcelRequire("31Wrd");
/* eslint-disable max-len */ /**
 * Checks if value is object-like. A value is object-like if it's not null and has a typeof result of "object".
 *
 * @func isObjLike
 * @aliases isObjectLike
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotObjLike|isNotObjLike}, {@link RA.isObj|isObj}, {@link RA.isPlainObj|isPlainObj}
 * @example
 *
 * RA.isObjLike({}); //=> true
 * RA.isObjLike([]); //=> true
 * RA.isObjLike(() => {}); //=> false
 * RA.isObjLike(null); //=> false
 * RA.isObjLike(undefined); //=> false
 */ /* eslint-enable max-len */ var $8b64f44092cf27a0$var$isObjLike = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $6G8Ri.default), (0, $31Wrd.default)));
var $8b64f44092cf27a0$export$2e2bcd8739ae039 = $8b64f44092cf27a0$var$isObjLike;

});

parcelRegister("cx4Ff", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91fc2f54effaa55b$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $bXZyz = parcelRequire("bXZyz");
/* eslint-disable max-len */ /**
 * Checks if value is not object-like. A value is object-like if it's not null and has a typeof result of "object".
 *
 * @func isNotObjLike
 * @aliases isNotObjectLike
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isObjLike|isObjLike}, {@link RA.isObj|isObj}, {@link RA.isPlainObj|isPlainObj}
 * @example
 *
 * RA.isNotObjLike({}); //=> false
 * RA.isNotObjLike([]); //=> false
 * RA.isNotObjLike(() => {}); //=> true
 * RA.isNotObjLike(null); //=> true
 * RA.isNotObjLike(undefined); //=> true
 */ /* eslint-enable max-len */ var $91fc2f54effaa55b$var$isNotObjLike = (0, $fm6cm.default)((0, $bXZyz.default));
var $91fc2f54effaa55b$export$2e2bcd8739ae039 = $91fc2f54effaa55b$var$isNotObjLike;

});

parcelRegister("iI0iH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9ec91bbaf06ba63$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");
var $g5jN3 = parcelRequire("g5jN3");
var $felhC = parcelRequire("felhC");
var $gISCw = parcelRequire("gISCw");
var $10F1K = parcelRequire("10F1K");
var $g2qM6 = parcelRequire("g2qM6");
var $6wxQA = parcelRequire("6wxQA");

var $5tUFs = parcelRequire("5tUFs");

var $bXZyz = parcelRequire("bXZyz");

var $3bTqG = parcelRequire("3bTqG");
var $d9ec91bbaf06ba63$var$isObject = (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("Object"));
var $d9ec91bbaf06ba63$var$isObjectConstructor = (0, $10F1K.default)((0, $g2qM6.default), (0, $g5jN3.default)((0, $g2qM6.default)(Object)));
var $d9ec91bbaf06ba63$var$hasObjectConstructor = (0, $gISCw.default)((0, $gi6wV.default)((0, $3bTqG.default), $d9ec91bbaf06ba63$var$isObjectConstructor), [
    "constructor"
]);
/* eslint-disable max-len */ /**
 * Check to see if an object is a plain object (created using `{}`, `new Object()` or `Object.create(null)`).
 *
 * @func isPlainObj
 * @aliases isPlainObject
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotPlainObj|isNotPlainObj}, {@link RA.isObjLike|isObjLike}, {@link RA.isObj|isObj}
 * @example
 *
 * class Bar {
 *   constructor() {
 *     this.prop = 'value';
 *   }
 * }
 *
 * RA.isPlainObj(new Bar()); //=> false
 * RA.isPlainObj({ prop: 'value' }); //=> true
 * RA.isPlainObj(['a', 'b', 'c']); //=> false
 * RA.isPlainObj(Object.create(null); //=> true
 * RA.isPlainObj(new Object()); //=> true
 */ /* eslint-enable max-len */ var $d9ec91bbaf06ba63$var$isPlainObj = (0, $dB93a.default)(1, function(val) {
    if (!(0, $bXZyz.default)(val) || !$d9ec91bbaf06ba63$var$isObject(val)) return false;
    var proto = Object.getPrototypeOf(val);
    if ((0, $5tUFs.default)(proto)) return true;
    return $d9ec91bbaf06ba63$var$hasObjectConstructor(proto);
});
var $d9ec91bbaf06ba63$export$2e2bcd8739ae039 = $d9ec91bbaf06ba63$var$isPlainObj;

});

parcelRegister("8QC20", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6710ae509f8f7a48$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $iI0iH = parcelRequire("iI0iH");
/* eslint-disable max-len */ /**
 * Check to see if an object is a not plain object (created using `{}`, `new Object()` or `Object.create(null)`).
 *
 * @func isNotPlainObj
 * @aliases isNotPlainObject
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isPlainObj|isPlainObj}, {@link RA.isObjLike|isObjLike}, {@link RA.isObj|isObj}
 * @example
 *
 * class Bar {
 *   constructor() {
 *     this.prop = 'value';
 *   }
 * }
 *
 * RA.isNotPlainObj(new Bar()); //=> true
 * RA.isNotPlainObj({ prop: 'value' }); //=> false
 * RA.isNotPlainObj(['a', 'b', 'c']); //=> true
 * RA.isNotPlainObj(Object.create(null); //=> false
 * RA.isNotPlainObj(new Object()); //=> false
 */ /* eslint-enable max-len */ var $6710ae509f8f7a48$var$isNotPlainObj = (0, $fm6cm.default)((0, $iI0iH.default));
var $6710ae509f8f7a48$export$2e2bcd8739ae039 = $6710ae509f8f7a48$var$isNotPlainObj;

});

parcelRegister("ku47P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03d930c2b9edc957$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Checks if value is `Date` object.
 *
 * @func isDate
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.6.0|v0.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotDate|isNotDate}, {@link RA.isValidDate|isValidDate}, {@link RA.isNotValidDate|isNotValidDate}
 * @example
 *
 * RA.isDate(new Date()); //=> true
 * RA.isDate('1997-07-16T19:20+01:00'); //=> false
 */ var $03d930c2b9edc957$var$isDate = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("Date")));
var $03d930c2b9edc957$export$2e2bcd8739ae039 = $03d930c2b9edc957$var$isDate;

});

parcelRegister("hGZdq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce15d80ad74d3cd7$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $ku47P = parcelRequire("ku47P");
/**
 * Checks if value is complement of `Date` object.
 *
 * @func isNotDate
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.6.0|v0.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isDate|isDate}
 * @example
 *
 * RA.isNotDate(new Date()); //=> false
 * RA.isNotDate('1997-07-16T19:20+01:00'); //=> true
 */ var $ce15d80ad74d3cd7$var$isNotDate = (0, $fm6cm.default)((0, $ku47P.default));
var $ce15d80ad74d3cd7$export$2e2bcd8739ae039 = $ce15d80ad74d3cd7$var$isNotDate;

});

parcelRegister("ioNpK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d650cc8d6da1e269$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");
var $leUBm = parcelRequire("leUBm");
var $10F1K = parcelRequire("10F1K");

var $ku47P = parcelRequire("ku47P");

var $Kqdh7 = parcelRequire("Kqdh7");
/* eslint-disable max-len */ /**
 * Checks if value is valid `Date` object.
 *
 * @func isValidDate
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.8.0|v1.8.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isDate|isDate}, {@link RA.isNotDate|isNotDate}, {@link RA.isNotValidDate|isNotValidDate}
 * @example
 *
 * RA.isValidDate(new Date()); //=> true
 * RA.isValidDate(new Date('a')); //=> false
 */ /* eslint-enable max-len */ var $d650cc8d6da1e269$var$isValidDate = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $ku47P.default), (0, $10F1K.default)((0, $leUBm.default)(0, "getTime"), (0, $Kqdh7.default))));
var $d650cc8d6da1e269$export$2e2bcd8739ae039 = $d650cc8d6da1e269$var$isValidDate;

});
parcelRegister("Kqdh7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08b8a15eed5ceced$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $2pFkf = parcelRequire("2pFkf");
/**
 * Checks whether the passed value is complement of `NaN` and its type is not `Number`.
 *
 * @func isNotNaN
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.6.0|v0.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNaN|isNaN}
 * @example
 *
 * RA.isNotNaN(NaN); // => false
 * RA.isNotNaN(Number.NaN); // => false
 * RA.isNotNaN(0 / 0); // => false
 *
 * RA.isNotNaN('NaN'); // => true
 * RA.isNotNaN(undefined); // => true
 * RA.isNotNaN({}); // => true
 * RA.isNotNaN('blabla'); // => true
 *
 * RA.isNotNaN(true); // => true
 * RA.isNotNaN(null); // => true
 * RA.isNotNaN(37); // => true
 * RA.isNotNaN('37'); // => true
 * RA.isNotNaN('37.37'); // => true
 * RA.isNotNaN(''); // => true
 * RA.isNotNaN(' '); // => true
 */ var $08b8a15eed5ceced$var$isNotNaN = (0, $fm6cm.default)((0, $2pFkf.default));
var $08b8a15eed5ceced$export$2e2bcd8739ae039 = $08b8a15eed5ceced$var$isNotNaN;

});
parcelRegister("2pFkf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c1df8f872bb506b$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");

var $3bTqG = parcelRequire("3bTqG");

var $gpPBf = parcelRequire("gpPBf");
var $1c1df8f872bb506b$export$824ad15a5540b0e8 = (0, $dB93a.default)(1, (0, $gpPBf.default));
/**
 * Checks whether the passed value is `NaN` and its type is `Number`.
 * It is a more robust version of the original, global isNaN().
 *
 *
 * @func isNaN
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.6.0|v0.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotNaN|isNotNaN}
 * @example
 *
 * RA.isNaN(NaN); // => true
 * RA.isNaN(Number.NaN); // => true
 * RA.isNaN(0 / 0); // => true
 *
 * // e.g. these would have been true with global isNaN().
 * RA.isNaN('NaN'); // => false
 * RA.isNaN(undefined); // => false
 * RA.isNaN({}); // => false
 * RA.isNaN('blabla'); // => false
 *
 * RA.isNaN(true); // => false
 * RA.isNaN(null); // => false
 * RA.isNaN(37); // => false
 * RA.isNaN('37'); // => false
 * RA.isNaN('37.37'); // => false
 * RA.isNaN(''); // => false
 * RA.isNaN(' '); // => false
 */ var $1c1df8f872bb506b$var$_isNaN = (0, $3bTqG.default)(Number.isNaN) ? (0, $dB93a.default)(1, Number.isNaN) : $1c1df8f872bb506b$export$824ad15a5540b0e8;
var $1c1df8f872bb506b$export$2e2bcd8739ae039 = $1c1df8f872bb506b$var$_isNaN;

});
parcelRegister("gpPBf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf3701c5f7488345$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");

var $3oTRA = parcelRequire("3oTRA");
var $bf3701c5f7488345$var$isNaNPonyfill = (0, $gi6wV.default)((0, $3oTRA.default), isNaN);
var $bf3701c5f7488345$export$2e2bcd8739ae039 = $bf3701c5f7488345$var$isNaNPonyfill;

});
parcelRegister("3oTRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $279ef24aff673b48$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Checks if value is a `Number` primitive or object.
 *
 * @func isNumber
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.6.0|v0.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotNumber|isNotNumber}
 * @example
 *
 * RA.isNumber(5); // => true
 * RA.isNumber(Number.MAX_VALUE); // => true
 * RA.isNumber(-Infinity); // => true
 * RA.isNumber(NaN); // => true
 * RA.isNumber('5'); // => false
 */ var $279ef24aff673b48$var$isNumber = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("Number")));
var $279ef24aff673b48$export$2e2bcd8739ae039 = $279ef24aff673b48$var$isNumber;

});





parcelRegister("1gum4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ebed4ef8ef27920$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $ioNpK = parcelRequire("ioNpK");
/**
 * Checks if value is complement of valid `Date` object.
 *
 * @func isNotValidDate
 * @aliases isInvalidDate
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.8.0|v1.8.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isValidDate|isValidDate}, {@link RA.isDate|isDate}, {@link RA.isNotDate|isNotDate}
 * @example
 *
 * RA.isNotValidDate(new Date()); //=> false
 * RA.isNotValidDate(new Date('a')); //=> true
 */ var $0ebed4ef8ef27920$var$isNotValidDate = (0, $fm6cm.default)((0, $ioNpK.default));
var $0ebed4ef8ef27920$export$2e2bcd8739ae039 = $0ebed4ef8ef27920$var$isNotValidDate;

});

parcelRegister("jAoYq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e424c05f2488cb7b$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $3oTRA = parcelRequire("3oTRA");
/**
 * Checks if value is a complement of `Number` primitive or object.
 *
 * @func isNotNumber
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.6.0|v0.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNumber|isNumber}
 * @example
 *
 * RA.isNotNumber(5); // => false
 * RA.isNotNumber(Number.MAX_VALUE); // => false
 * RA.isNotNumber(-Infinity); // => false
 * RA.isNotNumber('5'); // => true
 */ var $e424c05f2488cb7b$var$isNotNumber = (0, $fm6cm.default)((0, $3oTRA.default));
var $e424c05f2488cb7b$export$2e2bcd8739ae039 = $e424c05f2488cb7b$var$isNotNumber;

});

parcelRegister("iU4Dt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc310d822e9efb3b$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $jh4AG = parcelRequire("jh4AG");

var $3oTRA = parcelRequire("3oTRA");
/**
 * Checks if value is a positive `Number` primitive or object. Zero is not considered positive.
 *
 * @func isPositive
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.15.0|v1.15.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNegative|isNegative}
 * @example
 *
 * RA.isPositive(1); // => true
 * RA.isPositive(Number.MAX_VALUE); // => true
 * RA.isPositive(-Infinity); // => false
 * RA.isPositive(NaN); // => false
 * RA.isPositive('5'); // => false
 */ var $dc310d822e9efb3b$var$isPositive = (0, $gi6wV.default)((0, $3oTRA.default), (0, $jh4AG.default)(0));
var $dc310d822e9efb3b$export$2e2bcd8739ae039 = $dc310d822e9efb3b$var$isPositive;

});

parcelRegister("dT8Yh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1c75eefc9141970$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");
var $eiA2o = parcelRequire("eiA2o");

var $3oTRA = parcelRequire("3oTRA");
/**
 * Checks if value is a negative `Number` primitive or object. Zero is not considered neither
 * positive or negative.
 *
 * @func isNegative
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.15.0|v1.15.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isPositive|isPositive}
 * @example
 *
 * RA.isNegative(-1); // => true
 * RA.isNegative(Number.MIN_VALUE); // => false
 * RA.isNegative(+Infinity); // => false
 * RA.isNegative(NaN); // => false
 * RA.isNegative('5'); // => false
 */ var $a1c75eefc9141970$var$isNegative = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $3oTRA.default), (0, $eiA2o.default)(0)));
var $a1c75eefc9141970$export$2e2bcd8739ae039 = $a1c75eefc9141970$var$isNegative;

});

parcelRegister("c5LNt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cdb07275c851234$export$2e2bcd8739ae039; });

var $felhC = parcelRequire("felhC");
/**
 * Checks if value is a positive zero (+0).
 *
 * @func isPositiveZero
 * @memberof RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNegativeZero|isNegativeZero}
 * @example
 *
 * RA.isPositiveZero(+0); //=> true
 * RA.isPositiveZero(0); //=> true
 * RA.isPositiveZero(-0); //=> false
 * RA.isPositiveZero(null); //=> false
 */ var $8cdb07275c851234$var$isPositiveZero = (0, $felhC.default)(0);
var $8cdb07275c851234$export$2e2bcd8739ae039 = $8cdb07275c851234$var$isPositiveZero;

});

parcelRegister("50VsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a698649b2f74d9d$export$2e2bcd8739ae039; });

var $felhC = parcelRequire("felhC");
/**
 * Checks if value is a negative zero (-0).
 *
 * @func isNegativeZero
 * @memberof RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see @see {@link RA.isPositiveZero|isPositiveZero}
 * @example
 *
 * RA.isNegativeZero(-0); //=> true
 * RA.isNegativeZero(+0); //=> false
 * RA.isNegativeZero(0); //=> false
 * RA.isNegativeZero(null); //=> false
 */ var $3a698649b2f74d9d$var$isNegativeZero = (0, $felhC.default)(-0);
var $3a698649b2f74d9d$export$2e2bcd8739ae039 = $3a698649b2f74d9d$var$isNegativeZero;

});

parcelRegister("lLbaw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd76a6a310985992$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $56nDa = parcelRequire("56nDa");
/**
 * Returns `false` if the given value is its type's empty value, `null` or `undefined`.
 *
 * @func isNotNilOrEmpty
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.18.0|v2.18.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNilOrEmpty|isNilOrEmpty}
 * @example
 *
 * RA.isNotNilOrEmpty([1, 2, 3]); //=> true
 * RA.isNotNilOrEmpty([]); //=> false
 * RA.isNotNilOrEmpty(''); //=> false
 * RA.isNotNilOrEmpty(null); //=> false
 * RA.isNotNilOrEmpty(undefined): //=> false
 * RA.isNotNilOrEmpty({}); //=> false
 * RA.isNotNilOrEmpty({length: 0}); //=> true
 */ var $fd76a6a310985992$var$isNotNilOrEmpty = (0, $fm6cm.default)((0, $56nDa.default));
var $fd76a6a310985992$export$2e2bcd8739ae039 = $fd76a6a310985992$var$isNotNilOrEmpty;

});

parcelRegister("cSGIr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $960ba9a42f4f4009$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");
var $d071Y = parcelRequire("d071Y");
var $hZash = parcelRequire("hZash");

var $3oTRA = parcelRequire("3oTRA");
/**
 * Checks if value is a non-positive `Number` primitive or object. This includes all negative
 * numbers and zero.
 *
 * @func isNonPositive
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.6.0|v2.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNegative|isNegative}, {@link RA.isNonNegative|isNonNegative}
 * @example
 *
 * RA.isNonPositive(0); // => true
 * RA.isNonPositive(-1); // => true
 * RA.isNonPositive(-Infinity); // => true
 * RA.isNonPositive(Number.MIN_VALUE); // => true
 *
 * RA.isNonPositive(Infinity); // => false
 * RA.isNonPositive(Number.MAX_VALUE); // => false
 * RA.isNonPositive(NaN); // => false
 */ var $960ba9a42f4f4009$var$isNonPositive = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $3oTRA.default), (0, $d071Y.default)((0, $hZash.default))(0)));
var $960ba9a42f4f4009$export$2e2bcd8739ae039 = $960ba9a42f4f4009$var$isNonPositive;

});

parcelRegister("j6NDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de9515a6f9ebf2e5$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");
var $d071Y = parcelRequire("d071Y");
var $lDBZe = parcelRequire("lDBZe");

var $3oTRA = parcelRequire("3oTRA");
/**
 * Checks if value is a non-negative `Number` primitive or object. This includes all positive
 * numbers and zero.
 *
 * @func isNonNegative
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.6.0|v2.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isPositive|isPositive}, {@link RA.isNonPositive|isNonPositive}
 * @example
 *
 * RA.isNonNegative(0); // => true
 * RA.isNonNegative(1); // => true
 * RA.isNonNegative(Infinity); // => true
 * RA.isNonNegative(Number.MAX_VALUE); // => true
 *
 * RA.isNonNegative(-Infinity); // => false
 * RA.isNonNegative(Number.MIN_VALUE); // => false
 * RA.isNonNegative(NaN); // => false
 */ var $de9515a6f9ebf2e5$var$isNonNegative = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $3oTRA.default), (0, $d071Y.default)((0, $lDBZe.default))(0)));
var $de9515a6f9ebf2e5$export$2e2bcd8739ae039 = $de9515a6f9ebf2e5$var$isNonNegative;

});

parcelRegister("cgxHn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee11e8445cd0c52$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Predicate for determining if a provided value is an instance of a Map.
 *
 * @func isMap
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isSet|isSet}}
 * @example
 *
 * RA.isMap(new Map()); //=> true
 * RA.isMap(new Map([[1, 2], [2, 1]])); //=> true
 * RA.isSet(new Set()); //=> false
 * RA.isSet(new Set([1,2]); //=> false
 * RA.isSet(new Object()); //=> false
 */ var $8ee11e8445cd0c52$var$isMap = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("Map")));
var $8ee11e8445cd0c52$export$2e2bcd8739ae039 = $8ee11e8445cd0c52$var$isMap;

});

parcelRegister("59E8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c0ced37d00ebe3a$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $cgxHn = parcelRequire("cgxHn");
/**
 * Checks if value is complement of `Map` object.
 *
 * @func isNotMap
 * @memberOf RA
 * @category Type
 * @since {@link https://char0n.github.io/ramda-adjunct/2.27.0|v2.27.0}
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isMap|isMap}
 * @example
 *
 * RA.isNotMap(new Map()); //=> false
 * RA.isNotMap(new Map([[1, 2], [2, 1]])); //=> false
 * RA.isNotMap(new Set()); //=> true
 * RA.isNotMap({}); //=> true
 * RA.isNotMap(12); //=> true
 */ var $3c0ced37d00ebe3a$var$isNotMap = (0, $fm6cm.default)((0, $cgxHn.default));
var $3c0ced37d00ebe3a$export$2e2bcd8739ae039 = $3c0ced37d00ebe3a$var$isNotMap;

});

parcelRegister("6oaBx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a6d35cfee609ffc$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");

var $3bTqG = parcelRequire("3bTqG");

var $b5stB = parcelRequire("b5stB");
var $4a6d35cfee609ffc$export$8b8ad05bfe4e9ba8 = (0, $dB93a.default)(1, (0, $b5stB.default));
/**
 * Checks whether the passed value is a finite `Number`.
 *
 * @func isFinite
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.7.0|v0.7.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotFinite|isNotFinite}
 * @example
 *
 * RA.isFinite(Infinity); //=> false
 * RA.isFinite(NaN); //=> false
 * RA.isFinite(-Infinity); //=> false
 *
 * RA.isFinite(0); // true
 * RA.isFinite(2e64); // true
 *
 * RA.isFinite('0');  // => false
 *                    // would've been true with global isFinite('0')
 * RA.isFinite(null); // => false
 *                    // would've been true with global isFinite(null)
 */ var $4a6d35cfee609ffc$var$_isFinite = (0, $3bTqG.default)(Number.isFinite) ? (0, $dB93a.default)(1, (0, $2K8fC.default)(Number.isFinite, Number)) : $4a6d35cfee609ffc$export$8b8ad05bfe4e9ba8;
var $4a6d35cfee609ffc$export$2e2bcd8739ae039 = $4a6d35cfee609ffc$var$_isFinite;

});
parcelRegister("b5stB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8126402fcf315b8c$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");

var $3oTRA = parcelRequire("3oTRA");
var $8126402fcf315b8c$var$isFinitePonyfill = (0, $gi6wV.default)((0, $3oTRA.default), isFinite);
var $8126402fcf315b8c$export$2e2bcd8739ae039 = $8126402fcf315b8c$var$isFinitePonyfill;

});


parcelRegister("eaSfB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a51c14e517766c16$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $6oaBx = parcelRequire("6oaBx");
/**
 * Checks whether the passed value is complement of finite `Number`.
 *
 *
 * @func isNotFinite
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.7.0|v0.7.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isFinite|isFinite}
 * @example
 *
 * RA.isNotFinite(Infinity); //=> true
 * RA.isNotFinite(NaN); //=> true
 * RA.isNotFinite(-Infinity); //=> true
 *
 * RA.isNotFinite(0); // false
 * RA.isNotFinite(2e64); // false
 *
 * RA.isNotFinite('0');  // => true
 * RA.isNotFinite(null); // => true
 */ var $a51c14e517766c16$var$isNotFinite = (0, $fm6cm.default)((0, $6oaBx.default));
var $a51c14e517766c16$export$2e2bcd8739ae039 = $a51c14e517766c16$var$isNotFinite;

});

parcelRegister("ewjLt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a92362b7fa0f3683$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");

var $3bTqG = parcelRequire("3bTqG");

var $48Z0A = parcelRequire("48Z0A");
var $a92362b7fa0f3683$export$e0a9ddf0f854b7f = (0, $dB93a.default)(1, (0, $48Z0A.default));
/**
 * Checks whether the passed value is an `integer`.
 *
 * @func isInteger
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.7.0|v0.7.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotInteger|isNotInteger}
 * @example
 *
 * RA.isInteger(0); //=> true
 * RA.isInteger(1); //=> true
 * RA.isInteger(-100000); //=> true
 *
 * RA.isInteger(0.1);       //=> false
 * RA.isInteger(Math.PI);   //=> false
 *
 * RA.isInteger(NaN);       //=> false
 * RA.isInteger(Infinity);  //=> false
 * RA.isInteger(-Infinity); //=> false
 * RA.isInteger('10');      //=> false
 * RA.isInteger(true);      //=> false
 * RA.isInteger(false);     //=> false
 * RA.isInteger([1]);       //=> false
 */ var $a92362b7fa0f3683$var$isInteger = (0, $3bTqG.default)(Number.isInteger) ? (0, $dB93a.default)(1, (0, $2K8fC.default)(Number.isInteger, Number)) : $a92362b7fa0f3683$export$e0a9ddf0f854b7f;
var $a92362b7fa0f3683$export$2e2bcd8739ae039 = $a92362b7fa0f3683$var$isInteger;

});
parcelRegister("48Z0A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30473bc64244539f$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $6s1r9 = parcelRequire("6s1r9");
var $g5jN3 = parcelRequire("g5jN3");
var $6PHwe = parcelRequire("6PHwe");

var $6oaBx = parcelRequire("6oaBx");
var $30473bc64244539f$var$isIntegerPonyfill = (0, $gi6wV.default)((0, $6oaBx.default), (0, $6s1r9.default)((0, $g5jN3.default), [
    Math.floor,
    (0, $6PHwe.default)
]));
var $30473bc64244539f$export$2e2bcd8739ae039 = $30473bc64244539f$var$isIntegerPonyfill;

});


parcelRegister("gbVk5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc9a238e3e1504b8$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");

var $kZCME = parcelRequire("kZCME");
/**
 * Checks whether the passed value is a signed 32 bit integer.
 *
 * @func isInteger32
 * @aliases isInt32
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.32.0|v2.32.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.toInteger32|toInteger32}
 * @example
 *
 * RA.isInteger32(0); //=> true
 * RA.isInteger32((-2) ** 31); //=> true
 *
 * RA.isInteger32(Infinity); //=> false
 * RA.isInteger32(NaN); //=> false
 * RA.isInteger32(2 ** 31); //=> false
 */ var $bc9a238e3e1504b8$var$isInteger32 = (0, $dB93a.default)(1, function(val) {
    return (0, $kZCME.default)(val) === val;
});
var $bc9a238e3e1504b8$export$2e2bcd8739ae039 = $bc9a238e3e1504b8$var$isInteger32;

});
parcelRegister("kZCME", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f48796cba107d73f$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
/**
 * Converts double-precision 64-bit binary format IEEE 754 to signed 32 bit integer number.
 *
 * @func toInteger32
 * @aliases toInt32
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.28.0|v2.28.0}
 * @category Math
 * @sig Number -> Number
 * @param {number} number A number
 * @return {number} A signed 32-bit integer number
 * @see {@link RA.toUInteger32|toUInteger32}, {@link http://speakingjs.com/es5/ch11.html#integers_via_bitwise_operators}
 * @example
 *
 * RA.toInteger32(2 ** 35); // => 0
 * RA.toInteger32(2 ** 30); // => 1073741824
 */ // eslint-disable-next-line no-bitwise
var $f48796cba107d73f$var$toInteger32 = (0, $dB93a.default)(1, function(val) {
    return val >> 0;
});
var $f48796cba107d73f$export$2e2bcd8739ae039 = $f48796cba107d73f$var$toInteger32;

});


parcelRegister("3cPy4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $255a7a91662b9b84$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $ewjLt = parcelRequire("ewjLt");
/**
 * Checks whether the passed value is complement of an `integer`.
 *
 *
 * @func isNotInteger
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.7.0|v0.7.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isInteger|isInteger}
 * @example
 *
 * RA.isNotInteger(0); //=> false
 * RA.isNotInteger(1); //=> false
 * RA.isNotInteger(-100000); //=> false
 *
 * RA.isNotInteger(0.1);       //=> true
 * RA.isNotInteger(Math.PI);   //=> true
 *
 * RA.isNotInteger(NaN);       //=> true
 * RA.isNotInteger(Infinity);  //=> true
 * RA.isNotInteger(-Infinity); //=> true
 * RA.isNotInteger('10');      //=> true
 * RA.isNotInteger(true);      //=> true
 * RA.isNotInteger(false);     //=> true
 * RA.isNotInteger([1]);       //=> true
 */ var $255a7a91662b9b84$var$isNotInteger = (0, $fm6cm.default)((0, $ewjLt.default));
var $255a7a91662b9b84$export$2e2bcd8739ae039 = $255a7a91662b9b84$var$isNotInteger;

});

parcelRegister("j3Og3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de05484e7c168f08$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Checks if value is a BigInt.
 *
 * @func isBigInt
 * @memberOf RA
 * @category Type
 * @since {@link https://char0n.github.io/ramda-adjunct/2.27.0|v2.27.0}
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @example
 *
 * RA.isBigInt(5); // => false
 * RA.isBigInt(Number.MAX_VALUE); // => false
 * RA.isBigInt(-Infinity); // => false
 * RA.isBigInt(10); // => false
 * RA.isBigInt(10n); // => true
 * RA.isBigInt(BitInt(9007199254740991)); // => true
 */ var $de05484e7c168f08$var$isBigInt = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("BigInt")));
var $de05484e7c168f08$export$2e2bcd8739ae039 = $de05484e7c168f08$var$isBigInt;

});

parcelRegister("13BHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c53516e8eddcfb1$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $fm6cm = parcelRequire("fm6cm");

var $ewjLt = parcelRequire("ewjLt");

var $6oaBx = parcelRequire("6oaBx");
/**
 * Checks whether the passed value is a `float`.
 *
 * @func isFloat
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.14.0|v1.14.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotFloat|isNotFloat}
 * @example
 *
 * RA.isFloat(0); //=> false
 * RA.isFloat(1); //=> false
 * RA.isFloat(-100000); //=> false
 *
 * RA.isFloat(0.1);       //=> true
 * RA.isFloat(Math.PI);   //=> true
 *
 * RA.isFloat(NaN);       //=> false
 * RA.isFloat(Infinity);  //=> false
 * RA.isFloat(-Infinity); //=> false
 * RA.isFloat('10');      //=> false
 * RA.isFloat(true);      //=> false
 * RA.isFloat(false);     //=> false
 * RA.isFloat([1]);       //=> false
 */ var $0c53516e8eddcfb1$var$isFloat = (0, $gi6wV.default)((0, $6oaBx.default), (0, $fm6cm.default)((0, $ewjLt.default)));
var $0c53516e8eddcfb1$export$2e2bcd8739ae039 = $0c53516e8eddcfb1$var$isFloat;

});

parcelRegister("7TGUE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bfef50ad7850358$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $dB93a = parcelRequire("dB93a");

var $13BHH = parcelRequire("13BHH");
/**
 * Checks whether the passed value is complement of a `float`.
 *
 * @func isNotFloat
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.14.0|v1.14.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isFloat|isFloat}
 * @example
 *
 * RA.isNotFloat(0); //=> true
 * RA.isNotFloat(1); //=> true
 * RA.isNotFloat(-100000); //=> true
 *
 * RA.isNotFloat(0.1);       //=> false
 * RA.isNotFloat(Math.PI);   //=> false
 *
 * RA.isNotFloat(NaN);       //=> true
 * RA.isNotFloat(Infinity);  //=> true
 * RA.isNotFloat(-Infinity); //=> true
 * RA.isNotFloat('10');      //=> true
 * RA.isNotFloat(true);      //=> true
 * RA.isNotFloat(false);     //=> true
 * RA.isNotFloat([1]);       //=> true
 */ var $5bfef50ad7850358$var$isNotFloat = (0, $dB93a.default)(1, (0, $fm6cm.default)((0, $13BHH.default)));
var $5bfef50ad7850358$export$2e2bcd8739ae039 = $5bfef50ad7850358$var$isNotFloat;

});

parcelRegister("5eGwM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cff3fb31bca8fbb$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $3j7JT = parcelRequire("3j7JT");

var $13BHH = parcelRequire("13BHH");

var $ewjLt = parcelRequire("ewjLt");
/**
 * Checks if value is a valid `Number`. A valid `Number` is a number that is not `NaN`, `Infinity`
 * or `-Infinity`.
 *
 * @func isValidNumber
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.2.0|v2.2.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotValidNumber|isNotValidNumber}
 * @example
 *
 * RA.isValidNumber(1); //=> true
 * RA.isValidNumber(''); //=> false
 * RA.isValidNumber(NaN); //=> false
 * RA.isValidNumber(Infinity); //=> false
 * RA.isValidNumber(-Infinity); //=> false
 */ var $3cff3fb31bca8fbb$var$isValidNumber = (0, $dB93a.default)(1, (0, $3j7JT.default)((0, $ewjLt.default), (0, $13BHH.default)));
var $3cff3fb31bca8fbb$export$2e2bcd8739ae039 = $3cff3fb31bca8fbb$var$isValidNumber;

});

parcelRegister("hQjiq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfd642d123ef9551$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $5eGwM = parcelRequire("5eGwM");
/**
 * Checks if value is not a valid `Number`. A valid `Number` is a number that is not `NaN`,
 * `Infinity` or `-Infinity`.
 *
 * @func isNotValidNumber
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.2.0|v2.2.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isValidNumber|isValidNumber}
 * @example
 *
 * RA.isNotValidNumber(1); //=> false
 * RA.isNotValidNumber(''); //=> true
 * RA.isNotValidNumber(NaN); //=> true
 * RA.isNotValidNumber(Infinity); //=> true
 * RA.isNotValidNumber(-Infinity); //=> true
 */ var $cfd642d123ef9551$var$isNotValidNumber = (0, $fm6cm.default)((0, $5eGwM.default));
var $cfd642d123ef9551$export$2e2bcd8739ae039 = $cfd642d123ef9551$var$isNotValidNumber;

});

parcelRegister("aoozq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $790f34761d762d46$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $fm6cm = parcelRequire("fm6cm");
var $dB93a = parcelRequire("dB93a");
var $g5jN3 = parcelRequire("g5jN3");
var $d071Y = parcelRequire("d071Y");
var $5Lrx9 = parcelRequire("5Lrx9");
var $10F1K = parcelRequire("10F1K");

var $ewjLt = parcelRequire("ewjLt");
/**
 * Checks if value is odd integer number.
 * An odd number is an integer which is not a multiple DIVISIBLE of two.
 *
 * @func isOdd
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.18.0|v1.18.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isEven|isEven}
 * @example
 *
 * RA.isOdd(1); // => true
 * RA.isOdd(-Infinity); // => false
 * RA.isOdd(4); // => false
 * RA.isOdd(3); // => true
 */ var $790f34761d762d46$var$isOdd = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $ewjLt.default), (0, $10F1K.default)((0, $d071Y.default)((0, $5Lrx9.default))(2), (0, $fm6cm.default)((0, $g5jN3.default))(0))));
var $790f34761d762d46$export$2e2bcd8739ae039 = $790f34761d762d46$var$isOdd;

});

parcelRegister("ac3f9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76bd8a70877678ab$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $fm6cm = parcelRequire("fm6cm");
var $dB93a = parcelRequire("dB93a");

var $ewjLt = parcelRequire("ewjLt");

var $aoozq = parcelRequire("aoozq");
/**
 * Checks if value is even integer number.
 * An even number is an integer which is "evenly divisible" by two.
 * Zero is an even number because zero divided by two equals zero,
 * which despite not being a natural number, is an integer.
 * Even numbers are either positive or negative.
 *
 * @func isEven
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.18.0|v1.18.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isOdd|isOdd}
 * @example
 *
 * RA.isEven(0); // => true
 * RA.isEven(1); // => false
 * RA.isEven(-Infinity); // => false
 * RA.isEven(4); // => true
 * RA.isEven(3); // => false
 */ var $76bd8a70877678ab$var$isEven = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $ewjLt.default), (0, $fm6cm.default)((0, $aoozq.default))));
var $76bd8a70877678ab$export$2e2bcd8739ae039 = $76bd8a70877678ab$var$isEven;

});

parcelRegister("7wQ7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57b3f459301600c7$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");
var $g5jN3 = parcelRequire("g5jN3");
var $bHf4t = parcelRequire("bHf4t");
var $10F1K = parcelRequire("10F1K");

var $e6sx7 = parcelRequire("e6sx7");
/**
 * Checks if input value is a pair.
 *
 * @func isPair
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.19.0|v1.19.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link http://ramdajs.com/docs/#pair|R.pair}, {@link RA.isNotPair|isNotPair}
 * @example
 *
 * RA.isPair([]); // => false
 * RA.isPair([0]); // => false
 * RA.isPair([0, 1]); // => true
 * RA.isPair([0, 1, 2]); // => false
 * RA.isPair({ 0: 0, 1: 1 }); // => false
 * RA.isPair({ foo: 0, bar: 0 }); // => false
 */ var $57b3f459301600c7$var$isPair = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $e6sx7.default), (0, $10F1K.default)((0, $bHf4t.default), (0, $g5jN3.default)(2))));
var $57b3f459301600c7$export$2e2bcd8739ae039 = $57b3f459301600c7$var$isPair;

});

parcelRegister("2WMqP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22569113a7aebe0a$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $7wQ7L = parcelRequire("7wQ7L");
/**
 * Checks if input value is complement of a pair.
 *
 * @func isNotPair
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.19.0|v1.19.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link http://ramdajs.com/docs/#pair|R.pair}, {@link RA.isPair|isPair}
 * @example
 *
 * RA.isNotPair([]); // => true
 * RA.isNotPair([0]); // => true
 * RA.isNotPair([0, 1]); // => false
 * RA.isNotPair([0, 1, 2]); // => true
 * RA.isNotPair({0: 0, 1: 1}); // => true
 * RA.isNotPair({foo: 0, bar: 0}); // => true
 */ var $22569113a7aebe0a$var$isNotPair = (0, $fm6cm.default)((0, $7wQ7L.default));
var $22569113a7aebe0a$export$2e2bcd8739ae039 = $22569113a7aebe0a$var$isNotPair;

});

parcelRegister("58WmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3beaf930f7984333$export$2e2bcd8739ae039; });

var $gISCw = parcelRequire("gISCw");

var $3bTqG = parcelRequire("3bTqG");
/**
 * Checks if input value is a `thenable`.
 * `thenable` is an object or function that defines a `then` method.
 *
 * @func isThenable
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.1.0|v2.1.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isPromise|isPromise}
 * @example
 *
 * RA.isThenable(null); // => false
 * RA.isThenable(undefined); // => false
 * RA.isThenable([]); // => false
 * RA.isThenable(Promise.resolve()); // => true
 * RA.isThenable(Promise.reject()); // => true
 * RA.isThenable({ then: () => 1 }); // => true
 */ var $3beaf930f7984333$var$isThenable = (0, $gISCw.default)((0, $3bTqG.default), [
    "then"
]);
var $3beaf930f7984333$export$2e2bcd8739ae039 = $3beaf930f7984333$var$isThenable;

});

parcelRegister("fsiza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b407df63c1347b66$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");
var $g5jN3 = parcelRequire("g5jN3");
var $10F1K = parcelRequire("10F1K");
var $g2qM6 = parcelRequire("g2qM6");

var $gXHlo = parcelRequire("gXHlo");
/**
 * Checks if input value is a native `Promise`.
 * The Promise object represents the eventual completion (or failure)
 * of an asynchronous operation, and its resulting value.
 *
 * @func isPromise
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.1.0|v2.1.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link https://promisesaplus.com/|Promises/A+}, {@link RA.isThenable|isThenable}
 * @example
 *
 * RA.isPromise(null); // => false
 * RA.isPromise(undefined); // => false
 * RA.isPromise([]); // => false
 * RA.isPromise(Promise.resolve()); // => true
 * RA.isPromise(Promise.reject()); // => true
 * RA.isPromise({ then: () => 1 }); // => false
 */ var $b407df63c1347b66$var$isPromise = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $gXHlo.default), (0, $10F1K.default)((0, $g2qM6.default), (0, $g5jN3.default)("[object Promise]"))));
var $b407df63c1347b66$export$2e2bcd8739ae039 = $b407df63c1347b66$var$isPromise;

});

parcelRegister("khZor", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03cfd2a79ab82824$export$2e2bcd8739ae039; });

var $felhC = parcelRequire("felhC");
/**
 * Checks if input value is the Boolean primitive `true`. Will return false for Boolean objects
 * created using the `Boolean` function as a constructor.
 *
 * @func isTrue
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.6.0|v2.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isFalse|isFalse}, {@link RA.isTruthy|isTruthy}, {@link RA.isFalsy|isFalsy}
 * @example
 *
 * RA.isTrue(true); // => true
 * RA.isTrue(Boolean(true)); // => true
 * RA.isTrue(false); // => false
 * RA.isTrue(1); // => false
 * RA.isTrue('true'); // => false
 * RA.isTrue(new Boolean(true)); // => false
 */ var $03cfd2a79ab82824$var$isTrue = (0, $felhC.default)(true);
var $03cfd2a79ab82824$export$2e2bcd8739ae039 = $03cfd2a79ab82824$var$isTrue;

});

parcelRegister("306Ph", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22f6aab8936bd544$export$2e2bcd8739ae039; });

var $felhC = parcelRequire("felhC");
/**
 * Checks if input value is the Boolean primitive `false`. Will return false for all values created
 * using the `Boolean` function as a constructor.
 *
 * @func isFalse
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.6.0|v2.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isTrue|isTrue}, {@link RA.isTruthy|isTruthy}, {@link RA.isFalsy|isFalsy}
 * @example
 *
 * RA.isFalse(false); // => true
 * RA.isFalse(Boolean(false)); // => true
 * RA.isFalse(true); // => false
 * RA.isFalse(0); // => false
 * RA.isFalse(''); // => false
 * RA.isFalse(null); // => false
 * RA.isFalse(undefined); // => false
 * RA.isFalse(NaN); // => false
 * RA.isFalse([]); // => false
 * RA.isFalse(new Boolean(false)); // => false
 */ var $22f6aab8936bd544$var$isFalse = (0, $felhC.default)(false);
var $22f6aab8936bd544$export$2e2bcd8739ae039 = $22f6aab8936bd544$var$isFalse;

});

parcelRegister("gKUk2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c32ca1a6d1bebe96$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
/**
 * In JavaScript, a `truthy` value is a value that is considered true
 * when evaluated in a Boolean context. All values are truthy unless
 * they are defined as falsy (i.e., except for `false`, `0`, `""`, `null`, `undefined`, and `NaN`).
 *
 * @func isTruthy
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.2.0|v2.2.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link https://developer.mozilla.org/en-US/docs/Glossary/Truthy|truthy}, {@link RA.isFalsy|isFalsy}
 * @example
 *
 * RA.isTruthy({}); // => true
 * RA.isTruthy([]); // => true
 * RA.isTruthy(42); // => true
 * RA.isTruthy(3.14); // => true
 * RA.isTruthy('foo'); // => true
 * RA.isTruthy(new Date()); // => true
 * RA.isTruthy(Infinity); // => true
 */ var $c32ca1a6d1bebe96$var$isTruthy = (0, $dB93a.default)(1, Boolean);
var $c32ca1a6d1bebe96$export$2e2bcd8739ae039 = $c32ca1a6d1bebe96$var$isTruthy;

});

parcelRegister("1z2ql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $123af0ae0375dc53$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $gKUk2 = parcelRequire("gKUk2");
/**
 * A falsy value is a value that translates to false when evaluated in a Boolean context.
 * Falsy values are `false`, `0`, `""`, `null`, `undefined`, and `NaN`.
 *
 * @func isFalsy
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.2.0|v2.2..0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link https://developer.mozilla.org/en-US/docs/Glossary/Falsy|falsy}, {@link RA.isTruthy|isTruthy}
 * @example
 *
 * RA.isFalsy(false); // => true
 * RA.isFalsy(0); // => true
 * RA.isFalsy(''); // => true
 * RA.isFalsy(null); // => true
 * RA.isFalsy(undefined); // => true
 * RA.isFalsy(NaN); // => true
 */ var $123af0ae0375dc53$var$isFalsy = (0, $fm6cm.default)((0, $gKUk2.default));
var $123af0ae0375dc53$export$2e2bcd8739ae039 = $123af0ae0375dc53$var$isFalsy;

});

parcelRegister("5Sepw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $446d2c8cb3dcda17$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Checks if value is `RegExp` object.
 *
 * @func isRegExp
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.5.0|v2.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotRegExp|isNotRegExp}
 * @example
 *
 * RA.isRegExp(new RegExp()); //=> true
 * RA.isRegExp(/(?:)/); //=> true
 * RA.isRegExp(1); //=> false
 */ var $446d2c8cb3dcda17$var$isRegExp = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("RegExp")));
var $446d2c8cb3dcda17$export$2e2bcd8739ae039 = $446d2c8cb3dcda17$var$isRegExp;

});

parcelRegister("c9fzk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d8266f5026e62e3$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $5Sepw = parcelRequire("5Sepw");
/**
 * Checks if value is complement of `RegExp` object.
 *
 * @func isNotRegExp
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.5.0|v2.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isRegExp|isRegExp}
 * @example
 *
 * RA.isNotRegExp(1); //=> true
 * RA.isNotRegExp(/(?:)/); //=> false
 * RA.isNotRegExp(new RegExp()); //=> false
 */ var $8d8266f5026e62e3$var$isNotRegExp = (0, $fm6cm.default)((0, $5Sepw.default));
var $8d8266f5026e62e3$export$2e2bcd8739ae039 = $8d8266f5026e62e3$var$isNotRegExp;

});

parcelRegister("kQkuJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2c88fcd3a8edbbe$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Predicate for determining if a provided value is an instance of a Set.
 *
 * @func isSet
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isMap|isMap}}
 * @example
 *
 * RA.isSet(new Map()); //=> false
 * RA.isSet(new Set()); //=> true
 * RA.isSet(new Set([1,2]); //=> true
 * RA.isSet(new Object()); //=> false
 */ var $f2c88fcd3a8edbbe$var$isSet = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("Set")));
var $f2c88fcd3a8edbbe$export$2e2bcd8739ae039 = $f2c88fcd3a8edbbe$var$isSet;

});

parcelRegister("cvlhM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91a8e432c5932305$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $kQkuJ = parcelRequire("kQkuJ");
/**
 * Checks if value is complement of `Set` object.
 *
 * @func isNotSet
 * @memberOf RA
 * @category Type
 * @since {@link https://char0n.github.io/ramda-adjunct/2.27.0|v2.27.0}
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isSet|isSet}
 * @example
 *
 * RA.isNotSet(new Map()); //=> true
 * RA.isNotSet(new Set()); //=> false
 * RA.isNotSet(new Set([1,2]); //=> false
 * RA.isNotSet(new Object()); //=> true
 */ var $91a8e432c5932305$var$isNotSet = (0, $fm6cm.default)((0, $kQkuJ.default));
var $91a8e432c5932305$export$2e2bcd8739ae039 = $91a8e432c5932305$var$isNotSet;

});

parcelRegister("8gxm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6049b0c46c056dfc$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $fm6cm = parcelRequire("fm6cm");
var $6s1r9 = parcelRequire("6s1r9");
var $felhC = parcelRequire("felhC");
var $bHf4t = parcelRequire("bHf4t");
var $10F1K = parcelRequire("10F1K");
var $aWkCB = parcelRequire("aWkCB");

var $e6sx7 = parcelRequire("e6sx7");
/**
 * Checks if input value is a sparse Array.
 * An array with at least one "empty slot" in it is often called a "sparse array."
 * Empty slot doesn't mean that the slot contains `null` or `undefined` values,
 * but rather that the slots don't exist.
 *
 * @func isSparseArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.20.0|v2.20.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} list The list to test
 * @return {boolean}
 * @see {@link https://github.com/getify/You-Dont-Know-JS/blob/f0d591b6502c080b92e18fc470432af8144db610/types%20%26%20grammar/ch3.md#array|Sparse Arrays}, {@link RA.isArray|isArray}
 * @example
 *
 * RA.isSparseArray(new Array(3)); // => true
 * RA.isSparseArray([1,,3]); // => true
 *
 * const list = [1, 2, 3];
 * delete list[1];
 * RA.isSparseArray(list); // => true
 *
 * RA.isSparseArray([1, 2, 3]); // => false
 */ var $6049b0c46c056dfc$var$isSparseArray = (0, $gi6wV.default)((0, $e6sx7.default), (0, $6s1r9.default)((0, $fm6cm.default)((0, $felhC.default)), [
    (0, $10F1K.default)((0, $aWkCB.default), (0, $bHf4t.default)),
    (0, $bHf4t.default)
]));
var $6049b0c46c056dfc$export$2e2bcd8739ae039 = $6049b0c46c056dfc$var$isSparseArray;

});

parcelRegister("lya3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb04930e96e65928$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $6wxQA = parcelRequire("6wxQA");
function $fb04930e96e65928$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fb04930e96e65928$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fb04930e96e65928$var$_typeof(obj);
}
/**
 * Checks if input value is a Symbol.
 *
 * @func isSymbol
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol|MDN Symbol}
 * @example
 *
 * RA.isSymbol(Symbol('1')); //=> true
 * RA.isSymbol(Symbol(1)); //=> true
 * RA.isSymbol('string'); //=> false
 * RA.isSymbol(undefined); //=> false
 * RA.isSymbol(null); //=> false
 */ var $fb04930e96e65928$var$isSymbol = (0, $dB93a.default)(1, function(val) {
    return $fb04930e96e65928$var$_typeof(val) === "symbol" || $fb04930e96e65928$var$_typeof(val) === "object" && (0, $6wxQA.default)(val) === "Symbol";
});
var $fb04930e96e65928$export$2e2bcd8739ae039 = $fb04930e96e65928$var$isSymbol;

});

parcelRegister("e8T5a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4bc8a39de870f32$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");

var $3bTqG = parcelRequire("3bTqG");

var $i7GLk = parcelRequire("i7GLk");
var $a4bc8a39de870f32$export$c165f67340950937 = (0, $dB93a.default)(1, (0, $i7GLk.default));
/**
 * Checks whether the passed value is a safe `integer`.
 *
 * @func isSafeInteger
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @example
 *
 * RA.isSafeInteger(3); //=> true
 * RA.isSafeInteger(Math.pow(2, 53)) //=> false
 * RA.isSafeInteger(Math.pow(2, 53) - 1); //=> true
 * RA.isSafeInteger(NaN); //=> false
 * RA.isSafeInteger(Infinity); //=> false
 * RA.isSafeInteger('3') //=> false
 * RA.isSafeInteger(3.1); //=> false
 * RA.isSafeInteger(3.0); //=> true
 * RA.isSafeInteger('string'); //=> false
 * RA.isSafeInteger(null); //=> false
 * RA.isSafeInteger(undefined); //=> false
 * RA.isSafeInteger({}); //=> false
 * RA.isSafeInteger(() => { }); //=> false
 * RA.isSafeInteger(true); //=> false
 */ var $a4bc8a39de870f32$var$isSafeInteger = (0, $3bTqG.default)(Number.isSafeInteger) ? (0, $dB93a.default)(1, (0, $2K8fC.default)(Number.isSafeInteger, Number)) : $a4bc8a39de870f32$export$c165f67340950937;
var $a4bc8a39de870f32$export$2e2bcd8739ae039 = $a4bc8a39de870f32$var$isSafeInteger;

});
parcelRegister("i7GLk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d31a0d23b697dc82$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");

var $ewjLt = parcelRequire("ewjLt");

var $fVQB6 = parcelRequire("fVQB6");
var $d31a0d23b697dc82$var$isSafeIntegerPonyfill = (0, $gi6wV.default)((0, $ewjLt.default), function(value) {
    return Math.abs(value) <= (0, $fVQB6.default);
});
var $d31a0d23b697dc82$export$2e2bcd8739ae039 = $d31a0d23b697dc82$var$isSafeIntegerPonyfill;

});
parcelRegister("fVQB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b994faa2758a5b91$export$2e2bcd8739ae039; });
var $b994faa2758a5b91$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
var $b994faa2758a5b91$export$2e2bcd8739ae039 = $b994faa2758a5b91$var$MAX_SAFE_INTEGER;

});



parcelRegister("iM6tT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dab1bcba11c807e6$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $3j7JT = parcelRequire("3j7JT");

var $e6sx7 = parcelRequire("e6sx7");

var $dfegI = parcelRequire("dfegI");
/**
 * Determine if input value is an indexed data type.
 *
 * @func isIndexed
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.26.0|v2.26.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @example
 *
 * RA.isIndexed([1]) //=> true
 * RA.isIndexed('test') //=> true
 */ var $dab1bcba11c807e6$var$isIndexed = (0, $dB93a.default)(1, (0, $3j7JT.default)((0, $dfegI.default), (0, $e6sx7.default)));
var $dab1bcba11c807e6$export$2e2bcd8739ae039 = $dab1bcba11c807e6$var$isIndexed;

});

parcelRegister("3nefM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274e938d9508f2b6$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $6wxQA = parcelRequire("6wxQA");
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`, `SyntaxError`, `TypeError` or `URIError` object.
 *
 * @func isError
 * @category Type
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.30.0|v2.30.0}
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean} Returns `true` if value is an error object, `false` otherwise
 * @example
 *
 * RA.isError(new Error()); //=> true
 * RA.isError(Error); //=> false
 * RA.isError(1); // => false
 */ var $274e938d9508f2b6$var$isError = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $6wxQA.default), (0, $felhC.default)("Error")));
var $274e938d9508f2b6$export$2e2bcd8739ae039 = $274e938d9508f2b6$var$isError;

});

parcelRegister("262QT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $186e5ab3b810f94c$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $fm6cm = parcelRequire("fm6cm");
var $dB93a = parcelRequire("dB93a");

var $ewjLt = parcelRequire("ewjLt");

var $dT8Yh = parcelRequire("dT8Yh");
/**
 * Checks if value is a natural number.
 * Natural numbers correspond to all non-negative integers and 0.
 *
 * @func isNaturalNumber
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.29.0|v2.29.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @example
 *
 * RA.isNaturalNumber(5); // => true
 * RA.isNaturalNumber(Number.MAX_VALUE); // => true
 * RA.isNaturalNumber(0); // => true
 * RA.isNaturalNumber(-1); // => false
 * RA.isNaturalNumber(0.9); // => false
 */ var $186e5ab3b810f94c$var$isNaturalNumber = (0, $dB93a.default)(1, (0, $gi6wV.default)((0, $ewjLt.default), (0, $fm6cm.default)((0, $dT8Yh.default))));
var $186e5ab3b810f94c$export$2e2bcd8739ae039 = $186e5ab3b810f94c$var$isNaturalNumber;

});

parcelRegister("1oBpa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10450c31285cdff1$export$2e2bcd8739ae039; });

var $4qtNZ = parcelRequire("4qtNZ");
var $gi6wV = parcelRequire("gi6wV");

var $j6MrB = parcelRequire("j6MrB");

var $dfegI = parcelRequire("dfegI");

var $3oTRA = parcelRequire("3oTRA");

var $j3Og3 = parcelRequire("j3Og3");

var $lWNtl = parcelRequire("lWNtl");

var $8kRo3 = parcelRequire("8kRo3");

var $5tUFs = parcelRequire("5tUFs");

var $lya3B = parcelRequire("lya3B");
/**
 * Checks if value is a primitive data type. There are 6 primitive data types: `string`, `number`, `bigint`, `boolean`, `undefined`, `symbol` and a special case of `null`.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures#Primitive_values
 * for definition of what sub-types comprise a primitive.
 *
 * @func isPrimitive
 * @category Type
 * @sig * -> Boolean
 * @since {@link https://char0n.github.io/ramda-adjunct/2.32.0|v2.32.0}
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotPrimitive|isNotPrimitive}, {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures#primitive_values|MDN Primitive values}, {@link https://developer.mozilla.org/en-US/docs/Glossary/Primitive|MDN Primitive}
 * @example
 *
 * RA.isPrimitive("string"); //=> true
 * RA.isPrimitive(1); //=> true
 * RA.isPrimitive(new String("string")); //=> false
 * RA.isPrimitive(new Number(1)); //=> false
 */ var $10450c31285cdff1$var$isPrimitive = (0, $gi6wV.default)((0, $j6MrB.default), (0, $4qtNZ.default)([
    (0, $dfegI.default),
    (0, $3oTRA.default),
    (0, $j3Og3.default),
    (0, $lWNtl.default),
    (0, $8kRo3.default),
    (0, $5tUFs.default),
    (0, $lya3B.default)
]));
var $10450c31285cdff1$export$2e2bcd8739ae039 = $10450c31285cdff1$var$isPrimitive;

});

parcelRegister("gongf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bef0ee684cfc85d4$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $dB93a = parcelRequire("dB93a");

var $1oBpa = parcelRequire("1oBpa");
/**
 * Checks if value is not a primitive data type. There are 6 primitive data types: `string`, `number`, `bigint`, `boolean`, `undefined`, `symbol` and a special case of `null`.
 *
 * @func isNotPrimitive
 * @category Type
 * @sig * -> Boolean
 * @since {@link https://char0n.github.io/ramda-adjunct/2.32.0|v2.32.0}
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isPrimitive|isPrimitive}, {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures#primitive_values|MDN Primitive values}, {@link https://developer.mozilla.org/en-US/docs/Glossary/Primitive|MDN Primitive}
 * @example
 *
 * RA.isNotPrimitive(new String("string")); //=> true
 * RA.isNotPrimitive(new Number(1)); //=> true
 * RA.isNotPrimitive("string"); //=> false
 * RA.isNotPrimitive(1); //=> false
 */ var $bef0ee684cfc85d4$var$isNotPrimitive = (0, $dB93a.default)(1, (0, $fm6cm.default)((0, $1oBpa.default)));
var $bef0ee684cfc85d4$export$2e2bcd8739ae039 = $bef0ee684cfc85d4$var$isNotPrimitive;

});

parcelRegister("gbnV6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc803a6c492047fb$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");

var $gbVk5 = parcelRequire("gbVk5");
/**
 * Checks whether the passed value is {@link https://github.com/getify/You-Dont-Know-JS/blob/9959fc904d584bbf0b02cf41c192f74ff4238581/types-grammar/ch4.md#the-curious-case-of-the-|a sentinel value}.
 *
 * @func isSentinelValue
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.33.0|v2.33.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @example
 *
 * RA.isSentinelValue(-1); //=> true
 *
 * RA.isSentinelValue('-1'); //=> false
 * RA.isSentinelValue(1); //=> false
 * RA.isSentinelValue([-1]); //=> false
 */ // eslint-disable-next-line no-bitwise
var $bc803a6c492047fb$var$isSentinelValue = (0, $dB93a.default)(1, function(val) {
    return (0, $gbVk5.default)(val) && ~val === 0;
});
var $bc803a6c492047fb$export$2e2bcd8739ae039 = $bc803a6c492047fb$var$isSentinelValue;

});

parcelRegister("i5Pe0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03663351d1cf110c$export$2e2bcd8739ae039; });

var $cdVZD = parcelRequire("cdVZD");
/**
 * A function that returns `null`.
 *
 * @func stubNull
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.6.0|v1.6.0}
 * @category Function
 * @sig ... -> null
 * @return {null}
 * @example
 *
 * RA.stubNull(); //=> null
 * RA.stubNull(1, 2, 3); //=> null
 */ var $03663351d1cf110c$var$stubNull = (0, $cdVZD.default)(null);
var $03663351d1cf110c$export$2e2bcd8739ae039 = $03663351d1cf110c$var$stubNull;

});

parcelRegister("aszA4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79d81e889cb855b0$export$2e2bcd8739ae039; });
/**
 * This function returns a new empty object.
 *
 * @func stubObj
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.1.0|v2.1.0}
 * @category Function
 * @sig ... -> Object
 * @aliases stubObject
 * @return {Object} Returns the new empty object.
 * @example
 *
 * RA.stubObj(); //=> {}
 * RA.stubObj(1, 2, 3); //=> {}
 */ var $79d81e889cb855b0$var$stubObj = function stubObj() {
    return {};
};
var $79d81e889cb855b0$export$2e2bcd8739ae039 = $79d81e889cb855b0$var$stubObj;

});

parcelRegister("fC5N5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5dee58a1a3d9234$export$2e2bcd8739ae039; });

var $cdVZD = parcelRequire("cdVZD");
/**
 * A function that returns empty string.
 *
 * @func stubString
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.1.0|v2.1.0}
 * @category Function
 * @sig ... -> String
 * @return {string} The empty string
 * @example
 *
 * RA.stubString(); //=> ''
 * RA.stubString(1, 2, 3); //=> ''
 */ var $b5dee58a1a3d9234$var$stubString = (0, $cdVZD.default)("");
var $b5dee58a1a3d9234$export$2e2bcd8739ae039 = $b5dee58a1a3d9234$var$stubString;

});

parcelRegister("efwsS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5fba6365d058acf$export$2e2bcd8739ae039; });
/**
 * A function that returns new empty array on every call.
 *
 * @func stubArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.1.0|v2.1.0}
 * @category Function
 * @sig ... -> Array
 * @return {Array} New empty array
 * @example
 *
 * RA.stubArray(); //=> []
 * RA.stubArray(1, 2, 3); //=> []
 */ var $a5fba6365d058acf$var$stubArray = function stubArray() {
    return [];
};
var $a5fba6365d058acf$export$2e2bcd8739ae039 = $a5fba6365d058acf$var$stubArray;

});

parcelRegister("iVGTE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc7ed3423b741c61$export$2e2bcd8739ae039; });

var $cdVZD = parcelRequire("cdVZD");

var $cFBID = parcelRequire("cFBID");
/**
 * A function that performs no operations.
 *
 * @func noop
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.0.0|v1.0.0}
 * @category Function
 * @sig ... -> undefined
 * @return {undefined}
 * @example
 *
 * RA.noop(); //=> undefined
 * RA.noop(1, 2, 3); //=> undefined
 */ var $dc7ed3423b741c61$var$noop = (0, $cdVZD.default)((0, $cFBID.default)());
var $dc7ed3423b741c61$export$2e2bcd8739ae039 = $dc7ed3423b741c61$var$noop;

});

parcelRegister("5S7nt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4467b7e95bc064fc$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $dB93a = parcelRequire("dB93a");
var $4C86y = parcelRequire("4C86y");
var $kuJWW = parcelRequire("kuJWW");
var $9Zbrv = parcelRequire("9Zbrv");
var $5KOxr = parcelRequire("5KOxr");

var $3EdVF = parcelRequire("3EdVF");
/**
 * "lifts" a function to be the specified arity, so that it may "map over" objects that satisfy
 * the fantasy land Apply spec of algebraic structures.
 *
 * Lifting is specific for {@link https://github.com/scalaz/scalaz|scalaz} and {@link http://www.functionaljava.org/|functional java} implementations.
 * Old version of fantasy land spec were not compatible with this approach,
 * but as of fantasy land 1.0.0 Apply spec also adopted this approach.
 *
 * This function acts as interop for ramda <= 0.23.0 and {@link https://monet.github.io/monet.js/|monet.js}.
 *
 * More info {@link https://github.com/fantasyland/fantasy-land/issues/50|here}.
 *
 * @func liftFN
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.2.0|v1.2.0}
 * @category Function
 * @sig Apply a => Number -> (a... -> a) -> (a... -> a)
 * @param {number} arity The arity of the lifter function
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function
 * @see {@link http://ramdajs.com/docs/#lift|R.lift}, {@link http://ramdajs.com/docs/#ap|R.ap}
 * @example
 *
 * const { Maybe } = require('monet');
 *
 * const add3 = (a, b, c) => a + b + c;
 * const madd3 = RA.liftFN(3, add3);
 *
 * madd3(Maybe.Some(10), Maybe.Some(15), Maybe.Some(17)); //=> Maybe.Some(42)
 * madd3(Maybe.Some(10), Maybe.Nothing(), Maybe.Some(17)); //=> Maybe.Nothing()
 */ var $4467b7e95bc064fc$var$liftFN = (0, $iB6UK.default)(function(arity, fn) {
    var lifted = (0, $dB93a.default)(arity, fn);
    return (0, $dB93a.default)(arity, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var accumulator = (0, $kuJWW.default)(lifted, (0, $4C86y.default)(args));
        var apps = (0, $5KOxr.default)(1, Infinity, args);
        return (0, $9Zbrv.default)((0, $3EdVF.default), accumulator, apps);
    });
});
var $4467b7e95bc064fc$export$2e2bcd8739ae039 = $4467b7e95bc064fc$var$liftFN;

});
parcelRegister("3EdVF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a7fe98edf44cd63$export$2e2bcd8739ae039; });

var $7C2CH = parcelRequire("7C2CH");
var $gi6wV = parcelRequire("gi6wV");
var $dB93a = parcelRequire("dB93a");
var $3j7JT = parcelRequire("3j7JT");
var $gISCw = parcelRequire("gISCw");

var $3bTqG = parcelRequire("3bTqG");

var $h4Tkc = parcelRequire("h4Tkc");
var $2a7fe98edf44cd63$var$isFunctor = (0, $3j7JT.default)((0, $gISCw.default)((0, $3bTqG.default), [
    "map"
]), (0, $gISCw.default)((0, $3bTqG.default), [
    $h4Tkc.map
]));
var $2a7fe98edf44cd63$var$isApply = (0, $gi6wV.default)($2a7fe98edf44cd63$var$isFunctor, (0, $3j7JT.default)((0, $gISCw.default)((0, $3bTqG.default), [
    "ap"
]), (0, $gISCw.default)((0, $3bTqG.default), [
    $h4Tkc.ap
])));
var $2a7fe98edf44cd63$var$ap = (0, $dB93a.default)(2, function(applyF, applyX) {
    // return original ramda `ap` if not Apply spec
    if (!$2a7fe98edf44cd63$var$isApply(applyF) || !$2a7fe98edf44cd63$var$isApply(applyX)) return (0, $7C2CH.default)(applyF, applyX);
    try {
        // new version of `ap` starting from ramda version > 0.23.0
        return applyF.ap(applyX);
    } catch (e) {
        // old version of `ap` till ramda version <= 0.23.0
        return applyX.ap(applyF);
    }
});
var $2a7fe98edf44cd63$export$2e2bcd8739ae039 = $2a7fe98edf44cd63$var$ap;

});
parcelRegister("h4Tkc", function(module, exports) {

$parcel$export(module.exports, "equals", function () { return $c6edb9b7ab9e00ed$export$e9bab7fafb253603; });
$parcel$export(module.exports, "lte", function () { return $c6edb9b7ab9e00ed$export$489c007ed603c05d; });
$parcel$export(module.exports, "concat", function () { return $c6edb9b7ab9e00ed$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "empty", function () { return $c6edb9b7ab9e00ed$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "map", function () { return $c6edb9b7ab9e00ed$export$871de8747c9eaa88; });
$parcel$export(module.exports, "contramap", function () { return $c6edb9b7ab9e00ed$export$53b696d27ecb7ba7; });
$parcel$export(module.exports, "ap", function () { return $c6edb9b7ab9e00ed$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "of", function () { return $c6edb9b7ab9e00ed$export$ba255e9e49e00608; });
$parcel$export(module.exports, "chain", function () { return $c6edb9b7ab9e00ed$export$e08e3b67e392101e; });
var $c6edb9b7ab9e00ed$export$e9bab7fafb253603 = "fantasy-land/equals";
var $c6edb9b7ab9e00ed$export$489c007ed603c05d = "fantasy-land/lte";
var $c6edb9b7ab9e00ed$export$f672e0b6f7222cd7 = "fantasy-land/compose";
var $c6edb9b7ab9e00ed$export$d560c7e4a29451c2 = "fantasy-land/id";
var $c6edb9b7ab9e00ed$export$ee1b3e54f0441b22 = "fantasy-land/concat";
var $c6edb9b7ab9e00ed$export$6e22c362a0406a2c = "fantasy-land/empty";
var $c6edb9b7ab9e00ed$export$871de8747c9eaa88 = "fantasy-land/map";
var $c6edb9b7ab9e00ed$export$53b696d27ecb7ba7 = "fantasy-land/contramap";
var $c6edb9b7ab9e00ed$export$2f6ca3d3b1f80bf5 = "fantasy-land/ap";
var $c6edb9b7ab9e00ed$export$ba255e9e49e00608 = "fantasy-land/of";
var $c6edb9b7ab9e00ed$export$228be17d80722ab = "fantasy-land/alt";
var $c6edb9b7ab9e00ed$export$7f9972325ebfd559 = "fantasy-land/zero";
var $c6edb9b7ab9e00ed$export$533b26079ad0b4b = "fantasy-land/reduce";
var $c6edb9b7ab9e00ed$export$df3f009e3d155b20 = "fantasy-land/traverse";
var $c6edb9b7ab9e00ed$export$e08e3b67e392101e = "fantasy-land/chain";
var $c6edb9b7ab9e00ed$export$6e805f0bc1f0daa0 = "fantasy-land/chainRec";
var $c6edb9b7ab9e00ed$export$8b58be045bf06082 = "fantasy-land/extend";
var $c6edb9b7ab9e00ed$export$f9380c9a627682d3 = "fantasy-land/extract";
var $c6edb9b7ab9e00ed$export$eb54baf0b342cb1d = "fantasy-land/bimap";
var $c6edb9b7ab9e00ed$export$6684e88861ab74ec = "fantasy-land/promap";

});



parcelRegister("74Hse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $526a9d4514b70a91$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");

var $5S7nt = parcelRequire("5S7nt");
/**
 * "lifts" a function to be the specified arity, so that it may "map over" objects that satisfy
 * the fantasy land Apply spec of algebraic structures.
 *
 * Lifting is specific for {@link https://github.com/scalaz/scalaz|scalaz} and {@link http://functionaljava.org/|function Java} implementations.
 * Old version of fantasy land spec were not compatible with this approach,
 * but as of fantasy land 1.0.0 Apply spec also adopted this approach.
 *
 * This function acts as interop for ramda <= 0.23.0 and {@link https://monet.github.io/monet.js/|monet.js}.
 *
 * More info {@link https://github.com/fantasyland/fantasy-land/issues/50|here}.
 *
 * @func liftF
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.2.0|v1.2.0}
 * @category Function
 * @sig Apply a => (a... -> a) -> (a... -> a)
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function
 * @see {@link RA.liftFN|liftFN}
 * @example
 *
 * const { Maybe } = require('monet');
 *
 * const add3 = (a, b, c) => a + b + c;
 * const madd3 = RA.liftF(add3);
 *
 * madd3(Maybe.Some(10), Maybe.Some(15), Maybe.Some(17)); //=> Maybe.Some(42)
 * madd3(Maybe.Some(10), Maybe.Nothing(), Maybe.Some(17)); //=> Maybe.Nothing()
 */ var $526a9d4514b70a91$var$liftF = (0, $dB93a.default)(1, function(fn) {
    return (0, $5S7nt.default)(fn.length, fn);
});
var $526a9d4514b70a91$export$2e2bcd8739ae039 = $526a9d4514b70a91$var$liftF;

});

parcelRegister("l6WlR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5e76beb0ccd98a8$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");

var $3bTqG = parcelRequire("3bTqG");
/**
 * The catamorphism is a way of folding a type into a value.
 *
 * **Either**
 *
 * If the either is right then the right function will be executed with
 * the `right` value and the value of the function returned. Otherwise the left function
 * will be called with the `left` value.
 *
 * **Maybe**
 *
 * If the maybe is Some than the right function will be executed with the `some` value and the value of the function
 * returned. Otherwise the left function with be called without an argument.
 *
 * **Result**
 *
 * If the result is Ok than the right function will be executed with the `Ok` value and the value of the function
 * returned. Otherwise the left function will be called with the `Error` value.
 *
 * **Validation**
 *
 * If the validation is Success than the right function will be executed with the `Success` value and the value of the function
 * returned. Otherwise the left function will be called with the `Failure` value.
 *
 * Supported monadic libraries: {@link https://monet.github.io/monet.js/|monet.js}, {@link https://folktale.origamitower.com/|folktale}, {@link https://github.com/ramda/ramda-fantasy|ramda-fantasy}
 *
 * @func cata
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.4.0|v1.4.0}
 * @category Function
 * @sig (a -> b) -> (a -> c) -> Cata a -> b | c
 * @param {Function} leftFn The left function that consumes the left value
 * @param {Function} rightFn The right function that consumes the right value
 * @param {Cata} catamorphicObj Either, Maybe or any other type with catamorphic capabilities (`cata` or `either` method)
 * @return {*}
 * @see {@link https://monet.github.io/monet.js/#cata|cata explained}
 * @example
 *
 * // Either
 * const eitherR = Either.Right(1);
 * const eitherL = Either.Left(2);
 *
 * RA.cata(identity, identity, eitherR); //=> 1
 * RA.cata(identity, identity, eitherL); //=> 2
 *
 * // Maybe
 * const maybeSome = Maybe.Some(1);
 * const maybeNothing = Maybe.Nothing();
 *
 * RA.cata(identity, identity, maybeSome); //=> 1
 * RA.cata(identity, identity, maybeNothing); //=> undefined
 */ var $f5e76beb0ccd98a8$var$catamorphism = (0, $iB6UK.default)(function(leftFn, rightFn, catamorphicObj) {
    // folktale support
    if ((0, $3bTqG.default)(catamorphicObj.matchWith)) return catamorphicObj.matchWith({
        // Result type
        Ok: function Ok(_ref) {
            var value = _ref.value;
            return rightFn(value);
        },
        Error: function Error(_ref2) {
            var value = _ref2.value;
            return leftFn(value);
        },
        // Maybe type
        Just: function Just(_ref3) {
            var value = _ref3.value;
            return rightFn(value);
        },
        Nothing: function Nothing() {
            return leftFn(undefined);
        },
        // Validation type
        Success: function Success(_ref4) {
            var value = _ref4.value;
            return rightFn(value);
        },
        Failure: function Failure(_ref5) {
            var value = _ref5.value;
            return leftFn(value);
        }
    });
    if ((0, $3bTqG.default)(catamorphicObj.cata)) return catamorphicObj.cata(leftFn, rightFn);
    if ((0, $3bTqG.default)(catamorphicObj.getOrElse)) {
        var elseValue = "RA.cata".concat(Math.random());
        var value = catamorphicObj.getOrElse(elseValue);
        return value === elseValue ? leftFn() : rightFn(value);
    }
    return catamorphicObj.either(leftFn, rightFn);
});
var $f5e76beb0ccd98a8$export$2e2bcd8739ae039 = $f5e76beb0ccd98a8$var$catamorphism;

});

parcelRegister("fTdvD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b91678b8066ff67b$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
/**
 * Weaves a configuration into function returning the runnable monad like `Reader` or `Free`.
 * This allows us to pre-bind the configuration in advance and use the weaved function
 * without need to explicitly pass the configuration on every call.
 *
 * @func weave
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.7.0|v1.7.0}
 * @category Function
 * @sig (*... -> *) -> * -> (*... -> *)
 * @param {Function} fn The function to weave
 * @param {*} config The configuration to weave into fn
 * @return {Function} Auto-curried weaved function
 * @example
 *
 * const { Reader: reader } = require('monet');
 *
 * const log = value => reader(
 *   config => config.log(value)
 * );
 *
 * // no weaving
 * log('test').run(console); //=> prints 'test'
 *
 * // weaving
 * const wlog = RA.weave(log, console);
 * wlog('test'); //=> prints 'test'
 */ var $b91678b8066ff67b$var$weave = (0, $dB93a.default)(2, function(fn, config) {
    return (0, $dB93a.default)(fn.length, function() {
        return fn.apply(void 0, arguments).run(config);
    });
});
var $b91678b8066ff67b$export$2e2bcd8739ae039 = $b91678b8066ff67b$var$weave;

});

parcelRegister("gNm7Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3a2630d45d6de25$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
/**
 * Weaves a configuration into function returning the runnable monad like `Reader` or `Free`.
 * This allows us to pre-bind the configuration in advance and use the weaved function
 * without need to explicitly pass the configuration on every call.
 *
 * @func weaveLazy
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.10.0|v1.10.0}
 * @category Function
 * @sig (*... -> *) -> (* -> *) -> (*... -> *)
 * @param {Function} fn The function to weave
 * @param {Function} configAccessor The function that returns the configuration object
 * @return {Function} Auto-curried weaved function
 * @example
 *
 * const { Reader: reader } = require('monet');
 *
 * const log = value => reader(
 *   config => config.log(value)
 * );
 *
 * const consoleAccessor = R.always(console);
 *
 * // no weaving
 * log('test').run(console); //=> prints 'test'
 *
 * // weaving
 * const wlog = RA.weaveLazy(log, consoleAccessor);
 * wlog('test'); //=> prints 'test'
 */ var $c3a2630d45d6de25$var$weaveLazy = (0, $dB93a.default)(2, function(fn, configAccessor) {
    return (0, $dB93a.default)(fn.length, function() {
        return fn.apply(void 0, arguments).run(configAccessor());
    });
});
var $c3a2630d45d6de25$export$2e2bcd8739ae039 = $c3a2630d45d6de25$var$weaveLazy;

});

parcelRegister("kcVpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb6175dee9dad016$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $cSdZE = parcelRequire("cSdZE");
/**
 * Returns a curried equivalent of the provided function, with the specified arity.
 * This function is like curryN, except that the provided arguments order is reversed.
 *
 * @func curryRightN
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.12.0|v1.12.0}
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {number} length The arity for the returned function
 * @param {Function} fn The function to curry
 * @return {Function}  A new, curried function
 * @see {@link http://ramdajs.com/docs/#curryN|R.curryN}, {@link RA.curryRight|curryRight}
 * @example
 *
 * const concatStrings = (a, b, c) => a + b + c;
 * const concatStringsCurried = RA.curryRightN(3, concatStrings);
 *
 * concatStringCurried('a')('b')('c'); // => 'cba'
 */ var $eb6175dee9dad016$var$curryRightN = (0, $dB93a.default)(2, function(arity, fn) {
    return (0, $dB93a.default)(arity, function wrapper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return fn.apply(this, (0, $cSdZE.default)(args));
    });
});
var $eb6175dee9dad016$export$2e2bcd8739ae039 = $eb6175dee9dad016$var$curryRightN;

});

parcelRegister("54Y3h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b2be88dcbdffe75$export$2e2bcd8739ae039; });

var $6s1r9 = parcelRequire("6s1r9");
var $6PHwe = parcelRequire("6PHwe");
var $bHf4t = parcelRequire("bHf4t");

var $kcVpq = parcelRequire("kcVpq");
/**
 * Returns a curried equivalent of the provided function.
 * This function is like curry, except that the provided arguments order is reversed.
 *
 * @func curryRight
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.12.0|v1.12.0}
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry
 * @return {Function}  A new, curried function
 * @see {@link http://ramdajs.com/docs/#curry|R.curry}, {@link RA.curryRightN|curryRightN}
 * @example
 *
 * const concatStrings = (a, b, c) => a + b + c;
 * const concatStringsCurried = RA.curryRight(concatStrings);
 *
 * concatStringCurried('a')('b')('c'); // => 'cba'
 */ var $3b2be88dcbdffe75$var$curryRight = (0, $6s1r9.default)((0, $kcVpq.default), [
    (0, $bHf4t.default),
    (0, $6PHwe.default)
]);
var $3b2be88dcbdffe75$export$2e2bcd8739ae039 = $3b2be88dcbdffe75$var$curryRight;

});

parcelRegister("87any", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e870734352825fd$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");
/**
 * Composable shortcut for `Promise.all`.
 *
 * The `allP` method returns a single Promise that resolves when all of the promises
 * in the iterable argument have resolved or when the iterable argument contains no promises.
 * It rejects with the reason of the first promise that rejects.
 *
 * @func allP
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.3.0|v2.3.0}
 * @category Function
 * @sig [Promise a] -> Promise [a]
 * @param {Iterable.<*>} iterable An iterable object such as an Array or String
 * @return {Promise} An already resolved Promise if the iterable passed is empty. An asynchronously resolved Promise if the iterable passed contains no promises. Note, Google Chrome 58 returns an already resolved promise in this case. A pending Promise in all other cases. This returned promise is then resolved/rejected asynchronously (as soon as the stack is empty) when all the promises in the given iterable have resolved, or if any of the promises reject. See the example about "Asynchronicity or synchronicity of allP" below.
 * @see {@link RA.resolveP|resolveP}, {@link RA.rejectP|rejectP}
 * @example
 *
 * RA.allP([1, 2]); //=> Promise([1, 2])
 * RA.allP([1, Promise.resolve(2)]); //=> Promise([1, 2])
 * RA.allP([Promise.resolve(1), Promise.resolve(2)]); //=> Promise([1, 2])
 * RA.allP([1, Promise.reject(2)]); //=> Promise(2)
 */ var $5e870734352825fd$var$allP = (0, $dB93a.default)(1, (0, $2K8fC.default)(Promise.all, Promise));
var $5e870734352825fd$export$2e2bcd8739ae039 = $5e870734352825fd$var$allP;

});

parcelRegister("acskY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76d101937893b057$export$2e2bcd8739ae039; });

var $leUBm = parcelRequire("leUBm");
/**
 * Composable shortcut for `Promise.catch`.
 * The catchP function returns a Promise. It takes two arguments: a callback function for the failure of the Promise
 * and the promise instance itself.
 *
 * @func catchP
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.29.0|v2.29.0}
 * @category Function
 * @sig (a -> Promise b | b) -> Promise b
 * @param {Function} onRejected A Function called if the Promise is rejected. This function has one argument, the rejection reason.
 * @param {Promise} promise Any Promise
 * @return {Promise} Returns a Promise with dealt rejected cases
 * @see {@link RA.thenP|thenP}, {@link RA.resolveP|resolveP}, {@link RA.rejectP|rejectP}, {@link RA.allP|allP}
 *
 * @example
 *
 * RA.catchP(() => 'b', Promise.resolve('a')); //=> Promise('a')
 * RA.catchP(() => 'b', Promise.reject('a')); //=> Promise('b')
 */ var $76d101937893b057$var$catchP = (0, $leUBm.default)(1, "catch");
var $76d101937893b057$export$2e2bcd8739ae039 = $76d101937893b057$var$catchP;

});

parcelRegister("hFZDv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cde613a6b3d1d63a$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $kuJWW = parcelRequire("kuJWW");
var $10F1K = parcelRequire("10F1K");

var $87any = parcelRequire("87any");

var $h2ky7 = parcelRequire("h2ky7");

var $4ee2H = parcelRequire("4ee2H");
/**
 * Returns a Promise that is resolved with an array of reasons when all of the provided Promises reject, or rejected when any Promise is resolved.
 * This pattern is like allP, but fulfillments and rejections are transposed - rejections become the fulfillment values and vice versa.
 *
 * @func noneP
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Function
 * @sig [Promise a] -> Promise [a]
 * @param {Iterable.<*>} iterable An iterable object such as an Array or String
 * @return {Promise} A Promise that is resolved with a list of rejection reasons if all Promises are rejected, or a Promise that is rejected with the fulfillment value of the first Promise that resolves.
 * @see {@link RA.allP|allP}
 * @example
 *
 * RA.noneP([Promise.reject('hello'), Promise.reject('world')]); //=> Promise(['hello', 'world'])
 * RA.noneP([]); //=> Promise([])
 * RA.noneP([Promise.reject(), Promise.resolve('hello world')]); //=> Promise('hello world')
 * RA.noneP([Promise.reject(), 'hello world']); //=> Promise('hello world')
 */ var $cde613a6b3d1d63a$var$noneP = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $kuJWW.default)((0, $4ee2H.default)), (0, $kuJWW.default)(function(p) {
    return p.then((0, $h2ky7.default), (0, $4ee2H.default));
}), (0, $87any.default)));
var $cde613a6b3d1d63a$export$2e2bcd8739ae039 = $cde613a6b3d1d63a$var$noneP;

});
parcelRegister("h2ky7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c672903dcb64f75c$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
/**
 * Composable shortcut for `Promise.reject`.
 *
 * Returns a Promise object that is rejected with the given reason.
 *
 * @func rejectP
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.16.0|v1.16.0}
 * @category Function
 * @sig a -> Promise a
 * @param {*} [reason=undefined] Reason why this Promise rejected
 * @return {Promise} A Promise that is rejected with the given reason
 * @see {@link RA.resolveP|resolveP}
 * @example
 *
 * RA.rejectP(); //=> Promise(undefined)
 * RA.rejectP('a'); //=> Promise('a')
 * RA.rejectP([1, 2, 3]); //=> Promise([1, 2, 3])
 */ var $c672903dcb64f75c$var$rejectP = (0, $2K8fC.default)(Promise.reject, Promise);
var $c672903dcb64f75c$export$2e2bcd8739ae039 = $c672903dcb64f75c$var$rejectP;

});

parcelRegister("4ee2H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31435cc3d4840985$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
/* eslint-disable max-len */ /**
 * Composable shortcut for `Promise.resolve`.
 *
 * Returns a Promise object that is resolved with the given value.
 * If the value is a thenable (i.e. has a "then" method), the returned promise will
 * "follow" that thenable, adopting its eventual state.
 *
 * @func resolveP
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.16.0|v1.16.0}
 * @category Function
 * @sig a -> Promise a
 * @param {*} [value=undefined] Argument to be resolved by this Promise. Can also be a Promise or a thenable to resolve
 * @return {Promise} A Promise that is resolved with the given value, or the promise passed as value, if the value was a promise object
 * @see {@link RA.rejectP|rejectP}
 * @example
 *
 * RA.resolveP(); //=> Promise(undefined)
 * RA.resolveP('a'); //=> Promise('a')
 * RA.resolveP([1, 2, 3]); //=> Promise([1, 2, 3])
 */ /* eslint-enable max-len */ var $31435cc3d4840985$var$resolveP = (0, $2K8fC.default)(Promise.resolve, Promise);
var $31435cc3d4840985$export$2e2bcd8739ae039 = $31435cc3d4840985$var$resolveP;

});


parcelRegister("nQKpt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $047b10a93a5aa7f3$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $am2mP = parcelRequire("am2mP");
var $7FSiY = parcelRequire("7FSiY");
var $5fdvW = parcelRequire("5fdvW");

var $j6NDQ = parcelRequire("j6NDQ");

var $ewjLt = parcelRequire("ewjLt");
/**
 * Creates a promise which resolves/rejects after the specified milliseconds.
 *
 * @func delayP
 * @memberOf RA
 * @category Function
 * @sig Number -> Promise Undefined
 * @sig {timeout: Number, value: a} -> Promise a
 * @param {number|Object} milliseconds number of milliseconds or options object
 * @return {Promise} A Promise that is resolved/rejected with the given value (if provided) after the specified delay
 * @example
 *
 * RA.delayP(200); //=> Promise(undefined)
 * RA.delayP({ timeout: 1000, value: 'hello world' }); //=> Promise('hello world')
 * RA.delayP.reject(100); //=> Promise(undefined)
 * RA.delayP.reject({ timeout: 100, value: new Error('error') }); //=> Promise(Error('error'))
 */ var $047b10a93a5aa7f3$var$makeDelay = (0, $iB6UK.default)(function(settleFnPicker, opts) {
    var timeout;
    var value;
    if ((0, $ewjLt.default)(opts) && (0, $j6NDQ.default)(opts)) timeout = opts;
    else {
        timeout = (0, $5fdvW.default)(0, "timeout", opts);
        value = (0, $5fdvW.default)(value, "value", opts);
    }
    return new Promise(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var settleFn = settleFnPicker(args);
        setTimeout((0, $7FSiY.default)(settleFn, [
            value
        ]), timeout);
    });
});
var $047b10a93a5aa7f3$var$delayP = $047b10a93a5aa7f3$var$makeDelay((0, $am2mP.default)(0));
$047b10a93a5aa7f3$var$delayP.reject = $047b10a93a5aa7f3$var$makeDelay((0, $am2mP.default)(1));
var $047b10a93a5aa7f3$export$2e2bcd8739ae039 = $047b10a93a5aa7f3$var$delayP;

});

parcelRegister("c0GXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8be6d0566ea19ab7$export$2e2bcd8739ae039; });

var $leUBm = parcelRequire("leUBm");
/**
 * Composable shortcut for `Promise.then`.
 * The thenP function returns a Promise. It takes two arguments: a callback function for the success of the Promise
 * and the promise instance itself.
 *
 * @func thenP
 * @memberOf RA
 * @aliases then
 * @since {@link https://char0n.github.io/ramda-adjunct/2.8.0|v2.8.0}
 * @deprecated since v2.12.0; available in ramda@0.26.0 as R.then
 * @category Function
 * @sig (a -> Promise b | b) -> Promise b
 * @param {Function} onFulfilled A Function called if the Promise is fulfilled. This function has one argument, the fulfillment value
 * @param {Promise} promise Any Promise or Thenable object
 * @return {Promise} A Promise in the pending status

 * @see {@link RA.resolveP|resolveP}, {@link RA.rejectP|rejectP}, {@link RA.allP|allP}
 * @example
 *
 * const promise = Promise.resolve(1);
 * const add1 = v => v + 1;
 *
 * RA.thenP(add1, promise); // => Promise(2)
 */ var $8be6d0566ea19ab7$var$thenP = (0, $leUBm.default)(1, "then");
var $8be6d0566ea19ab7$export$2e2bcd8739ae039 = $8be6d0566ea19ab7$var$thenP;

});

parcelRegister("2ahRB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $193a5f490a9ebba7$export$2e2bcd8739ae039; });

var $leUBm = parcelRequire("leUBm");
var $193a5f490a9ebba7$export$ba93edb3ca1d216d = (0, $leUBm.default)(2, "then");
var $193a5f490a9ebba7$export$2e2bcd8739ae039 = $193a5f490a9ebba7$export$ba93edb3ca1d216d;

});

parcelRegister("6jLdq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4999246f1dfd56f8$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");

var $3bTqG = parcelRequire("3bTqG");

var $fSNca = parcelRequire("fSNca");
var $4999246f1dfd56f8$export$d85c9b0b13acabc6 = (0, $dB93a.default)(1, (0, $fSNca.default));
/**
 * Returns a promise that is fulfilled with an array of promise state snapshots,
 * but only after all the original promises have settled, i.e. become either fulfilled or rejected.
 * We say that a promise is settled if it is not pending, i.e. if it is either fulfilled or rejected.
 *
 * @func allSettledP
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.18.0|v2.18.0}
 * @category Function
 * @typedef Settlement = { status: String, value: * }
 * @sig [Promise a] -> Promise [Settlement a]
 * @param {Iterable.<*>} iterable An iterable object such as an Array or String
 * @return {Promise} Returns a promise that is fulfilled with an array of promise state snapshots
 * @see {@link RA.allP|allP}
 * @example
 *
 * RA.allSettledP([
 *   Promise.resolve(1),
 *   2,
 *   Promise.reject(3),
 * ]); //=> Promise([{ status: 'fulfilled', value: 1 }, { status: 'fulfilled', value: 2 }, { status: 'rejected', reason: 3 }])
 */ var $4999246f1dfd56f8$var$allSettledP = (0, $3bTqG.default)(Promise.allSettled) ? (0, $dB93a.default)(1, (0, $2K8fC.default)(Promise.allSettled, Promise)) : $4999246f1dfd56f8$export$d85c9b0b13acabc6;
var $4999246f1dfd56f8$export$2e2bcd8739ae039 = $4999246f1dfd56f8$var$allSettledP;

});
parcelRegister("fSNca", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9020f4aeba36ea6$export$2e2bcd8739ae039; });

var $kuJWW = parcelRequire("kuJWW");

var $87any = parcelRequire("87any");

var $4ee2H = parcelRequire("4ee2H");
function $b9020f4aeba36ea6$var$_toConsumableArray(arr) {
    return $b9020f4aeba36ea6$var$_arrayWithoutHoles(arr) || $b9020f4aeba36ea6$var$_iterableToArray(arr) || $b9020f4aeba36ea6$var$_unsupportedIterableToArray(arr) || $b9020f4aeba36ea6$var$_nonIterableSpread();
}
function $b9020f4aeba36ea6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b9020f4aeba36ea6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b9020f4aeba36ea6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b9020f4aeba36ea6$var$_arrayLikeToArray(o, minLen);
}
function $b9020f4aeba36ea6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b9020f4aeba36ea6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b9020f4aeba36ea6$var$_arrayLikeToArray(arr);
}
function $b9020f4aeba36ea6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $b9020f4aeba36ea6$var$onFulfill = function onFulfill(value) {
    return {
        status: "fulfilled",
        value: value
    };
};
var $b9020f4aeba36ea6$var$onReject = function onReject(reason) {
    return {
        status: "rejected",
        reason: reason
    };
};
var $b9020f4aeba36ea6$var$allSettledPonyfill = function allSettledPonyfill(iterable) {
    var array = (0, $kuJWW.default)(function(p) {
        return (0, $4ee2H.default)(p).then($b9020f4aeba36ea6$var$onFulfill)["catch"]($b9020f4aeba36ea6$var$onReject);
    }, $b9020f4aeba36ea6$var$_toConsumableArray(iterable));
    return (0, $87any.default)(array);
};
var $b9020f4aeba36ea6$export$2e2bcd8739ae039 = $b9020f4aeba36ea6$var$allSettledPonyfill;

});


parcelRegister("h00QP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c60318c615535530$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
/**
 * Y-combinator
 *
 * The Y combinator is an interesting function which only works with functional languages,
 * showing how recursion can still be done even without any variable or function declarations,
 * only functions and parameters
 *
 * @func Y
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.3.0|v2.3.0}
 * @category Function
 * @sig (a, ... -> b -> b) -> (a, ... -> b)
 * @param {Function} le Recursive function maker
 * @return {Function}
 * @see {@link http://kestas.kuliukas.com/YCombinatorExplained/|Y combinator explained}
 * @example
 *
 * const makeFact = givenFact => (n) => {
 *   if (n < 2) { return 1 }
 *   return n * givenFact(n - 1);
 * };
 *
 * const factorial = RA.Y(makeFact);
 *
 * factorial(5); //=> 120
 */ var $c60318c615535530$var$Y = (0, $dB93a.default)(1, function(le) {
    return function(f) {
        return f(f);
    }(function(g) {
        return le(function(x) {
            return g(g)(x);
        });
    });
});
var $c60318c615535530$export$2e2bcd8739ae039 = $c60318c615535530$var$Y;

});

parcelRegister("1PZjc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $156a1c82427388b7$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $kuJWW = parcelRequire("kuJWW");
var $eMmfs = parcelRequire("eMmfs");
/* eslint-disable max-len */ /**
 * Runs the given list of functions in order with the supplied object, then returns the object.
 * Also known as the normal order sequencing combinator.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func seq
 * @aliases sequencing
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.3.0|v2.3.0}
 * @category Function
 * @sig [(a -> *), (a -> *), ...] -> a -> a
 * @param {Array} fns The list of functions to call in order with `x` whose return values will be thrown away
 * @param {*} x
 * @return {*} `x`
 * @see {@link http://ramdajs.com/docs/#tap|R.tap}, {@link http://www.cs.rpi.edu/academics/courses/spring11/proglang/handouts/lambda-calculus-chapter.pdf|sequencing combinator explained}
 * @example
 *
 * RA.seq([console.info, console.log])('foo'); //=> prints 'foo' via info then log
 *
 * // usage in composition
 * R.pipe(
 *   R.concat('prefix '),
 *   RA.seq([
 *     console.info, //=> prints 'prefix test'
 *     console.log //=> prints 'prefix test'
 *   ]),
 *   R.toUpper
 * )('test'); //=> 'PREFIX TEST'
 */ /* eslint-enable max-len */ var $156a1c82427388b7$var$seq = (0, $iB6UK.default)(function(fns, x) {
    return (0, $eMmfs.default)(function(tx) {
        return (0, $kuJWW.default)(function(fn) {
            return fn(tx);
        })(fns);
    })(x);
});
var $156a1c82427388b7$export$2e2bcd8739ae039 = $156a1c82427388b7$var$seq;

});

parcelRegister("3CRmW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a3e51b093cdfc3b$export$2e2bcd8739ae039; });

var $1LQXj = parcelRequire("1LQXj");
var $iB6UK = parcelRequire("iB6UK");
var $dB93a = parcelRequire("dB93a");
var $4C86y = parcelRequire("4C86y");
var $6Ocs1 = parcelRequire("6Ocs1");
var $10F1K = parcelRequire("10F1K");
var $iOjwE = parcelRequire("iOjwE");
var $9Zbrv = parcelRequire("9Zbrv");
var $8va4b = parcelRequire("8va4b");
var $3OmdN = parcelRequire("3OmdN");

var $5tela = parcelRequire("5tela");

var $9FoQ0 = parcelRequire("9FoQ0");

var $cFBID = parcelRequire("cFBID");
function $2a3e51b093cdfc3b$var$_toConsumableArray(arr) {
    return $2a3e51b093cdfc3b$var$_arrayWithoutHoles(arr) || $2a3e51b093cdfc3b$var$_iterableToArray(arr) || $2a3e51b093cdfc3b$var$_unsupportedIterableToArray(arr) || $2a3e51b093cdfc3b$var$_nonIterableSpread();
}
function $2a3e51b093cdfc3b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a3e51b093cdfc3b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2a3e51b093cdfc3b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2a3e51b093cdfc3b$var$_arrayLikeToArray(o, minLen);
}
function $2a3e51b093cdfc3b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $2a3e51b093cdfc3b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2a3e51b093cdfc3b$var$_arrayLikeToArray(arr);
}
function $2a3e51b093cdfc3b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $2a3e51b093cdfc3b$var$byArity = (0, $1LQXj.default)(function(a, b) {
    return a.length > b.length;
});
var $2a3e51b093cdfc3b$var$getMaxArity = (0, $10F1K.default)((0, $3OmdN.default)($2a3e51b093cdfc3b$var$byArity), (0, $4C86y.default), (0, $iOjwE.default)("length"));
var $2a3e51b093cdfc3b$var$iteratorFn = (0, $iB6UK.default)(function(args, accumulator, fn) {
    var result = fn.apply(void 0, $2a3e51b093cdfc3b$var$_toConsumableArray(args));
    return (0, $5tela.default)(result) ? (0, $8va4b.default)(result) : accumulator;
});
var $2a3e51b093cdfc3b$var$dispatchImpl = function dispatchImpl(functions) {
    var arity = $2a3e51b093cdfc3b$var$getMaxArity(functions);
    return (0, $dB93a.default)(arity, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (0, $9Zbrv.default)($2a3e51b093cdfc3b$var$iteratorFn(args), undefined, functions);
    });
};
var $2a3e51b093cdfc3b$var$dispatch = (0, $6Ocs1.default)((0, $9FoQ0.default), $2a3e51b093cdfc3b$var$dispatchImpl, (0, $cFBID.default));
var $2a3e51b093cdfc3b$export$2e2bcd8739ae039 = $2a3e51b093cdfc3b$var$dispatch;

});

parcelRegister("1Zrxr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1730d9850576cb75$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");

var $4ee2H = parcelRequire("4ee2H");

var $h2ky7 = parcelRequire("h2ky7");
/**
 * Takes a generator function and returns an async function.
 * The async function returned is a curried function whose arity matches that of the generator function.
 *
 * Note: This function is handy for environments that does support generators but doesn't support async/await.
 *
 * @func async
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.16.0|v2.16.0}
 * @category Function
 * @sig Promise c => (a, b, ...) -> a -> b -> ... -> c
 * @param {Function} generatorFn The generator function
 * @return {Function} Curried async function
 * @see {@link https://www.promisejs.org/generators/}
 * @example
 *
 * const asyncFn = RA.async(function* generator(val1, val2) {
 *   const a = yield Promise.resolve(val1);
 *   const b = yield Promise.resolve(val2);
 *
 *   return a + b;
 * });
 *
 * asyncFn(1, 2); //=> Promise(3)
 *
 */ var $1730d9850576cb75$var$async = (0, $dB93a.default)(1, function(generatorFn) {
    function asyncWrapper() {
        var iterator = (0, $2K8fC.default)(generatorFn, this).apply(void 0, arguments);
        var handle = function handle(result) {
            var resolved = (0, $4ee2H.default)(result.value);
            return result.done ? resolved : resolved.then(function(value) {
                return handle(iterator.next(value));
            }, function(error) {
                return handle(iterator["throw"](error));
            });
        };
        try {
            return handle(iterator.next());
        } catch (error) {
            return (0, $h2ky7.default)(error);
        }
    }
    if (generatorFn.length > 0) return (0, $dB93a.default)(generatorFn.length, asyncWrapper);
    return asyncWrapper;
});
var $1730d9850576cb75$export$2e2bcd8739ae039 = $1730d9850576cb75$var$async;

});

parcelRegister("7Oks5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5afd11450c4e1e8c$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");

var $3bTqG = parcelRequire("3bTqG");

var $dY4Vs = parcelRequire("dY4Vs");
var $5afd11450c4e1e8c$export$8cc584be064cea99 = (0, $dB93a.default)(1, (0, $dY4Vs.default));
/**
 * Returns a promise that is fulfilled by the first given promise to be fulfilled,
 * or rejected with an array of rejection reasons if all of the given promises are rejected.
 *
 * @func anyP
 * @memberOf RA
 * @category Function
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @sig [Promise a] -> Promise a
 * @param {Iterable.<*>} iterable An iterable object such as an Array or String
 * @return {Promise} A promise that is fulfilled by the first given promise to be fulfilled, or rejected with an array of rejection reasons if all of the given promises are rejected
 * @see {@link RA.lastP|lastP}
 * @example
 *
 * RA.anyP([
 *   Promise.resolve(1),
 *   2,
 *   Promise.reject(3),
 * ]); //=> Promise(1)
 */ var $5afd11450c4e1e8c$var$anyP = (0, $3bTqG.default)(Promise.any) ? (0, $dB93a.default)(1, (0, $2K8fC.default)(Promise.any, Promise)) : $5afd11450c4e1e8c$export$8cc584be064cea99;
var $5afd11450c4e1e8c$export$2e2bcd8739ae039 = $5afd11450c4e1e8c$var$anyP;

});
parcelRegister("dY4Vs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2b4b3154ddd8c15$export$2e2bcd8739ae039; });

var $kuJWW = parcelRequire("kuJWW");

var $4ee2H = parcelRequire("4ee2H");
function $a2b4b3154ddd8c15$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a2b4b3154ddd8c15$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a2b4b3154ddd8c15$var$_typeof(obj);
}
function $a2b4b3154ddd8c15$var$_toConsumableArray(arr) {
    return $a2b4b3154ddd8c15$var$_arrayWithoutHoles(arr) || $a2b4b3154ddd8c15$var$_iterableToArray(arr) || $a2b4b3154ddd8c15$var$_unsupportedIterableToArray(arr) || $a2b4b3154ddd8c15$var$_nonIterableSpread();
}
function $a2b4b3154ddd8c15$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a2b4b3154ddd8c15$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a2b4b3154ddd8c15$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a2b4b3154ddd8c15$var$_arrayLikeToArray(o, minLen);
}
function $a2b4b3154ddd8c15$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a2b4b3154ddd8c15$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a2b4b3154ddd8c15$var$_arrayLikeToArray(arr);
}
function $a2b4b3154ddd8c15$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a2b4b3154ddd8c15$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a2b4b3154ddd8c15$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a2b4b3154ddd8c15$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a2b4b3154ddd8c15$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a2b4b3154ddd8c15$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a2b4b3154ddd8c15$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a2b4b3154ddd8c15$var$_setPrototypeOf(subClass, superClass);
}
function $a2b4b3154ddd8c15$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a2b4b3154ddd8c15$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a2b4b3154ddd8c15$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a2b4b3154ddd8c15$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a2b4b3154ddd8c15$var$_possibleConstructorReturn(this, result);
    };
}
function $a2b4b3154ddd8c15$var$_possibleConstructorReturn(self, call) {
    if (call && ($a2b4b3154ddd8c15$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a2b4b3154ddd8c15$var$_assertThisInitialized(self);
}
function $a2b4b3154ddd8c15$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a2b4b3154ddd8c15$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $a2b4b3154ddd8c15$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$a2b4b3154ddd8c15$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $a2b4b3154ddd8c15$var$_construct(Class, arguments, $a2b4b3154ddd8c15$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $a2b4b3154ddd8c15$var$_setPrototypeOf(Wrapper, Class);
    };
    return $a2b4b3154ddd8c15$var$_wrapNativeSuper(Class);
}
function $a2b4b3154ddd8c15$var$_construct(Parent, args, Class) {
    if ($a2b4b3154ddd8c15$var$_isNativeReflectConstruct()) $a2b4b3154ddd8c15$var$_construct = Reflect.construct;
    else $a2b4b3154ddd8c15$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $a2b4b3154ddd8c15$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $a2b4b3154ddd8c15$var$_construct.apply(null, arguments);
}
function $a2b4b3154ddd8c15$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a2b4b3154ddd8c15$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $a2b4b3154ddd8c15$var$_setPrototypeOf(o, p) {
    $a2b4b3154ddd8c15$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a2b4b3154ddd8c15$var$_setPrototypeOf(o, p);
}
function $a2b4b3154ddd8c15$var$_getPrototypeOf(o) {
    $a2b4b3154ddd8c15$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a2b4b3154ddd8c15$var$_getPrototypeOf(o);
}
var $a2b4b3154ddd8c15$export$9698b86da474710f = /*#__PURE__*/ function(_Error) {
    $a2b4b3154ddd8c15$var$_inherits(AggregatedError, _Error);
    var _super = $a2b4b3154ddd8c15$var$_createSuper(AggregatedError);
    function AggregatedError() {
        var _this;
        var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        $a2b4b3154ddd8c15$var$_classCallCheck(this, AggregatedError);
        _this = _super.call(this, message);
        _this.errors = errors;
        return _this;
    }
    return $a2b4b3154ddd8c15$var$_createClass(AggregatedError);
}(/*#__PURE__*/ $a2b4b3154ddd8c15$var$_wrapNativeSuper(Error));
var $a2b4b3154ddd8c15$var$anyPonyfill = function anyPonyfill(iterable) {
    var exceptions = [];
    return new Promise(function(resolve, reject) {
        var onReject = function onReject(e) {
            exceptions.push(e);
            if (exceptions.length === iterable.length) reject(new $a2b4b3154ddd8c15$export$9698b86da474710f(exceptions));
        };
        (0, $kuJWW.default)(function(p) {
            return (0, $4ee2H.default)(p).then(resolve)["catch"](onReject);
        }, $a2b4b3154ddd8c15$var$_toConsumableArray(iterable));
    });
};
var $a2b4b3154ddd8c15$export$2e2bcd8739ae039 = $a2b4b3154ddd8c15$var$anyPonyfill;

});


parcelRegister("4ODKn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $381aa9d90a7f4275$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");
var $6uiOQ = parcelRequire("6uiOQ");
var $kuJWW = parcelRequire("kuJWW");

var $87any = parcelRequire("87any");

var $2W6Rh = parcelRequire("2W6Rh");

var $2Hum2 = parcelRequire("2Hum2");

var $h2ky7 = parcelRequire("h2ky7");

var $4ee2H = parcelRequire("4ee2H");
function $381aa9d90a7f4275$var$_toConsumableArray(arr) {
    return $381aa9d90a7f4275$var$_arrayWithoutHoles(arr) || $381aa9d90a7f4275$var$_iterableToArray(arr) || $381aa9d90a7f4275$var$_unsupportedIterableToArray(arr) || $381aa9d90a7f4275$var$_nonIterableSpread();
}
function $381aa9d90a7f4275$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $381aa9d90a7f4275$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $381aa9d90a7f4275$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $381aa9d90a7f4275$var$_arrayLikeToArray(o, minLen);
}
function $381aa9d90a7f4275$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $381aa9d90a7f4275$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $381aa9d90a7f4275$var$_arrayLikeToArray(arr);
}
function $381aa9d90a7f4275$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a promise that is fulfilled by the last given promise to be fulfilled,
 * or rejected with an array of rejection reasons if all of the given promises are rejected.
 *
 * @func lastP
 * @memberOf RA
 * @category Function
 * @since {@link https://char0n.github.io/ramda-adjunct/2.23.0|v2.23.0}
 * @sig [Promise a] -> Promise a
 * @param {Iterable.<*>} iterable An iterable object such as an Array or String
 * @return {Promise} A promise that is fulfilled by the last given promise to be fulfilled, or rejected with an array of rejection reasons if all of the given promises are rejected.
 * @see {@link RA.anyP|anyP}
 * @example
 *
 * const delayP = timeout => new Promise(resolve => setTimeout(() => resolve(timeout), timeout));
 * delayP.reject = timeout => new Promise((resolve, reject) => setTimeout(() => reject(timeout), timeout));
 * RA.lastP([
 *   1,
 *   delayP(10),
 *   delayP(100),
 *   delayP.reject(1000),
 * ]); //=> Promise(100)
 */ var $381aa9d90a7f4275$var$lastP = (0, $dB93a.default)(1, function(iterable) {
    var fulfilled = [];
    var rejected = [];
    var onFulfill = (0, $2K8fC.default)(fulfilled.push, fulfilled);
    var onReject = (0, $2K8fC.default)(rejected.push, rejected);
    var listOfPromises = (0, $kuJWW.default)(function(p) {
        return (0, $4ee2H.default)(p).then(onFulfill)["catch"](onReject);
    }, $381aa9d90a7f4275$var$_toConsumableArray(iterable));
    return (0, $87any.default)(listOfPromises).then(function() {
        if ((0, $2W6Rh.default)(0, fulfilled) && (0, $2W6Rh.default)(0, rejected)) return undefined;
        if ((0, $2Hum2.default)(1, fulfilled)) return (0, $6uiOQ.default)(fulfilled);
        return (0, $h2ky7.default)(rejected);
    });
});
var $381aa9d90a7f4275$export$2e2bcd8739ae039 = $381aa9d90a7f4275$var$lastP;

});
parcelRegister("2W6Rh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2236517de1ee94d8$export$2e2bcd8739ae039; });

var $g5jN3 = parcelRequire("g5jN3");

var $4flyd = parcelRequire("4flyd");
/**
 * Returns `true` if the supplied list or string has a length equal to `valueLength`.
 *
 * @func lengthEq
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.8.0|v2.8.0}
 * @category List
 * @sig Number -> [*] -> Boolean
 * @param {number} valueLength The length of the list or string
 * @param {Array|string} value The list or string
 * @return {boolean}
 * @see {@link RA.lengthNotEq|lengthNotEq}, {@link RA.lengthLt|lengthLt}, {@link RA.lengthGt|lengthGt}, {@link RA.lengthLte|lengthLte}, {@link RA.lengthGte|lengthGte},, {@link http://ramdajs.com/docs/#equals|equals}, {@link http://ramdajs.com/docs/#length|length}
 * @example
 *
 * RA.lengthEq(3, [1,2,3]); //=> true
 * RA.lengthEq(3, [1,2,3,4]); //=> false
 */ var $2236517de1ee94d8$var$lengthEq = (0, $4flyd.default)((0, $g5jN3.default));
var $2236517de1ee94d8$export$2e2bcd8739ae039 = $2236517de1ee94d8$var$lengthEq;

});
parcelRegister("4flyd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $317947b4e6be2966$export$2e2bcd8739ae039; });

var $d8dol = parcelRequire("d8dol");
var $iB6UK = parcelRequire("iB6UK");
var $bHf4t = parcelRequire("bHf4t");
var $317947b4e6be2966$var$compareLength = (0, $iB6UK.default)(function(comparator, value, list) {
    return (0, $d8dol.default)(comparator(value), (0, $bHf4t.default))(list);
});
var $317947b4e6be2966$export$2e2bcd8739ae039 = $317947b4e6be2966$var$compareLength;

});


parcelRegister("2Hum2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f7724b4744ecf14$export$2e2bcd8739ae039; });

var $d071Y = parcelRequire("d071Y");
var $lDBZe = parcelRequire("lDBZe");

var $4flyd = parcelRequire("4flyd");
/**
 * Returns `true` if the supplied list or string has a length greater than or equal to
 * `valueLength`.
 *
 * @func lengthGte
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.8.0|v2.8.0}
 * @category List
 * @sig Number -> [*] -> Boolean
 * @param {number} valueLength The length of the list or string
 * @param {Array|string} value The list or string
 * @return {boolean}
 * @see {@link RA.lengthEq|lengthEq}, {@link RA.lengthNotEq|lengthNotEq}, {@link RA.lengthLt|lengthLt}, {@link RA.lengthGt|lengthGt}, {@link RA.lengthLte|lengthLte}, {@link http://ramdajs.com/docs/#gte|gte}, {@link http://ramdajs.com/docs/#length|length}
 * @example
 *
 * RA.lengthGte(3, [1,2,3,4]); //=> true
 * RA.lengthGte(3, [1,2,3]); //=> true
 * RA.lengthGte(3, [1,2]); //=> false
 */ var $1f7724b4744ecf14$var$lengthGte = (0, $4flyd.default)((0, $d071Y.default)((0, $lDBZe.default)));
var $1f7724b4744ecf14$export$2e2bcd8739ae039 = $1f7724b4744ecf14$var$lengthGte;

});


parcelRegister("3AGSj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29d5fdf93fd26997$export$2e2bcd8739ae039; });

var $384ED = parcelRequire("384ED");
var $iB6UK = parcelRequire("iB6UK");
var $dB93a = parcelRequire("dB93a");
var $1FHr3 = parcelRequire("1FHr3");

var $9V3Lk = parcelRequire("9V3Lk");

var $fsyKq = parcelRequire("fsyKq");
/**
 * Returns a function which is called with the given arguments. If any of the given arguments are null or undefined,
 * the corresponding default value for that argument is used instead.
 *
 * @func fnull
 * @memberOf RA
 * @category Function
 * @sig (a ... -> b) -> [c] -> a ... | c -> b
 * @param {Function} function to be executed
 * @param {Array} defaults default arguments
 * @return {Function} will apply provided arguments or default ones
 * @example
 *
 * const addDefaults = RA.fnull((a, b) => a + b, [4, 5])
 *
 * addDefaults(1, 2); // => 3
 * addDefaults(null, 2); // => 6
 * addDefaults(2, null); // => 7
 * addDefaults(undefined, undefined); // => 9
 */ var $29d5fdf93fd26997$var$fnull = (0, $iB6UK.default)(function(fn, defaults) {
    return (0, $dB93a.default)(fn.length, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsWithDefaults = (0, $fsyKq.default)(function(val, idx) {
            return (0, $9V3Lk.default)((0, $1FHr3.default), defaults[idx], val);
        }, args);
        return (0, $384ED.default)(fn, argsWithDefaults);
    });
});
var $29d5fdf93fd26997$export$2e2bcd8739ae039 = $29d5fdf93fd26997$var$fnull;

});
parcelRegister("9V3Lk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $738c5b122ece6d91$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
/**
 * Returns the second argument if predicate function returns `true`,
 * otherwise the third argument is returned.
 *
 * @func defaultWhen
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.2.0|v2.2.0}
 * @category Logic
 * @sig  (a -> Boolean) -> b -> a -> a | b
 * @param {!function} predicate The predicate function
 * @param {*} defaultVal The default value
 * @param {*} val `val` will be returned instead of `defaultVal` if predicate returns false
 * @return {*} The `val` if predicate returns `false`, otherwise the default value
 * @see {@link http://ramdajs.com/docs/#defaultTo|R.defaultTo}
 * @example
 *
 * RA.defaultWhen(RA.isNull, 1, null); // => 1
 * RA.defaultWhen(RA.isNull, 1, 2); // => 2
 */ var $738c5b122ece6d91$var$defaultWhen = (0, $iB6UK.default)(function(predicate, defaultVal, val) {
    return predicate(val) ? defaultVal : val;
});
var $738c5b122ece6d91$export$2e2bcd8739ae039 = $738c5b122ece6d91$var$defaultWhen;

});

parcelRegister("fsyKq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4146cb844f85d35$export$2e2bcd8739ae039; });

var $dvIel = parcelRequire("dvIel");
var $kuJWW = parcelRequire("kuJWW");
/**
 * {@link http://ramdajs.com/docs/#map|R.map} function that more closely resembles Array.prototype.map.
 * It takes two new parameters to its callback function: the current index, and the entire list.
 *
 * `mapIndexed` implementation is simple : `
 * const mapIndexed = R.addIndex(R.map);
 * `
 * @func mapIndexed
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.5.0|v2.5.0}
 * @category List
 * @typedef Idx = Number
 * @sig Functor f => ((a, Idx, f a) => b) => f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`
 * @param {Array} list The list to be iterated over
 * @return {Array} The new list
 * @see {@link http://ramdajs.com/docs/#addIndex|R.addIndex}, {@link http://ramdajs.com/docs/#map|R.map}
 * @example
 *
 * RA.mapIndexed((val, idx, list) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 * //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var $b4146cb844f85d35$var$mapIndexed = (0, $dvIel.default)((0, $kuJWW.default));
var $b4146cb844f85d35$export$2e2bcd8739ae039 = $b4146cb844f85d35$var$mapIndexed;

});


parcelRegister("2DsmD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eb539cfa3b6b547$export$2e2bcd8739ae039; });

var $dvIel = parcelRequire("dvIel");
var $9Zbrv = parcelRequire("9Zbrv");
/**
 * {@link http://ramdajs.com/docs/#reduce|R.reduce} function that more closely resembles Array.prototype.reduce.
 * It takes two new parameters to its callback function: the current index, and the entire list.
 *
 * `reduceIndexed` implementation is simple : `
 * const reduceIndexed = R.addIndex(R.reduce);
 * `
 * @func reduceIndexed
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.5.0|v2.5.0}
 * @category List
 * @typedef Idx = Number
 * @sig ((a, b, Idx, [b]) => a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives four values,
 * the accumulator, the current element from the array, index and the entire list
 * @param {*} acc The accumulator value
 * @param {Array} list The list to iterate over
 * @return {*} The final, accumulated value
 * @see {@link http://ramdajs.com/docs/#addIndex|R.addIndex}, {@link http://ramdajs.com/docs/#reduce|R.reduce}
 * @example
 *
 * const initialList = ['f', 'o', 'o', 'b', 'a', 'r'];
 *
 * reduceIndexed((acc, val, idx, list) => acc + '-' + val + idx, '', initialList);
 * //=> "-f0-o1-o2-b3-a4-r5"
 */ var $1eb539cfa3b6b547$var$reduceIndexed = (0, $dvIel.default)((0, $9Zbrv.default));
var $1eb539cfa3b6b547$export$2e2bcd8739ae039 = $1eb539cfa3b6b547$var$reduceIndexed;

});

parcelRegister("1EZZc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13599c02037e3451$export$2e2bcd8739ae039; });

var $dvIel = parcelRequire("dvIel");
var $r0sUa = parcelRequire("r0sUa");
/**
 * {@link http://ramdajs.com/docs/#filter|R.filter} function that more closely resembles `Array.prototype.filter`.
 * It takes two new parameters to its callback function: the current index, and the entire list.
 *
 * `filterIndexed` implementation is simple: `
 *  const filterIndexed = R.addIndex(R.filter);
 * `
 *
 * @func filterIndexed
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.31.0|v2.31.0}
 * @category List
 * @typedef Idx = Number
 * @sig Filterable f => ((a, Idx, f a) -> Boolean) -> f a -> f a
 * @param {Function} pred The predicate function
 * @param {Array} list The collection to filter
 * @return {Array} Filterable
 * @see {@link http://ramdajs.com/docs/#addIndex|R.addIndex}, {@link http://ramdajs.com/docs/#filter|R.filter}
 * @example
 *
 * const isValueGtIndex = (val, idx) => val > idx;
 * RA.filterIndexed(isValueGtIndex, [5, 4, 3, 2, 1, 0]); //=> [5, 4, 3]
 */ var $13599c02037e3451$var$filterIndexed = (0, $dvIel.default)((0, $r0sUa.default));
var $13599c02037e3451$export$2e2bcd8739ae039 = $13599c02037e3451$var$filterIndexed;

});

parcelRegister("bObFg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $898d6991b47e5097$export$2e2bcd8739ae039; });

var $dvIel = parcelRequire("dvIel");
var $iIHod = parcelRequire("iIHod");
var $iB6UK = parcelRequire("iB6UK");
var $r0sUa = parcelRequire("r0sUa");
var $898d6991b47e5097$var$filterIndexed = (0, $dvIel.default)((0, $r0sUa.default));
var $898d6991b47e5097$var$containsIndex = (0, $iB6UK.default)(function(indexes, val, index) {
    return (0, $iIHod.default)(index, indexes);
});
/**
 * Picks values from list by indexes.
 *
 * Note: pickIndexes will skip non existing indexes. If you want to include them
 * use ramda's `props` function.
 *
 * @func pickIndexes
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.1.0|v1.1.0}
 * @category List
 * @sig  [Number] -> [a] -> [a]
 * @param {Array} indexes The indexes to pick
 * @param {Array} list The list to pick values from
 * @return {Array} New array containing only values at `indexes`
 * @see {@link http://ramdajs.com/docs/#pick|R.pick}, {@link RA.omitIndexes|omitIndexes}
 * @example
 *
 * RA.pickIndexes([0, 2], ['a', 'b', 'c']); //=> ['a', 'c']
 */ var $898d6991b47e5097$var$pickIndexes = (0, $iB6UK.default)(function(indexes, list) {
    return $898d6991b47e5097$var$filterIndexed($898d6991b47e5097$var$containsIndex(indexes), list);
});
var $898d6991b47e5097$export$2e2bcd8739ae039 = $898d6991b47e5097$var$pickIndexes;

});

parcelRegister("3KuR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bad9a5e768278c8$export$2e2bcd8739ae039; });

var $6PHwe = parcelRequire("6PHwe");
var $bBRxi = parcelRequire("bBRxi");
/**
 * Creates a list from arguments.
 *
 * @func list
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.1.0|v1.1.0}
 * @category List
 * @sig  a... -> [a...]
 * @param {...*} items The items of the feature list
 * @return {Array} New list created from items
 * @see {@link https://github.com/ramda/ramda/wiki/Cookbook#create-a-list-function|Ramda Cookbook}
 * @example
 *
 * RA.list('a', 'b', 'c'); //=> ['a', 'b', 'c']
 */ var $2bad9a5e768278c8$var$list = (0, $bBRxi.default)((0, $6PHwe.default));
var $2bad9a5e768278c8$export$2e2bcd8739ae039 = $2bad9a5e768278c8$var$list;

});

parcelRegister("93hMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6972316ad00b8936$export$2e2bcd8739ae039; });

var $2Bayo = parcelRequire("2Bayo");
var $7Dogi = parcelRequire("7Dogi");

var $5O8bC = parcelRequire("5O8bC");
/**
 * Returns a singleton array containing the value provided.
 * If value is already an array, it is returned as is.
 *
 * @func ensureArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.6.0|v2.6.0}
 * @category List
 * @sig a | [a] -> [a]
 * @param {*|Array} val the value ensure as Array
 * @return {Array}
 * @see {@link http://ramdajs.com/docs/#of|R.of}
 * @example
 *
 * RA.ensureArray(42); //=> [42]
 * RA.ensureArray([42]); //=> [42]
 */ var $6972316ad00b8936$var$ensureArray = (0, $7Dogi.default)((0, $5O8bC.default), (0, $2Bayo.default));
var $6972316ad00b8936$export$2e2bcd8739ae039 = $6972316ad00b8936$var$ensureArray;

});

parcelRegister("dL6Up", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0450618fd159bb1$export$2e2bcd8739ae039; });

var $g8SbF = parcelRequire("g8SbF");
var $felhC = parcelRequire("felhC");
var $6PHwe = parcelRequire("6PHwe");
var $10F1K = parcelRequire("10F1K");
var $9Zbrv = parcelRequire("9Zbrv");
var $7Dogi = parcelRequire("7Dogi");

var $cFBID = parcelRequire("cFBID");
var $a0450618fd159bb1$var$leftIdentitySemigroup = {
    concat: (0, $6PHwe.default)
};
/**
 * Returns the result of concatenating the given lists or strings.
 * Note: RA.concatAll expects all elements to be of the same type. It will throw an error if you concat an Array with a non-Array value.
 * Dispatches to the concat method of the preceding element, if present. Can also concatenate multiple elements of a [fantasy-land compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 * Returns undefined if empty array was passed.
 *
 * @func concatAll
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.6.0|v2.6.0}
 * @category List
 * @sig [[a]] -> [a] | Undefined
 * @sig [String] -> String | Undefined
 * @sig Semigroup s => Foldable s f => f -> s | Undefined
 * @param {Array.<Array|string>} list List containing elements that will be concatenated
 * @return {Array|string|undefined} Concatenated elements
 * @see {@link http://ramdajs.com/docs/#concat|R.concat}, {@link RA.concatRight|concatRight}, {@link http://ramdajs.com/docs/#unnest|R.unnest}, {@link http://ramdajs.com/docs/#join|R.join}
 * @example
 *
 * concatAll([[1], [2], [3]]); //=> [1, 2, 3]
 * concatAll(['1', '2', '3']); //=> '123'
 * concatAll([]); //=> undefined;
 */ var $a0450618fd159bb1$var$concatAll = (0, $10F1K.default)((0, $9Zbrv.default)((0, $g8SbF.default), $a0450618fd159bb1$var$leftIdentitySemigroup), (0, $7Dogi.default)((0, $felhC.default)($a0450618fd159bb1$var$leftIdentitySemigroup), (0, $cFBID.default)));
var $a0450618fd159bb1$export$2e2bcd8739ae039 = $a0450618fd159bb1$var$concatAll;

});

parcelRegister("6qh0M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ad25df245080cfa$export$2e2bcd8739ae039; });

var $g8SbF = parcelRequire("g8SbF");
var $d071Y = parcelRequire("d071Y");
/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: R.concat expects both arguments to be of the same type, unlike
 * the native Array.prototype.concat method.
 * It will throw an error if you concat an Array with a non-Array value.
 * Dispatches to the concat method of the second argument, if present.
 *
 * @func concatRight
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.11.0|v1.11.0}
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `secondList`
 * followed by the elements of `firstList`.
 * @see {@link http://ramdajs.com/docs/#concat|R.concat}
 * @example
 *
 * RA.concatRight('ABC', 'DEF'); //=> 'DEFABC'
 * RA.concatRight([4, 5, 6], [1, 2, 3]); //=> [1, 2, 3, 4, 5, 6]
 * RA.concatRight([], []); //=> []
 */ var $4ad25df245080cfa$var$concatRight = (0, $d071Y.default)((0, $g8SbF.default));
var $4ad25df245080cfa$export$2e2bcd8739ae039 = $4ad25df245080cfa$var$concatRight;

});

parcelRegister("7jBKJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $553797ad909113f0$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $bHf4t = parcelRequire("bHf4t");
var $9Zbrv = parcelRequire("9Zbrv");

var $8kRo3 = parcelRequire("8kRo3");

var $4ee2H = parcelRequire("4ee2H");

var $87any = parcelRequire("87any");
function $553797ad909113f0$var$_slicedToArray(arr, i) {
    return $553797ad909113f0$var$_arrayWithHoles(arr) || $553797ad909113f0$var$_iterableToArrayLimit(arr, i) || $553797ad909113f0$var$_unsupportedIterableToArray(arr, i) || $553797ad909113f0$var$_nonIterableRest();
}
function $553797ad909113f0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $553797ad909113f0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $553797ad909113f0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $553797ad909113f0$var$_arrayLikeToArray(o, minLen);
}
function $553797ad909113f0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $553797ad909113f0$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $553797ad909113f0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/* eslint-disable max-len */ /**
 * Given an `Iterable`(arrays are `Iterable`), or a promise of an `Iterable`,
 * which produces promises (or a mix of promises and values),
 * iterate over all the values in the `Iterable` into an array and
 * reduce the array to a value using the given iterator function.
 *
 * If the iterator function returns a promise, then the result of the promise is awaited,
 * before continuing with next iteration. If any promise in the array is rejected or a promise
 * returned by the iterator function is rejected, the result is rejected as well.
 *
 * If `initialValue` is `undefined` (or a promise that resolves to `undefined`) and
 * the `Iterable` contains only 1 item, the callback will not be called and
 * the `Iterable's` single item is returned. If the `Iterable` is empty, the callback
 * will not be called and `initialValue` is returned (which may be undefined).
 *
 * This function is basically equivalent to {@link http://bluebirdjs.com/docs/api/promise.reduce.html|bluebird.reduce}.
 *
 * @func reduceP
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.13.0|v1.13.0}
 * @category List
 * @typedef MaybePromise = Promise.<*> | *
 * @sig ((Promise a, MaybePromise b) -> Promise a) -> MaybePromise a -> MaybePromise [MaybePromise b] -> Promise a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the current element from the list
 * @param {*|Promise.<*>} acc The accumulator value
 * @param {Array.<*>|Promise.<Array<*|Promise.<*>>>} list The list to iterate over
 * @return {Promise} The final, accumulated value
 * @see {@link http://ramdajs.com/docs/#reduce|R.reduce}, {@link RA.reduceRightP|reduceRightP}, {@link http://bluebirdjs.com/docs/api/promise.reduce.html|bluebird.reduce}
 * @example
 *
 * RA.reduceP(
 *   (total, fileName) => fs
 *     .readFileAsync(fileName, 'utf8')
 *     .then(contents => total + parseInt(contents, 10)),
 *   0,
 *   ['file1.txt', 'file2.txt', 'file3.txt']
 * ); // => Promise(10)
 *
 * RA.reduceP(
 *   (total, fileName) => fs
 *     .readFileAsync(fileName, 'utf8')
 *     .then(contents => total + parseInt(contents, 10)),
 *   Promise.resolve(0),
 *   ['file1.txt', 'file2.txt', 'file3.txt']
 * ); // => Promise(10)
 *
 * RA.reduceP(
 *   (total, fileName) => fs
 *     .readFileAsync(fileName, 'utf8')
 *     .then(contents => total + parseInt(contents, 10)),
 *   0,
 *   [Promise.resolve('file1.txt'), 'file2.txt', 'file3.txt']
 * ); // => Promise(10)
 *
 * RA.reduceP(
 *   (total, fileName) => fs
 *     .readFileAsync(fileName, 'utf8')
 *     .then(contents => total + parseInt(contents, 10)),
 *   0,
 *   Promise.resolve([Promise.resolve('file1.txt'), 'file2.txt', 'file3.txt'])
 * ); // => Promise(10)
 *
 */ /* esline-enable max-len */ var $553797ad909113f0$var$reduceP = (0, $dB93a.default)(3, function(fn, acc, list) {
    return (0, $4ee2H.default)(list).then(function(iterable) {
        var listLength = (0, $bHf4t.default)(iterable);
        if (listLength === 0) return acc;
        var reducer = (0, $9Zbrv.default)(function(accP, currentValueP) {
            return accP.then(function(previousValue) {
                return (0, $87any.default)([
                    previousValue,
                    currentValueP
                ]);
            }).then(function(_ref) {
                var _ref2 = $553797ad909113f0$var$_slicedToArray(_ref, 2), previousValue = _ref2[0], currentValue = _ref2[1];
                if ((0, $8kRo3.default)(previousValue) && listLength === 1) return currentValue;
                return fn(previousValue, currentValue);
            });
        });
        return reducer((0, $4ee2H.default)(acc), iterable);
    });
});
var $553797ad909113f0$export$2e2bcd8739ae039 = $553797ad909113f0$var$reduceP;

});

parcelRegister("lc8sJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6e1486f52ba2e3a$export$2e2bcd8739ae039; });

var $g8SbF = parcelRequire("g8SbF");
var $dB93a = parcelRequire("dB93a");
var $g5jN3 = parcelRequire("g5jN3");
var $bHf4t = parcelRequire("bHf4t");
var $10F1K = parcelRequire("10F1K");
var $jLvnw = parcelRequire("jLvnw");

var $8kRo3 = parcelRequire("8kRo3");

var $4ee2H = parcelRequire("4ee2H");

var $87any = parcelRequire("87any");
function $f6e1486f52ba2e3a$var$_slicedToArray(arr, i) {
    return $f6e1486f52ba2e3a$var$_arrayWithHoles(arr) || $f6e1486f52ba2e3a$var$_iterableToArrayLimit(arr, i) || $f6e1486f52ba2e3a$var$_unsupportedIterableToArray(arr, i) || $f6e1486f52ba2e3a$var$_nonIterableRest();
}
function $f6e1486f52ba2e3a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f6e1486f52ba2e3a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f6e1486f52ba2e3a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f6e1486f52ba2e3a$var$_arrayLikeToArray(o, minLen);
}
function $f6e1486f52ba2e3a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f6e1486f52ba2e3a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f6e1486f52ba2e3a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $f6e1486f52ba2e3a$var$flipArgs = (0, $10F1K.default)((0, $jLvnw.default)((0, $g8SbF.default), ""), (0, $g5jN3.default)("ba"))([
    "a",
    "b"
]);
/* eslint-disable max-len */ /**
 * Given an `Iterable`(arrays are `Iterable`), or a promise of an `Iterable`,
 * which produces promises (or a mix of promises and values),
 * iterate over all the values in the `Iterable` into an array and
 * reduce the array to a value using the given iterator function.
 *
 * Similar to {@link RA.reduceP|reduceP} except moves through the input list from the right to the left.
 * The iterator function receives two values: (value, acc),
 * while the arguments' order of reduceP's iterator function is (acc, value).
 *
 * @func reduceRightP
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.13.0|v1.13.0}
 * @category List
 * @typedef MaybePromise = Promise.<*> | *
 * @sig ((MaybePromise b, Promise a) -> Promise a) -> MaybePromise a -> MaybePromise [MaybePromise b] -> Promise a
 * @param {Function} fn The iterator function. Receives two values, the current element from the list and the accumulator
 * @param {*|Promise.<*>} acc The accumulator value
 * @param {Array.<*>|Promise.<Array<*|Promise.<*>>>} list The list to iterate over
 * @return {Promise} The final, accumulated value
 * @see {@link RA.reduceP|reduceP}, {@link http://bluebirdjs.com/docs/api/promise.reduce.html|bluebird.reduce}
 * @example
 *
 * RA.reduceRightP(
 *   (fileName, total) => fs
 *     .readFileAsync(fileName, 'utf8')
 *     .then(contents => total + parseInt(contents, 10)),
 *   0,
 *   ['file1.txt', 'file2.txt', 'file3.txt']
 * ); // => Promise(10)
 *
 * RA.reduceRightP(
 *   (fileName, total) => fs
 *     .readFileAsync(fileName, 'utf8')
 *     .then(contents => total + parseInt(contents, 10)),
 *   Promise.resolve(0),
 *   ['file1.txt', 'file2.txt', 'file3.txt']
 * ); // => Promise(10)
 *
 * RA.reduceRightP(
 *   (fileName, total) => fs
 *     .readFileAsync(fileName, 'utf8')
 *     .then(contents => total + parseInt(contents, 10)),
 *   0,
 *   [Promise.resolve('file1.txt'), 'file2.txt', 'file3.txt']
 * ); // => Promise(10)
 *
 * RA.reduceRightP(
 *   (fileName, total) => fs
 *     .readFileAsync(fileName, 'utf8')
 *     .then(contents => total + parseInt(contents, 10)),
 *   0,
 *   Promise.resolve([Promise.resolve('file1.txt'), 'file2.txt', 'file3.txt'])
 * ); // => Promise(10)
 *
 */ /* esline-enable max-len */ var $f6e1486f52ba2e3a$var$reduceRightP = (0, $dB93a.default)(3, function(fn, acc, list) {
    return (0, $4ee2H.default)(list).then(function(iterable) {
        var listLength = (0, $bHf4t.default)(iterable);
        if (listLength === 0) return acc;
        var reducer = (0, $jLvnw.default)(function(arg1, arg2) {
            var accP;
            var currentValueP;
            if ($f6e1486f52ba2e3a$var$flipArgs) {
                accP = arg1;
                currentValueP = arg2;
            } else {
                accP = arg2;
                currentValueP = arg1;
            }
            return accP.then(function(previousValue) {
                return (0, $87any.default)([
                    previousValue,
                    currentValueP
                ]);
            }).then(function(_ref) {
                var _ref2 = $f6e1486f52ba2e3a$var$_slicedToArray(_ref, 2), previousValue = _ref2[0], currentValue = _ref2[1];
                if ((0, $8kRo3.default)(previousValue) && listLength === 1) return currentValue;
                return fn(currentValue, previousValue);
            });
        });
        return reducer((0, $4ee2H.default)(acc), iterable);
    });
});
var $f6e1486f52ba2e3a$export$2e2bcd8739ae039 = $f6e1486f52ba2e3a$var$reduceRightP;

});

parcelRegister("aim6A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77ecbb775906fb8c$export$2e2bcd8739ae039; });

var $AVvPi = parcelRequire("AVvPi");
var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns the elements of the given list or string (or object with a slice method)
 * from fromIndex (inclusive).
 * Dispatches to the slice method of the second argument, if present.
 *
 * @func sliceFrom
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.16.0|v1.16.0}
 * @category List
 * @sig  Number -> [a] -> [a]
 * @param {number} fromIndex The start index (inclusive)
 * @param {Array|string} list The list or string to slice
 * @return {Array|string} The sliced list or string
 * @see {@link http://ramdajs.com/docs/#slice|R.slice}, {@link RA.sliceTo|sliceTo}
 * @example
 *
 * RA.sliceFrom(1, [1, 2, 3]); //=> [2, 3]
 */ var $77ecbb775906fb8c$var$sliceFrom = (0, $5KOxr.default)((0, $AVvPi.default), Infinity);
var $77ecbb775906fb8c$export$2e2bcd8739ae039 = $77ecbb775906fb8c$var$sliceFrom;

});

parcelRegister("bTKOy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a99251e18ee1ae3$export$2e2bcd8739ae039; });

var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns the elements of the given list or string (or object with a slice method)
 * to toIndex (exclusive).
 * Dispatches to the slice method of the second argument, if present.
 *
 * @func sliceTo
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.16.0|v1.16.0}
 * @category List
 * @sig  Number -> [a] -> [a]
 * @param {number} toIndex The end index (exclusive)
 * @param {Array|string} list The list or string to slice
 * @return {Array|string} The sliced list or string
 * @see {@link http://ramdajs.com/docs/#slice|R.slice}, {@link RA.sliceFrom|sliceFrom}
 * @example
 *
 * RA.sliceTo(2, [1, 2, 3]); //=> [1, 2]
 */ var $8a99251e18ee1ae3$var$sliceTo = (0, $5KOxr.default)(0);
var $8a99251e18ee1ae3$export$2e2bcd8739ae039 = $8a99251e18ee1ae3$var$sliceTo;

});

parcelRegister("4CQIa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35e3996e69a192a5$export$2e2bcd8739ae039; });

var $dvIel = parcelRequire("dvIel");
var $iIHod = parcelRequire("iIHod");
var $iB6UK = parcelRequire("iB6UK");
var $2m6Qn = parcelRequire("2m6Qn");
var $35e3996e69a192a5$var$rejectIndexed = (0, $dvIel.default)((0, $2m6Qn.default));
var $35e3996e69a192a5$var$containsIndex = (0, $iB6UK.default)(function(indexes, val, index) {
    return (0, $iIHod.default)(index, indexes);
});
/**
 * Returns a partial copy of an array omitting the indexes specified.
 *
 * @func omitIndexes
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.19.0|v1.19.0}
 * @category List
 * @sig [Int] -> [a] -> [a]
 * @see {@link http://ramdajs.com/docs/#omit|R.omit}, {@link RA.pickIndexes|pickIndexes}
 * @param {!Array} indexes The array of indexes to omit from the new array
 * @param {!Array} list The array to copy from
 * @return {!Array} The new array with omitted indexes
 * @example
 *
 * RA.omitIndexes([-1, 1, 3], ['a', 'b', 'c', 'd']); //=> ['a', 'c']
 */ var $35e3996e69a192a5$var$omitIndexes = (0, $iB6UK.default)(function(indexes, list) {
    return $35e3996e69a192a5$var$rejectIndexed($35e3996e69a192a5$var$containsIndex(indexes), list);
});
var $35e3996e69a192a5$export$2e2bcd8739ae039 = $35e3996e69a192a5$var$omitIndexes;

});

parcelRegister("60LWC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4607eef57f3dfd72$export$2e2bcd8739ae039; });

var $2m6Qn = parcelRequire("2m6Qn");

var $1z2ql = parcelRequire("1z2ql");
/**
 * Creates an array with all falsy values removed.
 * The values false, null, 0, "", undefined, and NaN are falsy.
 *
 * @func compact
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.5.0|v2.5.0}
 * @category List
 * @sig Filterable f => f a -> f a
 * @param {Array} list The array to compact
 * @return {Array} Returns the new array of filtered values
 * @see {@link RA.isFalsy|isFalsy}
 * @example
 *
 * RA.compact([0, 1, false, 2, '', 3]); //=> [1, 2, 3]
 */ var $4607eef57f3dfd72$var$compact = (0, $2m6Qn.default)((0, $1z2ql.default));
var $4607eef57f3dfd72$export$2e2bcd8739ae039 = $4607eef57f3dfd72$var$compact;

});

parcelRegister("hHp2k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce29df8a923abffe$export$2e2bcd8739ae039; });

var $aj4Qz = parcelRequire("aj4Qz");
var $d071Y = parcelRequire("d071Y");
/**
 * Returns a new list containing the contents of the given list, followed by the given element.
 * Like {@link http://ramdajs.com/docs/#append|R.append} but with argument order reversed.
 *
 * @func appendFlipped
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.5.0|v2.5.0}
 * @category List
 * @sig [a] -> a -> [a]
 * @param {Array} list The list of elements to add a new item to
 * @param {*} el The element to add to the end of the new list
 * @return {Array} A new list containing the elements of the old list followed by `el`
 * @see {@link http://ramdajs.com/docs/#append|R.append}
 * @example
 *
 * RA.appendFlipped(['write', 'more'], 'tests'); //=> ['write', 'more', 'tests']
 * RA.appendFlipped([], 'tests'); //=> ['tests']
 * RA.appendFlipped(['write', 'more'], ['tests']); //=> ['write', 'more', ['tests']]
 */ var $ce29df8a923abffe$var$appendFlipped = (0, $d071Y.default)((0, $aj4Qz.default));
var $ce29df8a923abffe$export$2e2bcd8739ae039 = $ce29df8a923abffe$var$appendFlipped;

});

parcelRegister("hCFXH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd468902e3bc400f$export$2e2bcd8739ae039; });

var $iIHod = parcelRequire("iIHod");
var $d071Y = parcelRequire("d071Y");
/**
 * Returns true if the specified value is equal, in R.equals terms,
 * to at least one element of the given list or false otherwise.
 * Given list can be a string.
 *
 * Like {@link http://ramdajs.com/docs/#contains|R.contains} but with argument order reversed.
 *
 * @func contained
 * @aliases included
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.8.0|v2.8.0}
 * @deprecated since v2.12.0; please use RA.included alias
 * @category List
 * @sig [a] -> a -> Boolean
 * @param {Array|String} list The list to consider
 * @param {*} a The item to compare against
 * @return {boolean} Returns Boolean `true` if an equivalent item is in the list or `false` otherwise
 * @see {@link http://ramdajs.com/docs/#contains|R.contains}
 * @example
 *
 * RA.contained([1, 2, 3], 3); //=> true
 * RA.contained([1, 2, 3], 4); //=> false
 * RA.contained([{ name: 'Fred' }], { name: 'Fred' }); //=> true
 * RA.contained([[42]], [42]); //=> true
 */ var $cd468902e3bc400f$var$contained = (0, $d071Y.default)((0, $iIHod.default));
var $cd468902e3bc400f$export$2e2bcd8739ae039 = $cd468902e3bc400f$var$contained;

});

parcelRegister("jLlIA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e63340de0d82bede$export$2e2bcd8739ae039; });

var $d8dol = parcelRequire("d8dol");
var $iB6UK = parcelRequire("iB6UK");
var $8DoXL = parcelRequire("8DoXL");
var $am2mP = parcelRequire("am2mP");
var $bGNEx = parcelRequire("bGNEx");
/**
 * Returns a new list with the item at the position `fromIdx` moved to the position `toIdx`. If the
 * `toIdx` is out of the `list` range, the item will be placed at the last position of the `list`.
 * When negative indices are provided, the behavior of the move is unspecified.
 *
 * @func move
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.8.0|v2.8.0}
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {number} fromIdx The position of item to be moved
 * @param {number} toIdx The position of item after move
 * @param {Array} list The list containing the item to be moved
 * @return {Array}
 * @example
 *
 * const list = ['a', 'b', 'c', 'd', 'e'];
 * RA.move(1, 3, list) //=> ['a', 'c', 'd', 'b', 'e']
 */ var $e63340de0d82bede$var$move = (0, $iB6UK.default)(function(fromIdx, toIdx, list) {
    return (0, $d8dol.default)((0, $8DoXL.default)(toIdx, (0, $am2mP.default)(fromIdx, list)), (0, $bGNEx.default)(fromIdx, 1))(list);
});
var $e63340de0d82bede$export$2e2bcd8739ae039 = $e63340de0d82bede$var$move;

});

parcelRegister("dadMr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9956e600f1a06d79$export$2e2bcd8739ae039; });

var $d071Y = parcelRequire("d071Y");
var $eiA2o = parcelRequire("eiA2o");

var $4flyd = parcelRequire("4flyd");
/**
 * Returns `true` if the supplied list or string has a length greater than `valueLength`.
 *
 * @func lengthGt
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.8.0|v2.8.0}
 * @category List
 * @sig Number -> [*] -> Boolean
 * @param {number} valueLength The length of the list or string
 * @param {Array|string} value The list or string
 * @return {boolean}
 * @see {@link RA.lengthEq|lengthEq}, {@link RA.lengthNotEq|lengthNotEq}, {@link RA.lengthLt|lengthLt}, {@link RA.lengthLte|lengthLte}, {@link RA.lengthGte|lengthGte}, {@link http://ramdajs.com/docs/#gt|gt},  {@link http://ramdajs.com/docs/#length|length}
 * @example
 *
 * RA.lengthGt(3, [1,2,3,4]); //=> true
 * RA.lengthGt(3, [1,2,3]); //=> false
 */ var $9956e600f1a06d79$var$lengthGt = (0, $4flyd.default)((0, $d071Y.default)((0, $eiA2o.default)));
var $9956e600f1a06d79$export$2e2bcd8739ae039 = $9956e600f1a06d79$var$lengthGt;

});

parcelRegister("4rOEB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33d0f9d2d6c000e2$export$2e2bcd8739ae039; });

var $d071Y = parcelRequire("d071Y");
var $jh4AG = parcelRequire("jh4AG");

var $4flyd = parcelRequire("4flyd");
/**
 * Returns `true` if the supplied list or string has a length less than `valueLength`.
 *
 * @func lengthLt
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.8.0|v2.8.0}
 * @category List
 * @sig Number -> [*] -> Boolean
 * @param {number} valueLength The length of the list or string
 * @param {Array|string} value The list or string
 * @return {boolean}
 * @see {@link RA.lengthEq|lengthEq}, {@link RA.lengthNotEq|lengthNotEq}, {@link RA.lengthGt|lengthGt}, {@link RA.lengthLte|lengthLte}, {@link RA.lengthGte|lengthGte}, {@link http://ramdajs.com/docs/#lt|lt}, {@link http://ramdajs.com/docs/#length|length}
 * @example
 *
 * RA.lengthLt(3, [1,2]); //=> true
 * RA.lengthLt(3, [1,2,3]); //=> false
 */ var $33d0f9d2d6c000e2$var$lengthLt = (0, $4flyd.default)((0, $d071Y.default)((0, $jh4AG.default)));
var $33d0f9d2d6c000e2$export$2e2bcd8739ae039 = $33d0f9d2d6c000e2$var$lengthLt;

});

parcelRegister("d31Hk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97fcdf51c0e09029$export$2e2bcd8739ae039; });

var $d071Y = parcelRequire("d071Y");
var $hZash = parcelRequire("hZash");

var $4flyd = parcelRequire("4flyd");
/**
 * Returns `true` if the supplied list or string has a length less than or equal to `valueLength`.
 *
 * @func lengthLte
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.8.0|v2.8.0}
 * @category List
 * @sig Number -> [*] -> Boolean
 * @param {number} valueLength The length of the list or string
 * @param {Array|string} value The list or string
 * @return {boolean}
 * @see {@link RA.lengthEq|lengthEq}, {@link RA.lengthNotEq|lengthNotEq}, {@link RA.lengthLt|lengthLt}, {@link RA.lengthGt|lengthGt}, {@link RA.lengthGte|lengthGte}, {@link http://ramdajs.com/docs/#lte|lte}, {@link http://ramdajs.com/docs/#length|length}
 * @example
 *
 * RA.lengthLte(3, [1,2]); //=> true
 * RA.lengthLte(3, [1,2,3]); //=> true
 * RA.lengthLte(3, [1,2,3,4]); //=> false
 */ var $97fcdf51c0e09029$var$lengthLte = (0, $4flyd.default)((0, $d071Y.default)((0, $hZash.default)));
var $97fcdf51c0e09029$export$2e2bcd8739ae039 = $97fcdf51c0e09029$var$lengthLte;

});

parcelRegister("g17V5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba92e20714ed59da$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $g5jN3 = parcelRequire("g5jN3");

var $4flyd = parcelRequire("4flyd");
/**
 * Returns `true` if the supplied list or string has a length not equal to `valueLength`.
 *
 * @func lengthNotEq
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.8.0|v2.8.0}
 * @category List
 * @sig Number -> [*] -> Boolean
 * @param {number} valueLength The length of the list or string
 * @param {Array|string} value The list or string
 * @return {boolean}
 * @see {@link RA.lengthEq|lengthEq}, {@link RA.lengthLt|lengthLt}, {@link RA.lengthGt|lengthGt}, {@link RA.lengthLte|lengthLte}, {@link RA.lengthGte|lengthGte}, {@link http://ramdajs.com/docs/#equals|equals}, {@link http://ramdajs.com/docs/#length|length}
 * @example
 *
 * RA.lengthNotEq(3, [1,2,3,4]); //=> true
 * RA.lengthNotEq(3, [1,2,3]); //=> false
 */ var $ba92e20714ed59da$var$lengthNotEq = (0, $4flyd.default)((0, $fm6cm.default)((0, $g5jN3.default)));
var $ba92e20714ed59da$export$2e2bcd8739ae039 = $ba92e20714ed59da$var$lengthNotEq;

});

parcelRegister("llWNQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8b92c324ea2f7ff$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $10F1K = parcelRequire("10F1K");
var $7bi4H = parcelRequire("7bi4H");

var $d31Hk = parcelRequire("d31Hk");
// in https://github.com/char0n/ramda-adjunct/pull/513.
/**
 * Returns true if all items in the list are equivalent using `R.equals` for equality comparisons.
 *
 * @func allEqual
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.9.0|v2.9.0}
 * @category List
 * @sig [a] -> Boolean
 * @param {Array} list The list of values
 * @return {boolean}
 * @see {@link https://ramdajs.com/docs/#equals|equals}
 * @example
 *
 * RA.allEqual([ 1, 2, 3, 4 ]); //=> false
 * RA.allEqual([ 1, 1, 1, 1 ]); //=> true
 * RA.allEqual([]); //=> true
 *
 */ var $f8b92c324ea2f7ff$var$allEqual = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $7bi4H.default), (0, $d31Hk.default)(1)));
var $f8b92c324ea2f7ff$export$2e2bcd8739ae039 = $f8b92c324ea2f7ff$var$allEqual;

});

parcelRegister("gvRc1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c058cd971f4538eb$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $d071Y = parcelRequire("d071Y");
var $leUBm = parcelRequire("leUBm");

var $fJX8p = parcelRequire("fJX8p");

var $3bTqG = parcelRequire("3bTqG");
var $c058cd971f4538eb$export$f3f2c2c157f9a146 = (0, $iB6UK.default)((0, $fJX8p.default));
var $c058cd971f4538eb$export$32033aadc884b61 = (0, $d071Y.default)((0, $leUBm.default)(1, "repeat"));
/**
 * Constructs and returns a new string which contains the specified
 * number of copies of the string on which it was called, concatenated together.
 *
 * @func repeatStr
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.11.0|v2.11.0}
 * @category List
 * @sig String -> Number -> String
 * @param {string} value String value to be repeated
 * @param {number} count An integer between 0 and +∞: [0, +∞), indicating the number of times to repeat the string in the newly-created string that is to be returned
 * @return {string} A new string containing the specified number of copies of the given string
 * @example
 *
 * RA.repeatStr('a', 3); //=> 'aaa'
 */ var $c058cd971f4538eb$var$repeatStr = (0, $3bTqG.default)(String.prototype.repeat) ? $c058cd971f4538eb$export$32033aadc884b61 : $c058cd971f4538eb$export$f3f2c2c157f9a146;
var $c058cd971f4538eb$export$2e2bcd8739ae039 = $c058cd971f4538eb$var$repeatStr;

});
parcelRegister("fJX8p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b758ede7dde7f5cc$export$2e2bcd8739ae039; });

var $eaSfB = parcelRequire("eaSfB");

var $dT8Yh = parcelRequire("dT8Yh");
var $b758ede7dde7f5cc$var$repeat = function repeat(value, count) {
    var validCount = Number(count);
    if (validCount !== count) validCount = 0;
    if ((0, $dT8Yh.default)(validCount)) throw new RangeError("repeat count must be non-negative");
    if ((0, $eaSfB.default)(validCount)) throw new RangeError("repeat count must be less than infinity");
    validCount = Math.floor(validCount);
    if (value.length === 0 || validCount === 0) return "";
     // Ensuring validCount is a 31-bit integer allows us to heavily optimize the
    // main part. But anyway, most current (August 2014) browsers can't handle
    // strings 1 << 28 chars or longer, so:
    // eslint-disable-next-line no-bitwise
    if (value.length * validCount >= 268435456) throw new RangeError("repeat count must not overflow maximum string size");
    var maxCount = value.length * validCount;
    validCount = Math.floor(Math.log(validCount) / Math.log(2));
    var result = value;
    while(validCount){
        result += value;
        validCount -= 1;
    }
    result += result.substring(0, maxCount - result.length);
    return result;
};
var $b758ede7dde7f5cc$export$2e2bcd8739ae039 = $b758ede7dde7f5cc$var$repeat;

});


parcelRegister("3NadV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c2de0e30e30628b$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $10F1K = parcelRequire("10F1K");
var $ehShu = parcelRequire("ehShu");

var $d31Hk = parcelRequire("d31Hk");
/**
 * Returns true if all items in the list are equivalent using `R.identical` for equality comparisons.
 *
 * @func allIdentical
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.11.0|v2.11.0}
 * @category List
 * @sig [a] -> Boolean
 * @param {Array} list The list of values
 * @return {boolean}
 * @see {@link https://ramdajs.com/docs/#identical|identical}
 * @example
 *
 * RA.allIdentical([ 1, 2, 3, 4 ]); //=> false
 * RA.allIdentical([ 1, 1, 1, 1 ]); //=> true
 * RA.allIdentical([]); //=> true
 * RA.allIdentical([ {}, {} ]); //=> false
 * RA.allIdentical([ () => {}, () => {} ]); //=> false
 */ var $2c2de0e30e30628b$var$allIdentical = (0, $dB93a.default)(1, (0, $10F1K.default)((0, $ehShu.default)((0, $felhC.default)), (0, $d31Hk.default)(1)));
var $2c2de0e30e30628b$export$2e2bcd8739ae039 = $2c2de0e30e30628b$var$allIdentical;

});

parcelRegister("iWW6f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcbab62b4562b774$export$2e2bcd8739ae039; });

var $fs01P = parcelRequire("fs01P");
var $iB6UK = parcelRequire("iB6UK");
var $felhC = parcelRequire("felhC");
/**
 * Returns true if all items in the list are equivalent to user provided value using `R.identical` for equality comparisons.
 *
 * @func allIdenticalTo
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.11.0|v2.11.0}
 * @category List
 * @sig a -> [b] -> Boolean
 * @param {*} val User provided value to check the `list` against
 * @param {Array} list The list of values
 * @return {boolean}
 * @see {@link RA.allIdentical|allIdentical}, {@link http://ramdajs.com/docs/#identical|R.identical}
 * @example
 *
 * RA.allIdenticalTo(1, [ 1, 2, 3, 4 ]); //=> false
 * RA.allIdenticalTo(1, [ 1, 1, 1, 1 ]); //=> true
 * RA.allIdenticalTo(1, []); //=> true
 * RA.allIdenticalTo({}, [ {}, {} ]); //=> false
 *
 */ var $dcbab62b4562b774$var$allIdenticalTo = (0, $iB6UK.default)(function(val, list) {
    return (0, $fs01P.default)((0, $felhC.default)(val), list);
});
var $dcbab62b4562b774$export$2e2bcd8739ae039 = $dcbab62b4562b774$var$allIdenticalTo;

});

parcelRegister("54xOI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b178ed2ba6eb03f$export$2e2bcd8739ae039; });

var $fs01P = parcelRequire("fs01P");
var $iB6UK = parcelRequire("iB6UK");
var $g5jN3 = parcelRequire("g5jN3");
/**
 * Returns true if all items in the list are equivalent to user provided value using `R.equals` for equality comparisons.
 *
 * @func allEqualTo
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.11.0|v2.11.0}
 * @category List
 * @sig a -> [b] -> Boolean
 * @param {*} val User provided value to check the `list` against
 * @param {Array} list The list of values
 * @return {boolean}
 * @see {@link RA.allEqual|allEqual}, {@link https://ramdajs.com/docs/#equals|equals}
 * @example
 *
 * RA.allEqualTo(1, [ 1, 2, 3, 4 ]); //=> false
 * RA.allEqualTo(1, [ 1, 1, 1, 1 ]); //=> true
 * RA.allEqualTo({}, [ {}, {} ]); //=> true
 * RA.allEqualTo(1, []); //=> true
 *
 */ var $3b178ed2ba6eb03f$var$allEqualTo = (0, $iB6UK.default)(function(val, list) {
    return (0, $fs01P.default)((0, $g5jN3.default)(val), list);
});
var $3b178ed2ba6eb03f$export$2e2bcd8739ae039 = $3b178ed2ba6eb03f$var$allEqualTo;

});

parcelRegister("jtqZq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2d5a95b01733300$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");

var $3Amgv = parcelRequire("3Amgv");
function $e2d5a95b01733300$var$_toConsumableArray(arr) {
    return $e2d5a95b01733300$var$_arrayWithoutHoles(arr) || $e2d5a95b01733300$var$_iterableToArray(arr) || $e2d5a95b01733300$var$_unsupportedIterableToArray(arr) || $e2d5a95b01733300$var$_nonIterableSpread();
}
function $e2d5a95b01733300$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e2d5a95b01733300$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e2d5a95b01733300$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e2d5a95b01733300$var$_arrayLikeToArray(o, minLen);
}
function $e2d5a95b01733300$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e2d5a95b01733300$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e2d5a95b01733300$var$_arrayLikeToArray(arr);
}
function $e2d5a95b01733300$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $e2d5a95b01733300$var$flatten1 = (0, $3Amgv.default)(false);
/**
 * Flattens the list to the specified depth.
 *
 * @func flattenDepth
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.19.0|v2.19.0}
 * @category List
 * @sig Number -> [a] -> [b]
 * @param {!number} depth The maximum recursion depth
 * @param {!Array} list The array to flatten
 * @return {!Array} Returns the new flattened array
 * @see {@link http://ramdajs.com/docs/#flatten|R.flatten}, {@link http://ramdajs.com/docs/#unnest|R.unnest}
 * @example
 *
 * RA.flattenDepth(
 *   2,
 *   [1, [2], [3, [4, 5], 6, [[[7], 8]]], 9, 10]
 * ); //=> [1, 2, 3, 4, 5, 6, [[7], 8], 9, 10];
 */ var $e2d5a95b01733300$var$flattenDepth = (0, $iB6UK.default)(function(depth, list) {
    var currentDept = depth;
    var flatList = $e2d5a95b01733300$var$_toConsumableArray(list);
    while(currentDept > 0){
        flatList = $e2d5a95b01733300$var$flatten1(flatList);
        currentDept -= 1;
    }
    return flatList;
});
var $e2d5a95b01733300$export$2e2bcd8739ae039 = $e2d5a95b01733300$var$flattenDepth;

});
parcelRegister("3Amgv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29c60147bfebe6aa$export$2e2bcd8739ae039; });

var $ldL2E = parcelRequire("ldL2E");
/**
 * `makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @func makeFlat
 * @memberOf RA
 *
 * @category List
 * @param {!bool} = should recursively flatten
 * @param {!Array} = the nested list to be flattened
 * @return {!Array} = the flattened list
 * @sig Bool -> List -> List
 *
 */ var $29c60147bfebe6aa$var$makeFlat = function makeFlat(recursive) {
    return function flatt(list) {
        var value;
        var jlen;
        var j;
        var result = [];
        var idx = 0;
        while(idx < list.length){
            if ((0, $ldL2E.default)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
};
var $29c60147bfebe6aa$export$2e2bcd8739ae039 = $29c60147bfebe6aa$var$makeFlat;

});


parcelRegister("6vx1B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bcf4162e0420fd4$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $6Ocs1 = parcelRequire("6Ocs1");
var $aWkCB = parcelRequire("aWkCB");

var $dZ54d = parcelRequire("dZ54d");

var $3bTqG = parcelRequire("3bTqG");

var $lanrD = parcelRequire("lanrD");
var $4bcf4162e0420fd4$export$9632833319b5af7d = (0, $dB93a.default)(1, (0, $lanrD.default));
var $4bcf4162e0420fd4$var$fromArray = (0, $3bTqG.default)(Array.from) ? (0, $dB93a.default)(1, Array.from) : $4bcf4162e0420fd4$export$9632833319b5af7d;
/**
 * Converts value to an array.
 *
 * @func toArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category List
 * @sig * -> [a]
 * @param {*} val The value to convert
 * @return {Array}
 * @example
 *
 * RA.toArray([1, 2]); //=> [1, 2]
 * RA.toArray({'foo': 1, 'bar': 2}); //=> [1, 2]
 * RA.toArray('abc'); //=> ['a', 'b', 'c']
 * RA.toArray(1); //=> []
 * RA.toArray(null); //=> []
 */ var $4bcf4162e0420fd4$var$toArray = (0, $6Ocs1.default)((0, $dZ54d.default), $4bcf4162e0420fd4$var$fromArray, (0, $aWkCB.default));
var $4bcf4162e0420fd4$export$2e2bcd8739ae039 = $4bcf4162e0420fd4$var$toArray;

});
parcelRegister("lanrD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f68cb7caf93a7356$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");

var $dZ54d = parcelRequire("dZ54d");

var $jNpFq = parcelRequire("jNpFq");

var $5tela = parcelRequire("5tela");

var $bVQiS = parcelRequire("bVQiS");
function $f68cb7caf93a7356$var$_toConsumableArray(arr) {
    return $f68cb7caf93a7356$var$_arrayWithoutHoles(arr) || $f68cb7caf93a7356$var$_iterableToArray(arr) || $f68cb7caf93a7356$var$_unsupportedIterableToArray(arr) || $f68cb7caf93a7356$var$_nonIterableSpread();
}
function $f68cb7caf93a7356$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f68cb7caf93a7356$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f68cb7caf93a7356$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f68cb7caf93a7356$var$_arrayLikeToArray(o, minLen);
}
function $f68cb7caf93a7356$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f68cb7caf93a7356$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f68cb7caf93a7356$var$_arrayLikeToArray(arr);
}
function $f68cb7caf93a7356$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f68cb7caf93a7356$var$copyArray = function copyArray(items, mapFn, thisArg) {
    var boundMapFn = (0, $jNpFq.default)(thisArg) ? (0, $2K8fC.default)(mapFn, thisArg) : mapFn;
    return (0, $jNpFq.default)(mapFn) ? $f68cb7caf93a7356$var$_toConsumableArray(items).map(boundMapFn) : $f68cb7caf93a7356$var$_toConsumableArray(items);
};
var $f68cb7caf93a7356$var$fromArray = function fromArray(items, mapFn, thisArg) {
    if (items == null) throw new TypeError("Array.from requires an array-like object - not null or undefined");
    if ((0, $5tela.default)(mapFn) && (0, $bVQiS.default)(mapFn)) throw new TypeError("Array.from: when provided, the second argument must be a function");
    if ((0, $dZ54d.default)(items)) return $f68cb7caf93a7356$var$copyArray(items, mapFn, thisArg);
    return [];
};
var $f68cb7caf93a7356$export$2e2bcd8739ae039 = $f68cb7caf93a7356$var$fromArray;

});


parcelRegister("bxwOI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866c3b8ab794a7b7$export$2e2bcd8739ae039; });

var $6s1r9 = parcelRequire("6s1r9");
var $bHf4t = parcelRequire("bHf4t");
var $7bi4H = parcelRequire("7bi4H");

var $2W6Rh = parcelRequire("2W6Rh");
/**
 * Returns true if all items in the list are unique. `R.equals` is used to determine equality.
 *
 * @func allUnique
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category List
 * @sig [a] -> Boolean
 * @param {Array} list The list of values
 * @return {boolean}
 * @see {@link RA.notAllUnique|notAllUnique},  {@link https://ramdajs.com/docs/#equals|equals}
 * @example
 *
 * RA.allUnique([ 1, 2, 3, 4 ]); //=> true
 * RA.allUnique([ 1, 1, 2, 3 ]); //=> false
 * RA.allUnique([]); //=> true
 *
 */ var $866c3b8ab794a7b7$var$allUnique = (0, $6s1r9.default)((0, $2W6Rh.default), [
    (0, $bHf4t.default),
    (0, $7bi4H.default)
]);
var $866c3b8ab794a7b7$export$2e2bcd8739ae039 = $866c3b8ab794a7b7$var$allUnique;

});

parcelRegister("9jEtz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c8549186f1973a1$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $bxwOI = parcelRequire("bxwOI");
/**
 * Returns true if at least one item of the list is repeated. `R.equals` is used to determine equality.
 *
 * @func notAllUnique
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category List
 * @sig [a] -> Boolean
 * @param {Array} list The list of values
 * @return {boolean}
 * @see {@link RA.allUnique|allUnique}, {@link https://ramdajs.com/docs/#equals|equals}
 * @example
 *
 * RA.notAllUnique([ 1, 1, 2, 3 ]); //=> true
 * RA.notAllUnique([ 1, 2, 3, 4 ]); //=> false
 * RA.notAllUnique([]); //=> false
 *
 */ var $6c8549186f1973a1$var$notAllUnique = (0, $fm6cm.default)((0, $bxwOI.default));
var $6c8549186f1973a1$export$2e2bcd8739ae039 = $6c8549186f1973a1$var$notAllUnique;

});

parcelRegister("etCQh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8a1e7675dedce90$export$2e2bcd8739ae039; });

var $1LQXj = parcelRequire("1LQXj");
var $iB6UK = parcelRequire("iB6UK");
var $3j7JT = parcelRequire("3j7JT");
var $jh4AG = parcelRequire("jh4AG");
var $kuJWW = parcelRequire("kuJWW");
var $iOjwE = parcelRequire("iOjwE");
var $9Zbrv = parcelRequire("9Zbrv");
var $3OmdN = parcelRequire("3OmdN");
function $a8a1e7675dedce90$var$_toArray(arr) {
    return $a8a1e7675dedce90$var$_arrayWithHoles(arr) || $a8a1e7675dedce90$var$_iterableToArray(arr) || $a8a1e7675dedce90$var$_unsupportedIterableToArray(arr) || $a8a1e7675dedce90$var$_nonIterableRest();
}
function $a8a1e7675dedce90$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a8a1e7675dedce90$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a8a1e7675dedce90$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a8a1e7675dedce90$var$_arrayLikeToArray(o, minLen);
}
function $a8a1e7675dedce90$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a8a1e7675dedce90$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a8a1e7675dedce90$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Sort a list of objects by a list of props (if first prop value is equivalent, sort by second, etc).
 *
 * @func sortByProps
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.26.0|v2.26.0}
 * @category List
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array.<string>} props A list of properties in the list param to sort by
 * @param {Array.<object>} list A list of objects to be sorted
 * @return {Array.<object>} A new list sorted by the properties in the props param
 * @example
 *
 * sortByProps(['num'], [{num: 3}, {num: 2}, {num: 1}])
 * //=> [{num: 1}, {num: 2} {num: 3}]
 * sortByProps(['letter', 'num'], [{num: 3, letter: 'a'}, {num: 2, letter: 'a'} {num: 1, letter: 'z'}])
 * //=> [ {num: 2, letter: 'a'}, {num: 3, letter: 'a'}, {num: 1, letter: 'z'}]
 * sortByProps(['name', 'num'], [{num: 3}, {num: 2}, {num: 1}])
 * //=> [{num: 1}, {num: 2}, {num: 3}]
 */ var $a8a1e7675dedce90$var$sortByProps = (0, $iB6UK.default)(function(props, list) {
    var firstTruthy = function firstTruthy(_ref) {
        var _ref2 = $a8a1e7675dedce90$var$_toArray(_ref), head = _ref2[0], tail = _ref2.slice(1);
        return (0, $9Zbrv.default)((0, $3j7JT.default), head, tail);
    };
    var makeComparator = function makeComparator(propName) {
        return (0, $1LQXj.default)(function(a, b) {
            return (0, $jh4AG.default)((0, $iOjwE.default)(propName, a), (0, $iOjwE.default)(propName, b));
        });
    };
    return (0, $3OmdN.default)(firstTruthy((0, $kuJWW.default)(makeComparator, props)), list);
});
var $a8a1e7675dedce90$export$2e2bcd8739ae039 = $a8a1e7675dedce90$var$sortByProps;

});

parcelRegister("lJ5Ew", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd122f711e1e924f$export$2e2bcd8739ae039; });

var $AVvPi = parcelRequire("AVvPi");
var $dvIel = parcelRequire("dvIel");
var $iB6UK = parcelRequire("iB6UK");
var $r0sUa = parcelRequire("r0sUa");
var $felhC = parcelRequire("felhC");
var $5Lrx9 = parcelRequire("5Lrx9");
var $karPh = parcelRequire("karPh");
var $10F1K = parcelRequire("10F1K");
/**
 * When given a number n and an array, returns an array containing every nth element.
 *
 * @func skipTake
 * @memberOf RA
 * @category List
 * @since {@link https://char0n.github.io/ramda-adjunct/2.26.0|v2.26.0}
 * @sig Number -> [a] -> [a]
 * @param {number} the nth element to extract
 * @param {Array} value the input array
 * @return {Array} An array containing every nth element
 * @example
 *
 * RA.skipTake(2, [1,2,3,4]) //=> [1, 3]
 * RA.skipTake(3, R.range(0, 20)); //=> [0, 3, 6, 9, 12, 15, 18]
 */ var $fd122f711e1e924f$var$skipTake = (0, $iB6UK.default)(function(n, list) {
    return (0, $dvIel.default)((0, $r0sUa.default))((0, $10F1K.default)((0, $karPh.default)(1), (0, $5Lrx9.default)((0, $AVvPi.default), n), (0, $felhC.default)(0)))(list);
});
var $fd122f711e1e924f$export$2e2bcd8739ae039 = $fd122f711e1e924f$var$skipTake;

});

parcelRegister("bvJ91", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86159bbd968affd5$export$2e2bcd8739ae039; });

var $cdVZD = parcelRequire("cdVZD");
var $dB93a = parcelRequire("dB93a");
var $kuJWW = parcelRequire("kuJWW");
var $949T3 = parcelRequire("949T3");

var $bpujt = parcelRequire("bpujt");
/**
 * Creates an array of numbers (positive and/or negative) progressing from start up to, but not including, end.
 *
 * `Note`: JavaScript follows the IEEE-754 standard for resolving floating-point values which can produce unexpected results.
 *
 * @func rangeStep
 * @memberOf RA
 * @category List
 * @since {@link https://char0n.github.io/ramda-adjunct/2.30.0|v2.30.0}
 * @sig Number -> Number -> Number -> [Number]
 * @param {number} step The value to increment or decrement by
 * @param {number} from The start of the range
 * @param {number} to The end of the range
 * @return {number[]} Returns the range of numbers
 * @see {@link http://ramdajs.com/docs/#range|R.range}
 * @example
 *
 * RA.rangeStep(1, 0, 4); // => [0, 1 ,2, 3]
 * RA.rangeStep(-1, 0, -4); // => [0, -1, -2, -3]
 * RA.rangeStep(1, 1, 5); // => [1, 2, 3, 4]
 * RA.rangeStep(5, 0, 20); // => [0, 5, 10, 15]
 * RA.rangeStep(-1, 0, -4); // => [0, -1, -2, -3]
 * RA.rangeStep(0, 1, 4); // => [1, 1, 1]
 * RA.rangeStep(1, 0, 0); // => []
 */ var $86159bbd968affd5$var$rangeStep = (0, $dB93a.default)(3, function(step, from, to) {
    var callback = step === 0 ? (0, $cdVZD.default)(from) : function(n) {
        return from + step * n;
    };
    var rangeEnd = step === 0 ? to - from : (0, $bpujt.default)((to - from) / step);
    return (0, $kuJWW.default)(callback, (0, $949T3.default)(0, rangeEnd));
});
var $86159bbd968affd5$export$2e2bcd8739ae039 = $86159bbd968affd5$var$rangeStep;

});
parcelRegister("bpujt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84e98b0979748172$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");
/**
 * Returns the largest integer less than or equal to a given number.
 *
 * Note: floor(null) returns integer 0 and do not give a NaN error.
 *
 * @func floor
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.15.0|v2.15.0}
 * @category Math
 * @sig Number -> Number
 * @param {number} number The number to floor
 * @return {number} A number representing the largest integer less than or equal to the specified number
 * @example
 *
 * RA.floor(45.95); //=> 45
 * RA.floor(45.05); //=> 45
 * RA.floor(4); //=> 4
 * RA.floor(-45.05); //=> -46
 * RA.floor(-45.95); //=> -46
 * RA.floor(null); //=> 0
 */ var $84e98b0979748172$var$floor = (0, $dB93a.default)(1, (0, $2K8fC.default)(Math.floor, Math));
var $84e98b0979748172$export$2e2bcd8739ae039 = $84e98b0979748172$var$floor;

});


parcelRegister("a4xop", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75542e2e282073c9$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $iGZmr = parcelRequire("iGZmr");
var $gkBGB = parcelRequire("gkBGB");
var $10F1K = parcelRequire("10F1K");
/**
 * Returns the first element of the list which matches the predicate.
 * Returns default value if no element matches or matched element is `null`, `undefined` or `NaN`.
 * Dispatches to the find method of the second argument, if present.
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func findOr
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.32.0|v2.32.0}
 * @category List
 * @sig  a -> (b -> Boolean) -> [b] -> b | a
 * @param {*} defaultValue The default value
 * @param {Function} fn The predicate function used to determine if the element is the desired one.
 * @param {Array} list The array to consider.
 * @return {*} The element found, or the default value.
 * @see {@link http://ramdajs.com/docs/#defaultTo|R.defaultTo}, {@link http://ramdajs.com/docs/#find|R.find}
 * @example
 *
 * RA.findOr(1, isUndefined, [1, 2, undefined]); // => 1
 * RA.findOr(1, val => val === 2, [1, 2, undefined]); // => 2
 * RA.findOr(1, val => val === 3, [1, 2, undefined]); // => 1
 */ var $75542e2e282073c9$var$findOr = (0, $iB6UK.default)(function(defaultVal, fn, list) {
    return (0, $10F1K.default)((0, $gkBGB.default)(fn), (0, $iGZmr.default)(defaultVal))(list);
});
var $75542e2e282073c9$export$2e2bcd8739ae039 = $75542e2e282073c9$var$findOr;

});

parcelRegister("zd3rL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $069d655e9a670ce8$export$2e2bcd8739ae039; });

var $AVvPi = parcelRequire("AVvPi");

var $1etMX = parcelRequire("1etMX");
/**
 * Invokes the method at path of object.
 *
 * @func invoke
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.31.0|v2.31.0}
 * @category Object
 * @sig Array -> Object -> *
 * @param {Array.<string|number>} path The path of the method to invoke
 * @param {Object} obj The object to query
 * @return {*}
 * @example
 *
 * RA.invoke(['random'], Math); //=> 0.5113253820009047
 */ var $069d655e9a670ce8$var$invoke = (0, $1etMX.default)((0, $AVvPi.default), [], (0, $AVvPi.default));
var $069d655e9a670ce8$export$2e2bcd8739ae039 = $069d655e9a670ce8$var$invoke;

});
parcelRegister("1etMX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e5e34ad889ecaaa$export$2e2bcd8739ae039; });

var $384ED = parcelRequire("384ED");
var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");
var $km41b = parcelRequire("km41b");
var $6W9Xk = parcelRequire("6W9Xk");

var $bVQiS = parcelRequire("bVQiS");

var $glFqn = parcelRequire("glFqn");
/**
 * Invokes the method at path of object with given arguments.
 *
 * @func invokeArgs
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.27.0|v2.27.0}
 * @category Object
 * @sig Array -> Array -> Object -> *
 * @param {Array.<string|number>} path The path of the method to invoke
 * @param {Array} args The arguments to invoke the method with
 * @param {Object} obj The object to query
 * @return {*}
 * @example
 *
 * RA.invokeArgs(['abs'], [-1], Math); //=> 1
 * RA.invokeArgs(['path', 'to', 'non-existent', 'method'], [-1], Math); //=> undefined
 */ var $0e5e34ad889ecaaa$var$invokeArgs = (0, $dB93a.default)(3, function(mpath, args, obj) {
    var method = (0, $6W9Xk.default)(mpath, obj);
    var context = (0, $6W9Xk.default)((0, $km41b.default)(mpath), obj);
    if ((0, $bVQiS.default)(method)) return undefined;
    if ((0, $glFqn.default)(mpath)) return undefined;
    var boundMethod = (0, $2K8fC.default)(method, context);
    return (0, $384ED.default)(boundMethod, args);
});
var $0e5e34ad889ecaaa$export$2e2bcd8739ae039 = $0e5e34ad889ecaaa$var$invokeArgs;

});


parcelRegister("h8uW6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c79b2e4de4e40dbf$export$2e2bcd8739ae039; });

var $AVvPi = parcelRequire("AVvPi");
var $7C2CH = parcelRequire("7C2CH");
var $iB6UK = parcelRequire("iB6UK");
var $6W9Xk = parcelRequire("6W9Xk");
/**
 * Acts as multiple path: arrays of paths in, array of values out. Preserves order.
 *
 * @func paths
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.2.0|v1.2.0}
 * @category List
 * @sig  [[k]] -> {k: v} - [v]
 * @param {Array} ps The property paths to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function
 * @see {@link https://github.com/ramda/ramda/wiki/Cookbook#derivative-of-rprops-for-deep-fields|Ramda Cookbook}, {@link http://ramdajs.com/docs/#props|R.props}
 * @example
 *
 * const obj = {
 *   a: { b: { c: 1 } },
 *   x: 2,
 * };
 *
 * RA.paths([['a', 'b', 'c'], ['x']], obj); //=> [1, 2]
 */ var $c79b2e4de4e40dbf$var$paths = (0, $iB6UK.default)(function(ps, obj) {
    return (0, $7C2CH.default)([
        (0, $6W9Xk.default)((0, $AVvPi.default), obj)
    ], ps);
});
var $c79b2e4de4e40dbf$export$2e2bcd8739ae039 = $c79b2e4de4e40dbf$var$paths;

});

parcelRegister("5BXis", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $415e679126299bcd$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $aTDBn = parcelRequire("aTDBn");

var $h3meP = parcelRequire("h3meP");
var $415e679126299bcd$var$valueOrKey = function valueOrKey(keysMap) {
    return function(key) {
        if ((0, $aTDBn.default)(key, keysMap)) return keysMap[key];
        return key;
    };
};
/**
 * Creates a new object with the own properties of the provided object, but the
 * keys renamed according to the keysMap object as `{oldKey: newKey}`.
 * When some key is not found in the keysMap, then it's passed as-is.
 *
 * Keep in mind that in the case of keys conflict is behaviour undefined and
 * the result may vary between various JS engines!
 *
 * @func renameKeys
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.5.0|v1.5.0}
 * @category Object
 * @sig {a: b} -> {a: *} -> {b: *}
 * @param {!Object} keysMap
 * @param {!Object} obj
 * @return {!Object} New object with renamed keys
 * @see {@link https://github.com/ramda/ramda/wiki/Cookbook#rename-keys-of-an-object|Ramda Cookbook}, {@link RA.renameKeysWith|renameKeysWith}
 * @example
 *
 * const input = { firstName: 'Elisia', age: 22, type: 'human' };
 *
 * RA.renameKeys({ firstName: 'name', type: 'kind', foo: 'bar' })(input);
 * //=> { name: 'Elisia', age: 22, kind: 'human' }
 */ var $415e679126299bcd$var$renameKeys = (0, $iB6UK.default)(function(keysMap, obj) {
    return (0, $h3meP.default)($415e679126299bcd$var$valueOrKey(keysMap), obj);
});
var $415e679126299bcd$export$2e2bcd8739ae039 = $415e679126299bcd$var$renameKeys;

});
parcelRegister("h3meP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6a3f788e97200c0$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $cxJv1 = parcelRequire("cxJv1");
var $gRmZR = parcelRequire("gRmZR");
var $kuJWW = parcelRequire("kuJWW");
var $9Qgld = parcelRequire("9Qgld");
var $10F1K = parcelRequire("10F1K");
var $ev3xd = parcelRequire("ev3xd");
/**
 * Creates a new object with the own properties of the provided object, but the
 * keys renamed according to logic of renaming function.
 *
 * Keep in mind that in the case of keys conflict is behaviour undefined and
 * the result may vary between various JS engines!
 *
 * @func renameKeysWith
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.5.0|v1.5.0}
 * @category Object
 * @sig (a -> b) -> {a: *} -> {b: *}
 * @param {Function} fn Function that renames the keys
 * @param {!Object} obj Provided object
 * @return {!Object} New object with renamed keys
 * @see {@link https://github.com/ramda/ramda/wiki/Cookbook#rename-keys-of-an-object-by-a-function|Ramda Cookbook}, {@link RA.renameKeys|renameKeys}
 * @example
 *
 * RA.renameKeysWith(R.concat('a'), { A: 1, B: 2, C: 3 }) //=> { aA: 1, aB: 2, aC: 3 }
 */ var $c6a3f788e97200c0$var$renameKeysWith = (0, $iB6UK.default)(function(fn, obj) {
    return (0, $10F1K.default)((0, $ev3xd.default), (0, $kuJWW.default)((0, $9Qgld.default)((0, $gRmZR.default)(0), fn)), (0, $cxJv1.default))(obj);
});
var $c6a3f788e97200c0$export$2e2bcd8739ae039 = $c6a3f788e97200c0$var$renameKeysWith;

});


parcelRegister("7nAsU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55f6f7a47e64e81e$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $g5jN3 = parcelRequire("g5jN3");
var $7Dogi = parcelRequire("7Dogi");

var $h3meP = parcelRequire("h3meP");
/**
 * Creates a new object with the own properties of the provided object, but the
 * key `key` renamed according to logic of renaming function.
 *
 * Keep in mind that in case the new key name already existed on the object,
 * the behaviour is undefined and the result may vary between various JS engines!
 *
 * @func renameKeyWith
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.29.0|v2.29.0}
 * @category Object
 * @sig (k -> k) -> k -> {k: v} -> {k: v}
 * @param {Function} fn Function that renames the keys
 * @param {!string} key Key to rename
 * @param {!Object} obj Provided object
 * @return {!Object} New object with renamed key
 * @see {@link RA.renameKeysWith|renameKeysWith}
 * @example
 *
 * RA.renameKeyWith(R.concat('a'), 'A', { A: 1 }) //=> { aA: 1 }
 */ var $55f6f7a47e64e81e$var$renameKeyWith = (0, $iB6UK.default)(function(fn, key, obj) {
    return (0, $h3meP.default)((0, $7Dogi.default)((0, $g5jN3.default)(key), fn), obj);
});
var $55f6f7a47e64e81e$export$2e2bcd8739ae039 = $55f6f7a47e64e81e$var$renameKeyWith;

});

parcelRegister("6TSUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5062786b1fe9f7fd$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");

var $5BXis = parcelRequire("5BXis");
function $5062786b1fe9f7fd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5062786b1fe9f7fd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5062786b1fe9f7fd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5062786b1fe9f7fd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5062786b1fe9f7fd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5062786b1fe9f7fd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Creates a new object with the own properties of the provided object, and the
 * keys copied according to the keysMap object as `{oldKey: newKey}`.
 * When no key from the keysMap is found, then a shallow clone of an object is returned.
 *
 * Keep in mind that in the case of keys conflict is behaviour undefined and
 * the result may vary between various JS engines!
 *
 * @func copyKeys
 * @memberOf RA
 * @category Object
 * @sig {a: b} -> {a: *} -> {b: *}
 * @param {!Object} keysMap
 * @param {!Object} obj
 * @return {!Object} New object with copied keys
 * @see {@link RA.renameKeys|renameKeys}
 * @example
 *
 * copyKeys({ a: 'b' }, { a: true }); //=> { a: true, b: true }
 * copyKeys({ a: 'b' }, { a: true, b: false }); //=> { a: true, b: true }
 */ var $5062786b1fe9f7fd$var$copyKeys = (0, $dB93a.default)(2, function(keysMap, obj) {
    return $5062786b1fe9f7fd$var$_objectSpread($5062786b1fe9f7fd$var$_objectSpread({}, obj), (0, $5BXis.default)(keysMap, obj));
});
var $5062786b1fe9f7fd$export$2e2bcd8739ae039 = $5062786b1fe9f7fd$var$copyKeys;

});

parcelRegister("7XFGY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cbe6248a0c39b41$export$2e2bcd8739ae039; });

var $d071Y = parcelRequire("d071Y");
var $5RNYG = parcelRequire("5RNYG");
/**
 * Create a new object with the own properties of the second object merged with
 * the own properties of the first object. If a key exists in both objects,
 * the value from the first object will be used. *
 * Putting it simply: it sets properties only if they don't exist.
 *
 * @func mergeRight
 * @deprecated since v2.12.0; available in ramda@0.26.0 as R.mergeLeft
 * @aliases mergeLeft, resetToDefault
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.6.0|v1.6.0}
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} r Destination
 * @param {Object} l Source
 * @return {Object}
 * @see {@link http://ramdajs.com/docs/#merge|R.merge}, {@link https://github.com/ramda/ramda/wiki/Cookbook#set-properties-only-if-they-dont-exist|Ramda Cookbook}
 * @example
 *
 * RA.mergeRight({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 * //=> { 'name': 'fred', 'age': 40 }
 */ var $5cbe6248a0c39b41$var$mergeRight = (0, $d071Y.default)((0, $5RNYG.default));
var $5cbe6248a0c39b41$export$2e2bcd8739ae039 = $5cbe6248a0c39b41$var$mergeRight;

});

parcelRegister("hFoHX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdc96e7e7fe9a468$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $fnNWC = parcelRequire("fnNWC");
var $10F1K = parcelRequire("10F1K");
var $jZtDt = parcelRequire("jZtDt");
/**
 * Functional equivalent of merging object properties with object spread operator.
 *
 * @func mergeProps
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.17.0|v1.17.0}
 * @category Object
 * @sig [k] -> {k: {a}} -> {a}
 * @see {@link RA.mergePaths|mergePaths}
 * @param {!Array} ps The property names to merge
 * @param {!Object} obj The object to query
 * @return {!Object} The object composed of merged properties of obj
 * @example
 *
 * const obj = {
 *   foo: { fooInner: 1 },
 *   bar: { barInner: 2 }
 * };
 *
 * { ...obj.foo, ...obj.bar }; //=> { fooInner: 1, barInner: 2 }
 * RA.mergeProps(['foo', 'bar'], obj); //=> { fooInner: 1, barInner: 2 }
 */ var $cdc96e7e7fe9a468$var$mergeProps = (0, $dB93a.default)(2, (0, $10F1K.default)((0, $jZtDt.default), (0, $fnNWC.default)));
var $cdc96e7e7fe9a468$export$2e2bcd8739ae039 = $cdc96e7e7fe9a468$var$mergeProps;

});

parcelRegister("fcAzQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b11459784431a7fa$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $fnNWC = parcelRequire("fnNWC");
var $10F1K = parcelRequire("10F1K");

var $h8uW6 = parcelRequire("h8uW6");
/**
 * Merge objects under corresponding paths.
 *
 * @func mergePaths
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.17.0|v1.17.0}
 * @category Object
 * @sig [[k]] -> {k: {a}} -> {a}
 * @see {@link RA.mergeProps|mergeProps}
 * @param {!Array} paths The property paths to merge
 * @param {!Object} obj The object to query
 * @return {!Object} The object composed of merged property paths of obj
 * @example
 *
 * const obj = {
 *   foo: { fooInner: { fooInner2: 1 } },
 *   bar: { barInner: 2 }
 * };
 *
 * { ...obj.foo.fooInner, ...obj.bar }; //=>  { fooInner2: 1, barInner: 2 }
 * RA.mergePaths([['foo', 'fooInner'], ['bar']], obj); //=> { fooInner2: 1, barInner: 2 }
 */ var $b11459784431a7fa$var$mergePaths = (0, $dB93a.default)(2, (0, $10F1K.default)((0, $h8uW6.default), (0, $fnNWC.default)));
var $b11459784431a7fa$export$2e2bcd8739ae039 = $b11459784431a7fa$var$mergePaths;

});

parcelRegister("kvLBi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeeba05eff995727$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $2Bayo = parcelRequire("2Bayo");

var $6sMaS = parcelRequire("6sMaS");
/**
 * Create a new object with the own properties of the object under the `p`
 * merged with the own properties of the provided `source`.
 * If a key exists in both objects, the value from the `source` object will be used.
 *
 * @func mergeProp
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.18.0|v1.18.0}
 * @category Object
 * @sig [k] -> {a} -> {k: {a}} -> {k: {a}}
 * @see {@link RA.mergePath|mergePath}
 * @param {!Array} p The property of the destination object
 * @param {!Object} source The source object
 * @param {!Object} obj The object that has destination object under corresponding property
 * @return {!Object} The new version of object
 * @example
 *
 * RA.mergeProp(
 *  'outer',
 *  { foo: 3, bar: 4 },
 *  { outer: { foo: 2 } }
 * ); //=> { outer: { foo: 3, bar: 4 } };
 */ var $eeeba05eff995727$var$mergeProp = (0, $iB6UK.default)(function(p, subj, obj) {
    return (0, $6sMaS.default)((0, $2Bayo.default)(p), subj, obj);
});
var $eeeba05eff995727$export$2e2bcd8739ae039 = $eeeba05eff995727$var$mergeProp;

});
parcelRegister("6sMaS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b4aba073d23340b$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $kDmJv = parcelRequire("kDmJv");
var $9Qgld = parcelRequire("9Qgld");

var $7XFGY = parcelRequire("7XFGY");
/**
 * Create a new object with the own properties of the object under the `path`
 * merged with the own properties of the provided `source`.
 * If a key exists in both objects, the value from the `source` object will be used.
 *
 * @func mergePath
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.18.0|v1.18.0}
 * @category Object
 * @sig [k] -> {a} -> {k: {a}} -> {k: {a}}
 * @see {@link RA.mergeProp|mergeProp}
 * @param {!Array} path The property path of the destination object
 * @param {!Object} source The source object
 * @param {!Object} obj The object that has destination object under corresponding property path
 * @return {!Object} The new version of object
 * @example
 *
 * RA.mergePath(
 *  ['outer', 'inner'],
 *  { foo: 3, bar: 4 },
 *  { outer: { inner: { foo: 2 } } }
 * ); //=> { outer: { inner: { foo: 3, bar: 4 } }
 */ var $4b4aba073d23340b$var$mergePath = (0, $iB6UK.default)(function(path, source, obj) {
    return (0, $9Qgld.default)((0, $kDmJv.default)(path), (0, $7XFGY.default)(source), obj);
});
var $4b4aba073d23340b$export$2e2bcd8739ae039 = $4b4aba073d23340b$var$mergePath;

});


parcelRegister("cvsfr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91ae4ac6caf596dd$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $6PHwe = parcelRequire("6PHwe");
var $4tVS1 = parcelRequire("4tVS1");
var $eu8tn = parcelRequire("eu8tn");
/* eslint-disable max-len */ /**
 * Returns a partial copy of an object containing only the keys
 * that don't satisfy the supplied predicate.
 *
 * @func omitBy
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.6.0|v2.6.0}
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {!Function} pred A predicate to determine whether or not a key should be included on the output object
 * @param {!Object} obj The object to copy from
 * @return {!Object} A new object only with properties that don't satisfy `pred`
 *
 * @example
 *
 * const isLowerCase = (val, key) => key.toLowerCase() === key;
 * RA.omitBy(isLowerCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ /* eslint-enable max-len */ var $91ae4ac6caf596dd$var$omitBy = (0, $eu8tn.default)((0, $4tVS1.default), [
    (0, $fm6cm.default),
    (0, $6PHwe.default)
]);
var $91ae4ac6caf596dd$export$2e2bcd8739ae039 = $91ae4ac6caf596dd$var$omitBy;

});

parcelRegister("guhxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c00d0e9785938b3b$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $felhC = parcelRequire("felhC");
var $7FSiY = parcelRequire("7FSiY");
var $32TYw = parcelRequire("32TYw");
var $6Loxk = parcelRequire("6Loxk");
var $7Dogi = parcelRequire("7Dogi");
/**
 * If the given, non-null object has a value at the given path, returns the value at that path.
 * Otherwise returns the result of invoking the provided function with the object.
 *
 * @func pathOrLazy
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Object
 * @typedef Idx = String | Int
 * @sig ({a} -> a) -> [Idx] -> {a} -> a
 * @param {Function} defaultFn The function that will return the default value.
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 * RA.pathOrLazy(() => 'N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 * RA.pathOrLazy(() => 'N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var $c00d0e9785938b3b$var$pathOrLazy = (0, $dB93a.default)(3, function(defaultFn, path, obj) {
    return (0, $7Dogi.default)((0, $felhC.default)(defaultFn), (0, $7FSiY.default)((0, $6Loxk.default)(defaultFn), [
        obj
    ]), (0, $32TYw.default)(defaultFn, path, obj));
});
var $c00d0e9785938b3b$export$2e2bcd8739ae039 = $c00d0e9785938b3b$var$pathOrLazy;

});

parcelRegister("dZyir", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2fb936694057d60$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $iGZmr = parcelRequire("iGZmr");
var $bTuJn = parcelRequire("bTuJn");
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 * Returns the defaultValue if "view" is null, undefined or NaN; otherwise the "view" is returned.
 *
 * @func viewOr
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.13.0|1.13.0}
 * @category Object
 * @typedef Lens s b = Functor f => (b -> f b) -> s -> f s
 * @sig a -> Lens s b -> s -> b | a
 * @see {@link http://ramdajs.com/docs/#view|R.view}
 * @param {*} defaultValue The default value
 * @param {Function} lens Van Laarhoven lens
 * @param {*} data The data structure
 * @returns {*} "view" or defaultValue
 *
 * @example
 *
 * RA.viewOr('N/A', R.lensProp('x'), {}); // => 'N/A'
 * RA.viewOr('N/A', R.lensProp('x'), { x: 1 }); // => 1
 * RA.viewOr('some', R.lensProp('y'), { y: null }); // => 'some'
 * RA.viewOr('some', R.lensProp('y'), { y: false }); // => false
 */ var $a2fb936694057d60$var$viewOr = (0, $dB93a.default)(3, function(defaultValue, lens, data) {
    return (0, $iGZmr.default)(defaultValue, (0, $bTuJn.default)(lens, data));
});
var $a2fb936694057d60$export$2e2bcd8739ae039 = $a2fb936694057d60$var$viewOr;

});

parcelRegister("2n2XG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ba006dbf9feac1f$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $aTDBn = parcelRequire("aTDBn");
var $4C86y = parcelRequire("4C86y");
var $bHf4t = parcelRequire("bHf4t");
var $6W9Xk = parcelRequire("6W9Xk");
var $g0wyi = parcelRequire("g0wyi");

var $gXHlo = parcelRequire("gXHlo");
/**
 * Returns whether or not an object has an own property with the specified name at a given path.
 *
 * @func hasPath
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.14.0|v1.14.0}
 * @deprecated since v2.12.0; ramda@0.26.0 contains hasPath
 * @category Object
 * @typedef Idx = String | Int
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array.<string|number>} path The path of the nested property
 * @param {Object} obj The object to test
 * @return {boolean}
 * @see {@link http://ramdajs.com/docs/#has|R.has}
 * @example
 *
 * RA.hasPath(['a', 'b'], { a: { b: 1 } }); //=> true
 * RA.hasPath(['a', 'b', 'c'], { a: { b: 1 } }); //=> false
 * RA.hasPath(['a', 'b'], { a: { } }); //=> false
 * RA.hasPath([0], [1, 2]); //=> true
 */ var $1ba006dbf9feac1f$var$hasPath = (0, $dB93a.default)(2, function(objPath, obj) {
    var prop = (0, $4C86y.default)(objPath); // termination conditions
    if ((0, $bHf4t.default)(objPath) === 0 || !(0, $gXHlo.default)(obj)) return false;
    if ((0, $bHf4t.default)(objPath) === 1) return (0, $aTDBn.default)(prop, obj);
    return $1ba006dbf9feac1f$var$hasPath((0, $g0wyi.default)(objPath), (0, $6W9Xk.default)([
        prop
    ], obj)); // base case
});
var $1ba006dbf9feac1f$export$2e2bcd8739ae039 = $1ba006dbf9feac1f$var$hasPath;

});

parcelRegister("10MZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bcbcc9dbd56bec0$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $2Bayo = parcelRequire("2Bayo");

var $iMNmG = parcelRequire("iMNmG");
/**
 * Spreads object under property onto provided object.
 * It's like {@link RA.flattenProp|flattenProp}, but removes object under the property.
 *
 * @func spreadProp
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.19.0|v1.19.0}
 * @category Object
 * @typedef Idx = String | Int
 * @sig Idx -> {k: v} -> {k: v}
 * @param {!string|number} prop The property to spread
 * @param {!Object} obj The provided object
 * @return {!Object} The result of the spread
 * @see {@link RA.spreadPath|spreadPath}, {@link RA.flattenProp|flattenProp}
 * @example
 *
 * RA.spreadProp('b', { a: 1, b: { c: 3, d: 4 } }); // => { a: 1, c: 3, d: 4 };
 */ var $0bcbcc9dbd56bec0$var$spreadProp = (0, $iB6UK.default)(function(prop, obj) {
    return (0, $iMNmG.default)((0, $2Bayo.default)(prop), obj);
});
var $0bcbcc9dbd56bec0$export$2e2bcd8739ae039 = $0bcbcc9dbd56bec0$var$spreadProp;

});
parcelRegister("iMNmG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dad300892df8abf1$export$2e2bcd8739ae039; });

var $6s1r9 = parcelRequire("6s1r9");
var $dB93a = parcelRequire("dB93a");
var $lVVvb = parcelRequire("lVVvb");
var $5RNYG = parcelRequire("5RNYG");
var $32TYw = parcelRequire("32TYw");
/**
 * Spreads object under property path onto provided object.
 * It's like {@link RA.flattenPath|flattenPath}, but removes object under the property path.
 *
 * @func spreadPath
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.19.0|v1.19.0}
 * @category Object
 * @typedef Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {!Array.<string|number>} path The property path to spread
 * @param {!Object} obj The provided object
 * @return {!Object} The result of the spread
 * @see {@link RA.spreadProp|spreadProp}, {@link RA.flattenPath|flattenPath}
 * @example
 *
 * RA.spreadPath(
 *   ['b1', 'b2'],
 *   { a: 1, b1: { b2: { c: 3, d: 4 } } }
 * ); // => { a: 1, c: 3, d: 4, b1: {} };
 */ var $dad300892df8abf1$var$spreadPath = (0, $dB93a.default)(2, (0, $6s1r9.default)((0, $5RNYG.default), [
    (0, $lVVvb.default),
    (0, $32TYw.default)({})
]));
var $dad300892df8abf1$export$2e2bcd8739ae039 = $dad300892df8abf1$var$spreadPath;

});


parcelRegister("5cCu0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9beca46cf57b13$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $2Bayo = parcelRequire("2Bayo");

var $4gLhi = parcelRequire("4gLhi");
/**
 * Flattens a property so that its fields are spread out into the provided object.
 * It's like {@link RA.spreadProp|spreadProp}, but preserves object under the property path.
 *
 * @func flattenProp
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.19.0|v1.19.0}
 * @category Object
 * @typedef Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {!string|number} prop The property to flatten
 * @param {!Object} obj The provided object
 * @return {!Object} The flattened object
 * @see {@link RA.flattenPath|flattenPath}, {@link RA.spreadProp|spreadProp}
 * @example
 *
 * RA.flattenProp(
 *   'b',
 *   { a: 1, b: { c: 3, d: 4 } }
 * ); // => { a: 1, c: 3, d: 4, b: { c: 3, d: 4 } };
 */ var $3c9beca46cf57b13$var$flattenProp = (0, $iB6UK.default)(function(prop, obj) {
    return (0, $4gLhi.default)((0, $2Bayo.default)(prop), obj);
});
var $3c9beca46cf57b13$export$2e2bcd8739ae039 = $3c9beca46cf57b13$var$flattenProp;

});
parcelRegister("4gLhi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31bd54781377f923$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $5RNYG = parcelRequire("5RNYG");
var $32TYw = parcelRequire("32TYw");
/**
 * Flattens a property path so that its fields are spread out into the provided object.
 * It's like {@link RA.spreadPath|spreadPath}, but preserves object under the property path.
 *
 * @func flattenPath
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.19.0|v1.19.0}
 * @category Object
 * @typedef Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {!Array.<string|number>} path The property path to flatten
 * @param {!Object} obj The provided object
 * @return {!Object} The flattened object
 * @see {@link RA.flattenProp|flattenProp}, {@link RA.spreadPath|spreadPath}
 * @example
 *
 * RA.flattenPath(
 *   ['b1', 'b2'],
 *   { a: 1, b1: { b2: { c: 3, d: 4 } } }
 * ); // => { a: 1, c: 3, d: 4, b1: { b2: { c: 3, d: 4 } } };
 */ var $31bd54781377f923$var$flattenPath = (0, $iB6UK.default)(function(path, obj) {
    return (0, $5RNYG.default)(obj, (0, $32TYw.default)({}, path, obj));
});
var $31bd54781377f923$export$2e2bcd8739ae039 = $31bd54781377f923$var$flattenPath;

});


parcelRegister("dbyvg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $999711157ca299ec$export$2e2bcd8739ae039; });

var $384ED = parcelRequire("384ED");
var $dB93a = parcelRequire("dB93a");
var $d071Y = parcelRequire("d071Y");
var $kuJWW = parcelRequire("kuJWW");
var $10F1K = parcelRequire("10F1K");
var $ev3xd = parcelRequire("ev3xd");
var $bqbCh = parcelRequire("bqbCh");
var $7Dogi = parcelRequire("7Dogi");

var $2W6Rh = parcelRequire("2W6Rh");
/**
 * Creates a new list out of the supplied object by applying the function to each key/value pairing.
 *
 * @func unzipObjWith
 * @memberOf RA
 * @category Object
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @sig  (v, k) => [k, v] -> { k: v } -> [[k], [v]]
 * @param {Function} fn The function to transform each value-key pair
 * @param {Object} obj Object to unzip
 * @return {Array} A pair of tw lists: a list of keys and a list of values
 * @see {@link https://ramdajs.com/docs/#zipObj|zipObj}, {@link RA.zipObjWith|zipObjWith}
 * @example
 *
 * RA.unzipObjWith((v, k) => [`new${k.toUpperCase()}`, 2 * v], { a: 1, b: 2, c: 3 });
 * //=> [['newA', 'newB', 'newC'], [2, 4, 6]]
 */ var $999711157ca299ec$var$unzipObjWith = (0, $dB93a.default)(2, function(fn, obj) {
    return (0, $10F1K.default)((0, $ev3xd.default), (0, $kuJWW.default)((0, $10F1K.default)((0, $d071Y.default), (0, $384ED.default))(fn)), (0, $bqbCh.default), (0, $7Dogi.default)((0, $2W6Rh.default)(0), function() {
        return [
            [],
            []
        ];
    }))(obj);
});
var $999711157ca299ec$export$2e2bcd8739ae039 = $999711157ca299ec$var$unzipObjWith;

});

parcelRegister("bFD7S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87f1dfa43fec6650$export$2e2bcd8739ae039; });

var $384ED = parcelRequire("384ED");
var $dB93a = parcelRequire("dB93a");
var $cxJv1 = parcelRequire("cxJv1");
var $kuJWW = parcelRequire("kuJWW");
var $10F1K = parcelRequire("10F1K");
var $ij5yn = parcelRequire("ij5yn");
/**
 * Creates a new object out of a list of keys and a list of values by applying the function
 * to each equally-positioned pair in the lists.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 *
 * @func zipObjWith
 * @memberOf RA
 * @category Object
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @sig (b, a) -> [k, v] -> [a] -> [b] -> { k: v }
 * @param {Function} fn The function to transform each value-key pair
 * @param {Array} keys Array to transform into the properties on the output object
 * @param {Array} values Array to transform into the values on the output object
 * @return {Object}  The object made by pairing up and transforming same-indexed elements of `keys` and `values`.
 * @see {@link https://ramdajs.com/docs/#zipObj|zipObj}, {@link RA.unzipObjWith|unzipObjWith}
 * @example
 *
 * RA.zipObjWith((value, key) => [key, `${key}${value + 1}`]), ['a', 'b', 'c'], [1, 2, 3]);
 *  // => { a: 'a2', b: 'b3', c: 'c4' }
 */ var $87f1dfa43fec6650$var$zipObjWith = (0, $dB93a.default)(3, function(fn, keys, values) {
    return (0, $10F1K.default)((0, $ij5yn.default), (0, $kuJWW.default)((0, $384ED.default)(fn)), (0, $cxJv1.default))(values, keys);
});
var $87f1dfa43fec6650$export$2e2bcd8739ae039 = $87f1dfa43fec6650$var$zipObjWith;

});

parcelRegister("CpHMV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07377d40f5ac43d6$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");

var $1etMX = parcelRequire("1etMX");
/**
 * Checks if an object exists in another object's prototype chain.
 *
 * @func isPrototypeOf
 * @category Object
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.31.0|v2.31.0}
 * @sig * -> Boolean
 * @param {Object} type The prototype that we're searching for
 * @param {Object} object The object whose prototype chain will be searched
 * @return {boolean}
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isPrototypeOf|Object.prorotype.isPrototypeOf}
 * @example
 * function Foo() {}
 * function Bar() {}
 * function Baz() {}
 *
 * Bar.prototype = Object.create(Foo.prototype);
 * Baz.prototype = Object.create(Bar.prototype);
 *
 * const baz = new Baz();
 *
 * RA.isPrototypeOf(Baz, baz); // => true
 * RA.isPrototypeOf(Bar, baz); // => true
 * RA.isPrototypeOf(Foo, baz); // => true
 * RA.isPrototypeOf(Object, baz); // => true
 */ var $07377d40f5ac43d6$var$isPrototypeOf = (0, $iB6UK.default)(function(type, object) {
    return Boolean((0, $1etMX.default)([
        "prototype",
        "isPrototypeOf"
    ], [
        object
    ], type));
});
var $07377d40f5ac43d6$export$2e2bcd8739ae039 = $07377d40f5ac43d6$var$isPrototypeOf;

});

parcelRegister("4eamc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $314080e74d3ce7de$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $g5jN3 = parcelRequire("g5jN3");
var $10F1K = parcelRequire("10F1K");
var $bTuJn = parcelRequire("bTuJn");
/**
 * Returns `true` if data structure focused by the given lens equals provided value.
 *
 * @func lensEq
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.13.0|1.13.0}
 * @category Relation
 * @typedef Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig  Lens s a -> b -> s -> Boolean
 * @see {@link RA.lensNotEq|lensNotEq}
 * @param {function} lens Van Laarhoven lens
 * @param {*} value The value to compare the focused data structure with
 * @param {*} data The data structure
 * @return {boolean} `true` if the focused data structure equals value, `false` otherwise
 *
 * @example
 *
 * RA.lensEq(R.lensIndex(0), 1, [0, 1, 2]); // => false
 * RA.lensEq(R.lensIndex(1), 1, [0, 1, 2]); // => true
 * RA.lensEq(R.lensPath(['a', 'b']), 'foo', { a: { b: 'foo' } }) // => true
 */ var $314080e74d3ce7de$var$lensEq = (0, $dB93a.default)(3, function(lens, val, data) {
    return (0, $10F1K.default)((0, $bTuJn.default)(lens), (0, $g5jN3.default)(val))(data);
});
var $314080e74d3ce7de$export$2e2bcd8739ae039 = $314080e74d3ce7de$var$lensEq;

});

parcelRegister("gRumg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c469250cfe4b4220$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $4eamc = parcelRequire("4eamc");
/**
 * Returns `true` if data structure focused by the given lens doesn't equal provided value.
 *
 * @func lensNotEq
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.13.0|1.13.0}
 * @category Relation
 * @typedef Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> b -> s -> Boolean
 * @see {@link RA.lensEq|lensEq}
 * @param {function} lens Van Laarhoven lens
 * @param {*} value The value to compare the focused data structure with
 * @param {*} data The data structure
 * @return {boolean} `false` if the focused data structure equals value, `true` otherwise
 *
 * @example
 *
 * RA.lensNotEq(R.lensIndex(0), 1, [0, 1, 2]); // => true
 * RA.lensNotEq(R.lensIndex(1), 1, [0, 1, 2]); // => false
 * RA.lensNotEq(R.lensPath(['a', 'b']), 'foo', { a: { b: 'foo' } }) // => false
 */ var $c469250cfe4b4220$var$lensNotEq = (0, $fm6cm.default)((0, $4eamc.default));
var $c469250cfe4b4220$export$2e2bcd8739ae039 = $c469250cfe4b4220$var$lensNotEq;

});

parcelRegister("kgFFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec15a097fce2e03e$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $10F1K = parcelRequire("10F1K");
var $bTuJn = parcelRequire("bTuJn");

var $khZor = parcelRequire("khZor");
/**
 * Returns `true` if data structure focused by the given lens satisfies the predicate.
 * Note that the predicate is expected to return boolean value and will be evaluated
 * as `false` unless the predicate returns `true`.
 *
 * @func lensSatisfies
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.13.0|1.13.0}
 * @category Relation
 * @typedef Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig  Boolean b => (a -> b) -> Lens s a -> s -> b
 * @see {@link RA.lensNotSatisfy|lensNotSatisfy}
 * @param {Function} predicate The predicate function
 * @param {Function} lens Van Laarhoven lens
 * @param {*} data The data structure
 * @return {boolean} `true` if the focused data structure satisfies the predicate, `false` otherwise
 *
 * @example
 *
 * RA.lensSatisfies(RA.isTrue, R.lensIndex(0), [false, true, 1]); // => false
 * RA.lensSatisfies(RA.isTrue, R.lensIndex(1), [false, true, 1]); // => true
 * RA.lensSatisfies(RA.isTrue, R.lensIndex(2), [false, true, 1]); // => false
 * RA.lensSatisfies(R.identity, R.lensProp('x'), { x: 1 }); // => false
 */ var $ec15a097fce2e03e$var$lensSatisfies = (0, $dB93a.default)(3, function(predicate, lens, data) {
    return (0, $10F1K.default)((0, $bTuJn.default)(lens), predicate, (0, $khZor.default))(data);
});
var $ec15a097fce2e03e$export$2e2bcd8739ae039 = $ec15a097fce2e03e$var$lensSatisfies;

});

parcelRegister("70lIp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $519960b46f6994ab$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");

var $kgFFL = parcelRequire("kgFFL");
/**
 * Returns `true` if data structure focused by the given lens doesn't satisfy the predicate.
 * Note that the predicate is expected to return boolean value.
 *
 * @func lensNotSatisfy
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.13.0|1.13.0}
 * @category Relation
 * @typedef Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig  Boolean b => (a -> b) -> Lens s a -> s -> b
 * @see {@link RA.lensSatisfies|lensSatisfies}
 * @param {Function} predicate The predicate function
 * @param {Function} lens Van Laarhoven lens
 * @param {*} data The data structure
 * @return {boolean} `false` if the focused data structure satisfies the predicate, `true` otherwise
 *
 * @example
 *
 * RA.lensNotSatisfy(RA.isTrue, R.lensIndex(0), [false, true, 1]); // => true
 * RA.lensNotSatisfy(RA.isTrue, R.lensIndex(1), [false, true, 1]); // => false
 * RA.lensNotSatisfy(RA.isTrue, R.lensIndex(2), [false, true, 1]); // => true
 * RA.lensNotSatisfy(R.identity, R.lensProp('x'), { x: 1 }); // => true
 */ var $519960b46f6994ab$var$lensNotSatisfy = (0, $fm6cm.default)((0, $kgFFL.default));
var $519960b46f6994ab$export$2e2bcd8739ae039 = $519960b46f6994ab$var$lensNotSatisfy;

});

parcelRegister("9M2BF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71da9e5ac0214a43$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $dB93a = parcelRequire("dB93a");
var $10F1K = parcelRequire("10F1K");
var $iOjwE = parcelRequire("iOjwE");
var $iUNOD = parcelRequire("iUNOD");

var $j2AbX = parcelRequire("j2AbX");
/**
 * Creates a [Traversable](https://github.com/fantasyland/fantasy-land#traversable) lens
 * from an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning function.
 *
 * When executed, it maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](https://ramdajs.com/docs/#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func lensTraverse
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.7.0|2.7.0}
 * @category Relation
 * @typedef Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Applicative f => (a -> f a) -> Lens s a
 * @param {!function} of The Applicative-returning function
 * @return {!function} The Traversable lens
 * @see {@link http://ramdajs.com/docs/#lens|R.lens}, {@link http://ramdajs.com/docs/#traverse|R.traverse}
 *
 * @example
 *
 * const maybeLens = RA.lensTraverse(Maybe.of);
 * const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 * R.over(maybeLens, safeDiv(10), [2, 4, 5]); // => Just([5, 2.5, 2])
 * R.over(maybeLens, safeDiv(10), [2, 0, 5]); // => Nothing
 *
 * R.view(maybeLens, [Maybe.Just(2), Maybe.Just(3)]); // => Maybe.Just([2, 3])
 *
 * R.set(maybeLens, Maybe.Just(1), [Maybe.just(2), Maybe.Just(3)]); // => Maybe.Just([1, 1])
 */ var $71da9e5ac0214a43$var$lensTraverse = (0, $dB93a.default)(1, function(of) {
    return (0, $iB6UK.default)(function(toFunctorFn, target) {
        return (0, $j2AbX.default).of((0, $iUNOD.default)(of, (0, $10F1K.default)(toFunctorFn, (0, $iOjwE.default)("value")), target));
    });
});
var $71da9e5ac0214a43$export$2e2bcd8739ae039 = $71da9e5ac0214a43$var$lensTraverse;

});
parcelRegister("j2AbX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddca473066a821f9$export$2e2bcd8739ae039; });

var $cRpaA = parcelRequire("cRpaA");

var $h4Tkc = parcelRequire("h4Tkc");

var $hFfRA = parcelRequire("hFfRA");
function $ddca473066a821f9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ddca473066a821f9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ddca473066a821f9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ddca473066a821f9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ddca473066a821f9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/**
 * The simplest {@link https://github.com/fantasyland/fantasy-land|fantasy-land}
 * compatible monad which attaches no information to values.
 *
 * The Identity type is a very simple type that has no interesting side effects and
 * is effectively just a container of some value. So why does it exist ?
 * The Identity type is often used as the base monad of a monad
 * transformer when no other behaviour is required.
 *
 * @memberOf RA
 * @implements
 * {@link https://github.com/fantasyland/fantasy-land#apply|Apply},
 * {@link https://github.com/fantasyland/fantasy-land#applicative|Applicative},
 * {@link https://github.com/fantasyland/fantasy-land#functor|Functor},
 * {@link https://github.com/fantasyland/fantasy-land#setoid|Setoid},
 * {@link https://github.com/fantasyland/fantasy-land#semigroup|Semigroup},
 * {@link https://github.com/fantasyland/fantasy-land#chain|Chain},
 * {@link https://github.com/fantasyland/fantasy-land#monad|Monad},
 * {@link https://github.com/fantasyland/fantasy-land#ord|Ord},
 * {@link https://github.com/fantasyland/fantasy-land#monoid|Monoid*},
 * {@link https://github.com/fantasyland/fantasy-land#contravariant|Contravariant}
 * @since {@link https://char0n.github.io/ramda-adjunct/1.8.0|v1.8.0}
 */ var $ddca473066a821f9$var$Identity = /*#__PURE__*/ function(_fl$of, _fl$ap, _fl$map, _fl$equals, _fl$concat, _fl$chain, _fl$lte, _fl$empty, _fl$contramap) {
    /**
   * Private constructor. Use {@link RA.Identity.of|Identity.of} instead.
   *
   * @param {*} value
   * @return {RA.Identity}
   */ function Identity(value) {
        $ddca473066a821f9$var$_classCallCheck(this, Identity);
        this.value = value;
    }
    /**
   * Catamorphism for a value.
   * @returns {*}
   * @example
   *
   * const a = Identity.of(1);
   * a.get(); //=> 1
   */ $ddca473066a821f9$var$_createClass(Identity, [
        {
            key: "get",
            value: function get() {
                return this.value;
            }
        },
        {
            key: _fl$ap,
            value: function value(applyWithFn) {
                return (0, $hFfRA.applyTrait)[$h4Tkc.ap].call(this, applyWithFn);
            }
        },
        {
            key: "ap",
            value: function ap(applyWithFn) {
                return this[$h4Tkc.ap](applyWithFn);
            }
        },
        {
            key: _fl$map,
            value: function value(fn) {
                return (0, $hFfRA.functorTrait)[$h4Tkc.map].call(this, fn);
            }
        },
        {
            key: "map",
            value: function map(fn) {
                return this[$h4Tkc.map](fn);
            }
        },
        {
            key: _fl$equals,
            value: function value(setoid) {
                return (0, $hFfRA.setoidTrait)[$h4Tkc.equals].call(this, setoid);
            }
        },
        {
            key: "equals",
            value: function equals(setoid) {
                return this[$h4Tkc.equals](setoid);
            }
        },
        {
            key: _fl$concat,
            value: function value(semigroup) {
                return (0, $hFfRA.semigroupTrait)[$h4Tkc.concat].call(this, semigroup);
            }
        },
        {
            key: "concat",
            value: function concat(semigroup) {
                return this[$h4Tkc.concat](semigroup);
            }
        },
        {
            key: _fl$chain,
            value: function value(fn) {
                return (0, $hFfRA.chainTrait)[$h4Tkc.chain].call(this, fn);
            }
        },
        {
            key: "chain",
            value: function chain(fn) {
                return this[$h4Tkc.chain](fn);
            }
        },
        {
            key: _fl$lte,
            value: function value(ord) {
                return (0, $hFfRA.ordTrait)[$h4Tkc.lte].call(this, ord);
            }
        },
        {
            key: "lte",
            value: function lte(ord) {
                return this[$h4Tkc.lte](ord);
            }
        },
        {
            key: _fl$empty,
            value: function value() {
                return this.constructor.of((0, $cRpaA.default)(this.value));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return this[$h4Tkc.empty]();
            }
        },
        {
            key: _fl$contramap,
            value: function value(fn) {
                var _this = this;
                return this.constructor.of(function(value) {
                    return _this.value(fn(value));
                });
            }
        },
        {
            key: "contramap",
            value: function contramap(fn) {
                return this[$h4Tkc.contramap](fn);
            }
        }
    ], [
        {
            key: _fl$of,
            value: /**
     * Fantasy land {@link https://github.com/fantasyland/fantasy-land#applicative|Applicative} specification.
     *
     * @static
     * @sig of :: Applicative f => a -> f a
     * @param {*} value
     * @returns {RA.Identity}
     * @example
     *
     * const a = Identity.of(1); //=> Identity(1)
     */ function value(_value) {
                return new Identity(_value);
            }
        },
        {
            key: "of",
            value: function of(value) {
                return new Identity(value);
            }
        },
        {
            key: "@@type",
            get: function get() {
                return "RA/Identity";
            }
        }
    ]);
    return Identity;
}($h4Tkc.of, $h4Tkc.ap, $h4Tkc.map, $h4Tkc.equals, $h4Tkc.concat, $h4Tkc.chain, $h4Tkc.lte, $h4Tkc.empty, $h4Tkc.contramap);
var $ddca473066a821f9$export$2e2bcd8739ae039 = $ddca473066a821f9$var$Identity;

});
parcelRegister("hFfRA", function(module, exports) {

$parcel$export(module.exports, "functorTrait", function () { return $cdc292252c834e97$export$d6850d6a310ae9c0; });
$parcel$export(module.exports, "applyTrait", function () { return $cdc292252c834e97$export$43ded694a95a309f; });
$parcel$export(module.exports, "setoidTrait", function () { return $cdc292252c834e97$export$a572cf64768249e9; });
$parcel$export(module.exports, "semigroupTrait", function () { return $cdc292252c834e97$export$745b880c414ad41d; });
$parcel$export(module.exports, "chainTrait", function () { return $cdc292252c834e97$export$31106ea3074d2568; });
$parcel$export(module.exports, "ordTrait", function () { return $cdc292252c834e97$export$5467a251abbab643; });

var $g5jN3 = parcelRequire("g5jN3");
var $gISCw = parcelRequire("gISCw");

var $dfegI = parcelRequire("dfegI");

var $3oTRA = parcelRequire("3oTRA");

var $3bTqG = parcelRequire("3bTqG");

var $8MK4W = parcelRequire("8MK4W");

var $h4Tkc = parcelRequire("h4Tkc");
function $cdc292252c834e97$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $cdc292252c834e97$export$d6850d6a310ae9c0 = $cdc292252c834e97$var$_defineProperty({}, $h4Tkc.map, function(fn) {
    return this.constructor[$h4Tkc.of](fn(this.value));
});
var $cdc292252c834e97$export$43ded694a95a309f = $cdc292252c834e97$var$_defineProperty({}, $h4Tkc.ap, function(applyWithFn) {
    var _this = this;
    return applyWithFn.map(function(fn) {
        return fn(_this.value);
    });
});
var $cdc292252c834e97$export$a572cf64768249e9 = $cdc292252c834e97$var$_defineProperty({}, $h4Tkc.equals, function(setoid) {
    return (0, $8MK4W.isSameType)(this, setoid) && (0, $g5jN3.default)(this.value, setoid.value);
});
var $cdc292252c834e97$export$745b880c414ad41d = $cdc292252c834e97$var$_defineProperty({}, $h4Tkc.concat, function(semigroup) {
    var concatenatedValue = this.value;
    if ((0, $dfegI.default)(this.value) || (0, $3oTRA.default)(this.value)) concatenatedValue = this.value + semigroup.value;
    else if ((0, $gISCw.default)((0, $3bTqG.default), [
        "value",
        $h4Tkc.concat
    ], this)) concatenatedValue = this.value[$h4Tkc.concat](semigroup.value);
    else if ((0, $gISCw.default)((0, $3bTqG.default), [
        "value",
        "concat"
    ], this)) concatenatedValue = this.value.concat(semigroup.value);
    return this.constructor[$h4Tkc.of](concatenatedValue);
});
var $cdc292252c834e97$export$31106ea3074d2568 = $cdc292252c834e97$var$_defineProperty({}, $h4Tkc.chain, function(fn) {
    var newChain = fn(this.value);
    return (0, $8MK4W.isSameType)(this, newChain) ? newChain : this;
});
var $cdc292252c834e97$export$5467a251abbab643 = $cdc292252c834e97$var$_defineProperty({}, $h4Tkc.lte, function(ord) {
    return (0, $8MK4W.isSameType)(this, ord) && (this.value < ord.value || this[$h4Tkc.equals](ord));
});

});
parcelRegister("8MK4W", function(module, exports) {

$parcel$export(module.exports, "isSameType", function () { return $66568cb049948696$export$4c490638efbdd0da; });

var $fm6cm = parcelRequire("fm6cm");
var $iB6UK = parcelRequire("iB6UK");
var $dB93a = parcelRequire("dB93a");
var $3j7JT = parcelRequire("3j7JT");
var $g5jN3 = parcelRequire("g5jN3");
var $6W9Xk = parcelRequire("6W9Xk");
var $eu8tn = parcelRequire("eu8tn");
var $66568cb049948696$export$bf9fb029d174d554 = (0, $3j7JT.default)((0, $6W9Xk.default)([
    "@@type"
]), (0, $6W9Xk.default)([
    "constructor",
    "@@type"
])); // typeEquals :: Monad a => String -> a -> Boolean
var $66568cb049948696$export$9c0b966c1cef2fd1 = (0, $iB6UK.default)(function(typeIdent, monad) {
    return $66568cb049948696$export$bf9fb029d174d554(monad) === typeIdent;
}); // isSameType :: (Monad a, Monad b) => a -> b -> Boolean
var $66568cb049948696$export$4c490638efbdd0da = (0, $dB93a.default)(2, (0, $eu8tn.default)((0, $g5jN3.default), [
    $66568cb049948696$export$bf9fb029d174d554,
    $66568cb049948696$export$bf9fb029d174d554
])); // isNotSameType :: (Monad a, Monad b) => a -> b -> Boolean
var $66568cb049948696$export$8823fa9a565ded1a = (0, $fm6cm.default)($66568cb049948696$export$4c490638efbdd0da);

});




parcelRegister("474Ln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2feb82be6c792068$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $kuJWW = parcelRequire("kuJWW");
// in ramda-lens library.
//
// https://github.com/ramda/ramda-lens
// isomorphic :: ((a -> b), (b -> a)) -> Isomorphism
//     Isomorphism = x -> y
var $2feb82be6c792068$var$isomorphic = function isomorphic(to, from) {
    var isomorphism = function isomorphism(x) {
        return to(x);
    };
    isomorphism.from = from;
    return isomorphism;
}; // isomorphisms :: ((a -> b), (b -> a)) -> (a -> b)
var $2feb82be6c792068$var$isomorphisms = function isomorphisms(to, from) {
    return $2feb82be6c792068$var$isomorphic((0, $iB6UK.default)(function(toFunctorFn, target) {
        return (0, $kuJWW.default)(from, toFunctorFn(to(target)));
    }), (0, $iB6UK.default)(function(toFunctorFn, target) {
        return (0, $kuJWW.default)(to, toFunctorFn(from(target)));
    }));
}; // from :: Isomorphism -> a -> b
var $2feb82be6c792068$var$from = (0, $iB6UK.default)(function(isomorphism, x) {
    return isomorphism.from(x);
});
/**
 * Defines an isomorphism that will work like a lens. It takes two functions.
 * The function that converts and the function that recovers.
 *
 * @func lensIso
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.19.0|1.19.0}
 * @category Relation
 * @typedef Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> (a -> s) -> Lens s a
 * @param {!function} to The function that converts
 * @param {!function} from The function that recovers
 * @return {!function} The isomorphic lens
 * @see {@link http://ramdajs.com/docs/#lens|R.lens}
 *
 * @example
 *
 * const lensJSON = RA.lensIso(JSON.parse, JSON.stringify);
 *
 * R.over(lensJSON, assoc('b', 2), '{"a":1}'); //=> '{"a":1,"b":2}'
 * R.over(RA.lensIso.from(lensJSON), R.replace('}', ',"b":2}'), { a: 1 }); // => { a: 1, b: 2 }
 */ var $2feb82be6c792068$var$lensIso = (0, $iB6UK.default)($2feb82be6c792068$var$isomorphisms);
$2feb82be6c792068$var$lensIso.from = $2feb82be6c792068$var$from;
var $2feb82be6c792068$export$2e2bcd8739ae039 = $2feb82be6c792068$var$lensIso;

});

parcelRegister("en3mS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02b330d4903891d1$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $3e6vr = parcelRequire("3e6vr");
/**
 * Returns true if the specified object property is not equal,
 * in R.equals terms, to the given value; false otherwise.
 *
 * @func propNotEq
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.3.0|v2.3.0}
 * @category Relation
 * @sig  String -> a -> Object -> Boolean
 * @param {String} name The property to pick
 * @param {a} val The value to compare to
 * @param {Object} object The object, that presumably contains value under the property
 * @return {boolean} Comparison result
 * @see {@link http://ramdajs.com/docs/#propEq|R.propEq}
 * @example
 *
 * const abby = { name: 'Abby', age: 7, hair: 'blond' };
 * const fred = { name: 'Fred', age: 12, hair: 'brown' };
 * const rusty = { name: 'Rusty', age: 10, hair: 'brown' };
 * const alois = { name: 'Alois', age: 15, disposition: 'surly' };
 * const kids = [abby, fred, rusty, alois];
 * const hasNotBrownHair = RA.propNotEq('hair', 'brown');
 *
 * R.filter(hasNotBrownHair, kids); //=> [abby, alois]
 */ var $02b330d4903891d1$var$propNotEq = (0, $fm6cm.default)((0, $3e6vr.default));
var $02b330d4903891d1$export$2e2bcd8739ae039 = $02b330d4903891d1$var$propNotEq;

});

parcelRegister("i5hPo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2a685dbb60539ac$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $628nw = parcelRequire("628nw");
/* eslint-disable max-len */ /**
 * Determines whether a nested path on an object doesn't have a specific value,
 * in R.equals terms. Most likely used to filter a list.
 *
 * @func pathNotEq
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.4.0|v2.4.0}
 * @category Relation
 * @sig [Idx] => a => {a} => Boolean
 * @sig Idx = String | Int
 * @param {Array} path The path of the nested property to use
 * @param {a} val The value to compare the nested property with
 * @param {Object} object The object to check the nested property in
 * @return {boolean} Returns Boolean `false` if the value equals the nested object property, `true` otherwise
 * @see {@link http://ramdajs.com/docs/#pathEq|R.pathEq}
 * @example
 *
 * const user1 = { address: { zipCode: 90210 } };
 * const user2 = { address: { zipCode: 55555 } };
 * const user3 = { name: 'Bob' };
 * const users = [ user1, user2, user3 ];
 * const isFamous = R.pathNotEq(['address', 'zipCode'], 90210);
 * R.filter(isFamous, users); //=> [ user2, user3 ]
 */ /* eslint-enable max-len */ var $d2a685dbb60539ac$var$pathNotEq = (0, $fm6cm.default)((0, $628nw.default));
var $d2a685dbb60539ac$export$2e2bcd8739ae039 = $d2a685dbb60539ac$var$pathNotEq;

});

parcelRegister("9tnVe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e5960ec6d80c98d$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $iB6UK = parcelRequire("iB6UK");
var $eiA2o = parcelRequire("eiA2o");
var $lDBZe = parcelRequire("lDBZe");
var $6Ocs1 = parcelRequire("6Ocs1");
var $hZash = parcelRequire("hZash");
var $eu8tn = parcelRequire("eu8tn");
var $6e5960ec6d80c98d$var$inRangeImp = (0, $6Ocs1.default)((0, $lDBZe.default), function() {
    throw new Error("low must not be greater than high in inRange(low, high, value)");
}, (0, $eu8tn.default)((0, $gi6wV.default), [
    (0, $hZash.default),
    (0, $eiA2o.default)
]));
var /**
 * Checks if `value` is between `low` and up to but not including `high`.
 *
 * @func inRange
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.7.0|v2.7.0}
 * @category Relation
 * @sig Number -> Number -> Number -> Boolean
 * @param {number} low Start of the range
 * @param {number} high The end of the range
 * @param {number} value The value to test
 * @return {boolean}
 * @throws {Error} When `low` is greater than or equal to `high`
 * @example
 *
 * RA.inRange(0, 5, 3); //=> true
 * RA.inRange(0, 5, 0); //=> true
 * RA.inRange(0, 5, 4); //=> true
 * RA.inRange(0, 5, 5); //=> false
 * RA.inRange(0, 5, -1); //=> false
 */ $6e5960ec6d80c98d$export$2e2bcd8739ae039 = (0, $iB6UK.default)(function(low, high, value) {
    return $6e5960ec6d80c98d$var$inRangeImp(low, high)(value);
});

});

parcelRegister("duYb5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d3cc1bed77b7f5b$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $g5jN3 = parcelRequire("g5jN3");
/**
 * Returns `true` if its arguments are not equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func notEqual
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.29.0|v2.29.0}
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see {@link https://ramdajs.com/docs/#equals|equals}
 * @example
 *
 * RA.notEqual(1, 1); //=> false
 * RA.notEqual(1, '1'); //=> true
 * RA.notEqual([1, 2, 3], [1, 2, 3]); //=> false
 *
 * const a = {}; a.v = a;
 * const b = {}; b.v = b;
 * RA.notEqual(a, b); //=> false
 */ var $9d3cc1bed77b7f5b$var$notEqual = (0, $fm6cm.default)((0, $g5jN3.default));
var $9d3cc1bed77b7f5b$export$2e2bcd8739ae039 = $9d3cc1bed77b7f5b$var$notEqual;

});

parcelRegister("j25wW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddb27e6c2b4ab046$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $jwOLA = parcelRequire("jwOLA");
var $7DKgw = parcelRequire("7DKgw");
var $10F1K = parcelRequire("10F1K");

var $7xCIx = parcelRequire("7xCIx");
/**
 * Returns true if two lists have at least one element common to both lists.
 *
 * @func overlaps
 * @memberOf RA
 * @category Relation
 * @since {@link https://char0n.github.io/ramda-adjunct/2.30.0|v2.30.0}
 * @sig [a] -> [a] -> Boolean
 * @param {Array} list1 The first list
 * @param {Array} list2 The second list
 * @return {boolean} True if two lists have at least one element common to both lists
 * @example
 *
 * RA.overlaps(['-v', '--verbose'], ['node', 'script.js', '-v']); //=> true
 * RA.overlaps(['-v', '--verbose'], []); //=> false
 * RA.overlaps([1, 2, 3], [3, 4, 5]); //=> true
 * RA.overlaps([1, 2, 3], [4, 5]); //=> false
 */ var $ddb27e6c2b4ab046$var$overlaps = (0, $dB93a.default)(2, function(list1, list2) {
    if ((0, $7DKgw.default)(list1)) return true;
    return (0, $10F1K.default)((0, $jwOLA.default), (0, $7xCIx.default))(list1, list2);
});
var $ddb27e6c2b4ab046$export$2e2bcd8739ae039 = $ddb27e6c2b4ab046$var$overlaps;

});

parcelRegister("kckpG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb44c34b027aeccf$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $fm6cm = parcelRequire("fm6cm");
var $d8dol = parcelRequire("d8dol");
var $iB6UK = parcelRequire("iB6UK");
/* eslint-disable max-len */ /**
 * A function which calls the two provided functions and returns the complement of `&&`ing the
 * results.
 * It returns true if the first function is false-y and the complement of the second function
 * otherwise. Note that this is short-circuited, meaning that the second function will not be
 * invoked if the first returns a false-y value. In short it will return true unless both predicates
 * return true.
 *
 * In addition to functions, `RA.notBoth` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func notBoth
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.3.0|v2.3.0}
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} Returns a function that applies its arguments to `f` and `g` and returns the complement of `&&`ing their outputs together.
 * @see {@link http://ramdajs.com/docs/#both|R.both}
 * @example
 *
 * const gt10 = R.gt(R.__, 10)
 * const even = (x) => x % 2 === 0;
 * const f = RA.notBoth(gt10, even);
 *
 * f(12); //=> false
 * f(8); //=> true
 * f(11); //=> true
 * f(9); //=> true
 */ /* eslint-enable max-len */ var $eb44c34b027aeccf$var$notBoth = (0, $iB6UK.default)((0, $d8dol.default)((0, $fm6cm.default), (0, $gi6wV.default)));
var $eb44c34b027aeccf$export$2e2bcd8739ae039 = $eb44c34b027aeccf$var$notBoth;

});

parcelRegister("gE7ET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e6529ded5c89a9$export$2e2bcd8739ae039; });

var $jWdy6 = parcelRequire("jWdy6");
var $fm6cm = parcelRequire("fm6cm");
/**
 * Returns false if both arguments are truthy; true otherwise.
 *
 * @func nand
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.19.0|v2.19.0}
 * @category Logic
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean} false if both arguments are truesy
 * @example
 *
 * RA.nand(true, true); //=> false
 * RA.nand(false, true); //=> true
 * RA.nand(true, false); //=> true
 * RA.nand(false, false); //=> true
 * RA.nand(1.0, 1.0); //=> false
 * RA.nand(1.0, 0); //=> true
 * RA.nand(0, 1.0); //=> true
 * RA.nand(0, 0); //=> true
 */ var $c1e6529ded5c89a9$var$nand = (0, $fm6cm.default)((0, $jWdy6.default)); // eslint-disable-line ramda/complement-simplification
var $c1e6529ded5c89a9$export$2e2bcd8739ae039 = $c1e6529ded5c89a9$var$nand;

});

parcelRegister("9hJsg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c28f5f6a67d04f5$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $d8dol = parcelRequire("d8dol");
var $iB6UK = parcelRequire("iB6UK");
var $3j7JT = parcelRequire("3j7JT");
/* eslint-disable max-len */ /**
 * A function which calls the two provided functions and returns the complement of `||`ing the
 * results.
 * It returns false if the first function is truth-y and the complement of the second function
 * otherwise. Note that this is short-circuited, meaning that the second function will not be
 * invoked if the first returns a truth-y value. In short it will return true if neither predicate
 * returns true.
 *
 * In addition to functions, `RA.neither` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func neither
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.3.0|v2.3.0}
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} Returns a function that applies its arguments to `f` and `g` and returns the complement of `||`ing their outputs together.
 * @see {@link http://ramdajs.com/docs/#either|R.either}, {@link http://ramdajs.com/docs/#or|R.or}
 * @example
 *
 * const gt10 = R.gt(R.__, 10)
 * const even = (x) => x % 2 === 0;
 * const f = RA.neither(gt10, even);
 *
 * f(12); //=> false
 * f(8); //=> false
 * f(11); //=> false
 * f(9); //=> true
 */ /* eslint-enable max-len */ var $6c28f5f6a67d04f5$var$neither = (0, $iB6UK.default)((0, $d8dol.default)((0, $fm6cm.default), (0, $3j7JT.default)));
var $6c28f5f6a67d04f5$export$2e2bcd8739ae039 = $6c28f5f6a67d04f5$var$neither;

});

parcelRegister("cRO1N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95e13dcc8ee8600a$export$2e2bcd8739ae039; });

var $fm6cm = parcelRequire("fm6cm");
var $hDBEN = parcelRequire("hDBEN");
/**
 * Returns true if both arguments are falsy; false otherwise.
 *
 * @func nor
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.20.0|v2.20.0}
 * @category Logic
 * @sig a -> b -> a ⊽ b
 * @param {*} a
 * @param {*} b
 * @return {boolean} true if both arguments are falsy
 * @see {@link RA.neither|neither}
 * @example
 *
 * RA.nor(true, true); //=> false
 * RA.nor(false, true); //=> false
 * RA.nor(true, false); //=> false
 * RA.nor(false, false); //=> true
 * RA.nor(1, 1); //=> false
 * RA.nor(1, 0); //=> false
 * RA.nor(0, 1); //=> false
 * RA.nor(0, 0); //=> true
 */ var $95e13dcc8ee8600a$var$nor = (0, $fm6cm.default)((0, $hDBEN.default)); // eslint-disable-line ramda/complement-simplification
var $95e13dcc8ee8600a$export$2e2bcd8739ae039 = $95e13dcc8ee8600a$var$nor;

});

parcelRegister("e4Jnx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3f4a3a6c53149af$export$2e2bcd8739ae039; });

var $bKc8Z = parcelRequire("bKc8Z");
var $fm6cm = parcelRequire("fm6cm");
var $d8dol = parcelRequire("d8dol");
var $iB6UK = parcelRequire("iB6UK");
/**
 * Takes a list of predicates and returns a predicate that returns true for a given list of
 * arguments if one or more of the provided predicates is not satisfied by those arguments. It is
 * the complement of Ramda's allPass.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func notAllPass
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.4.0|v2.4.0}
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see {@link http://ramdajs.com/docs/#allPass|R.allPass}
 * @example
 *
 * const gt10 = R.gt(R.__, 10)
 * const even = (x) => x % 2 === 0;
 * const f = RA.notAllPass([gt10, even]);
 *
 * f(12); //=> false
 * f(8); //=> true
 * f(11); //=> true
 * f(9); //=> true
 */ var $a3f4a3a6c53149af$var$notAllPass = (0, $iB6UK.default)((0, $d8dol.default)((0, $fm6cm.default), (0, $bKc8Z.default)));
var $a3f4a3a6c53149af$export$2e2bcd8739ae039 = $a3f4a3a6c53149af$var$notAllPass;

});

parcelRegister("axR6A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ad62e05040272c1$export$2e2bcd8739ae039; });

var $4qtNZ = parcelRequire("4qtNZ");
var $fm6cm = parcelRequire("fm6cm");
var $d8dol = parcelRequire("d8dol");
var $dB93a = parcelRequire("dB93a");
/**
 * Takes a list of predicates and returns a predicate that returns true for a given list of
 * arguments if none of the provided predicates are satisfied by those arguments. It is the
 * complement of Ramda's anyPass.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func nonePass
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.5.0|v2.5.0}
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see {@link http://ramdajs.com/docs/#anyPass|R.anyPass}
 * @example
 *
 * const gt10 = R.gt(R.__, 10)
 * const even = (x) => x % 2 === 0;
 * const f = RA.nonePass([gt10, even]);
 *
 * f(12); //=> false
 * f(8); //=> false
 * f(11); //=> false
 * f(9); //=> true
 */ var $7ad62e05040272c1$var$nonePass = (0, $dB93a.default)(1, (0, $d8dol.default)((0, $fm6cm.default), (0, $4qtNZ.default)));
var $7ad62e05040272c1$export$2e2bcd8739ae039 = $7ad62e05040272c1$var$nonePass;

});

parcelRegister("jP8KW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6e99280fbe8b09e$export$2e2bcd8739ae039; });

var $d8dol = parcelRequire("d8dol");
var $iB6UK = parcelRequire("iB6UK");
var $eu8tn = parcelRequire("eu8tn");

var $3KuR9 = parcelRequire("3KuR9");

var $gKUk2 = parcelRequire("gKUk2");
/**
 * Takes a combining predicate and a list of functions and returns a function which will map the
 * arguments it receives to the list of functions and returns the result of passing the values
 * returned from each function to the combining predicate. A combining predicate is a function that
 * combines a list of Boolean values into a single Boolean value, such as `R.any` or `R.all`. It
 * will test each value using `RA.isTruthy`, meaning the functions don't necessarily have to be
 * predicates.
 *
 * The function returned is curried to the number of functions supplied, and if called with more
 * arguments than functions, any remaining arguments are passed in to the combining predicate
 * untouched.
 *
 * @func argsPass
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.7.0|v2.7.0}
 * @category Logic
 * @sig ((* -> Boolean) -> [*] -> Boolean) -> [(* -> Boolean), ...] -> (*...) -> Boolean
 * @param {Function} combiningPredicate The predicate used to combine the values returned from the
 * list of functions
 * @param {Array} functions List of functions
 * @return {boolean} Returns the combined result of mapping arguments to functions
 * @example
 *
 * RA.argsPass(R.all, [RA.isArray, RA.isBoolean, RA.isString])([], false, 'abc') //=> true
 * RA.argsPass(R.all, [RA.isArray, RA.isBoolean, RA.isString])([], false, 1) //=> false
 * RA.argsPass(R.any, [RA.isArray, RA.isBoolean, RA.isString])({}, 1, 'abc') //=> true
 * RA.argsPass(R.any, [RA.isArray, RA.isBoolean, RA.isString])({}, 1, false) //=> false
 * RA.argsPass(R.none, [RA.isArray, RA.isBoolean, RA.isString])({}, 1, false) //=> true
 * RA.argsPass(R.none, [RA.isArray, RA.isBoolean, RA.isString])({}, 1, 'abc') //=> false
 */ var $e6e99280fbe8b09e$var$argsPass = (0, $iB6UK.default)(function(combiningPredicate, predicates) {
    return (0, $eu8tn.default)((0, $d8dol.default)(combiningPredicate((0, $gKUk2.default)), (0, $3KuR9.default)), predicates);
});
var $e6e99280fbe8b09e$export$2e2bcd8739ae039 = $e6e99280fbe8b09e$var$argsPass;

});

parcelRegister("csOEg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $912f634b9d31428f$export$2e2bcd8739ae039; });

var $51mxt = parcelRequire("51mxt");
/**
 * Accepts a function with any arity and returns a function with arity of zero.
 * The returned function ignores any arguments supplied to it.
 *
 * @func dropArgs
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.10.0|v2.10.0}
 * @category Logic
 * @sig (...a -> b)-> () -> b
 * @param {Function} fn The function with any arity
 * @return {Function} Returns function with arity of zero
 * @see {@link http://ramdajs.com/docs/#nAry|R.nAry}
 * @example
 *
 * const fn = (a = 1, b = 2) => a + b;
 *
 * RA.dropArgs(fn)('ignore1', 'ignore2'); //=> 3
 */ var $912f634b9d31428f$var$dropArgs = (0, $51mxt.default)(0);
var $912f634b9d31428f$export$2e2bcd8739ae039 = $912f634b9d31428f$var$dropArgs;

});

parcelRegister("bL45h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88f7408360660d8e$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");
/**
 * Returns the value of a number rounded to the nearest integer.
 *
 * @func round
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.15.0|v2.15.0}
 * @category Math
 * @sig Number -> Number
 * @param {number} number The number to round
 * @return {number} The value of the given number rounded to the nearest integer
 * @example
 *
 * RA.round(0.9); //=> 1
 * RA.round(5.95); //=> 6
 * RA.round(5.5); //=> 6
 * RA.round(5.05); //=> 5
 * RA.round(-5.05); //=> -5
 * RA.round(-5.5); //=> -5
 * RA.round(-5.95); //=> -6
 */ var $88f7408360660d8e$var$round = (0, $dB93a.default)(1, (0, $2K8fC.default)(Math.round, Math));
var $88f7408360660d8e$export$2e2bcd8739ae039 = $88f7408360660d8e$var$round;

});

parcelRegister("ieYcH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4783c044d75fbe5$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");
/**
 * Returns the smallest integer greater than or equal to a given number.
 *
 * Note: ceil(null) returns integer 0 and does not give a NaN error.
 *
 * @func ceil
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.15.0|v2.15.0}
 * @category Math
 * @sig Number -> Number
 * @param {number} number The number to ceil
 * @return {number} The smallest integer greater than or equal to the given number
 * @example
 *
 * RA.ceil(.95); //=> 1
 * RA.ceil(4); //=> 4
 * RA.ceil(7.004); //=> 8
 * RA.ceil(-0.95); //=> -0
 * RA.ceil(-4); //=> -4
 * RA.ceil(-7.004); //=> -7
 * RA.ceil(null); //=> 0
 */ var $d4783c044d75fbe5$var$ceil = (0, $dB93a.default)(1, (0, $2K8fC.default)(Math.ceil, Math));
var $d4783c044d75fbe5$export$2e2bcd8739ae039 = $d4783c044d75fbe5$var$ceil;

});

parcelRegister("ltHaS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa2dcbf820fb091e$export$2e2bcd8739ae039; });

var $drXm2 = parcelRequire("drXm2");
var $d071Y = parcelRequire("d071Y");
/**
 * Divides two numbers, where the second number is divided by the first number.
 *
 * @func divideNum
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Math
 * @sig Number -> Number -> Number
 * @param {number} divisor the number to divide by
 * @param {number} dividend the number to divide
 * @return {number} A number representing the quotient of dividing the dividend by the divisor
 * @example
 *
 * RA.divideNum(2, 1); //=> 0.5
 */ var $fa2dcbf820fb091e$var$divideNum = (0, $d071Y.default)((0, $drXm2.default));
var $fa2dcbf820fb091e$export$2e2bcd8739ae039 = $fa2dcbf820fb091e$var$divideNum;

});

parcelRegister("dwfAf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d7a5a1c520298ee$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");

var $1iEez = parcelRequire("1iEez");

var $3bTqG = parcelRequire("3bTqG");
var $9d7a5a1c520298ee$export$c77eec7171c0c3c5 = (0, $dB93a.default)(1, (0, $1iEez.default));
/**
 * Returns the integer part of a number by removing any fractional digits.
 *
 * @func trunc
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.15.0|v2.15.0}
 * @category Math
 * @sig Number | String -> Number
 * @param {number|string} number The number to trunc
 * @return {number} The integer part of the given number
 * @example
 *
 * RA.trunc(13.37); //=> 13
 * RA.trunc(42.84); //=> 42
 * RA.trunc(0.123); //=>  0
 * RA.trunc(-0.123); //=> -0
 * RA.trunc('-1.123'); //=> -1
 * RA.trunc(NaN); //=> NaN
 * RA.trunc('foo'); //=> NaN
 */ var $9d7a5a1c520298ee$var$trunc = (0, $3bTqG.default)(Math.trunc) ? (0, $dB93a.default)(1, (0, $2K8fC.default)(Math.trunc, Math)) : $9d7a5a1c520298ee$export$c77eec7171c0c3c5;
var $9d7a5a1c520298ee$export$2e2bcd8739ae039 = $9d7a5a1c520298ee$var$trunc;

});
parcelRegister("1iEez", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f26ae86f4cc4291$export$2e2bcd8739ae039; });

var $6oaBx = parcelRequire("6oaBx");
var $0f26ae86f4cc4291$var$truncPonyfill = function truncPonyfill(v) {
    var numV = Number(v);
    if (!(0, $6oaBx.default)(numV)) return numV;
     // eslint-disable-next-line no-nested-ternary
    return numV - numV % 1 || (numV < 0 ? -0 : numV === 0 ? numV : 0);
};
var $0f26ae86f4cc4291$export$2e2bcd8739ae039 = $0f26ae86f4cc4291$var$truncPonyfill;

});


parcelRegister("iOlIK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db1dbec6223712eb$export$2e2bcd8739ae039; });

var $2K8fC = parcelRequire("2K8fC");
var $dB93a = parcelRequire("dB93a");

var $3bTqG = parcelRequire("3bTqG");

var $i46Ry = parcelRequire("i46Ry");
var $db1dbec6223712eb$export$a815be4e12fd07eb = (0, $dB93a.default)(1, (0, $i46Ry.default));
/**
 * Returns the sign of a number, indicating whether the number is positive, negative or zero.
 *
 * @func sign
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.15.0|v2.15.0}
 * @category Math
 * @sig Number | String -> Number
 * @param {number} number A number
 * @return {number} A number representing the sign of the given argument. If the argument is a positive number, negative number, positive zero or negative zero, the function will return 1, -1, 0 or -0 respectively. Otherwise, NaN is returned
 * @example
 *
 * RA.sign(3); //  1
 * RA.sign(-3); // -1
 * RA.sign('-3'); // -1
 * RA.sign(0); //  0
 * RA.sign(-0); // -0
 * RA.sign(NaN); // NaN
 * RA.sign('foo'); // NaN
 */ var $db1dbec6223712eb$var$sign = (0, $3bTqG.default)(Math.sign) ? (0, $dB93a.default)(1, (0, $2K8fC.default)(Math.sign, Math)) : $db1dbec6223712eb$export$a815be4e12fd07eb;
var $db1dbec6223712eb$export$2e2bcd8739ae039 = $db1dbec6223712eb$var$sign;

});
parcelRegister("i46Ry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d26dec82de8c2c6a$export$2e2bcd8739ae039; });
var $d26dec82de8c2c6a$var$signPonyfill = function signPonyfill(number) {
    return (number > 0) - (number < 0) || +number;
};
var $d26dec82de8c2c6a$export$2e2bcd8739ae039 = $d26dec82de8c2c6a$var$signPonyfill;

});


parcelRegister("isp3P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6fe480babfecb8f$export$2e2bcd8739ae039; });

var $d071Y = parcelRequire("d071Y");
var $gfOB4 = parcelRequire("gfOB4");
/**
 * Subtracts its first argument from its second argument.
 *
 * @func subtractNum
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category Math
 * @sig Number -> Number -> Number
 * @param {number} subtrahend the number to subtract
 * @param {number} minuend the number to subtract from
 * @return {number} A number representing the difference of subtracting the subtrahend from the minuend
 * @example
 *
 * RA.subtractNum(3, 5); //=> 2
 */ var $d6fe480babfecb8f$var$subtractNum = (0, $d071Y.default)((0, $gfOB4.default));
var $d6fe480babfecb8f$export$2e2bcd8739ae039 = $d6fe480babfecb8f$var$subtractNum;

});

parcelRegister("96bCG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69fdb0a7ef120dd4$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
/**
 * Converts double-precision 64-bit binary format IEEE 754 to unsigned 32 bit integer number.
 *
 * @func toUinteger32
 * @aliases toUint32
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.28.0|v2.28.0}
 * @category Math
 * @sig Number -> Number
 * @param {number} val Value to be converted.
 * @return {number}
 * @see {@link RA.toInteger32|toInteger32}, {@link http://speakingjs.com/es5/ch11.html#integers_via_bitwise_operators}
 * @example
 *
 * RA.toUinteger32(1.5); //=> 1
 * RA.toInteger32(2 ** 35); // => 0
 * RA.toInteger32(2 ** 31); // => 2147483648
 * RA.toInteger32(2 ** 30); // => 1073741824
 */ // eslint-disable-next-line no-bitwise
var $69fdb0a7ef120dd4$var$toUinteger32 = (0, $dB93a.default)(1, function(val) {
    return val >>> 0;
});
var $69fdb0a7ef120dd4$export$2e2bcd8739ae039 = $69fdb0a7ef120dd4$var$toUinteger32;

});

parcelRegister("8gPA2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6057d41af1cc17b7$export$2e2bcd8739ae039; });

var $cdVZD = parcelRequire("cdVZD");
var $6Ocs1 = parcelRequire("6Ocs1");

var $hzmKW = parcelRequire("hzmKW");
/**
 * Converts value to a number.
 *
 * @func toNumber
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.36.0|v2.36.0}
 * @category Type
 * @param {*} val The value to convert
 * @return {Number}
 * @example
 *
 * RA.toNumber(3.2); //=> 3.2
 * RA.toNumber(Number.MIN_VALUE); //=> 5e-324
 * RA.toNumber(Infinity); //=> Infinity
 * RA.toNumber('3.2'); //=> 3.2
 * RA.toNumber(Symbol('3.2')); //=> NaN
 */ var $6057d41af1cc17b7$var$toNumber = (0, $6Ocs1.default)((0, $hzmKW.default), Number, (0, $cdVZD.default)(NaN));
var $6057d41af1cc17b7$export$2e2bcd8739ae039 = $6057d41af1cc17b7$var$toNumber;

});
parcelRegister("hzmKW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cca75b7597fa58c1$export$2e2bcd8739ae039; });

var $gi6wV = parcelRequire("gi6wV");
var $j9bAE = parcelRequire("j9bAE");

var $gXHlo = parcelRequire("gXHlo");

var $lya3B = parcelRequire("lya3B");

var $9hJsg = parcelRequire("9hJsg");
var $cca75b7597fa58c1$var$isCoercible = (0, $9hJsg.default)((0, $lya3B.default), (0, $gi6wV.default)((0, $gXHlo.default), (0, $9hJsg.default)((0, $j9bAE.default)("toString"), (0, $j9bAE.default)("valueOf"))));
var $cca75b7597fa58c1$export$2e2bcd8739ae039 = $cca75b7597fa58c1$var$isCoercible;

});


parcelRegister("1ANUb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $128fdd57bb1acf47$export$2e2bcd8739ae039; });

var $dB93a = parcelRequire("dB93a");
var $leUBm = parcelRequire("leUBm");

var $3bTqG = parcelRequire("3bTqG");

var $8cnWm = parcelRequire("8cnWm");
var $128fdd57bb1acf47$export$d10bcf604b58a12 = (0, $dB93a.default)(3, (0, $8cnWm.default));
var $128fdd57bb1acf47$export$261f37808f98e140 = (0, $leUBm.default)(2, "replaceAll");
/**
 * Replaces all substring matches in a string with a replacement.
 *
 * @func replaceAll
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.17.0|v2.17.0}
 * @category String
 * @sig String -> String -> String -> String
 * @param {string} searchValue The substring or a global RegExp to match
 * @param {string} replaceValue The string to replace the matches with
 * @param {string} str The String to do the search and replacement in
 * @return {string} A new string containing all the `searchValue` replaced with the `replaceValue`
 * @throws {TypeError} When invalid arguments provided
 * @see {@link http://ramdajs.com/docs/#replace|R.replace}, {@link https://github.com/tc39/proposal-string-replaceall|TC39 proposal}
 * @example
 *
 * RA.replaceAll('ac', 'ef', 'ac ab ac ab'); //=> 'ef ab ef ab'
 * RA.replaceAll('', '_', 'xxx'); //=> '_x_x_x_'
 * RA.replaceAll(/x/g, 'v', 'xxx'); //=> 'vvv'
 * RA.replaceAll(/x/, 'v', 'xxx'); //=> TypeError
 */ var $128fdd57bb1acf47$var$replaceAll = (0, $3bTqG.default)(String.prototype.replaceAll) ? $128fdd57bb1acf47$export$261f37808f98e140 : $128fdd57bb1acf47$export$d10bcf604b58a12;
var $128fdd57bb1acf47$export$2e2bcd8739ae039 = $128fdd57bb1acf47$var$replaceAll;

});
parcelRegister("8cnWm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f8203c2fe5f6e53$export$2e2bcd8739ae039; });

var $bfPoN = parcelRequire("bfPoN");

var $5Sepw = parcelRequire("5Sepw");

var $2vmc2 = parcelRequire("2vmc2");
var $5f8203c2fe5f6e53$var$checkArguments = function checkArguments(searchValue, replaceValue, str) {
    if (str == null || searchValue == null || replaceValue == null) throw TypeError("Input values must not be `null` or `undefined`");
};
var $5f8203c2fe5f6e53$var$checkValue = function checkValue(value, valueName) {
    if (typeof value !== "string") {
        if (!(value instanceof String)) throw TypeError("`".concat(valueName, "` must be a string"));
    }
};
var $5f8203c2fe5f6e53$var$checkSearchValue = function checkSearchValue(searchValue) {
    if (typeof searchValue !== "string" && !(searchValue instanceof String) && !(searchValue instanceof RegExp)) throw TypeError("`searchValue` must be a string or an regexp");
};
var $5f8203c2fe5f6e53$var$replaceAll = function replaceAll(searchValue, replaceValue, str) {
    $5f8203c2fe5f6e53$var$checkArguments(searchValue, replaceValue, str);
    $5f8203c2fe5f6e53$var$checkValue(str, "str");
    $5f8203c2fe5f6e53$var$checkValue(replaceValue, "replaceValue");
    $5f8203c2fe5f6e53$var$checkSearchValue(searchValue);
    var regexp = new RegExp((0, $5Sepw.default)(searchValue) ? searchValue : (0, $2vmc2.default)(searchValue), "g");
    return (0, $bfPoN.default)(regexp, replaceValue, str);
};
var $5f8203c2fe5f6e53$export$2e2bcd8739ae039 = $5f8203c2fe5f6e53$var$replaceAll;

});
parcelRegister("2vmc2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d2fb122960928c0$export$2e2bcd8739ae039; });

var $bfPoN = parcelRequire("bfPoN");
var $7Dogi = parcelRequire("7Dogi");

var $dfegI = parcelRequire("dfegI");
/**
 * Escapes the RegExp special characters.
 *
 * @func escapeRegExp
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.21.0|v2.21.0}
 * @category String
 * @sig String -> String
 * @param {string} val the value to escape
 * @return {string}
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping|MDN Regular Expressions Escaping}
 * @example
 *
 * RA.escapeRegExp('[ramda-adjunct](https://github.com/char0n/ramda-adjunct)'); //=> '\[ramda\-adjunct\]\(https://github\.com/char0n/ramda\-adjunct\)'
 */ var $1d2fb122960928c0$var$escapeRegExp = (0, $7Dogi.default)((0, $dfegI.default), (0, $bfPoN.default)(/[.*+?^${}()|[\]\\-]/g, "\\$&"));
var $1d2fb122960928c0$export$2e2bcd8739ae039 = $1d2fb122960928c0$var$escapeRegExp;

});



parcelRegister("4SKBh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38e05a65aab0fbeb$export$2e2bcd8739ae039; });

var $leUBm = parcelRequire("leUBm");

var $8LBrN = parcelRequire("8LBrN");

var $3bTqG = parcelRequire("3bTqG");
var $38e05a65aab0fbeb$export$ebfd55372637fa25 = (0, $8LBrN.default);
var $38e05a65aab0fbeb$export$536c0eb7ddf72c2e = (0, $leUBm.default)(0, "trimStart");
/**
 * Removes whitespace from the beginning of a string.
 *
 * @func trimStart
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category String
 * @sig String -> String
 * @param {string} value String value to have the whitespace removed from the beginning
 * @return {string} A new string representing the calling string stripped of whitespace from its beginning (left end).
 * @example
 *
 * RA.trimStart('  abc'); //=> 'abc'
 */ var $38e05a65aab0fbeb$var$trimStart = (0, $3bTqG.default)(String.prototype.trimStart) ? $38e05a65aab0fbeb$export$536c0eb7ddf72c2e : $38e05a65aab0fbeb$export$ebfd55372637fa25;
var $38e05a65aab0fbeb$export$2e2bcd8739ae039 = $38e05a65aab0fbeb$var$trimStart;

});
parcelRegister("8LBrN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $661fc2c884963e0b$export$2e2bcd8739ae039; });

var $bfPoN = parcelRequire("bfPoN");
var $661fc2c884963e0b$var$trimStart = (0, $bfPoN.default)(/^[\s\uFEFF\xA0]+/, "");
var $661fc2c884963e0b$export$2e2bcd8739ae039 = $661fc2c884963e0b$var$trimStart;

});


parcelRegister("fC8FZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5e1228dc4138f8e$export$2e2bcd8739ae039; });

var $leUBm = parcelRequire("leUBm");

var $dIzPW = parcelRequire("dIzPW");

var $3bTqG = parcelRequire("3bTqG");
var $b5e1228dc4138f8e$export$99d901795f513438 = (0, $dIzPW.default);
var $b5e1228dc4138f8e$export$4367b0f70f35ea94 = (0, $leUBm.default)(0, "trimEnd");
/**
 * Removes whitespace from the end of a string.
 *
 * @func trimEnd
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category String
 * @sig String -> String
 * @param {string} value String value to have the whitespace removed from the end
 * @return {string} A new string representing the calling string stripped of whitespace from its end (right end).
 * @see {@link RA.trimEnd|trimEnd}
 * @example
 *
 * RA.trimEnd('abc   '); //=> 'abc'
 */ var $b5e1228dc4138f8e$var$trimEnd = (0, $3bTqG.default)(String.prototype.trimEnd) ? $b5e1228dc4138f8e$export$4367b0f70f35ea94 : $b5e1228dc4138f8e$export$99d901795f513438;
var $b5e1228dc4138f8e$export$2e2bcd8739ae039 = $b5e1228dc4138f8e$var$trimEnd;

});
parcelRegister("dIzPW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fcb2edd2b218353$export$2e2bcd8739ae039; });

var $bfPoN = parcelRequire("bfPoN");
var $9fcb2edd2b218353$var$trimStart = (0, $bfPoN.default)(/[\s\uFEFF\xA0]+$/, "");
var $9fcb2edd2b218353$export$2e2bcd8739ae039 = $9fcb2edd2b218353$var$trimStart;

});


parcelRegister("fc4he", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0fb4b546969a6ad$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $bY7W0 = parcelRequire("bY7W0");
var $bDm6l = parcelRequire("bDm6l");
var $10F1K = parcelRequire("10F1K");
var $lgeR0 = parcelRequire("lgeR0");

var $hCFXH = parcelRequire("hCFXH");
/**
 * Removes specified characters from the end of a string.
 *
 * @func trimCharsEnd
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.25.0|v2.25.0}
 * @category String
 * @sig String -> String
 * @param {string} chars The characters to trim
 * @param {string} value The string to trim
 * @return {string} Returns the trimmed string.
 * @example
 *
 * RA.trimCharsEnd('_-', '-_-abc-_-'); //=> '-_-abc'
 */ var $b0fb4b546969a6ad$var$trimCharsEnd = (0, $iB6UK.default)(function(chars, value) {
    return (0, $10F1K.default)((0, $lgeR0.default)(""), (0, $bY7W0.default)((0, $hCFXH.default)(chars)), (0, $bDm6l.default)(""))(value);
});
var $b0fb4b546969a6ad$export$2e2bcd8739ae039 = $b0fb4b546969a6ad$var$trimCharsEnd;

});

parcelRegister("dX3zi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2838da12e4fd72f$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $7lWY7 = parcelRequire("7lWY7");
var $bDm6l = parcelRequire("bDm6l");
var $10F1K = parcelRequire("10F1K");
var $lgeR0 = parcelRequire("lgeR0");

var $hCFXH = parcelRequire("hCFXH");
/**
 * Removes specified characters from the beginning of a string.
 *
 * @func trimCharsStart
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.24.0|v2.24.0}
 * @category String
 * @sig String -> String
 * @param {string} chars The characters to trim
 * @param {string} value The string to trim
 * @return {string} Returns the trimmed string.
 * @example
 *
 * RA.trimCharsStart('_-', '-_-abc-_-'); //=> 'abc-_-'
 */ var $a2838da12e4fd72f$var$trimCharsStart = (0, $iB6UK.default)(function(chars, value) {
    return (0, $10F1K.default)((0, $lgeR0.default)(""), (0, $7lWY7.default)((0, $hCFXH.default)(chars)), (0, $bDm6l.default)(""))(value);
});
var $a2838da12e4fd72f$export$2e2bcd8739ae039 = $a2838da12e4fd72f$var$trimCharsStart;

});

parcelRegister("4SQMs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38e525abbd8d57f6$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $d071Y = parcelRequire("d071Y");
var $leUBm = parcelRequire("leUBm");

var $3bTqG = parcelRequire("3bTqG");

var $4p7n7 = parcelRequire("4p7n7");
var $38e525abbd8d57f6$export$148410c694225c0e = (0, $d071Y.default)((0, $leUBm.default)(2, "padStart"));
var $38e525abbd8d57f6$export$ce7f96c97cfcd75e = (0, $iB6UK.default)((0, $4p7n7.default));
/**
 * The function pads the current string with a given string
 * (repeated, if needed) so that the resulting string reaches a given length.
 * The padding is applied from the start of the current string.
 *
 * @func padCharsStart
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category String
 * @sig String -> Number -> String -> String
 * @param {string} padString The string to pad the current string with
 * @param {number} targetLength The length of the resulting string once the current string has been padded
 * @param {string} value String value to be padded
 * @return {string} A new string of the specified length with the pad string on the start of current string
 * @see {@link RA.padStart|padStart}, {@link RA.padEnd|padEnd}, {@link RA.padCharsEnd|padCharsEnd}
 * @example
 *
 * RA.padCharsStart('-', 3, 'a'); // => '--a'
 * RA.padCharsStart('foo', 10, 'abc'); // => 'foofoofabc'
 * RA.padCharsStart('123456', 6, 'abc'); // => '123abc'
 */ var $38e525abbd8d57f6$var$padCharsStart = (0, $3bTqG.default)(String.prototype.padStart) ? $38e525abbd8d57f6$export$148410c694225c0e : $38e525abbd8d57f6$export$ce7f96c97cfcd75e;
var $38e525abbd8d57f6$export$2e2bcd8739ae039 = $38e525abbd8d57f6$var$padCharsStart;

});
parcelRegister("4p7n7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $334f371bc332d53d$export$2e2bcd8739ae039; });

var $3bTqG = parcelRequire("3bTqG");

var $jNpFq = parcelRequire("jNpFq");

var $fJX8p = parcelRequire("fJX8p");
var $334f371bc332d53d$var$padStartPonyfill = function padStartPonyfill(padString, targetLength, value) {
    // eslint-disable-next-line no-bitwise
    var finalLength = targetLength >> 0; // truncate if number, or convert non-number to 0;
    var finalPadString = String((0, $jNpFq.default)(padString) ? padString : " "); // return the original string, if targeted length is less than original strings length
    if (value.length >= finalLength) return String(value);
    finalLength -= value.length;
    if (finalLength > finalPadString.length) {
        var lenghtToPad = finalLength / finalPadString.length; // append to original to ensure we are longer than needed
        finalPadString += (0, $3bTqG.default)(String.prototype.repeat) ? finalPadString.repeat(lenghtToPad) : (0, $fJX8p.default)(finalPadString, lenghtToPad);
    }
    return finalPadString.slice(0, finalLength) + String(value);
};
var $334f371bc332d53d$export$2e2bcd8739ae039 = $334f371bc332d53d$var$padStartPonyfill;

});


parcelRegister("Ho3cj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0826ac35dad95ce4$export$2e2bcd8739ae039; });

var $iB6UK = parcelRequire("iB6UK");
var $d071Y = parcelRequire("d071Y");
var $leUBm = parcelRequire("leUBm");

var $gpev6 = parcelRequire("gpev6");

var $3bTqG = parcelRequire("3bTqG");
var $0826ac35dad95ce4$export$7d987ae883674c66 = (0, $iB6UK.default)((0, $gpev6.default));
var $0826ac35dad95ce4$export$e13355471a8135f8 = (0, $d071Y.default)((0, $leUBm.default)(2, "padEnd"));
/**
 * The function pads the current string with a given string
 * (repeated, if needed) so that the resulting string reaches a given length.
 * The padding is applied from the end of the current string.
 *
 * @func padCharsEnd
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category String
 * @sig String -> Number -> String -> String
 * @param {string} padString The string to pad the current string with
 * @param {number} targetLength The length of the resulting string once
 * the current string has been padded
 * @param {string} value String value to be padded
 * @return {string} A new string of the specified length with the pad string
 * applied at the end of the current string
 * @see {@link RA.padEnd|padEnd}, {@link RA.padCharsStart|padCharsStart}, {@link RA.padStart|padStart}
 * @example
 *
 * RA.padCharsEnd('-', 3, 'a'); // => 'a--'
 * RA.padCharsEnd('foo', 10, 'abc'); // => 'abcfoofoof'
 * RA.padCharsEnd('123456', 6, 'abc'); // => 'abc123'
 */ var $0826ac35dad95ce4$var$padCharsEnd = (0, $3bTqG.default)(String.prototype.padEnd) ? $0826ac35dad95ce4$export$e13355471a8135f8 : $0826ac35dad95ce4$export$7d987ae883674c66;
var $0826ac35dad95ce4$export$2e2bcd8739ae039 = $0826ac35dad95ce4$var$padCharsEnd;

});
parcelRegister("gpev6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf1a3aabf20b963c$export$2e2bcd8739ae039; });

var $3bTqG = parcelRequire("3bTqG");

var $jNpFq = parcelRequire("jNpFq");

var $fJX8p = parcelRequire("fJX8p");
var $bf1a3aabf20b963c$var$padEndPonyfill = function padEndPonyfill(padString, targetLength, value) {
    // eslint-disable-next-line no-bitwise
    var finalLength = targetLength >> 0;
    var finalPadString = String((0, $jNpFq.default)(padString) ? padString : " ");
    if (value.length > finalLength) return String(value);
    finalLength -= value.length;
    if (finalLength > finalPadString.length) {
        var remainingLength = finalLength / finalPadString.length;
        finalPadString += (0, $3bTqG.default)(String.prototype.repeat) ? finalPadString.repeat(remainingLength) : (0, $fJX8p.default)(finalPadString, remainingLength);
    }
    return String(value) + finalPadString.slice(0, finalLength);
};
var $bf1a3aabf20b963c$export$2e2bcd8739ae039 = $bf1a3aabf20b963c$var$padEndPonyfill;

});


parcelRegister("6CMhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d2bbf3400329146$export$2e2bcd8739ae039; });

var $Ho3cj = parcelRequire("Ho3cj");
/**
 * The function pads the current string with an empty string
 * so that the resulting string reaches a given length.
 * The padding is applied from the end of the current string.
 *
 * @func padEnd
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.22.0|v2.22.0}
 * @category String
 * @sig Number -> String -> String
 * @param {number} targetLength The length of the resulting string once
 * the current string has been padded
 * @param {string} value String value to be padded
 * @return {string} A new string of the specified length with the pad string
 * applied at the end of the current string
 * @see {@link RA.padCharsEnd|padCharsEnd}, {@link RA.padCharsStart|padCharsStart}, {@link RA.padStart|padStart}
 * @example
 *
 * RA.padEnd(3, 'a'); // => 'a  '
 */ var $4d2bbf3400329146$var$padEnd = (0, $Ho3cj.default)(" ");
var $4d2bbf3400329146$export$2e2bcd8739ae039 = $4d2bbf3400329146$var$padEnd;

});

parcelRegister("9hurd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c1d4fec8660017e$export$2e2bcd8739ae039; });

var $4SQMs = parcelRequire("4SQMs");
/**
 * Pads string on the left side if it's shorter than length.
 *
 * @func padStart
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.25.0|v2.25.0}
 * @category String
 * @sig Number -> String -> String
 * @param {number} targetLength The length of the resulting string once
 * the current string has been padded
 * @param {string} value String value to be padded
 * @return {string} A new string of the specified length with the empty string
 * applied to the beginning of the current string
 * @see {@link RA.padCharsEnd|padCharsEnd}, {@link RA.padCharsStart|padCharsStart}, {@link RA.padEnd|padEnd}
 * @example
 *
 * RA.padStart(3, 'a'); // => '  a'
 */ var $6c1d4fec8660017e$var$padStart = (0, $4SQMs.default)(" ");
var $6c1d4fec8660017e$export$2e2bcd8739ae039 = $6c1d4fec8660017e$var$padStart;

});


var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;


parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
var $eade4dc275f59634$exports = {};


(function(global, factory) {
    factory($eade4dc275f59634$exports, (parcelRequire("g4Ykb")), (parcelRequire("dEow7")));
})($eade4dc275f59634$exports, function(exports1, ramda, ramdaAdjunct) {
    "use strict";
    var aFunction = function(it) {
        if (typeof it != "function") throw TypeError(String(it) + " is not a function");
        return it;
    };
    // optional / simple context binding
    var bindContext = function(fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch(length){
            case 0:
                return function() {
                    return fn.call(that);
                };
            case 1:
                return function(a) {
                    return fn.call(that, a);
                };
            case 2:
                return function(a, b) {
                    return fn.call(that, a, b);
                };
            case 3:
                return function(a, b, c) {
                    return fn.call(that, a, b, c);
                };
        }
        return function() {
            return fn.apply(that, arguments);
        };
    };
    var fails = function(exec) {
        try {
            return !!exec();
        } catch (error) {
            return true;
        }
    };
    var toString = {}.toString;
    var classofRaw = function(it) {
        return toString.call(it).slice(8, -1);
    };
    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var split = "".split;
    var indexedObject = fails(function() {
        // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
        // eslint-disable-next-line no-prototype-builtins
        return !Object("z").propertyIsEnumerable(0);
    }) ? function(it) {
        return classofRaw(it) == "String" ? split.call(it, "") : Object(it);
    } : Object;
    // `RequireObjectCoercible` abstract operation
    // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
    var requireObjectCoercible = function(it) {
        if (it == undefined) throw TypeError("Can't call method on " + it);
        return it;
    };
    // `ToObject` abstract operation
    // https://tc39.github.io/ecma262/#sec-toobject
    var toObject = function(argument) {
        return Object(requireObjectCoercible(argument));
    };
    var ceil = Math.ceil;
    var floor = Math.floor;
    // `ToInteger` abstract operation
    // https://tc39.github.io/ecma262/#sec-tointeger
    var toInteger = function(argument) {
        return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
    };
    var min = Math.min;
    // `ToLength` abstract operation
    // https://tc39.github.io/ecma262/#sec-tolength
    var toLength = function(argument) {
        return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };
    var isObject = function(it) {
        return typeof it === "object" ? it !== null : typeof it === "function";
    };
    // `IsArray` abstract operation
    // https://tc39.github.io/ecma262/#sec-isarray
    var isArray = Array.isArray || function isArray(arg) {
        return classofRaw(arg) == "Array";
    };
    function unwrapExports(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
    }
    function createCommonjsModule(fn, module) {
        return module = {
            exports: {}
        }, fn(module, module.exports), module.exports;
    }
    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global = typeof window == "object" && window && window.Math == Math ? window : typeof self == "object" && self && self.Math == Math ? self : Function("return this")();
    // Thank's IE8 for his funny defineProperty
    var descriptors = !fails(function() {
        return Object.defineProperty({}, "a", {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
    var document = global.document;
    // typeof document.createElement is 'object' in old IE
    var exist = isObject(document) && isObject(document.createElement);
    var documentCreateElement = function(it) {
        return exist ? document.createElement(it) : {};
    };
    // Thank's IE8 for his funny defineProperty
    var ie8DomDefine = !descriptors && !fails(function() {
        return Object.defineProperty(documentCreateElement("div"), "a", {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
    var anObject = function(it) {
        if (!isObject(it)) throw TypeError(String(it) + " is not an object");
        return it;
    };
    // 7.1.1 ToPrimitive(input [, PreferredType])
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string
    var toPrimitive = function(it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == "function" && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == "function" && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == "function" && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
    };
    var nativeDefineProperty = Object.defineProperty;
    var f = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (ie8DomDefine) try {
            return nativeDefineProperty(O, P, Attributes);
        } catch (error) {}
        if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
        if ("value" in Attributes) O[P] = Attributes.value;
        return O;
    };
    var objectDefineProperty = {
        f: f
    };
    var createPropertyDescriptor = function(bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };
    var hide = descriptors ? function(object, key, value) {
        return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
    } : function(object, key, value) {
        object[key] = value;
        return object;
    };
    var setGlobal = function(key, value) {
        try {
            hide(global, key, value);
        } catch (error) {
            global[key] = value;
        }
        return value;
    };
    var shared = createCommonjsModule(function(module) {
        var SHARED = "__core-js_shared__";
        var store = global[SHARED] || setGlobal(SHARED, {});
        (module.exports = function(key, value) {
            return store[key] || (store[key] = value !== undefined ? value : {});
        })("versions", []).push({
            version: "3.0.1",
            mode: "global",
            copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
        });
    });
    var id = 0;
    var postfix = Math.random();
    var uid = function(key) {
        return "Symbol(".concat(key === undefined ? "" : key, ")_", (++id + postfix).toString(36));
    };
    // Chrome 38 Symbol has incorrect toString conversion
    var nativeSymbol = !fails(function() {
        // eslint-disable-next-line no-undef
        return !String(Symbol());
    });
    var store = shared("wks");
    var Symbol$1 = global.Symbol;
    var wellKnownSymbol = function(name) {
        return store[name] || (store[name] = nativeSymbol && Symbol$1[name] || (nativeSymbol ? Symbol$1 : uid)("Symbol." + name));
    };
    var SPECIES = wellKnownSymbol("species");
    // `ArraySpeciesCreate` abstract operation
    // https://tc39.github.io/ecma262/#sec-arrayspeciescreate
    var arraySpeciesCreate = function(originalArray, length) {
        var C;
        if (isArray(originalArray)) {
            C = originalArray.constructor;
            // cross-realm fallback
            if (typeof C == "function" && (C === Array || isArray(C.prototype))) C = undefined;
            else if (isObject(C)) {
                C = C[SPECIES];
                if (C === null) C = undefined;
            }
        }
        return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
    };
    // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
    // 0 -> Array#forEach
    // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
    // 1 -> Array#map
    // https://tc39.github.io/ecma262/#sec-array.prototype.map
    // 2 -> Array#filter
    // https://tc39.github.io/ecma262/#sec-array.prototype.filter
    // 3 -> Array#some
    // https://tc39.github.io/ecma262/#sec-array.prototype.some
    // 4 -> Array#every
    // https://tc39.github.io/ecma262/#sec-array.prototype.every
    // 5 -> Array#find
    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    // 6 -> Array#findIndex
    // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
    var arrayMethods = function(TYPE, specificCreate) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        var create = specificCreate || arraySpeciesCreate;
        return function($this, callbackfn, that) {
            var O = toObject($this);
            var self1 = indexedObject(O);
            var boundFunction = bindContext(callbackfn, that, 3);
            var length = toLength(self1.length);
            var index = 0;
            var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
            var value, result;
            for(; length > index; index++)if (NO_HOLES || index in self1) {
                value = self1[index];
                result = boundFunction(value, index, O);
                if (TYPE) {
                    if (IS_MAP) target[index] = result; // map
                    else if (result) switch(TYPE){
                        case 3:
                            return true; // some
                        case 5:
                            return value; // find
                        case 6:
                            return index; // findIndex
                        case 2:
                            target.push(value); // filter
                    }
                    else if (IS_EVERY) return false; // every
                }
            }
            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
        };
    };
    var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
    var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    // Nashorn ~ JDK8 bug
    var NASHORN_BUG = nativeGetOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
        1: 2
    }, 1);
    var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = nativeGetOwnPropertyDescriptor(this, V);
        return !!descriptor && descriptor.enumerable;
    } : nativePropertyIsEnumerable;
    var objectPropertyIsEnumerable = {
        f: f$1
    };
    // toObject with fallback for non-array-like ES3 strings
    var toIndexedObject = function(it) {
        return indexedObject(requireObjectCoercible(it));
    };
    var hasOwnProperty = {}.hasOwnProperty;
    var has = function(it, key) {
        return hasOwnProperty.call(it, key);
    };
    var nativeGetOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
    var f$2 = descriptors ? nativeGetOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject(O);
        P = toPrimitive(P, true);
        if (ie8DomDefine) try {
            return nativeGetOwnPropertyDescriptor$1(O, P);
        } catch (error) {}
        if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
    };
    var objectGetOwnPropertyDescriptor = {
        f: f$2
    };
    var functionToString = shared("native-function-to-string", Function.toString);
    var WeakMap = global.WeakMap;
    var nativeWeakMap = typeof WeakMap === "function" && /native code/.test(functionToString.call(WeakMap));
    var shared$1 = shared("keys");
    var sharedKey = function(key) {
        return shared$1[key] || (shared$1[key] = uid(key));
    };
    var hiddenKeys = {};
    var WeakMap$1 = global.WeakMap;
    var set, get, has$1;
    var enforce = function(it) {
        return has$1(it) ? get(it) : set(it, {});
    };
    var getterFor = function(TYPE) {
        return function(it) {
            var state;
            if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
            return state;
        };
    };
    if (nativeWeakMap) {
        var store$1 = new WeakMap$1();
        var wmget = store$1.get;
        var wmhas = store$1.has;
        var wmset = store$1.set;
        set = function(it, metadata) {
            wmset.call(store$1, it, metadata);
            return metadata;
        };
        get = function(it) {
            return wmget.call(store$1, it) || {};
        };
        has$1 = function(it) {
            return wmhas.call(store$1, it);
        };
    } else {
        var STATE = sharedKey("state");
        hiddenKeys[STATE] = true;
        set = function(it, metadata) {
            hide(it, STATE, metadata);
            return metadata;
        };
        get = function(it) {
            return has(it, STATE) ? it[STATE] : {};
        };
        has$1 = function(it) {
            return has(it, STATE);
        };
    }
    var internalState = {
        set: set,
        get: get,
        has: has$1,
        enforce: enforce,
        getterFor: getterFor
    };
    var redefine = createCommonjsModule(function(module) {
        var getInternalState = internalState.get;
        var enforceInternalState = internalState.enforce;
        var TEMPLATE = String(functionToString).split("toString");
        shared("inspectSource", function(it) {
            return functionToString.call(it);
        });
        (module.exports = function(O, key, value, options) {
            var unsafe = options ? !!options.unsafe : false;
            var simple = options ? !!options.enumerable : false;
            var noTargetGet = options ? !!options.noTargetGet : false;
            if (typeof value == "function") {
                if (typeof key == "string" && !has(value, "name")) hide(value, "name", key);
                enforceInternalState(value).source = TEMPLATE.join(typeof key == "string" ? key : "");
            }
            if (O === global) {
                if (simple) O[key] = value;
                else setGlobal(key, value);
                return;
            } else if (!unsafe) delete O[key];
            else if (!noTargetGet && O[key]) simple = true;
            if (simple) O[key] = value;
            else hide(O, key, value);
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        })(Function.prototype, "toString", function toString() {
            return typeof this == "function" && getInternalState(this).source || functionToString.call(this);
        });
    });
    var max = Math.max;
    var min$1 = Math.min;
    // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
    var toAbsoluteIndex = function(index, length) {
        var integer = toInteger(index);
        return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
    };
    // `Array.prototype.{ indexOf, includes }` methods implementation
    // false -> Array#indexOf
    // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
    // true  -> Array#includes
    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    var arrayIncludes = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
            var O = toIndexedObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value;
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare
            if (IS_INCLUDES && el != el) while(length > index){
                value = O[index++];
                // eslint-disable-next-line no-self-compare
                if (value != value) return true;
            // Array#indexOf ignores holes, Array#includes - not
            }
            else for(; length > index; index++)if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
        };
    };
    var arrayIndexOf = arrayIncludes(false);
    var objectKeysInternal = function(object, names) {
        var O = toIndexedObject(object);
        var i = 0;
        var result = [];
        var key;
        for(key in O)!has(hiddenKeys, key) && has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        while(names.length > i)if (has(O, key = names[i++])) ~arrayIndexOf(result, key) || result.push(key);
        return result;
    };
    // IE8- don't enum bug keys
    var enumBugKeys = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf"
    ];
    // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
    var hiddenKeys$1 = enumBugKeys.concat("length", "prototype");
    var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return objectKeysInternal(O, hiddenKeys$1);
    };
    var objectGetOwnPropertyNames = {
        f: f$3
    };
    var f$4 = Object.getOwnPropertySymbols;
    var objectGetOwnPropertySymbols = {
        f: f$4
    };
    var Reflect$1 = global.Reflect;
    // all object keys, includes non-enumerable and symbols
    var ownKeys = Reflect$1 && Reflect$1.ownKeys || function ownKeys(it) {
        var keys = objectGetOwnPropertyNames.f(anObject(it));
        var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
        return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
    };
    var copyConstructorProperties = function(target, source) {
        var keys = ownKeys(source);
        var defineProperty = objectDefineProperty.f;
        var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        }
    };
    var replacement = /#|\.prototype\./;
    var isForced = function(feature, detection) {
        var value = data[normalize(feature)];
        return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == "function" ? fails(detection) : !!detection;
    };
    var normalize = isForced.normalize = function(string) {
        return String(string).replace(replacement, ".").toLowerCase();
    };
    var data = isForced.data = {};
    var NATIVE = isForced.NATIVE = "N";
    var POLYFILL = isForced.POLYFILL = "P";
    var isForced_1 = isForced;
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    /*
    options.target      - name of the target object
    options.global      - target is the global object
    options.stat        - export as static methods of target
    options.proto       - export as prototype methods of target
    options.real        - real prototype method for the `pure` version
    options.forced      - export even if the native feature is available
    options.bind        - bind methods to the target, required for the `pure` version
    options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
    options.unsafe      - use the simple assignment of property instead of delete + defineProperty
    options.sham        - add a flag to not completely full polyfills
    options.enumerable  - export as enumerable property
    options.noTargetGet - prevent calling a getter on target
  */ var _export = function(options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var FORCED, target, key, targetProperty, sourceProperty, descriptor;
        if (GLOBAL) target = global;
        else if (STATIC) target = global[TARGET] || setGlobal(TARGET, {});
        else target = (global[TARGET] || {}).prototype;
        if (target) for(key in source){
            sourceProperty = source[key];
            if (options.noTargetGet) {
                descriptor = getOwnPropertyDescriptor(target, key);
                targetProperty = descriptor && descriptor.value;
            } else targetProperty = target[key];
            FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
            // contained in target
            if (!FORCED && targetProperty !== undefined) {
                if (typeof sourceProperty === typeof targetProperty) continue;
                copyConstructorProperties(sourceProperty, targetProperty);
            }
            // add a flag to not completely full polyfills
            if (options.sham || targetProperty && targetProperty.sham) hide(sourceProperty, "sham", true);
            // extend global
            redefine(target, key, sourceProperty, options);
        }
    };
    // 19.1.2.14 / 15.2.3.14 Object.keys(O)
    var objectKeys = Object.keys || function keys(O) {
        return objectKeysInternal(O, enumBugKeys);
    };
    var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = objectKeys(Properties);
        var length = keys.length;
        var i = 0;
        var key;
        while(length > i)objectDefineProperty.f(O, key = keys[i++], Properties[key]);
        return O;
    };
    var document$1 = global.document;
    var html = document$1 && document$1.documentElement;
    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
    var IE_PROTO = sharedKey("IE_PROTO");
    var PROTOTYPE = "prototype";
    var Empty = function() {};
    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var createDict = function() {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = documentCreateElement("iframe");
        var length = enumBugKeys.length;
        var lt = "<";
        var script = "script";
        var gt = ">";
        var js = "java" + script + ":";
        var iframeDocument;
        iframe.style.display = "none";
        html.appendChild(iframe);
        iframe.src = String(js);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + script + gt + "document.F=Object" + lt + "/" + script + gt);
        iframeDocument.close();
        createDict = iframeDocument.F;
        while(length--)delete createDict[PROTOTYPE][enumBugKeys[length]];
        return createDict();
    };
    var objectCreate = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null;
            // add "__proto__" for Object.getPrototypeOf polyfill
            result[IE_PROTO] = O;
        } else result = createDict();
        return Properties === undefined ? result : objectDefineProperties(result, Properties);
    };
    hiddenKeys[IE_PROTO] = true;
    var UNSCOPABLES = wellKnownSymbol("unscopables");
    var ArrayPrototype = Array.prototype;
    // Array.prototype[@@unscopables]
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    if (ArrayPrototype[UNSCOPABLES] == undefined) hide(ArrayPrototype, UNSCOPABLES, objectCreate(null));
    // add a key to Array.prototype[@@unscopables]
    var addToUnscopables = function(key) {
        ArrayPrototype[UNSCOPABLES][key] = true;
    };
    var internalFind = arrayMethods(5);
    var FIND = "find";
    var SKIPS_HOLES = true;
    // Shouldn't skip holes
    if (FIND in []) Array(1)[FIND](function() {
        SKIPS_HOLES = false;
    });
    // `Array.prototype.find` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    _export({
        target: "Array",
        proto: true,
        forced: SKIPS_HOLES
    }, {
        find: function find(callbackfn /* , that = undefined */ ) {
            return internalFind(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    addToUnscopables(FIND);
    var sloppyArrayMethod = function(METHOD_NAME, argument) {
        var method = [][METHOD_NAME];
        return !method || !fails(function() {
            // eslint-disable-next-line no-useless-call,no-throw-literal
            method.call(null, argument || function() {
                throw 1;
            }, 1);
        });
    };
    var nativeForEach = [].forEach;
    var internalForEach = arrayMethods(0);
    var SLOPPY_METHOD = sloppyArrayMethod("forEach");
    // `Array.prototype.forEach` method implementation
    // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
    var arrayForEach = SLOPPY_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
        return internalForEach(this, callbackfn, arguments[1]);
    } : nativeForEach;
    // `Array.prototype.forEach` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
    _export({
        target: "Array",
        proto: true,
        forced: [].forEach != arrayForEach
    }, {
        forEach: arrayForEach
    });
    // iterable DOM collections
    // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
    var domIterables = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    };
    for(var COLLECTION_NAME in domIterables){
        var Collection = global[COLLECTION_NAME];
        var CollectionPrototype = Collection && Collection.prototype;
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
            hide(CollectionPrototype, "forEach", arrayForEach);
        } catch (error) {
            CollectionPrototype.forEach = arrayForEach;
        }
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _isNativeFunction(fn) {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
    function _wrapNativeSuper(Class) {
        var _cache = typeof Map === "function" ? new Map() : undefined;
        _wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !_isNativeFunction(Class)) return Class;
            if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
            }
            function Wrapper() {
                return _construct(Class, arguments, _getPrototypeOf(this).constructor);
            }
            Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            return _setPrototypeOf(Wrapper, Class);
        };
        return _wrapNativeSuper(Class);
    }
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (typeof call === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(self1);
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    /**
   * @module Assert
   */ /**
   * @description A special error that indicates an assertion has failed.
   *
   * @extends Error
   */ var AssertionError = /*#__PURE__*/ function(_Error) {
        _inherits(AssertionError, _Error);
        /**
     * @param {string} message - The message containing more information about a given AssertionError.
     */ function AssertionError(message) {
            _classCallCheck(this, AssertionError);
            return _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "AssertionError: ".concat(message)));
        }
        return AssertionError;
    }(_wrapNativeSuper(Error));
    /**
   * @description If the assertion is truthy then nothing will happen. Otherwise, this function throws
   * an {@link AssertionError} with the provided message if the assertion is falsy.
   *
   * @example
   * function example(param) {
   *   assert(typeof param === 'string', 'Param must be of type string!');
   * }
   *
   * @param {boolean} assertion
   * @param {string} message
   */ var assert = function assert(assertion, message) {
        if (!assertion) throw new AssertionError(message);
    };
    /**
   * @module Matrix
   */ /**
   * @description Checks if the given matrix includes the given
   * location
   *
   * @param {Object[][]} matrix
   * @param {Location} location
   *
   * @returns {Boolean} true if the given location exists within
   * the matrix.
   */ var isLocationInBounds = ramda.curry(function(matrix, _ref) {
        var row = _ref.row, col = _ref.col;
        return Boolean(row < matrix.length && row >= 0 && matrix[row] && col < matrix[row].length && col >= 0);
    });
    /**
   * @description Gets the cell's value at the specified location
   * from the matrix.
   *
   * @param {Object[][]} matrix
   * @param {Location} location
   *
   * @throws {AssertionError} the target location is not contained
   * in the provided matrix's bounds
   * @returns {Object} the retrieved object
   */ var getLocation = ramda.curry(function(matrix, location) {
        assert(isLocationInBounds(matrix, location), "Location: ".concat(JSON.stringify(location), " isn't in bounds!"));
        return matrix[location.row][location.col];
    });
    /**
   * @description Check if two locations are equal. Determined by
   * a comparison of row and col values of each location.
   *
   * @param {Location} a
   * @param {Location} b
   *
   * @returns {boolean} true if both locations are equal
   */ var compareLocations = ramda.curry(function(a, b) {
        return a.row === b.row && a.col === b.col;
    });
    /**
   * @description Calculates the Manhattan Distance between two
   * provided locations
   *
   * @param {Location} a
   * @param {Location} b
   *
   * @returns {number} the integer value of the calculated distance
   */ var manhattanDistance = ramda.curry(function(a, b) {
        return Math.abs(a.row - b.row) + Math.abs(a.col - b.col);
    });
    /**
   * @description Creates an array on a specified length and filled with a specified value.
   *
   * @function
   * @param {number} length - The length of the array to be filled.
   * @param {number} value - What value each index of the array will be filled with.
   * @returns {Object[]} Newly created array of values.
   */ var fillArray = ramda.curry(function(length, value) {
        return ramda.times(function() {
            return ramda.clone(value);
        }, length);
    });
    /**
   * @description Creates an array of the specified length and filled with 0s.
   *
   * @param {number} length - The length of the array to be filled.
   * @returns {number[]} Newly created array of 0s.
   */ var initArray = function initArray(length) {
        return fillArray(length, 0);
    };
    /**
   * @description A function used to construct the value of a given array index.
   *
   * @callback ArrayConstructor
   * @param {number} index - The index of the constructed value.
   */ /**
   * @description Creates an array of the specified length where each index is filled with the
   * result of running the constructor function.
   *
   * @param {ArrayConstructor} constructor - The function used to construct each value of the array.
   * @param {number} length - The length of the array to be filled. Must be a positive number not including zero.
   * @throws {AssertionError} - Will throw an error if constructor isn't a function.
   * @throws {AssertionError} - Will throw an error if length isn't a positive number not including zero.
   * @returns {Object[]} Newly created array of the constructed values.
   */ var constructArray = ramda.curry(function(constructor, length) {
        assert(ramdaAdjunct.isFunction(constructor), "Constructor argument should be a function!");
        assert(ramdaAdjunct.isPositive(length), "Length argument should be a positive number!");
        return ramda.pipe(initArray, // These values are all generated by initArray and the user doesn't care.
        ramdaAdjunct.mapIndexed(function(_, index) {
            return constructor(index);
        }))(length);
    });
    /**
   * @description Does the provided array contain the location provided.
   *
   * @method
   * @param {Object[]} array - The array to be searched.
   * @param {Location} location - The location to ge searched for.
   * @returns {boolean} True if the location is present in the array.
   */ var containsLocation = ramda.curry(function(array, location) {
        return Boolean(array.find(function(value) {
            return compareLocations(value, location);
        }));
    });
    var findBestMatch = ramda.curry(function(evaluator, determineBetterFit, array) {
        var currentBest;
        array.forEach(function(value, index) {
            var evaluated = evaluator(value);
            if (currentBest === undefined) currentBest = index;
            if (determineBetterFit(evaluator(array[currentBest]), evaluated)) currentBest = index;
        });
        return currentBest;
    });
    /**
   * @module Matrix
   */ /**
   * @description Creates a matrix of the specified dimensions filled
   * with the provided value at every location.
   *
   * @param {Dimensions} dimensions - width and height of this matrix
   * @param {Object} value - any value to fill the matrix with
   *
   * @returns {Object[][]} the newly created array
   */ var fillMatrix = ramda.curry(function(_ref, value) {
        var width = _ref.width, height = _ref.height;
        return ramda.pipe(fillArray(width), fillArray(height))(value);
    });
    /**
   * @module Matrix
   */ /**
   * @description Creates a matrix of the specified dimensions
   * with all cells set to a value of 0.
   *
   * @param {Dimensions} dimensions
   *
   * @returns {number[][]} the initialized matrix
   */ var initMatrix = function initMatrix(dimensions) {
        return fillMatrix(dimensions)(0);
    };
    var SPECIES$1 = wellKnownSymbol("species");
    var arrayMethodHasSpeciesSupport = function(METHOD_NAME) {
        return !fails(function() {
            var array = [];
            var constructor = array.constructor = {};
            constructor[SPECIES$1] = function() {
                return {
                    foo: 1
                };
            };
            return array[METHOD_NAME](Boolean).foo !== 1;
        });
    };
    var internalMap = arrayMethods(1);
    var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("map");
    // `Array.prototype.map` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.map
    // with adding support of @@species
    _export({
        target: "Array",
        proto: true,
        forced: !SPECIES_SUPPORT
    }, {
        map: function map(callbackfn /* , thisArg */ ) {
            return internalMap(this, callbackfn, arguments[1]);
        }
    });
    /**
   * Takes in the value, location, and matrix being mapped
   * and returns a new object.
   *
   * @callback CellMapper
   *
   * @param {Object} value
   * @param {Location} location
   * @param {Object[][]} matrix
   *
   * @returns {Object}
   */ /**
   * @description Maps over the provided matrix with the provided
   * callback and returns a new matrix.
   *
   * @param {CellMapper} callback
   * @param {Object[][]} matrix
   *
   * @returns {Object[][]} the newly mapped matrix
   */ var mapMatrix = ramda.curry(function(cb, matrix) {
        return matrix.map(function(array, row) {
            return array.map(function(value, col) {
                return cb(value, {
                    row: row,
                    col: col
                }, matrix);
            });
        });
    });
    /**
   * @module Matrix
   */ /**
   * @description Set the cell of the matrix at the location to a value.
   *
   * @param {Location} location
   * @param {Object} value
   * @param {Object[][]} matrix
   *
   * @returns {Object[][]} matrix with the location updated
   */ var updateMatrix = ramda.curry(function(_ref, value, matrix) {
        var row = _ref.row, col = _ref.col;
        return ramda.update(row, ramda.update(col, value, matrix[row]), matrix);
    });
    /**
   * @module Matrix
   */ var getLocationFromDirection = ramda.curry(function(location, direction) {
        var row = location.row, col = location.col;
        if (direction.up) row -= 1;
        else if (direction.down) row += 1;
        if (direction.left) col -= 1;
        else if (direction.right) col += 1;
        return {
            row: row,
            col: col
        };
    });
    /**
   * @description Get all the neighboring locations of the provided location from
   * the provided matrix that are in bounds.
   *
   * @param {function} - getDirections - this function should return a
   * {Connections} object defining how matrix cells are connected.
   * @param {Object[][]} - matrix - the matrix to be checked
   * @param {Location} - location - location in the matrix whose neighbors
   * should be returned.
   *
   * @returns {Location[]} array of all valid neighboring locations
   */ var getNeighbors = ramda.curry(function(getDirections, matrix, location) {
        var isLocationInBoundsWithMatrix = isLocationInBounds(matrix);
        if (!isLocationInBoundsWithMatrix(location)) // Location out of bounds has no neighbors
        return [];
        var getLocationFromDirectionWithLocation = getLocationFromDirection(location);
        return ramda.pipe(ramda.map(getLocationFromDirectionWithLocation), ramda.filter(isLocationInBoundsWithMatrix))(getDirections(getLocation(matrix, location)));
    });
    var internalFilter = arrayMethods(2);
    var SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport("filter");
    // `Array.prototype.filter` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.filter
    // with adding support of @@species
    _export({
        target: "Array",
        proto: true,
        forced: !SPECIES_SUPPORT$1
    }, {
        filter: function filter(callbackfn /* , thisArg */ ) {
            return internalFilter(this, callbackfn, arguments[1]);
        }
    });
    /**
   * @module Matrix
   */ /**
   * @description Get a row of the provided matrix
   *
   * @param {Object[][]} matrix
   * @param {number} rowIndex - row index to be gotten
   *
   * @returns {Object[]} a single row of the matrix
   */ var getRow = ramda.curry(function(matrix, rowIndex) {
        return matrix[rowIndex];
    });
    var isEntireArrayUndefined = function isEntireArrayUndefined(array) {
        return ramda.all(ramda.equals(undefined), array);
    };
    /**
   * @description Get a column of the provided matrix
   *
   * @param {Object[][]} matrix
   * @param {number} colIndex - column index to be gotten
   *
   * @returns {Object[]} a single column of the matrix
   */ var getCol = ramda.curry(function(matrix, colIndex) {
        var col = ramda.map(function(row) {
            return row[colIndex];
        }, matrix);
        return isEntireArrayUndefined(col) ? undefined : col;
    });
    /**
   * @description Get the dimensions objet describing the
   * provided matrix.
   *
   * @param {Object[][]} matrix
   *
   * @returns {Dimensions} width and height of the provided matrix
   */ var getDimensions = function getDimensions(matrix) {
        return {
            height: getCol(matrix, 0).length,
            width: getRow(matrix, 0).length
        };
    };
    // the docs, so I've hardcoded them into the enum's
    // description.
    /**
   * Directions to rotate a matrix:
   * CLOCKWISE, COUNTER_CLOCKWISE
   *
   * @readonly
   * @enum {string}
   */ var MATRIX_ROTATION_DIRECTIONS = {
        CLOCKWISE: "CLOCKWISE",
        COUNTER_CLOCKWISE: "COUNTER_CLOCKWISE"
    };
    /**
   * @description Rotate a matrix in the provided direction
   *
   * @param {Object} options - control how the matrix is rotated
   * @param {MATRIX_ROTATION_DIRECTIONS} options.direction - direction to rotate the matrix
   * @param {Object[][]} - matrix to be rotated
   *
   * @returns {Object[][]} newly rotated matrix
   */ var rotateMatrix = ramda.curry(function(_ref, matrix) {
        var direction = _ref.direction;
        var _getDimensions = getDimensions(matrix), width = _getDimensions.width;
        switch(direction){
            case MATRIX_ROTATION_DIRECTIONS.COUNTER_CLOCKWISE:
                return initArray(width).map(function(_, index) {
                    // Grab the columns in reverse order
                    var col = getCol(matrix, width - 1 - index); // We can only operate on a column that exists
                    if (col) return col;
                }) // Filter out rows that are falsy. If a matrix's dimensions are
                // uneven, we'll have this occur when referencing a row or col
                // that does not exist.
                .filter(function(row) {
                    return Boolean(row);
                });
            case MATRIX_ROTATION_DIRECTIONS.CLOCKWISE:
            default:
                return initArray(width).map(function(_, index) {
                    var col = getCol(matrix, index); // We can only operate on a column that exists
                    if (col) return col.reverse();
                }) // Filter out rows that are falsy. If a matrix's dimensions are
                // uneven, we'll have this occur when referencing a row or col
                // that does not exist.
                .filter(function(row) {
                    return Boolean(row);
                });
        }
    });
    /**
   * @description Transpose (flip the columns and rows) the provided matrix.
   *
   * @param {Object[][]} matrix
   *
   * @returns {Object[][]} the transposed matrix
   */ var transposeMatrix = ramda.curry(function(matrix) {
        var _getDimensions = getDimensions(matrix), width = _getDimensions.width;
        return initArray(width).map(function(_, index) {
            // Grab the columns in reverse order
            return getCol(matrix, index);
        });
    });
    // the docs, so I've hardcoded them into the enum's
    // description.
    /**
   * Directions to translate a matrix:
   * UP, DOWN, LEFT, RIGHT
   *
   * @readonly
   * @enum {string}
   */ var MATRIX_TRANSLATE_DIRECTIONS = {
        UP: "UP",
        DOWN: "DOWN",
        LEFT: "LEFT",
        RIGHT: "RIGHT"
    };
    /**
   * @description Translate a matrix in the provided direction
   *
   * @param {Object} options - control how the matrix is translated
   * @param {boolean} [options.shouldWrap=false] - should the edge of the matrix at the end of the
   * translation be placed on the opposite side of the matrix, or should it be removed entirely
   * @param {MatrixConstructor} [options.constructFn=()=>undefined] - if wrapping is disabled, this
   * constructor function is used to create the row at the newly exposed edge of the matrix.
   * @param {MATRIX_TRANSLATE_DIRECTIONS} options.direction - direction to translate the matrix
   * @param {Object[][]} - matrix to be translated
   *
   * @returns {Object[][]} newly translated matrix
   */ var translateMatrix = ramda.curry(function(_ref, matrix) {
        var _ref$shouldWrap = _ref.shouldWrap, shouldWrap = _ref$shouldWrap === void 0 ? false : _ref$shouldWrap, _ref$constructFn = _ref.constructFn, constructFn = _ref$constructFn === void 0 ? function() {
            return undefined;
        } : _ref$constructFn, direction = _ref.direction;
        var _getDimensions = getDimensions(matrix), height = _getDimensions.height, width = _getDimensions.width;
        switch(direction){
            case MATRIX_TRANSLATE_DIRECTIONS.UP:
                return matrix.map(function(_, rowIndex) {
                    var nextRow = getRow(matrix, rowIndex + 1); // If there is not next row, we're on the last row in our matrix
                    if (!nextRow) {
                        if (shouldWrap) // If we should wrap, our last row should become the original first row
                        return getRow(matrix, 0);
                         // If nothing else, use the provided construct function to build a new final row
                        return constructArray(constructFn, width);
                    }
                    return nextRow;
                });
            case MATRIX_TRANSLATE_DIRECTIONS.DOWN:
                return matrix.map(function(_, rowIndex) {
                    var prevRow = getRow(matrix, rowIndex - 1); // If there is not next row, we're on the first row in our matrix
                    if (!prevRow) {
                        if (shouldWrap) // If we should wrap, our first row should become the original last row
                        return getRow(matrix, height - 1);
                         // If nothing else, use the provided construct function to build a new final row
                        return constructArray(constructFn, width);
                    }
                    return prevRow;
                });
            case MATRIX_TRANSLATE_DIRECTIONS.RIGHT:
                var translatedColumns = initArray(width).map(function(_, colIndex) {
                    var prevCol = getCol(matrix, colIndex - 1); // If there is not prev column, we're on the first col in our matrix
                    if (!prevCol) {
                        if (shouldWrap) // If we should wrap, our first column should become the original last column
                        return getCol(matrix, width - 1);
                         // If nothing else, use the provided construct function to build a new final column
                        return constructArray(constructFn, height);
                    }
                    return prevCol;
                });
                return transposeMatrix(translatedColumns);
            case MATRIX_TRANSLATE_DIRECTIONS.LEFT:
                var _translatedColumns = initArray(width).map(function(_, colIndex) {
                    var nextCol = getCol(matrix, colIndex + 1); // If there is not next column, we're on the last col in our matrix
                    if (!nextCol) {
                        if (shouldWrap) // If we should wrap, our last column should become the original first column
                        return getCol(matrix, 0);
                         // If nothing else, use the provided construct function to build a new final column
                        return constructArray(constructFn, height);
                    }
                    return nextCol;
                });
                return transposeMatrix(_translatedColumns);
            default:
                break;
        }
    });
    var createProperty = function(object, key, value) {
        var propertyKey = toPrimitive(key);
        if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
        else object[propertyKey] = value;
    };
    var IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable");
    var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded";
    var IS_CONCAT_SPREADABLE_SUPPORT = !fails(function() {
        var array = [];
        array[IS_CONCAT_SPREADABLE] = false;
        return array.concat()[0] !== array;
    });
    var SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport("concat");
    var isConcatSpreadable = function(O) {
        if (!isObject(O)) return false;
        var spreadable = O[IS_CONCAT_SPREADABLE];
        return spreadable !== undefined ? !!spreadable : isArray(O);
    };
    var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT$2;
    // `Array.prototype.concat` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.concat
    // with adding support of @@isConcatSpreadable and @@species
    _export({
        target: "Array",
        proto: true,
        forced: FORCED
    }, {
        concat: function concat(arg) {
            var O = toObject(this);
            var A = arraySpeciesCreate(O, 0);
            var n = 0;
            var i, k, length, len, E;
            for(i = -1, length = arguments.length; i < length; i++){
                E = i === -1 ? O : arguments[i];
                if (isConcatSpreadable(E)) {
                    len = toLength(E.length);
                    if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                    for(k = 0; k < len; k++, n++)if (k in E) createProperty(A, n, E[k]);
                } else {
                    if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                    createProperty(A, n++, E);
                }
            }
            A.length = n;
            return A;
        }
    });
    /**
   * @description An object describing a direction. It should contain no more than 2 truthy properties.
   * @typedef {Object} Direction
   *
   * @property {boolean} up - Is a component of this direction facing up.
   * @property {boolean} down - Is a component of this direction facing down.
   * @property {boolean} left - Is a component of this direction facing left.
   * @property {boolean} right - Is a component of this direction facing right.
   */ /**
   * @description Creates an array of directions representing the cross-shaped
   * neighbors of a cell.
   *
   * The following diagram describes the neighboring directions represented by X's.
   * | |X| |
   * -------
   * |X| |X|
   * -------
   * | |X| |
   *
   * @returns {Direction[]} Directions representing up, down, left, and right.
   */ var getCrossDirections = function getCrossDirections() {
        return [
            {
                up: true
            },
            {
                left: true
            },
            {
                right: true
            },
            {
                down: true
            }
        ];
    };
    /**
   * @description Creates an array of directions representing the X-shaped diagonal
   * neighbors of a cell.
   *
   * The following diagram describes the neighboring directions represented by X's.
   * |X| |X|
   * -------
   * | | | |
   * -------
   * |X| |X|
   *
   * @returns {Direction[]} Directions representing upper left, upper right, lower left, and lower right.
   */ var getDiagonalDirections = function getDiagonalDirections() {
        return [
            {
                up: true,
                left: true
            },
            {
                up: true,
                right: true
            },
            {
                down: true,
                right: true
            },
            {
                down: true,
                left: true
            }
        ];
    };
    /**
   * @description Creates an array of directions representing the all diagonal and cross-shaped
   * neighbors of a cell.
   *
   * The following diagram describes the neighboring directions represented by X's.
   * |X|X|X|
   * -------
   * |X| |X|
   * -------
   * |X|X|X|
   *
   * @returns {Direction[]} Directions representing upper left, up, upper right, right,
   * lower right, down, lower left, and left.
   */ var getAllDirections = function getAllDirections() {
        return [].concat(_toConsumableArray(getCrossDirections()), _toConsumableArray(getDiagonalDirections()));
    };
    var isPairConnected = function isPairConnected(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), connected = _ref2[1];
        return connected;
    };
    var buildDirection = function buildDirection(_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1), direction = _ref4[0];
        return _defineProperty({}, direction, true);
    };
    /**
   * @description An object describing the connections of a cell.
   * @typedef {Object} Connections
   *
   * @property {boolean} up - Is this cell connected to its upper neighbor.
   * @property {boolean} down - Is this cell connected to its lower neighbor.
   * @property {boolean} left - Is this cell connected to its left neighbor.
   * @property {boolean} right - Is this cell connected to its right neighbor.
   */ /**
   * @description Creates an array of the directions connected to this object in a cross-shaped
   * pattern. A connection is determined by the connections object passed into this function.
   * If a connection direction is truthy then it is counted as connected.
   *
   * @param {Connections} connections - An object that describes which neighbors this cell is
   * connected to.
   * @returns {Directions[]} All directions connected to the cell.
   */ var getConnectedDirections = ramda.pipe(ramda.pick([
        "up",
        "down",
        "left",
        "right"
    ]), ramda.toPairs, ramda.filter(isPairConnected), ramda.map(buildDirection));
    // `Array.prototype.{ reduce, reduceRight }` methods implementation
    // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
    // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
    var arrayReduce = function(that, callbackfn, argumentsLength, memo, isRight) {
        aFunction(callbackfn);
        var O = toObject(that);
        var self1 = indexedObject(O);
        var length = toLength(O.length);
        var index = isRight ? length - 1 : 0;
        var i = isRight ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self1) {
                memo = self1[index];
                index += i;
                break;
            }
            index += i;
            if (isRight ? index < 0 : length <= index) throw TypeError("Reduce of empty array with no initial value");
        }
        for(; isRight ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
        return memo;
    };
    var SLOPPY_METHOD$1 = sloppyArrayMethod("reduce");
    // `Array.prototype.reduce` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
    _export({
        target: "Array",
        proto: true,
        forced: SLOPPY_METHOD$1
    }, {
        reduce: function reduce(callbackfn /* , initialValue */ ) {
            return arrayReduce(this, callbackfn, arguments.length, arguments[1], false);
        }
    });
    /**
   * The width and height of a matrix
   * @typedef Dimensions
   *
   * @param {number} width - How many columns are in a matrix
   * @param {number} height - How many rows are in a matrix
   */ /**
   * Find the length of the longest row in the provided matrix.
   * @param {Object} matrix
   */ var maxWidth = function maxWidth(matrix) {
        return matrix.reduce(function(greatest, row) {
            return row.length > greatest ? row.length : greatest;
        }, 0);
    };
    /**
   * Get the height of a matrix.
   * @param {Object} matrix
   */ var height = function height(matrix) {
        return matrix.length;
    };
    /**
   * @module Matrix
   */ /**
   * @callback CellComparator
   *
   * @param {Object} cell - the cell's value at the current location
   * @param {Location} location - the location being checked
   *
   * @returns {boolean} true if this cell/location satisfies the condition
   */ /**
   * @description Search a provided matrix for the first cell that satisfies
   * the provided comparator's condition. Returns that cell's value.
   *
   * @param {CellComparator} comparator - callback to check if any given cell
   * or location should be found.
   * @param {Object[][]} matrix - matrix to be searched
   *
   * @returns {(Object|undefined)} the found value or undefined if nothing
   * matching the comparator was found.
   */ var findValue = ramda.curry(function(comparator, matrix) {
        var found;
        for(var row = 0; row < height(matrix) && !found; row++){
            for(var col = 0; col < maxWidth(matrix) && !found; col++)if (comparator(matrix[row][col], {
                row: row,
                col: col
            })) found = matrix[row][col];
        }
        return found;
    });
    /**
   * @description Search a provided matrix for the first cell that satisfies
   * the provided comparator's condition. Return's that cell's location.
   *
   * @param {CellComparator} comparator - callback to check if any given cell
   * or location should be found.
   * @param {Object[][]} matrix - matrix to be searched
   *
   * @returns {(Location|undefined)} the found value or undefined if nothing
   * matching the comparator was found.
   */ var findLocation = ramda.curry(function(comparator, matrix) {
        var found = false;
        var location = {};
        for(var row = 0; row < height(matrix) && !found; row++){
            for(var col = 0; col < maxWidth(matrix) && !found; col++)if (comparator(matrix[row][col], {
                row: row,
                col: col
            })) {
                found = true;
                location = {
                    row: row,
                    col: col
                };
            }
        }
        return found ? location : undefined;
    });
    /**
   * @description Search a provided matrix for the all cell that satisfy
   * the provided comparator's condition. Returns all matching locations.
   *
   * @param {CellComparator} comparator - callback to check if any given cell
   * or location should be found.
   * @param {Object[][]} matrix - matrix to be searched
   *
   * @returns {Location[]} array containing all matching locations in the
   * provided matrix.
   */ var findLocations = ramda.curry(function(comparator, matrix) {
        var matches = [];
        for(var row = 0; row < height(matrix); row++){
            for(var col = 0; col < maxWidth(matrix); col++)if (comparator(matrix[row][col], {
                row: row,
                col: col
            })) matches.push({
                row: row,
                col: col
            });
        }
        return matches;
    });
    // `RegExp.prototype.flags` getter implementation
    // https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
    var regexpFlags = function() {
        var that = anObject(this);
        var result = "";
        if (that.global) result += "g";
        if (that.ignoreCase) result += "i";
        if (that.multiline) result += "m";
        if (that.unicode) result += "u";
        if (that.sticky) result += "y";
        return result;
    };
    var nativeExec = RegExp.prototype.exec;
    // This always refers to the native implementation, because the
    // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
    // which loads this file before patching the method.
    var nativeReplace = String.prototype.replace;
    var patchedExec = nativeExec;
    var UPDATES_LAST_INDEX_WRONG = function() {
        var re1 = /a/;
        var re2 = /b*/g;
        nativeExec.call(re1, "a");
        nativeExec.call(re2, "a");
        return re1.lastIndex !== 0 || re2.lastIndex !== 0;
    }();
    // nonparticipating capturing group, copied from es5-shim's String#split patch.
    var NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
    var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
    if (PATCH) patchedExec = function exec(str) {
        var re = this;
        var lastIndex, reCopy, match, i;
        if (NPCG_INCLUDED) reCopy = new RegExp("^" + re.source + "$(?!\\s)", regexpFlags.call(re));
        if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
        match = nativeExec.call(re, str);
        if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
        if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
        // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
        nativeReplace.call(match[0], reCopy, function() {
            for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
        });
        return match;
    };
    var regexpExec = patchedExec;
    _export({
        target: "RegExp",
        proto: true,
        forced: /./.exec !== regexpExec
    }, {
        exec: regexpExec
    });
    var MATCH = wellKnownSymbol("match");
    // `IsRegExp` abstract operation
    // https://tc39.github.io/ecma262/#sec-isregexp
    var isRegexp = function(it) {
        var isRegExp;
        return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == "RegExp");
    };
    var SPECIES$2 = wellKnownSymbol("species");
    // `SpeciesConstructor` abstract operation
    // https://tc39.github.io/ecma262/#sec-speciesconstructor
    var speciesConstructor = function(O, defaultConstructor) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES$2]) == undefined ? defaultConstructor : aFunction(S);
    };
    // CONVERT_TO_STRING: true  -> String#at
    // CONVERT_TO_STRING: false -> String#codePointAt
    var stringAt = function(that, pos, CONVERT_TO_STRING) {
        var S = String(requireObjectCoercible(that));
        var position = toInteger(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = S.charCodeAt(position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
    // `AdvanceStringIndex` abstract operation
    // https://tc39.github.io/ecma262/#sec-advancestringindex
    var advanceStringIndex = function(S, index, unicode) {
        return index + (unicode ? stringAt(S, index, true).length : 1);
    };
    // `RegExpExec` abstract operation
    // https://tc39.github.io/ecma262/#sec-regexpexec
    var regexpExecAbstract = function(R, S) {
        var exec = R.exec;
        if (typeof exec === "function") {
            var result = exec.call(R, S);
            if (typeof result !== "object") throw TypeError("RegExp exec method returned something other than an Object or null");
            return result;
        }
        if (classofRaw(R) !== "RegExp") throw TypeError("RegExp#exec called on incompatible receiver");
        return regexpExec.call(R, S);
    };
    var SPECIES$3 = wellKnownSymbol("species");
    var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
        // #replace needs built-in support for named groups.
        // #match works fine because it just return the exec results, even if it has
        // a "grops" property.
        var re = /./;
        re.exec = function() {
            var result = [];
            result.groups = {
                a: "7"
            };
            return result;
        };
        return "".replace(re, "$<a>") !== "7";
    });
    // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
    // Weex JS has frozen built-in prototypes, so use try / catch wrapper
    var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
        var re = /(?:)/;
        var originalExec = re.exec;
        re.exec = function() {
            return originalExec.apply(this, arguments);
        };
        var result = "ab".split(re);
        return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
    });
    var fixRegexpWellKnownSymbolLogic = function(KEY, length, exec, sham) {
        var SYMBOL = wellKnownSymbol(KEY);
        var DELEGATES_TO_SYMBOL = !fails(function() {
            // String methods call symbol-named RegEp methods
            var O = {};
            O[SYMBOL] = function() {
                return 7;
            };
            return ""[KEY](O) != 7;
        });
        var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
            // Symbol-named RegExp methods call .exec
            var execCalled = false;
            var re = /a/;
            re.exec = function() {
                execCalled = true;
                return null;
            };
            if (KEY === "split") {
                // RegExp[@@split] doesn't call the regex's exec method, but first creates
                // a new one. We need to return the patched regex when creating the new one.
                re.constructor = {};
                re.constructor[SPECIES$3] = function() {
                    return re;
                };
            }
            re[SYMBOL]("");
            return !execCalled;
        });
        if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === "replace" && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === "split" && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
            var nativeRegExpMethod = /./[SYMBOL];
            var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
                if (regexp.exec === regexpExec) {
                    if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                    // polyfilled function), leasing to infinite recursion.
                    // We avoid it by directly calling the native @@method method.
                    return {
                        done: true,
                        value: nativeRegExpMethod.call(regexp, str, arg2)
                    };
                    return {
                        done: true,
                        value: nativeMethod.call(str, regexp, arg2)
                    };
                }
                return {
                    done: false
                };
            });
            var stringMethod = methods[0];
            var regexMethod = methods[1];
            redefine(String.prototype, KEY, stringMethod);
            redefine(RegExp.prototype, SYMBOL, length == 2 ? function(string, arg) {
                return regexMethod.call(string, this, arg);
            } : function(string) {
                return regexMethod.call(string, this);
            });
            if (sham) hide(RegExp.prototype[SYMBOL], "sham", true);
        }
    };
    var arrayPush = [].push;
    var min$2 = Math.min;
    var MAX_UINT32 = 0xFFFFFFFF;
    // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
    var SUPPORTS_Y = !fails(function() {
        return !RegExp(MAX_UINT32, "y");
    });
    // @@split logic
    fixRegexpWellKnownSymbolLogic("split", 2, function(SPLIT, nativeSplit, maybeCallNative) {
        var internalSplit;
        if ("abbc".split(/(b)*/)[1] == "c" || "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
        internalSplit = function(separator, limit) {
            var string = String(requireObjectCoercible(this));
            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (separator === undefined) return [
                string
            ];
            // If `separator` is not a regex, use native split
            if (!isRegexp(separator)) return nativeSplit.call(string, separator, lim);
            var output = [];
            var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
            var lastLastIndex = 0;
            // Make `global` and avoid `lastIndex` issues by working with a copy
            var separatorCopy = new RegExp(separator.source, flags + "g");
            var match, lastIndex, lastLength;
            while(match = regexpExec.call(separatorCopy, string)){
                lastIndex = separatorCopy.lastIndex;
                if (lastIndex > lastLastIndex) {
                    output.push(string.slice(lastLastIndex, match.index));
                    if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
                    lastLength = match[0].length;
                    lastLastIndex = lastIndex;
                    if (output.length >= lim) break;
                }
                if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
            }
            if (lastLastIndex === string.length) {
                if (lastLength || !separatorCopy.test("")) output.push("");
            } else output.push(string.slice(lastLastIndex));
            return output.length > lim ? output.slice(0, lim) : output;
        };
        else if ("0".split(undefined, 0).length) internalSplit = function(separator, limit) {
            return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
        };
        else internalSplit = nativeSplit;
        return [
            // `String.prototype.split` method
            // https://tc39.github.io/ecma262/#sec-string.prototype.split
            function split(separator, limit) {
                var O = requireObjectCoercible(this);
                var splitter = separator == undefined ? undefined : separator[SPLIT];
                return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
            },
            // `RegExp.prototype[@@split]` method
            // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
            //
            // NOTE: This cannot be properly polyfilled in engines that don't support
            // the 'y' flag.
            function(regexp, limit) {
                var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
                if (res.done) return res.value;
                var rx = anObject(regexp);
                var S = String(this);
                var C = speciesConstructor(rx, RegExp);
                var unicodeMatching = rx.unicode;
                var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + (SUPPORTS_Y ? "y" : "g");
                // ^(? + rx + ) is needed, in combination with some S slicing, to
                // simulate the 'y' flag.
                var splitter = new C(SUPPORTS_Y ? rx : "^(?:" + rx.source + ")", flags);
                var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                if (lim === 0) return [];
                if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [
                    S
                ] : [];
                var p = 0;
                var q = 0;
                var A = [];
                while(q < S.length){
                    splitter.lastIndex = SUPPORTS_Y ? q : 0;
                    var z = regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
                    var e;
                    if (z === null || (e = min$2(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) q = advanceStringIndex(S, q, unicodeMatching);
                    else {
                        A.push(S.slice(p, q));
                        if (A.length === lim) return A;
                        for(var i = 1; i <= z.length - 1; i++){
                            A.push(z[i]);
                            if (A.length === lim) return A;
                        }
                        q = p = e;
                    }
                }
                A.push(S.slice(p));
                return A;
            }
        ];
    }, !SUPPORTS_Y);
    var TemplateTag_1 = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        var _createClass = function() {
            function defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        var _templateObject = _taggedTemplateLiteral([
            "",
            ""
        ], [
            "",
            ""
        ]);
        function _taggedTemplateLiteral(strings, raw) {
            return Object.freeze(Object.defineProperties(strings, {
                raw: {
                    value: Object.freeze(raw)
                }
            }));
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        /**
   * @class TemplateTag
   * @classdesc Consumes a pipeline of composable transformer plugins and produces a template tag.
   */ var TemplateTag = function() {
            /**
     * constructs a template tag
     * @constructs TemplateTag
     * @param  {...Object} [...transformers] - an array or arguments list of transformers
     * @return {Function}                    - a template tag
     */ function TemplateTag() {
                var _this = this;
                for(var _len = arguments.length, transformers = Array(_len), _key = 0; _key < _len; _key++)transformers[_key] = arguments[_key];
                _classCallCheck(this, TemplateTag);
                this.tag = function(strings) {
                    for(var _len2 = arguments.length, expressions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)expressions[_key2 - 1] = arguments[_key2];
                    if (typeof strings === "function") // if the first argument passed is a function, assume it is a template tag and return
                    // an intermediary tag that processes the template using the aforementioned tag, passing the
                    // result to our tag
                    return _this.interimTag.bind(_this, strings);
                    if (typeof strings === "string") // if the first argument passed is a string, just transform it
                    return _this.transformEndResult(strings);
                    // else, return a transformed end result of processing the template with our tag
                    strings = strings.map(_this.transformString.bind(_this));
                    return _this.transformEndResult(strings.reduce(_this.processSubstitutions.bind(_this, expressions)));
                };
                // if first argument is an array, extrude it as a list of transformers
                if (transformers.length > 0 && Array.isArray(transformers[0])) transformers = transformers[0];
                // if any transformers are functions, this means they are not initiated - automatically initiate them
                this.transformers = transformers.map(function(transformer) {
                    return typeof transformer === "function" ? transformer() : transformer;
                });
                // return an ES2015 template tag
                return this.tag;
            }
            /**
     * Applies all transformers to a template literal tagged with this method.
     * If a function is passed as the first argument, assumes the function is a template tag
     * and applies it to the template, returning a template tag.
     * @param  {(Function|String|Array<String>)} strings        - Either a template tag or an array containing template strings separated by identifier
     * @param  {...*}                            ...expressions - Optional list of substitution values.
     * @return {(String|Function)}                              - Either an intermediary tag function or the results of processing the template.
     */ _createClass(TemplateTag, [
                {
                    key: "interimTag",
                    /**
       * An intermediary template tag that receives a template tag and passes the result of calling the template with the received
       * template tag to our own template tag.
       * @param  {Function}        nextTag          - the received template tag
       * @param  {Array<String>}   template         - the template to process
       * @param  {...*}            ...substitutions - `substitutions` is an array of all substitutions in the template
       * @return {*}                                - the final processed value
       */ value: function interimTag(previousTag, template) {
                        for(var _len3 = arguments.length, substitutions = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)substitutions[_key3 - 2] = arguments[_key3];
                        return this.tag(_templateObject, previousTag.apply(undefined, [
                            template
                        ].concat(substitutions)));
                    }
                },
                {
                    key: "processSubstitutions",
                    value: function processSubstitutions(substitutions, resultSoFar, remainingPart) {
                        var substitution = this.transformSubstitution(substitutions.shift(), resultSoFar);
                        return "".concat(resultSoFar, substitution, remainingPart);
                    }
                },
                {
                    key: "transformString",
                    value: function transformString(str) {
                        var cb = function cb(res, transform) {
                            return transform.onString ? transform.onString(res) : res;
                        };
                        return this.transformers.reduce(cb, str);
                    }
                },
                {
                    key: "transformSubstitution",
                    value: function transformSubstitution(substitution, resultSoFar) {
                        var cb = function cb(res, transform) {
                            return transform.onSubstitution ? transform.onSubstitution(res, resultSoFar) : res;
                        };
                        return this.transformers.reduce(cb, substitution);
                    }
                },
                {
                    key: "transformEndResult",
                    value: function transformEndResult(endResult) {
                        var cb = function cb(res, transform) {
                            return transform.onEndResult ? transform.onEndResult(res) : res;
                        };
                        return this.transformers.reduce(cb, endResult);
                    }
                }
            ]);
            return TemplateTag;
        }();
        exports1.default = TemplateTag;
        module.exports = exports1["default"];
    });
    unwrapExports(TemplateTag_1);
    var TemplateTag = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        exports1.default = undefined;
        var _TemplateTag2 = _interopRequireDefault(TemplateTag_1);
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        exports1.default = _TemplateTag2.default;
        module.exports = exports1["default"];
    });
    unwrapExports(TemplateTag);
    var stripIndentTransformer_1 = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        function _toConsumableArray(arr) {
            if (Array.isArray(arr)) {
                for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                return arr2;
            } else return Array.from(arr);
        }
        /**
   * strips indentation from a template literal
   * @param  {String} type = 'initial' - whether to remove all indentation or just leading indentation. can be 'all' or 'initial'
   * @return {Object}                  - a TemplateTag transformer
   */ var stripIndentTransformer = function stripIndentTransformer() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "initial";
            return {
                onEndResult: function onEndResult(endResult) {
                    if (type === "initial") {
                        // remove the shortest leading indentation from each line
                        var match = endResult.match(/^[^\S\n]*(?=\S)/gm);
                        var indent = match && Math.min.apply(Math, _toConsumableArray(match.map(function(el) {
                            return el.length;
                        })));
                        if (indent) {
                            var regexp = new RegExp("^.{" + indent + "}", "gm");
                            return endResult.replace(regexp, "");
                        }
                        return endResult;
                    }
                    if (type === "all") // remove all indentation from each line
                    return endResult.replace(/^[^\S\n]+/gm, "");
                    throw new Error("Unknown type: " + type);
                }
            };
        };
        exports1.default = stripIndentTransformer;
        module.exports = exports1["default"];
    });
    unwrapExports(stripIndentTransformer_1);
    var stripIndentTransformer = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        exports1.default = undefined;
        var _stripIndentTransformer2 = _interopRequireDefault(stripIndentTransformer_1);
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        exports1.default = _stripIndentTransformer2.default;
        module.exports = exports1["default"];
    });
    unwrapExports(stripIndentTransformer);
    var trimResultTransformer_1 = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        /**
   * TemplateTag transformer that trims whitespace on the end result of a tagged template
   * @param  {String} side = '' - The side of the string to trim. Can be 'start' or 'end' (alternatively 'left' or 'right')
   * @return {Object}           - a TemplateTag transformer
   */ var trimResultTransformer = function trimResultTransformer() {
            var side = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            return {
                onEndResult: function onEndResult(endResult) {
                    if (side === "") return endResult.trim();
                    side = side.toLowerCase();
                    if (side === "start" || side === "left") return endResult.replace(/^\s*/, "");
                    if (side === "end" || side === "right") return endResult.replace(/\s*$/, "");
                    throw new Error("Side not supported: " + side);
                }
            };
        };
        exports1.default = trimResultTransformer;
        module.exports = exports1["default"];
    });
    unwrapExports(trimResultTransformer_1);
    var trimResultTransformer = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        exports1.default = undefined;
        var _trimResultTransformer2 = _interopRequireDefault(trimResultTransformer_1);
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        exports1.default = _trimResultTransformer2.default;
        module.exports = exports1["default"];
    });
    unwrapExports(trimResultTransformer);
    var stripIndents_1 = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        var _TemplateTag2 = _interopRequireDefault(TemplateTag);
        var _stripIndentTransformer2 = _interopRequireDefault(stripIndentTransformer);
        var _trimResultTransformer2 = _interopRequireDefault(trimResultTransformer);
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        var stripIndents = new _TemplateTag2.default((0, _stripIndentTransformer2.default)("all"), _trimResultTransformer2.default);
        exports1.default = stripIndents;
        module.exports = exports1["default"];
    });
    unwrapExports(stripIndents_1);
    var stripIndents = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        exports1.default = undefined;
        var _stripIndents2 = _interopRequireDefault(stripIndents_1);
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        exports1.default = _stripIndents2.default;
        module.exports = exports1["default"];
    });
    var stripIndents$1 = unwrapExports(stripIndents);
    /**
   * @description A function used to construct the value of a given matrix location.
   *
   * @callback MatrixConstructor
   * @param {Location} location - The location of the constructed value.
   *
   * @returns {Object} The value to be created at this location
   */ /**
   * @description Creates a matrix of the specified dimensions where each location is filled with the
   * result of running the constructor function.
   *
   * @param {MatrixConstructor} constructor - The function used to construct each value of the array.
   * @param {Dimensions} dimensions - The length of the array to be filled.
   * @returns {Object[][]} Newly created matrix of the constructed values.
   */ var constructMatrix = ramda.curry(function(constructor, dimensions) {
        return ramda.pipe(initMatrix, mapMatrix(function(_, location) {
            return constructor(location);
        }))(dimensions);
    });
    /**
   * @description A function used to construct the value of a given matrix location
   * based on an input character.
   *
   * @callback MatrixCharacterMap
   * @param {string} character - Character for the current location
   * @param {Location} location - The location of the constructed value.
   * @param {Object[][]} - the entire template matrix
   *
   * @returns {Object} The value to be created at this location
   */ /**
   * @description Constructs a matrix from a template string. The template string should
   * represent the matrix. Each line of the template string (separated by newlines)
   * represents a row in the matrix. On each line (or row), a column is indicated by a
   * space between characters.
   *
   * @example This template string would create a 3x3 matrix with a different value for
   * the center cell. The mapCharacter function could initialize different data based on
   * this character.
   * . . .
   * . x .
   * . . .
   *
   * @param {MatrixCharacterMap} mapCharacter - function to construct each location based
   * on the character map
   * @param {string} template - a two dimensional string representing the matrix to be created
   *
   * @returns {Object[][]} Newly created matrix of the constructed values.
   */ var constructMatrixFromTemplate = ramda.curry(function(mapCharacter, template) {
        var stripped = stripIndents$1(template);
        var rows = stripped.split("\n");
        var templateMatrix = rows.map(function(row) {
            return row.split(" ");
        });
        return mapMatrix(function(_char, location) {
            return mapCharacter(_char, location, templateMatrix);
        })(templateMatrix);
    });
    /**
   * @module Matrix
   */ /**
   * @description Returns an array of all locations connected to
   * the starting open locations. Connections defined by getNeighbors
   * and isLocationValid functions.
   *
   * @param {getNeighbors} getNeighbors
   * @param {CellComparator} isLocationValid
   * @param {Object[][]} matrix
   * @param {Location[]} open - locations to start floodfilling from
   * @param {Location[]} closed - usually empty, locations here will not
   * be checked by the floodfill algorithm.
   * @param {Location[]} found - usually empty, locations here will be
   * returned by the floodfill function. If this array contains locations
   * that the algorithm will find on its own, these values will be
   * duplicated. This function does not guarantee uniqueness in that case.
   *
   * @returns {Location[]} flooded locations
   */ var floodFill = function floodFill(getNeighbors, isLocationValid, matrix, open, closed, found) {
        if (open.length === 0) // exit case, we've found all connected locations
        return found;
         // get next open location
        var location = open.pop();
        if (isLocationValid(getLocation(matrix, location), location, matrix)) {
            // mark location as found
            found.push(location); // add all the neighbors
            var neighbors = getNeighbors(matrix, location);
            neighbors.forEach(function(neighbor) {
                if (!containsLocation(closed, neighbor) && !containsLocation(open, neighbor)) // if location not already closed or open, push it into open
                open.push(neighbor);
            });
        } // close current location
        closed.push(location);
        return floodFill(getNeighbors, isLocationValid, matrix, open, closed, found);
    };
    var max$1 = Math.max;
    var min$3 = Math.min;
    var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = "Maximum allowed length exceeded";
    var SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport("splice");
    // `Array.prototype.splice` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.splice
    // with adding support of @@species
    _export({
        target: "Array",
        proto: true,
        forced: !SPECIES_SUPPORT$3
    }, {
        splice: function splice(start, deleteCount /* , ...items */ ) {
            var O = toObject(this);
            var len = toLength(O.length);
            var actualStart = toAbsoluteIndex(start, len);
            var argumentsLength = arguments.length;
            var insertCount, actualDeleteCount, A, k, from, to;
            if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
            else if (argumentsLength === 1) {
                insertCount = 0;
                actualDeleteCount = len - actualStart;
            } else {
                insertCount = argumentsLength - 2;
                actualDeleteCount = min$3(max$1(toInteger(deleteCount), 0), len - actualStart);
            }
            if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER$1) throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
            A = arraySpeciesCreate(O, actualDeleteCount);
            for(k = 0; k < actualDeleteCount; k++){
                from = actualStart + k;
                if (from in O) createProperty(A, k, O[from]);
            }
            A.length = actualDeleteCount;
            if (insertCount < actualDeleteCount) {
                for(k = actualStart; k < len - actualDeleteCount; k++){
                    from = k + actualDeleteCount;
                    to = k + insertCount;
                    if (from in O) O[to] = O[from];
                    else delete O[to];
                }
                for(k = len; k > len - actualDeleteCount + insertCount; k--)delete O[k - 1];
            } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
                from = k + actualDeleteCount - 1;
                to = k + insertCount - 1;
                if (from in O) O[to] = O[from];
                else delete O[to];
            }
            for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
            O.length = len - actualDeleteCount + insertCount;
            return A;
        }
    });
    var findPath = function findPath(trackingMatrix, location) {
        var _getLocation = getLocation(trackingMatrix, location), parent = _getLocation.parent;
        if (!parent) return [
            location
        ];
        return [].concat(_toConsumableArray(findPath(trackingMatrix, parent)), [
            location
        ]);
    };
    var createTrackingMatrix = function createTrackingMatrix(matrix, start, target, heuristicFn) {
        var dimensions = getDimensions(matrix);
        var trackingMatrix = constructMatrix(function() {
            return {
                heuristicDistance: Infinity,
                distanceFromStart: Infinity
            };
        })(dimensions);
        var trackingMatrixWithStartMarked = updateMatrix(start, {
            heuristicDistance: heuristicFn(start, target),
            distanceFromStart: 0,
            parent: null
        }, trackingMatrix);
        return trackingMatrixWithStartMarked;
    };
    /*
   *
   *
   * A-Star Adaptation based on:
   * https://briangrinstead.com/blog/astar-search-algorithm-in-javascript/
   *
   * @param {*} getNeighbors
   * @param {*} isLocationValid
   * @param {*} matrix
   * @param {*} trackingMatrix
   * @param {*} target
   * @param {*} open
   * @param {*} closed
   * @param {*} distance
   * @param {*} heuristicFn
   */ var createPath = function createPath(getNeighbors, isLocationValid, matrix, trackingMatrix, target, open, closed, heuristicFn) {
        if (open.length === 0) // exit case, could not find target
        return undefined;
        var updatedTrackingMatrix = ramda.clone(trackingMatrix); // get next open location nearest to current location
        var locationIndex = findBestMatch(function(openLocation) {
            var _getLocation2 = getLocation(trackingMatrix, openLocation), heuristicDistance = _getLocation2.heuristicDistance, distanceFromStart = _getLocation2.distanceFromStart;
            return heuristicDistance + distanceFromStart;
        }, function(currentBest, evaluated) {
            if (evaluated < currentBest) return true;
            return false;
        }, open); // remove found location from open list
        var _open$splice = open.splice(locationIndex, 1), _open$splice2 = _slicedToArray(_open$splice, 1), location = _open$splice2[0]; // console.log("location -- ", location, open, trackingMatrix);
        if (isLocationValid(getLocation(matrix, location), location, matrix)) {
            // record our distance somehow
            if (compareLocations(location, target)) // exit case, we found our destination, return the end of our path
            return findPath(trackingMatrix, location);
             // open all the neighbors
            var neighbors = getNeighbors(matrix, location);
            neighbors.forEach(function(neighbor) {
                if (!containsLocation(closed, neighbor)) {
                    var isNewDistanceShortest = false;
                    var neighborHeuristicDistance = heuristicFn(neighbor, target);
                    var neighborDistanceFromStart = getLocation(trackingMatrix, location).distanceFromStart + 1;
                    if (!containsLocation(open, neighbor)) {
                        // no other distance tracked for this neighbor, it must be shortest
                        isNewDistanceShortest = true; // if location not already closed or open, push it into open
                        open.push(neighbor);
                    } // is neighbor's tracked distanceFromStart worse than the one we just calcuated?
                    if (neighborDistanceFromStart < getLocation(trackingMatrix, neighbor).distanceFromStart) // we have found a shorter path to our neighbor
                    isNewDistanceShortest = true;
                    if (isNewDistanceShortest) // updateTracking data
                    updatedTrackingMatrix = updateMatrix(neighbor, {
                        heuristicDistance: neighborHeuristicDistance,
                        distanceFromStart: neighborDistanceFromStart,
                        parent: location
                    }, updatedTrackingMatrix);
                }
            });
        } // close this location so we don't evaluate it again
        closed.push(location); // evaluate next location
        var path = createPath(getNeighbors, isLocationValid, matrix, updatedTrackingMatrix, target, open, closed, heuristicFn); // a path was found to target node, add our current location as a member of the path
        if (path) return path;
         // there is no path to the target along this node
        return undefined;
    };
    /**
   * @description Find the path from a start location to a target location
   * using the specified matrix and parameters.
   *
   * @param {getNeighbors} getNeighbors
   * @param {CellComparator} isLocationValid
   * @param {Objet[][]} matrix
   * @param {Location} start
   * @param {Location} target
   *
   * @returns {Location[]} array of locations leading from the start location
   * to the target location, including the start and target locations on either
   * end of the array.
   */ var getPath = ramda.curry(function(getNeighbors, isLocationValid, matrix, start, target) {
        var heuristicFn = manhattanDistance;
        var trackingMatrix = createTrackingMatrix(matrix, start, target, heuristicFn);
        return createPath(getNeighbors, isLocationValid, matrix, trackingMatrix, target, [
            start
        ], [], heuristicFn);
    });
    var internalSome = arrayMethods(3);
    var SLOPPY_METHOD$2 = sloppyArrayMethod("some");
    // `Array.prototype.some` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.some
    _export({
        target: "Array",
        proto: true,
        forced: SLOPPY_METHOD$2
    }, {
        some: function some(callbackfn /* , thisArg */ ) {
            return internalSome(this, callbackfn, arguments[1]);
        }
    });
    var defineProperty = objectDefineProperty.f;
    var TO_STRING_TAG = wellKnownSymbol("toStringTag");
    var setToStringTag = function(it, TAG, STATIC) {
        if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) defineProperty(it, TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
    };
    var f$5 = wellKnownSymbol;
    var wrappedWellKnownSymbol = {
        f: f$5
    };
    var path = global;
    var defineProperty$1 = objectDefineProperty.f;
    var defineWellKnownSymbol = function(NAME) {
        var Symbol1 = path.Symbol || (path.Symbol = {});
        if (!has(Symbol1, NAME)) defineProperty$1(Symbol1, NAME, {
            value: wrappedWellKnownSymbol.f(NAME)
        });
    };
    // all enumerable object keys, includes symbols
    var enumKeys = function(it) {
        var result = objectKeys(it);
        var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
        if (getOwnPropertySymbols) {
            var symbols = getOwnPropertySymbols(it);
            var propertyIsEnumerable = objectPropertyIsEnumerable.f;
            var i = 0;
            var key;
            while(symbols.length > i)if (propertyIsEnumerable.call(it, key = symbols[i++])) result.push(key);
        }
        return result;
    };
    // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
    var nativeGetOwnPropertyNames = objectGetOwnPropertyNames.f;
    var toString$1 = {}.toString;
    var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    var getWindowNames = function(it) {
        try {
            return nativeGetOwnPropertyNames(it);
        } catch (error) {
            return windowNames.slice();
        }
    };
    var f$6 = function getOwnPropertyNames(it) {
        return windowNames && toString$1.call(it) == "[object Window]" ? getWindowNames(it) : nativeGetOwnPropertyNames(toIndexedObject(it));
    };
    var objectGetOwnPropertyNamesExternal = {
        f: f$6
    };
    // ECMAScript 6 symbols shim
    var HIDDEN = sharedKey("hidden");
    var SYMBOL = "Symbol";
    var setInternalState = internalState.set;
    var getInternalState = internalState.getterFor(SYMBOL);
    var nativeGetOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
    var nativeDefineProperty$1 = objectDefineProperty.f;
    var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f;
    var $Symbol = global.Symbol;
    var JSON$1 = global.JSON;
    var nativeJSONStringify = JSON$1 && JSON$1.stringify;
    var PROTOTYPE$1 = "prototype";
    var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
    var nativePropertyIsEnumerable$1 = objectPropertyIsEnumerable.f;
    var SymbolRegistry = shared("symbol-registry");
    var AllSymbols = shared("symbols");
    var ObjectPrototypeSymbols = shared("op-symbols");
    var WellKnownSymbolsStore = shared("wks");
    var ObjectPrototype = Object[PROTOTYPE$1];
    var QObject = global.QObject;
    // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
    var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;
    // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
    var setSymbolDescriptor = descriptors && fails(function() {
        return objectCreate(nativeDefineProperty$1({}, "a", {
            get: function() {
                return nativeDefineProperty$1(this, "a", {
                    value: 7
                }).a;
            }
        })).a != 7;
    }) ? function(it, key, D) {
        var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$2(ObjectPrototype, key);
        if (ObjectPrototypeDescriptor) delete ObjectPrototype[key];
        nativeDefineProperty$1(it, key, D);
        if (ObjectPrototypeDescriptor && it !== ObjectPrototype) nativeDefineProperty$1(ObjectPrototype, key, ObjectPrototypeDescriptor);
    } : nativeDefineProperty$1;
    var wrap = function(tag, description) {
        var symbol = AllSymbols[tag] = objectCreate($Symbol[PROTOTYPE$1]);
        setInternalState(symbol, {
            type: SYMBOL,
            tag: tag,
            description: description
        });
        if (!descriptors) symbol.description = description;
        return symbol;
    };
    var isSymbol = nativeSymbol && typeof $Symbol.iterator == "symbol" ? function(it) {
        return typeof it == "symbol";
    } : function(it) {
        return Object(it) instanceof $Symbol;
    };
    var $defineProperty = function defineProperty(it, key, D) {
        if (it === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, key, D);
        anObject(it);
        key = toPrimitive(key, true);
        anObject(D);
        if (has(AllSymbols, key)) {
            if (!D.enumerable) {
                if (!has(it, HIDDEN)) nativeDefineProperty$1(it, HIDDEN, createPropertyDescriptor(1, {}));
                it[HIDDEN][key] = true;
            } else {
                if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
                D = objectCreate(D, {
                    enumerable: createPropertyDescriptor(0, false)
                });
            }
            return setSymbolDescriptor(it, key, D);
        }
        return nativeDefineProperty$1(it, key, D);
    };
    var $defineProperties = function defineProperties(it, P) {
        anObject(it);
        var keys = enumKeys(P = toIndexedObject(P));
        var i = 0;
        var l = keys.length;
        var key;
        while(l > i)$defineProperty(it, key = keys[i++], P[key]);
        return it;
    };
    var $create = function create(it, P) {
        return P === undefined ? objectCreate(it) : $defineProperties(objectCreate(it), P);
    };
    var $propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = nativePropertyIsEnumerable$1.call(this, key = toPrimitive(key, true));
        if (this === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return false;
        return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
    };
    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
        it = toIndexedObject(it);
        key = toPrimitive(key, true);
        if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
        var D = nativeGetOwnPropertyDescriptor$2(it, key);
        if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
        return D;
    };
    var $getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = nativeGetOwnPropertyNames$1(toIndexedObject(it));
        var result = [];
        var i = 0;
        var key;
        while(names.length > i)if (!has(AllSymbols, key = names[i++]) && !has(hiddenKeys, key)) result.push(key);
        return result;
    };
    var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === ObjectPrototype;
        var names = nativeGetOwnPropertyNames$1(IS_OP ? ObjectPrototypeSymbols : toIndexedObject(it));
        var result = [];
        var i = 0;
        var key;
        while(names.length > i)if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectPrototype, key) : true)) result.push(AllSymbols[key]);
        return result;
    };
    // `Symbol` constructor
    // https://tc39.github.io/ecma262/#sec-symbol-constructor
    if (!nativeSymbol) {
        $Symbol = function Symbol1() {
            if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor");
            var description = arguments[0] === undefined ? undefined : String(arguments[0]);
            var tag = uid(description);
            var setter = function(value) {
                if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
                if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
            };
            if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
                configurable: true,
                set: setter
            });
            return wrap(tag, description);
        };
        redefine($Symbol[PROTOTYPE$1], "toString", function toString() {
            return getInternalState(this).tag;
        });
        objectPropertyIsEnumerable.f = $propertyIsEnumerable;
        objectDefineProperty.f = $defineProperty;
        objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor;
        objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames;
        objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;
        if (descriptors) {
            // https://github.com/tc39/proposal-Symbol-description
            nativeDefineProperty$1($Symbol[PROTOTYPE$1], "description", {
                configurable: true,
                get: function description() {
                    return getInternalState(this).description;
                }
            });
            redefine(ObjectPrototype, "propertyIsEnumerable", $propertyIsEnumerable, {
                unsafe: true
            });
        }
        wrappedWellKnownSymbol.f = function(name) {
            return wrap(wellKnownSymbol(name), name);
        };
    }
    _export({
        global: true,
        wrap: true,
        forced: !nativeSymbol,
        sham: !nativeSymbol
    }, {
        Symbol: $Symbol
    });
    for(var wellKnownSymbols = objectKeys(WellKnownSymbolsStore), k = 0; wellKnownSymbols.length > k;)defineWellKnownSymbol(wellKnownSymbols[k++]);
    _export({
        target: SYMBOL,
        stat: true,
        forced: !nativeSymbol
    }, {
        // `Symbol.for` method
        // https://tc39.github.io/ecma262/#sec-symbol.for
        "for": function(key) {
            return has(SymbolRegistry, key += "") ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
        },
        // `Symbol.keyFor` method
        // https://tc39.github.io/ecma262/#sec-symbol.keyfor
        keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol");
            for(var key in SymbolRegistry)if (SymbolRegistry[key] === sym) return key;
        },
        useSetter: function() {
            USE_SETTER = true;
        },
        useSimple: function() {
            USE_SETTER = false;
        }
    });
    _export({
        target: "Object",
        stat: true,
        forced: !nativeSymbol,
        sham: !descriptors
    }, {
        // `Object.create` method
        // https://tc39.github.io/ecma262/#sec-object.create
        create: $create,
        // `Object.defineProperty` method
        // https://tc39.github.io/ecma262/#sec-object.defineproperty
        defineProperty: $defineProperty,
        // `Object.defineProperties` method
        // https://tc39.github.io/ecma262/#sec-object.defineproperties
        defineProperties: $defineProperties,
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor
    });
    _export({
        target: "Object",
        stat: true,
        forced: !nativeSymbol
    }, {
        // `Object.getOwnPropertyNames` method
        // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
        getOwnPropertyNames: $getOwnPropertyNames,
        // `Object.getOwnPropertySymbols` method
        // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
        getOwnPropertySymbols: $getOwnPropertySymbols
    });
    // `JSON.stringify` method behavior with symbols
    // https://tc39.github.io/ecma262/#sec-json.stringify
    JSON$1 && _export({
        target: "JSON",
        stat: true,
        forced: !nativeSymbol || fails(function() {
            var symbol = $Symbol();
            // MS Edge converts symbol values to JSON as {}
            return nativeJSONStringify([
                symbol
            ]) != "[null]" || nativeJSONStringify({
                a: symbol
            }) != "{}" || nativeJSONStringify(Object(symbol)) != "{}";
        })
    }, {
        stringify: function stringify(it) {
            var args = [
                it
            ];
            var i = 1;
            var replacer, $replacer;
            while(arguments.length > i)args.push(arguments[i++]);
            $replacer = replacer = args[1];
            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
            if (!isArray(replacer)) replacer = function(key, value) {
                if (typeof $replacer == "function") value = $replacer.call(this, key, value);
                if (!isSymbol(value)) return value;
            };
            args[1] = replacer;
            return nativeJSONStringify.apply(JSON$1, args);
        }
    });
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
    if (!$Symbol[PROTOTYPE$1][TO_PRIMITIVE]) hide($Symbol[PROTOTYPE$1], TO_PRIMITIVE, $Symbol[PROTOTYPE$1].valueOf);
    // `Symbol.prototype[@@toStringTag]` property
    // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
    setToStringTag($Symbol, SYMBOL);
    hiddenKeys[HIDDEN] = true;
    var defineProperty$2 = objectDefineProperty.f;
    var NativeSymbol = global.Symbol;
    if (descriptors && typeof NativeSymbol == "function" && (!("description" in NativeSymbol.prototype) || // Safari 12 bug
    NativeSymbol().description !== undefined)) {
        var EmptyStringDescriptionStore = {};
        // wrap Symbol constructor for correct work with undefined description
        var SymbolWrapper = function Symbol1() {
            var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
            var result = this instanceof SymbolWrapper ? new NativeSymbol(description) : description === undefined ? NativeSymbol() : NativeSymbol(description);
            if (description === "") EmptyStringDescriptionStore[result] = true;
            return result;
        };
        copyConstructorProperties(SymbolWrapper, NativeSymbol);
        var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
        symbolPrototype.constructor = SymbolWrapper;
        var symbolToString = symbolPrototype.toString;
        var native = String(NativeSymbol("test")) == "Symbol(test)";
        var regexp = /^Symbol\((.*)\)[^)]+$/;
        defineProperty$2(symbolPrototype, "description", {
            configurable: true,
            get: function description() {
                var symbol = isObject(this) ? this.valueOf() : this;
                var string = symbolToString.call(symbol);
                if (has(EmptyStringDescriptionStore, symbol)) return "";
                var desc = native ? string.slice(7, -1) : string.replace(regexp, "$1");
                return desc === "" ? undefined : desc;
            }
        });
        _export({
            global: true,
            forced: true
        }, {
            Symbol: SymbolWrapper
        });
    }
    // `Symbol.iterator` well-known symbol
    // https://tc39.github.io/ecma262/#sec-symbol.iterator
    defineWellKnownSymbol("iterator");
    var correctPrototypeGetter = !fails(function() {
        function F() {}
        F.prototype.constructor = null;
        return Object.getPrototypeOf(new F()) !== F.prototype;
    });
    // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
    var IE_PROTO$1 = sharedKey("IE_PROTO");
    var ObjectPrototype$1 = Object.prototype;
    var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function(O) {
        O = toObject(O);
        if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];
        if (typeof O.constructor == "function" && O instanceof O.constructor) return O.constructor.prototype;
        return O instanceof Object ? ObjectPrototype$1 : null;
    };
    var ITERATOR = wellKnownSymbol("iterator");
    var BUGGY_SAFARI_ITERATORS = false;
    var returnThis = function() {
        return this;
    };
    // `%IteratorPrototype%` object
    // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
    var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
    if ([].keys) {
        arrayIterator = [].keys();
        // Safari 8 has buggy iterators w/o `next`
        if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
        else {
            PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
            if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
        }
    }
    if (IteratorPrototype == undefined) IteratorPrototype = {};
    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
    if (!has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    var iteratorsCore = {
        IteratorPrototype: IteratorPrototype,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
    };
    var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
    var createIteratorConstructor = function(IteratorConstructor, NAME, next) {
        var TO_STRING_TAG = NAME + " Iterator";
        IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
            next: createPropertyDescriptor(1, next)
        });
        setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
        return IteratorConstructor;
    };
    var validateSetPrototypeOfArguments = function(O, proto) {
        anObject(O);
        if (!isObject(proto) && proto !== null) throw TypeError("Can't set " + String(proto) + " as a prototype");
    };
    // Works with __proto__ only. Old v8 can't work with null proto objects.
    /* eslint-disable no-proto */ var objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var correctSetter = false;
        var test = {};
        var setter;
        try {
            setter = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set;
            setter.call(test, []);
            correctSetter = test instanceof Array;
        } catch (error) {}
        return function setPrototypeOf(O, proto) {
            validateSetPrototypeOfArguments(O, proto);
            if (correctSetter) setter.call(O, proto);
            else O.__proto__ = proto;
            return O;
        };
    }() : undefined);
    var ITERATOR$1 = wellKnownSymbol("iterator");
    var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
    var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
    var KEYS = "keys";
    var VALUES = "values";
    var ENTRIES = "entries";
    var returnThis$1 = function() {
        return this;
    };
    var defineIterator = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next);
        var getIterationMethod = function(KIND) {
            if (KIND === DEFAULT && defaultIterator) return defaultIterator;
            if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
            switch(KIND){
                case KEYS:
                    return function keys() {
                        return new IteratorConstructor(this, KIND);
                    };
                case VALUES:
                    return function values() {
                        return new IteratorConstructor(this, KIND);
                    };
                case ENTRIES:
                    return function entries() {
                        return new IteratorConstructor(this, KIND);
                    };
            }
            return function() {
                return new IteratorConstructor(this);
            };
        };
        var TO_STRING_TAG = NAME + " Iterator";
        var INCORRECT_VALUES_NAME = false;
        var IterablePrototype = Iterable.prototype;
        var nativeIterator = IterablePrototype[ITERATOR$1] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
        var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
        var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
        var CurrentIteratorPrototype, methods, KEY;
        // fix native
        if (anyNativeIterator) {
            CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
            if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
                if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
                    if (objectSetPrototypeOf) objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
                    else if (typeof CurrentIteratorPrototype[ITERATOR$1] != "function") hide(CurrentIteratorPrototype, ITERATOR$1, returnThis$1);
                }
                // Set @@toStringTag to native iterators
                setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            }
        }
        // fix Array#{values, @@iterator}.name in V8 / FF
        if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return nativeIterator.call(this);
            };
        }
        // define iterator
        if (IterablePrototype[ITERATOR$1] !== defaultIterator) hide(IterablePrototype, ITERATOR$1, defaultIterator);
        // export additional methods
        if (DEFAULT) {
            methods = {
                values: getIterationMethod(VALUES),
                keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                entries: getIterationMethod(ENTRIES)
            };
            if (FORCED) {
                for(KEY in methods)if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) redefine(IterablePrototype, KEY, methods[KEY]);
            } else _export({
                target: NAME,
                proto: true,
                forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME
            }, methods);
        }
        return methods;
    };
    var ARRAY_ITERATOR = "Array Iterator";
    var setInternalState$1 = internalState.set;
    var getInternalState$1 = internalState.getterFor(ARRAY_ITERATOR);
    // `Array.prototype.entries` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.entries
    // `Array.prototype.keys` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.keys
    // `Array.prototype.values` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.values
    // `Array.prototype[@@iterator]` method
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
    // `CreateArrayIterator` internal method
    // https://tc39.github.io/ecma262/#sec-createarrayiterator
    var es_array_iterator = defineIterator(Array, "Array", function(iterated, kind) {
        setInternalState$1(this, {
            type: ARRAY_ITERATOR,
            target: toIndexedObject(iterated),
            index: 0,
            kind: kind // kind
        });
    // `%ArrayIteratorPrototype%.next` method
    // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
    }, function() {
        var state = getInternalState$1(this);
        var target = state.target;
        var kind = state.kind;
        var index = state.index++;
        if (!target || index >= target.length) {
            state.target = undefined;
            return {
                value: undefined,
                done: true
            };
        }
        if (kind == "keys") return {
            value: index,
            done: false
        };
        if (kind == "values") return {
            value: target[index],
            done: false
        };
        return {
            value: [
                index,
                target[index]
            ],
            done: false
        };
    }, "values");
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    addToUnscopables("keys");
    addToUnscopables("values");
    addToUnscopables("entries");
    var TO_STRING_TAG$1 = wellKnownSymbol("toStringTag");
    // ES3 wrong here
    var CORRECT_ARGUMENTS = classofRaw(function() {
        return arguments;
    }()) == "Arguments";
    // fallback for IE11 Script Access Denied error
    var tryGet = function(it, key) {
        try {
            return it[key];
        } catch (error) {}
    };
    // getting tag from ES6+ `Object.prototype.toString`
    var classof = function(it) {
        var O, tag, result;
        return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : result;
    };
    var TO_STRING_TAG$2 = wellKnownSymbol("toStringTag");
    var test = {};
    test[TO_STRING_TAG$2] = "z";
    // `Object.prototype.toString` method implementation
    // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
    var objectToString = String(test) !== "[object z]" ? function toString() {
        return "[object " + classof(this) + "]";
    } : test.toString;
    var ObjectPrototype$2 = Object.prototype;
    // `Object.prototype.toString` method
    // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
    if (objectToString !== ObjectPrototype$2.toString) redefine(ObjectPrototype$2, "toString", objectToString, {
        unsafe: true
    });
    var STRING_ITERATOR = "String Iterator";
    var setInternalState$2 = internalState.set;
    var getInternalState$2 = internalState.getterFor(STRING_ITERATOR);
    // `String.prototype[@@iterator]` method
    // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
    defineIterator(String, "String", function(iterated) {
        setInternalState$2(this, {
            type: STRING_ITERATOR,
            string: String(iterated),
            index: 0
        });
    // `%StringIteratorPrototype%.next` method
    // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
    }, function next() {
        var state = getInternalState$2(this);
        var string = state.string;
        var index = state.index;
        var point;
        if (index >= string.length) return {
            value: undefined,
            done: true
        };
        point = stringAt(string, index, true);
        state.index += point.length;
        return {
            value: point,
            done: false
        };
    });
    var ITERATOR$2 = wellKnownSymbol("iterator");
    var TO_STRING_TAG$3 = wellKnownSymbol("toStringTag");
    var ArrayValues = es_array_iterator.values;
    for(var COLLECTION_NAME$1 in domIterables){
        var Collection$1 = global[COLLECTION_NAME$1];
        var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
        if (CollectionPrototype$1) {
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype$1[ITERATOR$2] !== ArrayValues) try {
                hide(CollectionPrototype$1, ITERATOR$2, ArrayValues);
            } catch (error) {
                CollectionPrototype$1[ITERATOR$2] = ArrayValues;
            }
            if (!CollectionPrototype$1[TO_STRING_TAG$3]) hide(CollectionPrototype$1, TO_STRING_TAG$3, COLLECTION_NAME$1);
            if (domIterables[COLLECTION_NAME$1]) for(var METHOD_NAME in es_array_iterator){
                // some Chrome versions have non-configurable methods on DOMTokenList
                if (CollectionPrototype$1[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
                    hide(CollectionPrototype$1, METHOD_NAME, es_array_iterator[METHOD_NAME]);
                } catch (error) {
                    CollectionPrototype$1[METHOD_NAME] = es_array_iterator[METHOD_NAME];
                }
            }
        }
    }
    /**
   * @module Queue
   */ /**
   *
   */ var Queue = /*#__PURE__*/ function() {
        function Queue() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            _classCallCheck(this, Queue);
            // spread items to create a new array if it is iterable
            this.items = items[Symbol.iterator] ? _toConsumableArray(items) : [
                items
            ];
        }
        _createClass(Queue, [
            {
                key: "isEmpty",
                value: function isEmpty() {
                    return this.items.length === 0;
                }
            },
            {
                key: "enqueue",
                value: function enqueue(item) {
                    this.items.push(item);
                }
            },
            {
                key: "dequeue",
                value: function dequeue() {
                    return this.items.shift();
                }
            }
        ]);
        return Queue;
    }();
    var internalFindIndex = arrayMethods(6);
    var FIND_INDEX = "findIndex";
    var SKIPS_HOLES$1 = true;
    // Shouldn't skip holes
    if (FIND_INDEX in []) Array(1)[FIND_INDEX](function() {
        SKIPS_HOLES$1 = false;
    });
    // `Array.prototype.findIndex` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.findindex
    _export({
        target: "Array",
        proto: true,
        forced: SKIPS_HOLES$1
    }, {
        findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
            return internalFindIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    addToUnscopables(FIND_INDEX);
    /**
   * @module Set
   */ /**
   *
   */ var ComparableSet = /*#__PURE__*/ function() {
        function ComparableSet() {
            var comparator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function(a, b) {
                return a === b;
            };
            _classCallCheck(this, ComparableSet);
            this.items = [];
            this.comparator = comparator;
        }
        _createClass(ComparableSet, [
            {
                key: "add",
                value: function add(item) {
                    if (this.contains(item)) return;
                    this.items.push(item);
                }
            },
            {
                key: "contains",
                value: function contains(item) {
                    var _this = this;
                    return this.items.some(function(exisiting) {
                        return _this.comparator(item, exisiting);
                    });
                }
            },
            {
                key: "remove",
                value: function remove(item) {
                    var _this2 = this;
                    var targetIndex = this.items.findIndex(function(exisiting) {
                        return _this2.comparator(item, exisiting);
                    });
                    if (targetIndex === -1) return undefined;
                    var _this$items$splice = this.items.splice(targetIndex, 1), _this$items$splice2 = _slicedToArray(_this$items$splice, 1), target = _this$items$splice2[0];
                    return target;
                }
            },
            {
                key: "size",
                get: function get() {
                    return this.items.length;
                }
            }
        ]);
        return ComparableSet;
    }();
    function createBaseMap(matrix, goals) {
        return mapMatrix(function(value, location) {
            if (goals.some(function(goal) {
                return compareLocations(goal, location);
            })) return 0;
            return Infinity;
        }, matrix);
    }
    /**
   * @description Creates a distance map with the given specifications. A
   * distance map is a matrix. Each call has an integer value. The value
   * is the manhattan distance that cell is from any goal location.
   *
   * AKA a "Djikstra Map" - http://www.roguebasin.com/index.php/Dijkstra_Maps_Visualized
   *
   * @param {getNeighbors} getNeighbors - function defining how to retrieve a
   * cell's neighbors
   * @param {CellComparator} isLocationValid - is a given cell able to be traversed.
   * Could be used to create walls or other impassable terrain.
   * @param {Object[][]} matrix
   * @param {Location[]} goals - array of target cells
   *
   * @returns {number[][]} - matrix containing the calculated distance map
   */ function createDistanceMap(getNeighbors, isLocationValid, matrix, goals) {
        var distances = createBaseMap(matrix, goals);
        var cameFrom = initMatrix(getDimensions(matrix));
        var open = new Queue(goals);
        var closed = new ComparableSet(compareLocations); // close all goals so we don't revisit them
        goals.forEach(function(goal) {
            return closed.add(goal);
        });
        var _loop = function _loop() {
            var current = open.dequeue();
            var neighbors = getNeighbors(matrix, current);
            neighbors.forEach(function(neighbor) {
                if (!closed.contains(neighbor)) {
                    closed.add(neighbor);
                    if (isLocationValid(getLocation(matrix, neighbor), neighbor, matrix)) {
                        open.enqueue(neighbor);
                        cameFrom = updateMatrix(neighbor, current, cameFrom);
                        var distance = getLocation(distances, current) + 1; // if another path is a shorter distance, use that instead
                        if (distance < getLocation(distances, neighbor)) distances = updateMatrix(neighbor, distance, distances);
                    }
                }
            });
        };
        while(!open.isEmpty())_loop();
        return distances;
    }
    /**
   * @module Pathfinding
   */ /**
   * @module Util
   */ /**
   *
   */ var trace = ramda.curry(function(msg, x) {
        return console.log(msg, x), x;
    });
    var DatePrototype = Date.prototype;
    var INVALID_DATE = "Invalid Date";
    var TO_STRING = "toString";
    var nativeDateToString = DatePrototype[TO_STRING];
    var getTime = DatePrototype.getTime;
    // `Date.prototype.toString` method
    // https://tc39.github.io/ecma262/#sec-date.prototype.tostring
    if (new Date(NaN) + "" != INVALID_DATE) redefine(DatePrototype, TO_STRING, function toString() {
        var value = getTime.call(this);
        // eslint-disable-next-line no-self-compare
        return value === value ? nativeDateToString.call(this) : INVALID_DATE;
    });
    var TO_STRING$1 = "toString";
    var nativeToString = /./[TO_STRING$1];
    var NOT_GENERIC = fails(function() {
        return nativeToString.call({
            source: "a",
            flags: "b"
        }) != "/a/b";
    });
    // FF44- RegExp#toString has a wrong name
    var INCORRECT_NAME = nativeToString.name != TO_STRING$1;
    // `RegExp.prototype.toString` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
    if (NOT_GENERIC || INCORRECT_NAME) redefine(RegExp.prototype, TO_STRING$1, function toString() {
        var R = anObject(this);
        return "/".concat(R.source, "/", "flags" in R ? R.flags : !descriptors && R instanceof RegExp ? regexpFlags.call(R) : undefined);
    }, {
        unsafe: true
    });
    var max$2 = Math.max;
    var min$4 = Math.min;
    var floor$1 = Math.floor;
    var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
    var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
    var maybeToString = function(it) {
        return it === undefined ? it : String(it);
    };
    // @@replace logic
    fixRegexpWellKnownSymbolLogic("replace", 2, function(REPLACE, nativeReplace, maybeCallNative) {
        return [
            // `String.prototype.replace` method
            // https://tc39.github.io/ecma262/#sec-string.prototype.replace
            function replace(searchValue, replaceValue) {
                var O = requireObjectCoercible(this);
                var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
                return replacer !== undefined ? replacer.call(searchValue, O, replaceValue) : nativeReplace.call(String(O), searchValue, replaceValue);
            },
            // `RegExp.prototype[@@replace]` method
            // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
            function(regexp, replaceValue) {
                var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
                if (res.done) return res.value;
                var rx = anObject(regexp);
                var S = String(this);
                var functionalReplace = typeof replaceValue === "function";
                if (!functionalReplace) replaceValue = String(replaceValue);
                var global = rx.global;
                if (global) {
                    var fullUnicode = rx.unicode;
                    rx.lastIndex = 0;
                }
                var results = [];
                while(true){
                    var result = regexpExecAbstract(rx, S);
                    if (result === null) break;
                    results.push(result);
                    if (!global) break;
                    var matchStr = String(result[0]);
                    if (matchStr === "") rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                }
                var accumulatedResult = "";
                var nextSourcePosition = 0;
                for(var i = 0; i < results.length; i++){
                    result = results[i];
                    var matched = String(result[0]);
                    var position = max$2(min$4(toInteger(result.index), S.length), 0);
                    var captures = [];
                    // NOTE: This is equivalent to
                    //   captures = result.slice(1).map(maybeToString)
                    // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                    // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                    // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                    for(var j = 1; j < result.length; j++)captures.push(maybeToString(result[j]));
                    var namedCaptures = result.groups;
                    if (functionalReplace) {
                        var replacerArgs = [
                            matched
                        ].concat(captures, position, S);
                        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                        var replacement = String(replaceValue.apply(undefined, replacerArgs));
                    } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                    if (position >= nextSourcePosition) {
                        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                        nextSourcePosition = position + matched.length;
                    }
                }
                return accumulatedResult + S.slice(nextSourcePosition);
            }
        ];
        // https://tc39.github.io/ecma262/#sec-getsubstitution
        function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
            var tailPos = position + matched.length;
            var m = captures.length;
            var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
            if (namedCaptures !== undefined) {
                namedCaptures = toObject(namedCaptures);
                symbols = SUBSTITUTION_SYMBOLS;
            }
            return nativeReplace.call(replacement, symbols, function(match, ch) {
                var capture;
                switch(ch.charAt(0)){
                    case "$":
                        return "$";
                    case "&":
                        return matched;
                    case "`":
                        return str.slice(0, position);
                    case "'":
                        return str.slice(tailPos);
                    case "<":
                        capture = namedCaptures[ch.slice(1, -1)];
                        break;
                    default:
                        var n = +ch;
                        if (n === 0) return match;
                        if (n > m) {
                            var f = floor$1(n / 10);
                            if (f === 0) return match;
                            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                            return match;
                        }
                        capture = captures[n - 1];
                }
                return capture === undefined ? "" : capture;
            });
        }
    });
    /**
   * @module Util
   */ // https://gist.github.com/jed/982883
    /**
   *
   */ function generateUuid(a // placeholder
    ) {
        return a // if the placeholder was passed, return
         ? (a ^ // unless b is 8,
        Math.random() * // in which case
        16 >> // a random number from
        a / 4 // 8 to 11
        ).toString(16) // in hexadecimal
         : "10000000-1000-4000-8000-100000000000" // -100000000000,
        .replace(/[018]/g, generateUuid // random hex digits
        );
    }
    /**
   * @module Util
   */ exports1.AssertionError = AssertionError;
    exports1.ComparableSet = ComparableSet;
    exports1.MATRIX_ROTATION_DIRECTIONS = MATRIX_ROTATION_DIRECTIONS;
    exports1.MATRIX_TRANSLATE_DIRECTIONS = MATRIX_TRANSLATE_DIRECTIONS;
    exports1.Queue = Queue;
    exports1.compareLocations = compareLocations;
    exports1.constructArray = constructArray;
    exports1.constructMatrix = constructMatrix;
    exports1.constructMatrixFromTemplate = constructMatrixFromTemplate;
    exports1.containsLocation = containsLocation;
    exports1.createDistanceMap = createDistanceMap;
    exports1.fillArray = fillArray;
    exports1.fillMatrix = fillMatrix;
    exports1.findBestMatch = findBestMatch;
    exports1.findLocation = findLocation;
    exports1.findLocations = findLocations;
    exports1.findValue = findValue;
    exports1.floodFill = floodFill;
    exports1.generateUuid = generateUuid;
    exports1.getAllDirections = getAllDirections;
    exports1.getCol = getCol;
    exports1.getConnectedDirections = getConnectedDirections;
    exports1.getCrossDirections = getCrossDirections;
    exports1.getDiagonalDirections = getDiagonalDirections;
    exports1.getDimensions = getDimensions;
    exports1.getLocation = getLocation;
    exports1.getNeighbors = getNeighbors;
    exports1.getPath = getPath;
    exports1.getRow = getRow;
    exports1.initArray = initArray;
    exports1.initMatrix = initMatrix;
    exports1.isLocationInBounds = isLocationInBounds;
    exports1.manhattanDistance = manhattanDistance;
    exports1.mapMatrix = mapMatrix;
    exports1.rotateMatrix = rotateMatrix;
    exports1.trace = trace;
    exports1.translateMatrix = translateMatrix;
    exports1.transposeMatrix = transposeMatrix;
    exports1.updateMatrix = updateMatrix;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});




var $bh6RR = parcelRequire("bh6RR");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};


function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $a4c525d7dbc25949$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a4c525d7dbc25949$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9145dbf8e0e857b1$export$2e2bcd8739ae039)(function(prop) {
    return $a4c525d7dbc25949$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $bh6RR = parcelRequire("bh6RR");
var $53a106364dbd0a1b$exports = {};
//
$53a106364dbd0a1b$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$1c5a554c78c0cd12 = "@scope";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $783faa7ec18221fc$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$783faa7ec18221fc$export$4659b591c19bdf3d(e, r);
    });
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$590e8b2c435046d9(e) {
    while(e.root)e = $783faa7ec18221fc$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $783faa7ec18221fc$export$10d8903dec122b9d(e, e.siblings);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(z += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $783faa7ec18221fc$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $783faa7ec18221fc$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(z) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(j = $783faa7ec18221fc$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, j, j, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(z += $783faa7ec18221fc$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) z += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(k = z += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $783faa7ec18221fc$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $783faa7ec18221fc$export$2f35ab04d2335697(e, p + 1, p = $783faa7ec18221fc$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $783faa7ec18221fc$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span", 0) ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch", 0) ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            if (!$783faa7ec18221fc$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


var $e484c752f3f06549$var$f = ("undefined" != typeof $391299e0893a3dfa$exports && void 0 !== $391299e0893a3dfa$exports.env && undefined, "data-styled"), $e484c752f3f06549$var$m = "active", $e484c752f3f06549$var$y = "data-styled-version", $e484c752f3f06549$export$83d89fbfd8236492 = "6.1.13", $e484c752f3f06549$var$g = "/*!sc*/\n", $e484c752f3f06549$var$S = "undefined" != typeof window && "HTMLElement" in window, $e484c752f3f06549$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, "undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, false)), $e484c752f3f06549$var$b = {}, $e484c752f3f06549$var$E = /invalid hook call/i, $e484c752f3f06549$var$N = new Set, $e484c752f3f06549$var$P = function(t, n) {
    var o, s, i, a, e;
}, $e484c752f3f06549$var$_ = Object.freeze([]), $e484c752f3f06549$var$C = Object.freeze({});
function $e484c752f3f06549$var$I(e, t, n) {
    return void 0 === n && (n = $e484c752f3f06549$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e484c752f3f06549$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e484c752f3f06549$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e484c752f3f06549$var$D = /(^-|-$)/g;
function $e484c752f3f06549$var$R(e) {
    return e.replace($e484c752f3f06549$var$O, "-").replace($e484c752f3f06549$var$D, "");
}
var $e484c752f3f06549$var$T = /(a)(d)/gi, $e484c752f3f06549$var$k = 52, $e484c752f3f06549$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e484c752f3f06549$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $e484c752f3f06549$var$k; t = t / $e484c752f3f06549$var$k | 0)n = $e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n;
    return ($e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n).replace($e484c752f3f06549$var$T, "$1-$2");
}
var $e484c752f3f06549$var$V, $e484c752f3f06549$var$F = 5381, $e484c752f3f06549$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e484c752f3f06549$var$z = function(e) {
    return $e484c752f3f06549$var$M($e484c752f3f06549$var$F, e);
};
function $e484c752f3f06549$var$$(e) {
    return $e484c752f3f06549$var$x($e484c752f3f06549$var$z(e) >>> 0);
}
function $e484c752f3f06549$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e484c752f3f06549$var$L(e) {
    return "string" == typeof e && true;
}
var $e484c752f3f06549$var$G = "function" == typeof Symbol && Symbol.for, $e484c752f3f06549$var$Y = $e484c752f3f06549$var$G ? Symbol.for("react.memo") : 60115, $e484c752f3f06549$var$W = $e484c752f3f06549$var$G ? Symbol.for("react.forward_ref") : 60112, $e484c752f3f06549$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e484c752f3f06549$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$J = (($e484c752f3f06549$var$V = {})[$e484c752f3f06549$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e484c752f3f06549$var$V[$e484c752f3f06549$var$Y] = $e484c752f3f06549$var$U, $e484c752f3f06549$var$V);
function $e484c752f3f06549$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e484c752f3f06549$var$Y ? $e484c752f3f06549$var$U : "$$typeof" in e ? $e484c752f3f06549$var$J[e.$$typeof] : $e484c752f3f06549$var$q;
}
var $e484c752f3f06549$var$Z = Object.defineProperty, $e484c752f3f06549$var$K = Object.getOwnPropertyNames, $e484c752f3f06549$var$Q = Object.getOwnPropertySymbols, $e484c752f3f06549$var$ee = Object.getOwnPropertyDescriptor, $e484c752f3f06549$var$te = Object.getPrototypeOf, $e484c752f3f06549$var$ne = Object.prototype;
function $e484c752f3f06549$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($e484c752f3f06549$var$ne) {
            var o = $e484c752f3f06549$var$te(t);
            o && o !== $e484c752f3f06549$var$ne && $e484c752f3f06549$var$oe(e, o, n);
        }
        var r = $e484c752f3f06549$var$K(t);
        $e484c752f3f06549$var$Q && (r = r.concat($e484c752f3f06549$var$Q(t)));
        for(var s = $e484c752f3f06549$var$X(e), i = $e484c752f3f06549$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e484c752f3f06549$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $e484c752f3f06549$var$ee(t, c);
                try {
                    $e484c752f3f06549$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e484c752f3f06549$var$re(e) {
    return "function" == typeof e;
}
function $e484c752f3f06549$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e484c752f3f06549$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e484c752f3f06549$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e484c752f3f06549$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e484c752f3f06549$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e484c752f3f06549$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    else if ($e484c752f3f06549$var$ce(t)) for(var o in t)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    return e;
}
function $e484c752f3f06549$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e484c752f3f06549$var$pe = {};
function $e484c752f3f06549$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e484c752f3f06549$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e484c752f3f06549$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e484c752f3f06549$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($e484c752f3f06549$var$g);
        return t;
    }, e;
}(), $e484c752f3f06549$var$me = 1073741824, $e484c752f3f06549$var$ye = new Map, $e484c752f3f06549$var$ve = new Map, $e484c752f3f06549$var$ge = 1, $e484c752f3f06549$var$Se = function(e) {
    if ($e484c752f3f06549$var$ye.has(e)) return $e484c752f3f06549$var$ye.get(e);
    for(; $e484c752f3f06549$var$ve.has($e484c752f3f06549$var$ge);)$e484c752f3f06549$var$ge++;
    var t = $e484c752f3f06549$var$ge++;
    return $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e), t;
}, $e484c752f3f06549$var$we = function(e, t) {
    $e484c752f3f06549$var$ge = t + 1, $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e);
}, $e484c752f3f06549$var$be = "style[".concat($e484c752f3f06549$var$f, "][").concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"]'), $e484c752f3f06549$var$Ee = new RegExp("^".concat($e484c752f3f06549$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e484c752f3f06549$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e484c752f3f06549$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e484c752f3f06549$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e484c752f3f06549$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e484c752f3f06549$var$we(u, l), $e484c752f3f06549$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $e484c752f3f06549$var$_e = function(e) {
    for(var t = document.querySelectorAll($e484c752f3f06549$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($e484c752f3f06549$var$f) !== $e484c752f3f06549$var$m && ($e484c752f3f06549$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $e484c752f3f06549$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e484c752f3f06549$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e484c752f3f06549$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e484c752f3f06549$var$f, $e484c752f3f06549$var$m), o.setAttribute($e484c752f3f06549$var$y, $e484c752f3f06549$export$83d89fbfd8236492);
    var i = $e484c752f3f06549$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e484c752f3f06549$var$Ae = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e484c752f3f06549$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e484c752f3f06549$var$Oe = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e484c752f3f06549$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e484c752f3f06549$var$Re = $e484c752f3f06549$var$S, $e484c752f3f06549$var$Te = {
    isServer: !$e484c752f3f06549$var$S,
    useCSSOMInjection: !$e484c752f3f06549$var$w
}, $e484c752f3f06549$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e484c752f3f06549$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, $e484c752f3f06549$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$Re && ($e484c752f3f06549$var$Re = !1, $e484c752f3f06549$var$_e(this)), $e484c752f3f06549$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e484c752f3f06549$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($e484c752f3f06549$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($e484c752f3f06549$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e484c752f3f06549$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e484c752f3f06549$var$De(n) : t ? new $e484c752f3f06549$var$Ae(n) : new $e484c752f3f06549$var$Oe(n);
        }(this.options), new $e484c752f3f06549$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e484c752f3f06549$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e484c752f3f06549$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e484c752f3f06549$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e484c752f3f06549$var$je = /&/g, $e484c752f3f06549$var$xe = /^\s*\/\/.*$/gm;
function $e484c752f3f06549$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e484c752f3f06549$var$Ve(e.children, t)), e;
    });
}
function $e484c752f3f06549$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $e484c752f3f06549$var$C : e, s = r.options, i = void 0 === s ? $e484c752f3f06549$var$C : s, a = r.plugins, c = void 0 === a ? $e484c752f3f06549$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $783faa7ec18221fc$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e484c752f3f06549$var$je, n).replace(o, l));
    }), i.prefix && u.push($783faa7ec18221fc$export$e08c7d021b829b7a), u.push($783faa7ec18221fc$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e484c752f3f06549$var$xe, ""), l = $783faa7ec18221fc$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e484c752f3f06549$var$Ve(l, i.namespace));
        var p = [];
        return $783faa7ec18221fc$export$dfdc1655ccc5b9cb(l, $783faa7ec18221fc$export$5a7767152ae0305f(u.concat($783faa7ec18221fc$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e484c752f3f06549$var$he(15), $e484c752f3f06549$var$M(e, t.name);
    }, $e484c752f3f06549$var$F).toString() : "", p;
}
var $e484c752f3f06549$var$Me = new $e484c752f3f06549$var$ke, $e484c752f3f06549$var$ze = $e484c752f3f06549$var$Fe(), $e484c752f3f06549$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e484c752f3f06549$var$Me,
    stylis: $e484c752f3f06549$var$ze
}), $e484c752f3f06549$export$91317688fc694efa = $e484c752f3f06549$export$8c190ef828af4c86.Consumer, $e484c752f3f06549$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0);
function $e484c752f3f06549$var$Ge() {
    return (0, $bh6RR.useContext)($e484c752f3f06549$export$8c190ef828af4c86);
}
function $e484c752f3f06549$export$a473771da2f0ff7c(e) {
    var t = (0, $bh6RR.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e484c752f3f06549$var$Ge().styleSheet, l = (0, $bh6RR.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $bh6RR.useMemo)(function() {
        return $e484c752f3f06549$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $bh6RR.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($53a106364dbd0a1b$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $bh6RR.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$var$Le.Provider, {
        value: u
    }, e.children));
}
var $e484c752f3f06549$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e484c752f3f06549$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e484c752f3f06549$var$ue(this, function() {
            throw $e484c752f3f06549$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e484c752f3f06549$var$ze), this.name + e.hash;
    }, e;
}(), $e484c752f3f06549$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $e484c752f3f06549$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e484c752f3f06549$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e484c752f3f06549$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $e484c752f3f06549$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e484c752f3f06549$var$Ue(i) && (Array.isArray(i) && i.isCss || $e484c752f3f06549$var$re(i) ? r.push("".concat($e484c752f3f06549$var$He(s), ":"), i, ";") : $e484c752f3f06549$var$ce(i) ? r.push.apply(r, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)((0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e484c752f3f06549$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e484c752f3f06549$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $78b52bced097bc64$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e484c752f3f06549$var$Xe(e, t, n, o) {
    if ($e484c752f3f06549$var$Ue(e)) return [];
    if ($e484c752f3f06549$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e484c752f3f06549$var$re(e)) {
        if (!$e484c752f3f06549$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e484c752f3f06549$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $e484c752f3f06549$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e484c752f3f06549$var$ce(e) ? $e484c752f3f06549$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($e484c752f3f06549$var$_, e.map(function(e) {
        return $e484c752f3f06549$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e484c752f3f06549$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e484c752f3f06549$var$re(n) && !$e484c752f3f06549$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e484c752f3f06549$var$Ke = $e484c752f3f06549$var$z($e484c752f3f06549$export$83d89fbfd8236492), $e484c752f3f06549$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e484c752f3f06549$var$Ze(e), this.componentId = t, this.baseHash = $e484c752f3f06549$var$M($e484c752f3f06549$var$Ke, t), this.baseStyle = n, $e484c752f3f06549$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e484c752f3f06549$var$ie(o, this.staticRulesId);
            else {
                var r = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(this.rules, e, t, n)), s = $e484c752f3f06549$var$x($e484c752f3f06549$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e484c752f3f06549$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e484c752f3f06549$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(u, e, t, n));
                    a = $e484c752f3f06549$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e484c752f3f06549$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e484c752f3f06549$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $e484c752f3f06549$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0), $e484c752f3f06549$export$b631efc24e9d5e2f = $e484c752f3f06549$export$2c657da244d00bd6.Consumer;
function $e484c752f3f06549$export$93d4e7f90805808f() {
    var e = (0, $bh6RR.useContext)($e484c752f3f06549$export$2c657da244d00bd6);
    if (!e) throw $e484c752f3f06549$var$he(18);
    return e;
}
function $e484c752f3f06549$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, $bh6RR.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e484c752f3f06549$var$he(14);
            if ($e484c752f3f06549$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e484c752f3f06549$var$he(8);
            return n ? (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e484c752f3f06549$var$rt = {}, $e484c752f3f06549$var$st = new Set;
function $e484c752f3f06549$var$it(e, r, s) {
    var i = $e484c752f3f06549$export$7ba318d8d2f06c76(e), a = e, c = !$e484c752f3f06549$var$L(e), p = r.attrs, d = void 0 === p ? $e484c752f3f06549$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e484c752f3f06549$var$R(e);
        $e484c752f3f06549$var$rt[n] = ($e484c752f3f06549$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e484c752f3f06549$var$$($e484c752f3f06549$export$83d89fbfd8236492 + n + $e484c752f3f06549$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e484c752f3f06549$var$L(e) ? "styled.".concat(e) : "Styled(".concat($e484c752f3f06549$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($e484c752f3f06549$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $e484c752f3f06549$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), m = $e484c752f3f06549$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $e484c752f3f06549$var$I(r, f, c) || $e484c752f3f06549$var$C, g = function(e, n, o) {
                for(var r, s = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e484c752f3f06549$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e484c752f3f06549$var$ie(s[c], a[c]) : "style" === c ? (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e484c752f3f06549$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $e484c752f3f06549$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $e484c752f3f06549$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$e484c752f3f06549$var$L(S) && !$e484c752f3f06549$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $bh6RR.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $e484c752f3f06549$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e484c752f3f06549$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e484c752f3f06549$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e484c752f3f06549$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e484c752f3f06549$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e484c752f3f06549$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e484c752f3f06549$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e484c752f3f06549$var$re(t) || $e484c752f3f06549$var$ce(t)) return $e484c752f3f06549$var$ct($e484c752f3f06549$var$Xe($e484c752f3f06549$var$at($e484c752f3f06549$var$_, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $e484c752f3f06549$var$Xe(r) : $e484c752f3f06549$var$ct($e484c752f3f06549$var$Xe($e484c752f3f06549$var$at(r, n)));
}
function $e484c752f3f06549$var$ut(n, o, r) {
    if (void 0 === r && (r = $e484c752f3f06549$var$C), !o) throw $e484c752f3f06549$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e484c752f3f06549$var$ut(n, o, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e484c752f3f06549$var$ut(n, o, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e484c752f3f06549$var$pt = function(e) {
    return $e484c752f3f06549$var$ut($e484c752f3f06549$var$it, e);
}, $e484c752f3f06549$export$2e2bcd8739ae039 = $e484c752f3f06549$var$pt;
$e484c752f3f06549$var$A.forEach(function(e) {
    $e484c752f3f06549$export$2e2bcd8739ae039[e] = $e484c752f3f06549$var$pt(e);
});
var $e484c752f3f06549$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e484c752f3f06549$var$Ze(e), $e484c752f3f06549$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e484c752f3f06549$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e484c752f3f06549$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e484c752f3f06549$var$$(JSON.stringify(i))), c = new $e484c752f3f06549$var$ht(i, a);
    var l = function(e) {
        var t = $e484c752f3f06549$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e484c752f3f06549$var$b, o, s);
        else {
            var i = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n), {
                theme: $e484c752f3f06549$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(l);
}
function $e484c752f3f06549$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e484c752f3f06549$var$ae($e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e484c752f3f06549$var$$(r);
    return new $e484c752f3f06549$var$We(s, r);
}
function $e484c752f3f06549$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(n, r) {
        var s = $e484c752f3f06549$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(e, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($e484c752f3f06549$var$B(e), ")"), $e484c752f3f06549$var$oe(n, e);
}
var $e484c752f3f06549$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e484c752f3f06549$var$Ce(), o = $e484c752f3f06549$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e484c752f3f06549$var$f, '="true"'),
                "".concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$e484c752f3f06549$var$f] = "", n[$e484c752f3f06549$var$y] = $e484c752f3f06549$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $e484c752f3f06549$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e484c752f3f06549$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e484c752f3f06549$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e484c752f3f06549$var$he(3);
    }, e;
}(), $e484c752f3f06549$export$5c87cfe6c475f500 = {
    StyleSheet: $e484c752f3f06549$var$ke,
    mainSheet: $e484c752f3f06549$var$Me
};
var $e484c752f3f06549$var$St = "__sc-".concat($e484c752f3f06549$var$f, "__");



const $73652c70b38c91ed$var$StyledGrid = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: ${(props)=>(props.$tileSize + "px ").repeat(props.$width)};
  grid-template-rows: ${(props)=>(props.$tileSize + "px ").repeat(props.$height)};
  grid-gap: ${(props)=>props.$tileSize / 4}px;

  & > div {
    width: ${(props)=>props.$tileSize}px;
    height: ${(props)=>props.$tileSize}px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${(props)=>props.$tileSize}px;
    line-height: ${(props)=>props.$tileSize}px;
  }
`;
const $73652c70b38c91ed$var$Grid = ({ tiles: tiles, tileSize: tileSize, renderTile: renderTile })=>{
    const { width: width, height: height } = (0, $bh6RR.useMemo)(()=>(0, $eade4dc275f59634$exports.getDimensions)(tiles), [
        tiles
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($73652c70b38c91ed$var$StyledGrid, {
        $tileSize: tileSize,
        $width: width,
        $height: height,
        children: (0, $eade4dc275f59634$exports.mapMatrix)((tile, location)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bh6RR.Fragment), {
                children: renderTile(tile, location)
            }, JSON.stringify(location)), tiles)
    });
};
var $73652c70b38c91ed$export$2e2bcd8739ae039 = $73652c70b38c91ed$var$Grid;



var $bh6RR = parcelRequire("bh6RR");

const $5afbd4fb4df23c28$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $5afbd4fb4df23c28$export$2e2bcd8739ae039 = {
    randomUUID: $5afbd4fb4df23c28$var$randomUUID
};


let $ecc82b4b4d5334a5$var$getRandomValues;
const $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        if (typeof crypto === "undefined" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $ecc82b4b4d5334a5$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}


var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === "string" && (0, $83c241de251331e8$export$2e2bcd8739ae039).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;


const $5ce84198744ccadf$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$5ce84198744ccadf$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $5ce84198744ccadf$export$8fb373d660548968(arr, offset = 0) {
    return ($5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $5ce84198744ccadf$var$stringify(arr, offset = 0) {
    const uuid = $5ce84198744ccadf$export$8fb373d660548968(arr, offset);
    if (!(0, $e70e86397c656fa2$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;


function $87befc68df50040c$var$v4(options, buf, offset) {
    if ((0, $5afbd4fb4df23c28$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $5afbd4fb4df23c28$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $ecc82b4b4d5334a5$export$2e2bcd8739ae039))();
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $5ce84198744ccadf$export$8fb373d660548968)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;



var $bh6RR = parcelRequire("bh6RR");
const $c059bc34725ad51a$var$useKeyPress = (handlers = {}, dependencies = [])=>{
    (0, $bh6RR.useEffect)(()=>{
        const onKeyDown = (event)=>{
            if (!event.repeat) handlers[event.code]?.();
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>document.removeEventListener("keydown", onKeyDown);
    }, [
        handlers,
        ...dependencies
    ]);
};
var $c059bc34725ad51a$export$2e2bcd8739ae039 = $c059bc34725ad51a$var$useKeyPress;


function $d8db3300beacf32e$var$addLocations(a, b) {
    return {
        row: a.row + b.row,
        col: a.col + b.col
    };
}
var $d8db3300beacf32e$export$2e2bcd8739ae039 = $d8db3300beacf32e$var$addLocations;


function $e15d8db60d78474f$var$remove(array, index) {
    // We do not allow removal of index out of bounds of this array
    if (index < 0 || index > array.length - 1) return array;
    return [
        ...array.slice(0, index),
        ...array.slice(index + 1)
    ];
}
var $e15d8db60d78474f$export$2e2bcd8739ae039 = $e15d8db60d78474f$var$remove;



var $bh6RR = parcelRequire("bh6RR");


function $a76710a8925f8a66$var$forEachMatrix(callback, matrix) {
    const { width: width, height: height } = (0, $eade4dc275f59634$exports.getDimensions)(matrix);
    for(let row = 0; row < height; row += 1)for(let col = 0; col < width; col += 1)callback(matrix[row][col], {
        row: row,
        col: col
    });
}
var $a76710a8925f8a66$export$2e2bcd8739ae039 = $a76710a8925f8a66$var$forEachMatrix;


function $c62ae6cf0c18002e$var$update(array, index, value) {
    return [
        ...array.slice(0, index),
        value,
        ...array.slice(index + 1)
    ];
}
var $c62ae6cf0c18002e$export$2e2bcd8739ae039 = $c62ae6cf0c18002e$var$update;



const $c1e266851bb578a1$var$behaviorMap = {
    "\uD83C\uDF33": {
        type: "chop"
    },
    "\uD83C\uDF32": {
        type: "chop"
    },
    "\uD83C\uDF31": {
        type: "trample"
    },
    "\uD83D\uDC7D": {
        type: "trade",
        input: [],
        output: [
            "\uD83D\uDCB0"
        ],
        satisfiedText: "Welcome to Zoldath!!",
        requestText: "Welcome to Zoldath!!",
        hasTraded: false,
        reusable: false
    },
    "\uD83C\uDF44": {
        type: "none"
    },
    "\uD83E\uDD16": {
        type: "trade",
        input: [
            "\uD83D\uDD0B"
        ],
        output: [
            "\uD83D\uDEE0\uFE0F"
        ],
        satisfiedText: "BRRP. Robotic Assistant Online. Dispensing repair tools.",
        requestText: "-- power saver mode engaged --",
        hasTraded: false,
        reusable: false
    },
    "\uD83E\uDDD1\u200D\uD83D\uDE92": {
        type: "trade",
        requestText: "\uD83D\uDCB0\uD83D\uDCB0\uD83D\uDCB0 and you can have my \uD83E\uDE93.",
        satisfiedText: "Treat her well!",
        input: [
            "\uD83D\uDCB0",
            "\uD83D\uDCB0",
            "\uD83D\uDCB0"
        ],
        output: [
            "\uD83E\uDE93"
        ],
        hasTraded: false,
        reusable: false
    },
    // "🦖": { type: "fight" },
    "\uD83E\uDE93": {
        type: "item"
    },
    "\uD83E\uDEB5": {
        type: "item"
    },
    "\u2699\uFE0F": {
        type: "item"
    },
    "\uD83D\uDEE0\uFE0F": {
        type: "item"
    },
    "\uD83D\uDD29": {
        type: "item"
    },
    "\uD83D\uDCB0": {
        type: "item"
    },
    "\uD83D\uDC1D": {
        type: "fight",
        damage: 1,
        health: 1,
        drop: "\uD83C\uDF6F"
    },
    "\uD83C\uDF6F": {
        type: "item"
    },
    "\uD83D\uDC79": {
        type: "fight",
        damage: 1,
        health: 3,
        drop: "\uD83D\uDCB0"
    },
    "\uD83D\uDDE1\uFE0F": {
        type: "item"
    },
    "\uD83D\uDC3B": {
        type: "toll",
        requestText: "Grrrrrrrr!!!",
        satisfiedText: "Zzz...",
        blockedText: "Grrr",
        input: [
            "\uD83C\uDF6F"
        ]
    },
    "\uD83E\uDEA8": {
        type: "mine"
    },
    "\u26CF\uFE0F": {
        type: "item"
    },
    "\uD83D\uDD0B": {
        type: "item"
    },
    "\uD83E\uDEAB": {
        type: "item"
    },
    // "📦": { type: "replace", newEntity:  },
    "\uD83D\uDEF8": {
        type: "ship",
        isRepaired: false
    },
    "\uD83D\uDE81": {
        type: "item"
    },
    "\uD83D\uDCFB": {
        type: "audio",
        track: "zoldath2"
    },
    "\uD83E\uDD41": {
        type: "audio",
        track: "metronome1"
    },
    "\uD83C\uDFBA": {
        type: "audio",
        track: "metronome2"
    },
    "\uD83E\uDDAB": {
        type: "trade",
        requestText: "I'm tired, I'll buy \uD83E\uDEB5\uD83E\uDEB5\uD83E\uDEB5 at a time.",
        satisfiedText: "Yum - mmmmm - yummy!",
        input: [
            "\uD83E\uDEB5",
            "\uD83E\uDEB5",
            "\uD83E\uDEB5"
        ],
        output: [
            "\uD83D\uDCB0"
        ],
        hasTraded: false,
        reusable: true
    },
    "\uD83C\uDF30": {
        type: "item"
    },
    "\uD83D\uDC3F\uFE0F": {
        type: "planter",
        input: [
            "\uD83C\uDF30"
        ],
        output: [
            "\uD83C\uDF31"
        ],
        requestText: "\uD83C\uDF30?"
    },
    "\uD83E\uDD9C": {
        type: "bird",
        output: "\uD83C\uDF30"
    },
    "\uD83E\uDD3A": {
        type: "fight",
        damage: 1,
        health: 2,
        drop: "\uD83D\uDDE1\uFE0F"
    },
    "\uD83C\uDF70": {
        type: "eat",
        heal: 1
    },
    "\uD83C\uDF82": {
        type: "eat",
        heal: 3
    },
    "\uD83E\uDDCC": {
        type: "toll",
        requestText: "Come back with \uD83D\uDCB0",
        satisfiedText: "Thank you for your payment - \uD83D\uDCB0",
        blockedText: "There's no path here",
        input: [
            "\uD83D\uDCB0"
        ]
    },
    "\uD83D\uDC09": {
        type: "fight",
        damage: 2,
        health: 5,
        drop: "\uD83D\uDD29"
    },
    "\uD83C\uDF9B\uFE0F": {
        type: "trade",
        requestText: "Please insert \uD83D\uDCB0\uD83D\uDCB0 to charge",
        satisfiedText: "BRRRRRZT - ding!",
        input: [
            "\uD83E\uDEAB",
            "\uD83D\uDCB0",
            "\uD83D\uDCB0"
        ],
        output: [
            "\uD83D\uDD0B"
        ],
        hasTraded: false,
        reusable: false
    },
    "\uD83C\uDF0B": {
        type: "hurt",
        damage: 1
    },
    "\uD83D\uDD25": {
        type: "hurt",
        damage: 1
    }
};
const $c1e266851bb578a1$var$timerBehaviorMap = {
    "\uD83C\uDF31": {
        type: "grow",
        targetTime: 5,
        elapsedTime: 0,
        newEntity: "\uD83C\uDF33"
    },
    "\uD83C\uDF0B": {
        type: "flammable"
    },
    "\uD83D\uDD25": {
        type: "flammable"
    }
};
const $c1e266851bb578a1$export$1fe0dcec7c33c489 = (icon, location)=>{
    return {
        id: (0, $87befc68df50040c$export$2e2bcd8739ae039)(),
        icon: icon,
        behavior: $c1e266851bb578a1$var$behaviorMap[icon] ?? {
            type: "none"
        },
        timerBehavior: $c1e266851bb578a1$var$timerBehaviorMap[icon] ?? {
            type: "none"
        },
        location: location,
        text: ""
    };
};
const $c1e266851bb578a1$var$useEntities = ({ tiles: tiles })=>{
    const [entities, setEntities] = (0, $bh6RR.useState)([]);
    (0, $bh6RR.useEffect)(()=>{
        const newEntities = [];
        (0, $a76710a8925f8a66$export$2e2bcd8739ae039)((icon, location)=>{
            if (icon === ".") return;
            // TODO:
            // Randomize behaviors here?
            const entity = $c1e266851bb578a1$export$1fe0dcec7c33c489(icon, location);
            newEntities.push(entity);
        }, tiles);
        setEntities(newEntities);
    }, [
        tiles
    ]);
    const setTextForEntity = (targetEntity, text)=>{
        setEntities((prevEntities)=>{
            const entityIndex = prevEntities.findIndex((entity)=>{
                return targetEntity.id === entity.id;
            });
            const newEntities = (0, $c62ae6cf0c18002e$export$2e2bcd8739ae039)(prevEntities, entityIndex, {
                ...prevEntities[entityIndex],
                text: text
            });
            return newEntities;
        });
    };
    const clearAllEntityText = ()=>{
        setEntities((prevEntities)=>prevEntities.map((entity)=>({
                    ...entity,
                    text: ""
                })));
    };
    const deleteEntity = (targetEntity)=>{
        setEntities((prevEntities)=>{
            const entityIndex = prevEntities.findIndex((entity)=>{
                return targetEntity.id === entity.id;
            });
            const newEntities = (0, $e15d8db60d78474f$export$2e2bcd8739ae039)(prevEntities, entityIndex);
            return newEntities;
        });
    };
    const replaceEntity = (targetEntity, newEntity)=>{
        setEntities((prevEntities)=>{
            const entityIndex = prevEntities.findIndex((entity)=>{
                return targetEntity.id === entity.id;
            });
            const newEntities = (0, $c62ae6cf0c18002e$export$2e2bcd8739ae039)(prevEntities, entityIndex, newEntity);
            return newEntities;
        });
    };
    const addEntity = (icon, location)=>{
        const newEntity = $c1e266851bb578a1$export$1fe0dcec7c33c489(icon, location);
        setEntities((prevEntities)=>{
            return [
                ...prevEntities,
                newEntity
            ];
        });
    };
    return {
        entities: entities,
        setTextForEntity: setTextForEntity,
        clearAllEntityText: clearAllEntityText,
        deleteEntity: deleteEntity,
        replaceEntity: replaceEntity,
        addEntity: addEntity
    };
};
var $c1e266851bb578a1$export$2e2bcd8739ae039 = $c1e266851bb578a1$var$useEntities;


/**
 * This is a buffer source tied to a gain node.
 *
 * This Track is designed to be constantly playing,
 * but have its volume (gain) turned on and off when
 * "played" and "paused".
 */ class $56a491207203a425$var$Track {
    constructor(trackBuffer, audioContext){
        this.isPlaying = false;
        this.outputNode = audioContext.createGain();
        this.outputNode.gain.value = 0;
        this.source = audioContext.createBufferSource();
        this.source.buffer = trackBuffer;
        this.source.connect(this.outputNode);
        this.source.loop = true;
        this.outputNode.connect(audioContext.destination);
    }
    /**
   * This should only ever be called once inside of the Tracker
   * itself. Consumers of Track should not use this function.
   *
   * I should rework the API to not expose this on the public
   * facing API, but I will not for now.
   */ _start() {
        this.source.start();
    }
    play() {
        this.outputNode.gain.value = 1;
        this.isPlaying = true;
    }
    stop() {
        this.outputNode.gain.value = 0;
        this.isPlaying = false;
    }
}
var $5c5577093d5e84d5$exports = {};
$5c5577093d5e84d5$exports = new URL("metronome1.1c10e9b3.mp3", import.meta.url).toString();


var $e3cff78e75e21dc4$exports = {};
$e3cff78e75e21dc4$exports = new URL("metronome2.1c10e9b3.mp3", import.meta.url).toString();


var $574bbc010bcb83ed$exports = {};
$574bbc010bcb83ed$exports = new URL("Zoldath 2 2024-11-02 2035.69adf1d0.mp3", import.meta.url).toString();


class $56a491207203a425$var$Tracker {
    constructor(){
        this.audioContext = new AudioContext();
        this.trackUrls = {
            metronome1: new URL($5c5577093d5e84d5$exports),
            metronome2: new URL($e3cff78e75e21dc4$exports),
            zoldath2: new URL($574bbc010bcb83ed$exports)
        };
        this.tracks = {};
        this.isLoaded = false;
        this.isStarted = false;
        this.load();
    }
    async load() {
        const loadPromises = Object.entries(this.trackUrls).map(async ([key, url])=>{
            try {
                const response = await fetch(url);
                const arrayBuffer = await response.arrayBuffer();
                const trackBuffer = await this.audioContext.decodeAudioData(arrayBuffer);
                const track = new $56a491207203a425$var$Track(trackBuffer, this.audioContext);
                this.tracks[key] = track;
            } catch (error) {
                /**
           * For some reason, the metronome tracks I added for testing
           * seem to fail to load in Firefox. The track Brendan exported
           * seems to work fine though. Not going to bother to try and
           * fix those tracks. Just don't want them to cause the tracker
           * to fail to load.
           */ console.error(`Failed to load track: ${url}`);
                console.error(error);
            }
        });
        await Promise.all(loadPromises);
        this.isLoaded = true;
    }
    /**
   * Wait to do this after user has interacted with the
   * page so we can start the AudioContext.
   */ start() {
        if (!this.isLoaded) {
            console.error(`Tried to start Tracker before finished loading.`);
            return;
        }
        /**
     * We don't need to start the tracks again if the tracker
     * has already been started.
     */ if (this.isStarted) return;
        Object.values(this.tracks).forEach((track)=>track._start());
        this.isStarted = true;
    }
}
var $56a491207203a425$export$2e2bcd8739ae039 = new $56a491207203a425$var$Tracker();



function $efa46166df5e6cc7$var$getAllMatchingLocations(tiles, matcher) {
    const { width: width, height: height } = (0, $eade4dc275f59634$exports.getDimensions)(tiles);
    const matches = [];
    for(let row = 0; row < height; row += 1){
        for(let col = 0; col < width; col += 1)if (matcher(tiles[row][col], {
            row: row,
            col: col
        })) matches.push({
            row: row,
            col: col
        });
    }
    return matches;
}
var $efa46166df5e6cc7$export$2e2bcd8739ae039 = $efa46166df5e6cc7$var$getAllMatchingLocations;


function $4091686ce1a58644$var$pickRandomlyFromArray(array) {
    return array[Math.floor(Math.random() * array.length)];
}
var $4091686ce1a58644$export$2e2bcd8739ae039 = $4091686ce1a58644$var$pickRandomlyFromArray;


function $35eae0f67d801c79$var$clamp(number, min, max) {
    if (number < min) return min;
    if (number > max) return max;
    return number;
}
var $35eae0f67d801c79$export$2e2bcd8739ae039 = $35eae0f67d801c79$var$clamp;


const $7880a450eedd8f39$var$initialItems = [];
const $7880a450eedd8f39$var$initialHealth = 3;
const $7880a450eedd8f39$var$initialLocation = {
    row: 1,
    col: 1
};
const $7880a450eedd8f39$var$usePlayer = ({ tiles: tiles, entities: entities, setTextForEntity: setTextForEntity, clearAllEntityText: clearAllEntityText, deleteEntity: deleteEntity, replaceEntity: replaceEntity, addEntity: addEntity })=>{
    const { width: width, height: height } = (0, $bh6RR.useMemo)(()=>(0, $eade4dc275f59634$exports.getDimensions)(tiles), [
        tiles
    ]);
    const [items, setItems] = (0, $bh6RR.useState)($7880a450eedd8f39$var$initialItems);
    const [health, setHealth] = (0, $bh6RR.useState)($7880a450eedd8f39$var$initialHealth);
    const [playerLocation, setPlayerLocation] = (0, $bh6RR.useState)($7880a450eedd8f39$var$initialLocation);
    const isLocationEmpty = (location)=>{
        return !entities.some((entity)=>(0, $eade4dc275f59634$exports.compareLocations)(entity.location, location)) && !(0, $eade4dc275f59634$exports.compareLocations)(location, playerLocation);
    };
    const getEmptyLocations = ()=>(0, $efa46166df5e6cc7$export$2e2bcd8739ae039)(tiles, (_, location)=>{
            return isLocationEmpty(location);
        });
    const tryMoveDirection = (direction)=>{
        // You can no longer move if you are dead
        if (health <= 0) return;
        const newLocation = (0, $d8db3300beacf32e$export$2e2bcd8739ae039)(playerLocation, direction);
        const doesPlayerHaveHelicopter = items.some((item)=>item.icon === "\uD83D\uDE81");
        /**
     * If player has helicopter, then enable screen wrapping.
     */ if (doesPlayerHaveHelicopter) {
            if (newLocation.row < 0) newLocation.row = height - 1;
            if (newLocation.col < 0) newLocation.col = width - 1;
            if (newLocation.row > height - 1) newLocation.row = 0;
            if (newLocation.col > width - 1) newLocation.col = 0;
        }
        if (!(0, $eade4dc275f59634$exports.isLocationInBounds)(tiles, newLocation)) return;
        // Take a snapshot of entities at this time
        [
            ...entities
        ].forEach((entity)=>{
            switch(entity.timerBehavior.type){
                case "grow":
                    const newElapsedTime = entity.timerBehavior.elapsedTime + 1;
                    if (newElapsedTime >= entity.timerBehavior.targetTime) {
                        addEntity(entity.timerBehavior.newEntity, entity.location);
                        deleteEntity(entity);
                    } else replaceEntity(entity, {
                        ...entity,
                        timerBehavior: {
                            ...entity.timerBehavior,
                            elapsedTime: newElapsedTime
                        }
                    });
                    break;
                case "flammable":
                    const neighborLocations = (0, $eade4dc275f59634$exports.getNeighbors)((0, $eade4dc275f59634$exports.getCrossDirections), tiles, entity.location);
                    const neighbors = neighborLocations.map((neighborLocation)=>entities.find((otherEntity)=>(0, $eade4dc275f59634$exports.compareLocations)(neighborLocation, otherEntity.location)));
                    neighbors.forEach((neighbor)=>{
                        if (!neighbor) return;
                        // If flammable replace with fire
                        if (neighbor.icon === "\uD83C\uDF32" || neighbor.icon === "\uD83C\uDF33") {
                            addEntity("\uD83D\uDD25", neighbor.location);
                            deleteEntity(neighbor);
                        }
                    });
                    break;
                case "none":
                default:
                    break;
            }
        });
        const entityAtLocation = entities.find((entity)=>(0, $eade4dc275f59634$exports.compareLocations)(entity.location, newLocation));
        if (entityAtLocation) {
            switch(entityAtLocation.behavior.type){
                case "talk":
                    setTextForEntity(entityAtLocation, entityAtLocation.behavior.text);
                    break;
                case "fight":
                    const playerDamage = $7880a450eedd8f39$var$countIconsInInventory("\uD83D\uDDE1\uFE0F", items);
                    const newHealth = entityAtLocation.behavior.health - playerDamage;
                    let newEntity = {
                        ...entityAtLocation,
                        behavior: {
                            ...entityAtLocation.behavior,
                            health: newHealth
                        },
                        text: `${new Array(entityAtLocation.behavior.damage).fill("\uD83D\uDDE1\uFE0F").join("")} - ${new Array((0, $35eae0f67d801c79$export$2e2bcd8739ae039)(newHealth, 0, 100)).fill("\u2764\uFE0F").join("")}`
                    };
                    const isEntityAtLocationDead = newHealth <= 0;
                    if (isEntityAtLocationDead) newEntity = (0, $c1e266851bb578a1$export$1fe0dcec7c33c489)(entityAtLocation.behavior.drop, newLocation);
                    replaceEntity(entityAtLocation, newEntity);
                    if (!isEntityAtLocationDead) setHealth(health - entityAtLocation.behavior.damage);
                    break;
                case "chop":
                    if (items.find((item)=>item.icon === "\uD83E\uDE93")) {
                        const logEntity = (0, $c1e266851bb578a1$export$1fe0dcec7c33c489)("\uD83E\uDEB5", newLocation);
                        replaceEntity(entityAtLocation, logEntity);
                    }
                    break;
                case "item":
                    const newItems = [
                        ...items,
                        {
                            id: (0, $87befc68df50040c$export$2e2bcd8739ae039)(),
                            icon: entityAtLocation.icon
                        }
                    ];
                    setItems(newItems);
                    deleteEntity(entityAtLocation);
                    setPlayerLocation(newLocation);
                    break;
                case "trade":
                    if (entityAtLocation.behavior.hasTraded) setTextForEntity(entityAtLocation, entityAtLocation.behavior.satisfiedText);
                    else if ($7880a450eedd8f39$var$doesInventoryHaveAllItemsByIcon(entityAtLocation.behavior.input, items)) {
                        setItems([
                            ...$7880a450eedd8f39$var$removeAllByIcon(entityAtLocation.behavior.input, items),
                            ...entityAtLocation.behavior.output.map((icon)=>({
                                    id: (0, $87befc68df50040c$export$2e2bcd8739ae039)(),
                                    icon: icon
                                }))
                        ]);
                        replaceEntity(entityAtLocation, {
                            ...entityAtLocation,
                            text: entityAtLocation.behavior.satisfiedText,
                            behavior: {
                                ...entityAtLocation.behavior,
                                // If a trade is reusable, then we never mark it
                                // as hasTraded is true.
                                hasTraded: !entityAtLocation.behavior.reusable
                            }
                        });
                    } else setTextForEntity(entityAtLocation, entityAtLocation.behavior.requestText);
                    break;
                case "ship":
                    if ($7880a450eedd8f39$var$doesInventoryHaveAllItemsByIcon([
                        "\uD83D\uDEE0\uFE0F",
                        "\u2699\uFE0F",
                        "\uD83D\uDD29"
                    ], items)) {
                        replaceEntity(entityAtLocation, {
                            ...entityAtLocation,
                            text: "SHHWIP - Your ship's systems come back to life",
                            behavior: {
                                ...entityAtLocation.behavior,
                                isRepaired: true
                            }
                        });
                        setItems($7880a450eedd8f39$var$removeAllByIcon([
                            "\u2699\uFE0F",
                            "\uD83D\uDD29"
                        ], items));
                    } else setTextForEntity(entityAtLocation, "Your ship is damaged! It needs 3 parts to be repaired.");
                    break;
                case "audio":
                    const { track: trackName } = entityAtLocation.behavior;
                    if (!(0, $56a491207203a425$export$2e2bcd8739ae039).isLoaded) {
                        console.error(`Tried to play a track, but tracker isn't loaded.`);
                        return;
                    }
                    (0, $56a491207203a425$export$2e2bcd8739ae039).start();
                    if (!(0, $56a491207203a425$export$2e2bcd8739ae039).isStarted) {
                        console.error(`Tried to play a track, but tracker isn't started.`);
                        return;
                    }
                    const track = (0, $56a491207203a425$export$2e2bcd8739ae039).tracks[trackName];
                    if (!track) {
                        console.error(`Tried to play/stop track "${trackName}", but it doesn't exist.`);
                        return;
                    }
                    if (track.isPlaying) track.stop();
                    else track.play();
                    break;
                case "planter":
                    if ($7880a450eedd8f39$var$doesInventoryHaveAllItemsByIcon(entityAtLocation.behavior.input, items)) {
                        const emptyLocations = getEmptyLocations();
                        const targetLocation = (0, $4091686ce1a58644$export$2e2bcd8739ae039)(emptyLocations);
                        // TODO:
                        // Support multiple output locations
                        addEntity(entityAtLocation.behavior.output[0], targetLocation);
                        setItems($7880a450eedd8f39$var$removeAllByIcon(entityAtLocation.behavior.input, items));
                    } else setTextForEntity(entityAtLocation, entityAtLocation.behavior.requestText);
                    break;
                case "bird":
                    const emptyLocations = getEmptyLocations();
                    const targetLocation = (0, $4091686ce1a58644$export$2e2bcd8739ae039)(emptyLocations);
                    replaceEntity(entityAtLocation, {
                        ...entityAtLocation,
                        location: targetLocation
                    });
                    addEntity("\uD83C\uDF30", entityAtLocation.location);
                    break;
                case "toll":
                    const locationPastTollEntity = (0, $d8db3300beacf32e$export$2e2bcd8739ae039)(entityAtLocation.location, direction);
                    if (!isLocationEmpty(locationPastTollEntity)) {
                        // Cannot charge toll, if exit is blocked
                        setTextForEntity(entityAtLocation, entityAtLocation.behavior.blockedText);
                        return;
                    }
                    if ($7880a450eedd8f39$var$doesInventoryHaveAllItemsByIcon(entityAtLocation.behavior.input, items)) {
                        setItems($7880a450eedd8f39$var$removeAllByIcon(entityAtLocation.behavior.input, items));
                        setPlayerLocation(locationPastTollEntity);
                        setTextForEntity(entityAtLocation, entityAtLocation.behavior.satisfiedText);
                    } else setTextForEntity(entityAtLocation, entityAtLocation.behavior.requestText);
                    break;
                case "trample":
                    setPlayerLocation(entityAtLocation.location);
                    deleteEntity(entityAtLocation);
                    break;
                case "hurt":
                    setHealth(health - entityAtLocation.behavior.damage);
                    break;
                case "eat":
                    setPlayerLocation(entityAtLocation.location);
                    setHealth(health + entityAtLocation.behavior.heal);
                    deleteEntity(entityAtLocation);
                    break;
                default:
                    console.warn(`Behavior not implemented: ${entityAtLocation.behavior.type}`);
                    break;
            }
            return;
        }
        clearAllEntityText();
        setPlayerLocation(newLocation);
    };
    (0, $c059bc34725ad51a$export$2e2bcd8739ae039)({
        KeyW: ()=>tryMoveDirection({
                row: -1,
                col: 0
            }),
        KeyA: ()=>tryMoveDirection({
                row: 0,
                col: -1
            }),
        KeyS: ()=>tryMoveDirection({
                row: 1,
                col: 0
            }),
        KeyD: ()=>tryMoveDirection({
                row: 0,
                col: 1
            }),
        ArrowUp: ()=>tryMoveDirection({
                row: -1,
                col: 0
            }),
        ArrowLeft: ()=>tryMoveDirection({
                row: 0,
                col: -1
            }),
        ArrowDown: ()=>tryMoveDirection({
                row: 1,
                col: 0
            }),
        ArrowRight: ()=>tryMoveDirection({
                row: 0,
                col: 1
            })
    });
    const reset = ()=>{
        setItems([
            ...$7880a450eedd8f39$var$initialItems
        ]);
        setHealth($7880a450eedd8f39$var$initialHealth);
        setPlayerLocation({
            ...$7880a450eedd8f39$var$initialLocation
        });
    };
    return {
        playerLocation: playerLocation,
        health: health,
        items: items,
        reset: reset
    };
};
function $7880a450eedd8f39$var$doesInventoryHaveAllItemsByIcon(itemIcons, inventory) {
    let inventoryCopy = [
        ...inventory
    ];
    for (let itemIcon of itemIcons){
        const itemIndexInInventory = inventoryCopy.findIndex((inventoryItem)=>inventoryItem.icon === itemIcon);
        // If we can't find the item in the inventory, then
        // this match has failed.
        if (itemIndexInInventory === -1) return false;
        inventoryCopy = (0, $e15d8db60d78474f$export$2e2bcd8739ae039)(inventoryCopy, itemIndexInInventory);
    }
    return true;
}
function $7880a450eedd8f39$var$removeAllByIcon(itemIcons, inventory) {
    let inventoryCopy = [
        ...inventory
    ];
    for (let itemIcon of itemIcons){
        const itemIndexInInventory = inventoryCopy.findIndex((inventoryItem)=>inventoryItem.icon === itemIcon);
        inventoryCopy = (0, $e15d8db60d78474f$export$2e2bcd8739ae039)(inventoryCopy, itemIndexInInventory);
    }
    return inventoryCopy;
}
function $7880a450eedd8f39$var$countIconsInInventory(icon, inventory) {
    return inventory.reduce((total, item)=>{
        if (item.icon === icon) return total + 1;
        return total;
    }, 0);
}
var $7880a450eedd8f39$export$2e2bcd8739ae039 = $7880a450eedd8f39$var$usePlayer;




var $744ad2585e553435$exports = {};
$744ad2585e553435$exports = new URL("sand.c4c51c1c.jpg", import.meta.url).toString();



parcelRequire("bh6RR");

var $d06f02e66370a1f2$exports = {};
$d06f02e66370a1f2$exports = new URL("grunge.3e6f3ce1.jpg", import.meta.url).toString();


const $413f87cd271595bb$var$StyledModalBackground = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  z-index: 1;
  background-color: rgba(80, 0, 0, 0.6);

  &:before {
    content: " ";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.2;
    background-image: url(${(0, (/*@__PURE__*/$parcel$interopDefault($d06f02e66370a1f2$exports)))});
    background-repeat: no-repeat;
    background-position: 50% 0;
    background-size: cover;
    z-index: -1;
  }

  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;
const $413f87cd271595bb$var$StyledModal = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  background-color: white;
  box-shadow: 4px 4px black;
  border: 2px solid black;
  padding: 32px;

  font-size: 2rem;
`;
const $413f87cd271595bb$var$Modal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($413f87cd271595bb$var$StyledModalBackground, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($413f87cd271595bb$var$StyledModal, {
            className: "animate__animated animate__slideInUp",
            children: children
        })
    });
};
var $413f87cd271595bb$export$2e2bcd8739ae039 = $413f87cd271595bb$var$Modal;



parcelRequire("bh6RR");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $168a40e325c04e1b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $168a40e325c04e1b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $168a40e325c04e1b$export$803cd8101b6c182b = /*#__PURE__*/ $168a40e325c04e1b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[0], side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[1]), []);
const $168a40e325c04e1b$export$96ec731ed4dcb222 = Math.min;
const $168a40e325c04e1b$export$8960430cfd85939f = Math.max;
const $168a40e325c04e1b$export$2077e0241d6afd3c = Math.round;
const $168a40e325c04e1b$export$a3fe094919f356fd = Math.floor;
const $168a40e325c04e1b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $168a40e325c04e1b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $168a40e325c04e1b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $168a40e325c04e1b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $168a40e325c04e1b$export$8960430cfd85939f(start, $168a40e325c04e1b$export$96ec731ed4dcb222(value, end));
}
function $168a40e325c04e1b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $168a40e325c04e1b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $168a40e325c04e1b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $168a40e325c04e1b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $168a40e325c04e1b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $168a40e325c04e1b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($168a40e325c04e1b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement) {
    return $168a40e325c04e1b$export$8a000a963141ac32($168a40e325c04e1b$export$f28e8f882010718a(placement));
}
function $168a40e325c04e1b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement);
    const length = $168a40e325c04e1b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $168a40e325c04e1b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $168a40e325c04e1b$export$9c5e28bad23365fa(placement);
    return [
        $168a40e325c04e1b$export$2b182c584985588b(placement),
        oppositePlacement,
        $168a40e325c04e1b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $168a40e325c04e1b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$168a40e325c04e1b$var$oppositeAlignmentMap[alignment]);
}
function $168a40e325c04e1b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $168a40e325c04e1b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    let list = $168a40e325c04e1b$var$getSideList($168a40e325c04e1b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($168a40e325c04e1b$export$2b182c584985588b));
    }
    return list;
}
function $168a40e325c04e1b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$168a40e325c04e1b$var$oppositeSideMap[side]);
}
function $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $168a40e325c04e1b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $168a40e325c04e1b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $926256944d3cd62f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $926256944d3cd62f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $926256944d3cd62f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $926256944d3cd62f$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $926256944d3cd62f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $168a40e325c04e1b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $926256944d3cd62f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $168a40e325c04e1b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $168a40e325c04e1b$export$803cd8101b6c182b) ? $926256944d3cd62f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $168a40e325c04e1b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $926256944d3cd62f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $168a40e325c04e1b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $168a40e325c04e1b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $168a40e325c04e1b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $168a40e325c04e1b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $926256944d3cd62f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $926256944d3cd62f$var$isAnySideFullyClipped(overflow) {
    return (0, $168a40e325c04e1b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $926256944d3cd62f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $926256944d3cd62f$var$getBoundingRect(rects) {
    const minX = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $926256944d3cd62f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($926256944d3cd62f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $926256944d3cd62f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $926256944d3cd62f$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($926256944d3cd62f$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $926256944d3cd62f$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $926256944d3cd62f$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $926256944d3cd62f$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $926256944d3cd62f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $926256944d3cd62f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $926256944d3cd62f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $8da4680c6d092b5b$var$hasWindow() {
    return typeof window !== "undefined";
}
function $8da4680c6d092b5b$export$651544f548703224(node) {
    if ($8da4680c6d092b5b$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $8da4680c6d092b5b$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $8da4680c6d092b5b$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($8da4680c6d092b5b$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $8da4680c6d092b5b$export$8ee0fc9ee280b4ee(value) {
    if (!$8da4680c6d092b5b$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).Node;
}
function $8da4680c6d092b5b$export$45a5e7f76e0caa8d(value) {
    if (!$8da4680c6d092b5b$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).Element;
}
function $8da4680c6d092b5b$export$1b3bfaa9684536aa(value) {
    if (!$8da4680c6d092b5b$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).HTMLElement;
}
function $8da4680c6d092b5b$export$af51f0f06c0f328a(value) {
    if (!$8da4680c6d092b5b$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $8da4680c6d092b5b$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $8da4680c6d092b5b$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $8da4680c6d092b5b$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($8da4680c6d092b5b$export$651544f548703224(element));
}
function $8da4680c6d092b5b$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $8da4680c6d092b5b$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $8da4680c6d092b5b$export$78551043582a6a98();
    const css = $8da4680c6d092b5b$export$45a5e7f76e0caa8d(elementOrCss) ? $8da4680c6d092b5b$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $8da4680c6d092b5b$export$940d8225183e1404(element) {
    let currentNode = $8da4680c6d092b5b$export$4e12058fc4d51d56(element);
    while($8da4680c6d092b5b$export$1b3bfaa9684536aa(currentNode) && !$8da4680c6d092b5b$export$d1162fb0b6d4cd51(currentNode)){
        if ($8da4680c6d092b5b$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($8da4680c6d092b5b$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $8da4680c6d092b5b$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $8da4680c6d092b5b$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $8da4680c6d092b5b$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($8da4680c6d092b5b$export$651544f548703224(node));
}
function $8da4680c6d092b5b$export$3735103072e4a80(element) {
    return $8da4680c6d092b5b$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $8da4680c6d092b5b$export$dc8fc79fa2800137(element) {
    if ($8da4680c6d092b5b$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $8da4680c6d092b5b$export$4e12058fc4d51d56(node) {
    if ($8da4680c6d092b5b$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $8da4680c6d092b5b$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $8da4680c6d092b5b$export$e495491855dc5418(node);
    return $8da4680c6d092b5b$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $8da4680c6d092b5b$export$7cd01a57c8ca906c(node) {
    const parentNode = $8da4680c6d092b5b$export$4e12058fc4d51d56(node);
    if ($8da4680c6d092b5b$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($8da4680c6d092b5b$export$1b3bfaa9684536aa(parentNode) && $8da4680c6d092b5b$export$989e911fa9af580a(parentNode)) return parentNode;
    return $8da4680c6d092b5b$export$7cd01a57c8ca906c(parentNode);
}
function $8da4680c6d092b5b$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $8da4680c6d092b5b$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $8da4680c6d092b5b$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $8da4680c6d092b5b$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $8da4680c6d092b5b$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $8da4680c6d092b5b$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $8da4680c6d092b5b$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $8da4680c6d092b5b$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $985fd6054d85832a$var$getCssDimensions(element) {
    const css = (0, $8da4680c6d092b5b$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $985fd6054d85832a$var$unwrapElement(element) {
    return !(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $985fd6054d85832a$var$getScale(element) {
    const domElement = $985fd6054d85832a$var$unwrapElement(element);
    if (!(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(domElement)) return (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $985fd6054d85832a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $985fd6054d85832a$var$noOffsets = /*#__PURE__*/ (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
function $985fd6054d85832a$var$getVisualOffsets(element) {
    const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element);
    if (!(0, $8da4680c6d092b5b$export$78551043582a6a98)() || !win.visualViewport) return $985fd6054d85832a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $985fd6054d85832a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $985fd6054d85832a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $985fd6054d85832a$var$unwrapElement(element);
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(offsetParent)) scale = $985fd6054d85832a$var$getScale(offsetParent);
        } else scale = $985fd6054d85832a$var$getScale(element);
    }
    const visualOffsets = $985fd6054d85832a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $985fd6054d85832a$var$getVisualOffsets(domElement) : (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $8da4680c6d092b5b$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $985fd6054d85832a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $8da4680c6d092b5b$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $8da4680c6d092b5b$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $8da4680c6d092b5b$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $8da4680c6d092b5b$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) !== "body" || (0, $8da4680c6d092b5b$export$989e911fa9af580a)(documentElement)) scroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent);
            scale = $985fd6054d85832a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $985fd6054d85832a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $985fd6054d85832a$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $985fd6054d85832a$var$getBoundingClientRect((0, $8da4680c6d092b5b$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $985fd6054d85832a$var$getDocumentRect(element) {
    const html = (0, $8da4680c6d092b5b$export$e495491855dc5418)(element);
    const scroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $985fd6054d85832a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $8da4680c6d092b5b$export$3735103072e4a80)(body).direction === "rtl") x += (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getViewportRect(element, strategy) {
    const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element);
    const html = (0, $8da4680c6d092b5b$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $8da4680c6d092b5b$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $985fd6054d85832a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $985fd6054d85832a$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element) ? $985fd6054d85832a$var$getScale(element) : (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $985fd6054d85832a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $985fd6054d85832a$var$getDocumentRect((0, $8da4680c6d092b5b$export$e495491855dc5418)(element));
    else if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $985fd6054d85832a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $985fd6054d85832a$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(rect);
}
function $985fd6054d85832a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(parentNode) || (0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $8da4680c6d092b5b$export$3735103072e4a80)(parentNode).position === "fixed" || $985fd6054d85832a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $985fd6054d85832a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $8da4680c6d092b5b$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(el) && (0, $8da4680c6d092b5b$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(currentNode) && !(0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $8da4680c6d092b5b$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $8da4680c6d092b5b$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $8da4680c6d092b5b$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $985fd6054d85832a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $985fd6054d85832a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $8da4680c6d092b5b$export$89e651af02346cd4)(element) ? [] : $985fd6054d85832a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $985fd6054d85832a$var$getDimensions(element) {
    const { width: width, height: height } = $985fd6054d85832a$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $985fd6054d85832a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $8da4680c6d092b5b$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $985fd6054d85832a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8da4680c6d092b5b$export$651544f548703224)(offsetParent) !== "body" || (0, $8da4680c6d092b5b$export$989e911fa9af580a)(documentElement)) scroll = (0, $8da4680c6d092b5b$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $985fd6054d85832a$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $985fd6054d85832a$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $985fd6054d85832a$var$isStaticPositioned(element) {
    return (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).position === "static";
}
function $985fd6054d85832a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element) || (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $8da4680c6d092b5b$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $985fd6054d85832a$var$getOffsetParent(element, polyfill) {
    const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(element);
    if ((0, $8da4680c6d092b5b$export$89e651af02346cd4)(element)) return win;
    if (!(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$985fd6054d85832a$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $8da4680c6d092b5b$export$71535ffaa902797f)(offsetParent) && $985fd6054d85832a$var$isStaticPositioned(offsetParent))offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(offsetParent) && $985fd6054d85832a$var$isStaticPositioned(offsetParent) && !(0, $8da4680c6d092b5b$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $8da4680c6d092b5b$export$940d8225183e1404)(element) || win;
}
const $985fd6054d85832a$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $985fd6054d85832a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $985fd6054d85832a$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $985fd6054d85832a$var$isRTL(element) {
    return (0, $8da4680c6d092b5b$export$3735103072e4a80)(element).direction === "rtl";
}
const $985fd6054d85832a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $8da4680c6d092b5b$export$e495491855dc5418,
    getClippingRect: $985fd6054d85832a$var$getClippingRect,
    getOffsetParent: $985fd6054d85832a$var$getOffsetParent,
    getElementRects: $985fd6054d85832a$var$getElementRects,
    getClientRects: $985fd6054d85832a$var$getClientRects,
    getDimensions: $985fd6054d85832a$var$getDimensions,
    getScale: $985fd6054d85832a$var$getScale,
    isElement: $8da4680c6d092b5b$export$45a5e7f76e0caa8d,
    isRTL: $985fd6054d85832a$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $985fd6054d85832a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $8da4680c6d092b5b$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $168a40e325c04e1b$export$8960430cfd85939f)(0, (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $985fd6054d85832a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $985fd6054d85832a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $8da4680c6d092b5b$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $8da4680c6d092b5b$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $985fd6054d85832a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $985fd6054d85832a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $985fd6054d85832a$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $985fd6054d85832a$export$37b6bde19b108ecc = (0, $926256944d3cd62f$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $985fd6054d85832a$export$cc800923e997bb8 = (0, $926256944d3cd62f$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $985fd6054d85832a$export$91fb6ecbd551914 = (0, $926256944d3cd62f$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $985fd6054d85832a$export$fba63a578e423eb = (0, $926256944d3cd62f$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $985fd6054d85832a$export$8a83211c878a3f1f = (0, $926256944d3cd62f$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $985fd6054d85832a$export$346677f925de839c = (0, $926256944d3cd62f$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $985fd6054d85832a$export$fe8985bb6374093c = (0, $926256944d3cd62f$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $985fd6054d85832a$export$f2120bbfa5450bd2 = (0, $926256944d3cd62f$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $985fd6054d85832a$export$18c8ad048e32c7d5 = (0, $926256944d3cd62f$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $985fd6054d85832a$export$7bf07e38f3dc4b69 = (0, $926256944d3cd62f$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $985fd6054d85832a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $985fd6054d85832a$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $926256944d3cd62f$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $bh6RR = parcelRequire("bh6RR");

var $f0eb2bc09271deae$var$index = typeof document !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $f0eb2bc09271deae$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$f0eb2bc09271deae$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$f0eb2bc09271deae$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $f0eb2bc09271deae$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $f0eb2bc09271deae$var$roundByDPR(element, value) {
    const dpr = $f0eb2bc09271deae$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $f0eb2bc09271deae$var$useLatestRef(value) {
    const ref = $bh6RR.useRef(value);
    $f0eb2bc09271deae$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $f0eb2bc09271deae$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $bh6RR.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $bh6RR.useState(middleware);
    if (!$f0eb2bc09271deae$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $bh6RR.useState(null);
    const [_floating, _setFloating] = $bh6RR.useState(null);
    const setReference = $bh6RR.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $bh6RR.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $bh6RR.useRef(null);
    const floatingRef = $bh6RR.useRef(null);
    const dataRef = $bh6RR.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $f0eb2bc09271deae$var$useLatestRef(whileElementsMounted);
    const platformRef = $f0eb2bc09271deae$var$useLatestRef(platform);
    const openRef = $f0eb2bc09271deae$var$useLatestRef(open);
    const update = $bh6RR.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $985fd6054d85832a$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$f0eb2bc09271deae$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $47cfd4084854a574$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $f0eb2bc09271deae$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $bh6RR.useRef(false);
    $f0eb2bc09271deae$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $f0eb2bc09271deae$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $bh6RR.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $bh6RR.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $bh6RR.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $f0eb2bc09271deae$var$roundByDPR(elements.floating, data.x);
        const y = $f0eb2bc09271deae$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$f0eb2bc09271deae$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $bh6RR.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f0eb2bc09271deae$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $985fd6054d85832a$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $985fd6054d85832a$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $f0eb2bc09271deae$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $985fd6054d85832a$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $f0eb2bc09271deae$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $985fd6054d85832a$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $f0eb2bc09271deae$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $985fd6054d85832a$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $f0eb2bc09271deae$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $985fd6054d85832a$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $f0eb2bc09271deae$export$346677f925de839c = (options, deps)=>({
        ...(0, $985fd6054d85832a$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $f0eb2bc09271deae$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $985fd6054d85832a$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $f0eb2bc09271deae$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $985fd6054d85832a$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $f0eb2bc09271deae$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $985fd6054d85832a$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f0eb2bc09271deae$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$f0eb2bc09271deae$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


var $bh6RR = parcelRequire("bh6RR");

function $4ee6ff8059878997$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $4ee6ff8059878997$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $8da4680c6d092b5b$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $4ee6ff8059878997$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $4ee6ff8059878997$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $4ee6ff8059878997$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($4ee6ff8059878997$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $4ee6ff8059878997$export$29bf1b5f2c56cf63(event) {
    if ($4ee6ff8059878997$export$c8f880a2d81914c4()) return false;
    return !$4ee6ff8059878997$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $4ee6ff8059878997$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function $4ee6ff8059878997$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $4ee6ff8059878997$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($4ee6ff8059878997$export$867a782338812cb4()) || re.test($4ee6ff8059878997$export$7935961ef7719cb0());
}
function $4ee6ff8059878997$export$9ac100e40613ea10() {
    return $4ee6ff8059878997$export$867a782338812cb4().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $4ee6ff8059878997$export$c8f880a2d81914c4() {
    return $4ee6ff8059878997$export$7935961ef7719cb0().includes("jsdom/");
}
function $4ee6ff8059878997$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function $4ee6ff8059878997$export$94781ce41a161222(event) {
    return "nativeEvent" in event;
}
function $4ee6ff8059878997$export$7b296c28e0fa3aed(element) {
    return element.matches("html,body");
}
function $4ee6ff8059878997$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $4ee6ff8059878997$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $4ee6ff8059878997$export$c22522a4dfa48e9c(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $4ee6ff8059878997$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $4ee6ff8059878997$export$42ad131c32f0fb8d(element) {
    return (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(element) && element.matches($4ee6ff8059878997$export$78b3d091ff376bc);
}
function $4ee6ff8059878997$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $4ee6ff8059878997$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && $4ee6ff8059878997$export$42ad131c32f0fb8d(element);
}




/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $7b28c9bd65463003$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $7b28c9bd65463003$var$candidateSelector = /* #__PURE__ */ $7b28c9bd65463003$var$candidateSelectors.join(",");
var $7b28c9bd65463003$var$NoElement = typeof Element === "undefined";
var $7b28c9bd65463003$var$matches = $7b28c9bd65463003$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $7b28c9bd65463003$var$getRootNode = !$7b28c9bd65463003$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $7b28c9bd65463003$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $7b28c9bd65463003$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $7b28c9bd65463003$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($7b28c9bd65463003$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($7b28c9bd65463003$var$candidateSelector));
    if (includeContainer && $7b28c9bd65463003$var$matches.call(el, $7b28c9bd65463003$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $7b28c9bd65463003$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($7b28c9bd65463003$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $7b28c9bd65463003$var$matches.call(element, $7b28c9bd65463003$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$7b28c9bd65463003$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $7b28c9bd65463003$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $7b28c9bd65463003$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $7b28c9bd65463003$var$isContentEditable(node)) && !$7b28c9bd65463003$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $7b28c9bd65463003$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $7b28c9bd65463003$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$7b28c9bd65463003$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $7b28c9bd65463003$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $7b28c9bd65463003$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $7b28c9bd65463003$var$isHiddenInput = function isHiddenInput(node) {
    return $7b28c9bd65463003$var$isInput(node) && node.type === "hidden";
};
var $7b28c9bd65463003$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $7b28c9bd65463003$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $7b28c9bd65463003$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $7b28c9bd65463003$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $7b28c9bd65463003$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $7b28c9bd65463003$var$isRadio = function isRadio(node) {
    return $7b28c9bd65463003$var$isInput(node) && node.type === "radio";
};
var $7b28c9bd65463003$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $7b28c9bd65463003$var$isRadio(node) && !$7b28c9bd65463003$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $7b28c9bd65463003$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $7b28c9bd65463003$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $7b28c9bd65463003$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $7b28c9bd65463003$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $7b28c9bd65463003$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $7b28c9bd65463003$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($7b28c9bd65463003$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $7b28c9bd65463003$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $7b28c9bd65463003$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($7b28c9bd65463003$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $7b28c9bd65463003$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $7b28c9bd65463003$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $7b28c9bd65463003$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $7b28c9bd65463003$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $7b28c9bd65463003$var$isInert(node) || $7b28c9bd65463003$var$isHiddenInput(node) || $7b28c9bd65463003$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $7b28c9bd65463003$var$isDetailsWithSummary(node) || $7b28c9bd65463003$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $7b28c9bd65463003$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($7b28c9bd65463003$var$isNonTabbableRadio(node) || $7b28c9bd65463003$export$a4672efddb4181b8(node) < 0 || !$7b28c9bd65463003$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $7b28c9bd65463003$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $7b28c9bd65463003$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $7b28c9bd65463003$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($7b28c9bd65463003$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $7b28c9bd65463003$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $7b28c9bd65463003$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $7b28c9bd65463003$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $7b28c9bd65463003$var$isValidShadowRootTabbable
    });
    else candidates = $7b28c9bd65463003$var$getCandidates(container, options.includeContainer, $7b28c9bd65463003$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $7b28c9bd65463003$var$sortByOrder(candidates);
};
var $7b28c9bd65463003$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $7b28c9bd65463003$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $7b28c9bd65463003$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $7b28c9bd65463003$var$getCandidates(container, options.includeContainer, $7b28c9bd65463003$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $7b28c9bd65463003$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($7b28c9bd65463003$var$matches.call(node, $7b28c9bd65463003$var$candidateSelector) === false) return false;
    return $7b28c9bd65463003$var$isNodeMatchingSelectorTabbable(options, node);
};
var $7b28c9bd65463003$var$focusableCandidateSelector = /* #__PURE__ */ $7b28c9bd65463003$var$candidateSelectors.concat("iframe").join(",");
var $7b28c9bd65463003$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($7b28c9bd65463003$var$matches.call(node, $7b28c9bd65463003$var$focusableCandidateSelector) === false) return false;
    return $7b28c9bd65463003$var$isNodeMatchingSelectorFocusable(options, node);
};




/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $7533984aa684428c$export$74665b213cb5c4cf(refs) {
    return $bh6RR.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $7533984aa684428c$var$SafeReact = {
    ...$bh6RR
};
const $7533984aa684428c$var$useInsertionEffect = $7533984aa684428c$var$SafeReact.useInsertionEffect;
const $7533984aa684428c$var$useSafeInsertionEffect = $7533984aa684428c$var$useInsertionEffect || ((fn)=>fn());
function $7533984aa684428c$var$useEffectEvent(callback) {
    const ref = $bh6RR.useRef(()=>{});
    $7533984aa684428c$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $bh6RR.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $7533984aa684428c$var$ARROW_UP = "ArrowUp";
const $7533984aa684428c$var$ARROW_DOWN = "ArrowDown";
const $7533984aa684428c$var$ARROW_LEFT = "ArrowLeft";
const $7533984aa684428c$var$ARROW_RIGHT = "ArrowRight";
function $7533984aa684428c$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $7533984aa684428c$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $7533984aa684428c$var$getMinIndex(listRef, disabledIndices) {
    return $7533984aa684428c$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $7533984aa684428c$var$getMaxIndex(listRef, disabledIndices) {
    return $7533984aa684428c$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $7533984aa684428c$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $7533984aa684428c$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $7533984aa684428c$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $7533984aa684428c$var$ARROW_UP) {
        stop && (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($7533984aa684428c$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $7533984aa684428c$var$ARROW_DOWN) {
        stop && (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($7533984aa684428c$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        const prevRow = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === $7533984aa684428c$var$ARROW_RIGHT) {
            stop && (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $7533984aa684428c$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($7533984aa684428c$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === $7533984aa684428c$var$ARROW_LEFT) {
            stop && (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $7533984aa684428c$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($7533984aa684428c$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($7533984aa684428c$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === $7533984aa684428c$var$ARROW_LEFT ? maxIndex : $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $7533984aa684428c$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $7533984aa684428c$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $7533984aa684428c$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $7533984aa684428c$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
let $7533984aa684428c$var$rafId = 0;
function $7533984aa684428c$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($7533984aa684428c$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $7533984aa684428c$var$rafId = requestAnimationFrame(exec);
}
var $7533984aa684428c$var$index = typeof document !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
function $7533984aa684428c$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $7533984aa684428c$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $7533984aa684428c$var$FloatingListContext = /*#__PURE__*/ $bh6RR.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $7533984aa684428c$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $bh6RR.useState(()=>new Map());
    const register = $bh6RR.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $bh6RR.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $7533984aa684428c$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($7533984aa684428c$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$7533984aa684428c$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$FloatingListContext.Provider, {
        value: $bh6RR.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $7533984aa684428c$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $bh6RR.useContext($7533984aa684428c$var$FloatingListContext);
    const [index$1, setIndex] = $bh6RR.useState(null);
    const componentRef = $bh6RR.useRef(null);
    const ref = $bh6RR.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $7533984aa684428c$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $7533984aa684428c$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $bh6RR.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $7533984aa684428c$var$renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ $bh6RR.cloneElement(render, computedProps);
    return /*#__PURE__*/ $bh6RR.createElement("div", computedProps);
}
const $7533984aa684428c$var$CompositeContext = /*#__PURE__*/ $bh6RR.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $7533984aa684428c$var$horizontalKeys = [
    $7533984aa684428c$var$ARROW_LEFT,
    $7533984aa684428c$var$ARROW_RIGHT
];
const $7533984aa684428c$var$verticalKeys = [
    $7533984aa684428c$var$ARROW_UP,
    $7533984aa684428c$var$ARROW_DOWN
];
const $7533984aa684428c$var$allKeys = [
    ...$7533984aa684428c$var$horizontalKeys,
    ...$7533984aa684428c$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $7533984aa684428c$export$43586241d9db0c6d = /*#__PURE__*/ $bh6RR.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = "both", loop: loop = true, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $bh6RR.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $7533984aa684428c$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $bh6RR.useRef([]);
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const contextValue = $bh6RR.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$7533984aa684428c$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $7533984aa684428c$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $7533984aa684428c$var$getMaxIndex(elementsRef, disabledIndices);
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $7533984aa684428c$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$7533984aa684428c$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$7533984aa684428c$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$7533984aa684428c$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $7533984aa684428c$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$7533984aa684428c$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $7533984aa684428c$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $7533984aa684428c$var$ARROW_DOWN ? "bl" : event.key === $7533984aa684428c$var$ARROW_RIGHT ? "tr" : "tl")
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                $7533984aa684428c$var$ARROW_RIGHT
            ],
            vertical: [
                $7533984aa684428c$var$ARROW_DOWN
            ],
            both: [
                $7533984aa684428c$var$ARROW_RIGHT,
                $7533984aa684428c$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                $7533984aa684428c$var$ARROW_LEFT
            ],
            vertical: [
                $7533984aa684428c$var$ARROW_UP
            ],
            both: [
                $7533984aa684428c$var$ARROW_LEFT,
                $7533984aa684428c$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $7533984aa684428c$var$allKeys : ({
            horizontal: $7533984aa684428c$var$horizontalKeys,
            vertical: $7533984aa684428c$var$verticalKeys,
            both: $7533984aa684428c$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $7533984aa684428c$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$7533984aa684428c$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(()=>{
                $7533984aa684428c$var$enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $7533984aa684428c$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $7533984aa684428c$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $bh6RR.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $bh6RR.useContext($7533984aa684428c$var$CompositeContext);
    const { ref: ref, index: index } = $7533984aa684428c$export$dcdc7ff5149f7d1a();
    const mergedRef = $7533984aa684428c$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $7533984aa684428c$var$renderJsx(render, computedProps);
});
function $7533984aa684428c$var$_extends() {
    $7533984aa684428c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7533984aa684428c$var$_extends.apply(this, arguments);
}
let $7533984aa684428c$var$serverHandoffComplete = false;
let $7533984aa684428c$var$count = 0;
const $7533984aa684428c$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $7533984aa684428c$var$count++;
function $7533984aa684428c$var$useFloatingId() {
    const [id, setId] = $bh6RR.useState(()=>$7533984aa684428c$var$serverHandoffComplete ? $7533984aa684428c$var$genId() : undefined);
    $7533984aa684428c$var$index(()=>{
        if (id == null) setId($7533984aa684428c$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $bh6RR.useEffect(()=>{
        $7533984aa684428c$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $7533984aa684428c$var$useReactId = $7533984aa684428c$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $7533984aa684428c$export$f680877a34711e37 = $7533984aa684428c$var$useReactId || $7533984aa684428c$var$useFloatingId;
let $7533984aa684428c$var$devMessageSet;
function $7533984aa684428c$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = $7533984aa684428c$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $7533984aa684428c$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $7533984aa684428c$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = $7533984aa684428c$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $7533984aa684428c$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $7533984aa684428c$export$33511391554732bc = /*#__PURE__*/ $bh6RR.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $7533984aa684428c$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $bh6RR.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $7533984aa684428c$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $8da4680c6d092b5b$export$3735103072e4a80)(floating).direction === "rtl";
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split("-");
    const isVerticalSide = side === "top" || side === "bottom";
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ $bh6RR.createElement("svg", $7533984aa684428c$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(" "),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $bh6RR.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $bh6RR.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ $bh6RR.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $bh6RR.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $7533984aa684428c$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $7533984aa684428c$var$FloatingNodeContext = /*#__PURE__*/ $bh6RR.createContext(null);
const $7533984aa684428c$var$FloatingTreeContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $7533984aa684428c$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $bh6RR.useContext($7533984aa684428c$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $7533984aa684428c$export$db0c2a7c7a2a4f69 = ()=>$bh6RR.useContext($7533984aa684428c$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $7533984aa684428c$export$9b136e0e758a42f4(customParentId) {
    const id = $7533984aa684428c$export$f680877a34711e37();
    const tree = $7533984aa684428c$export$db0c2a7c7a2a4f69();
    const reactParentId = $7533984aa684428c$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $7533984aa684428c$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $7533984aa684428c$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $7533984aa684428c$export$165209eae06d3488();
    return /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$FloatingNodeContext.Provider, {
        value: $bh6RR.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $7533984aa684428c$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $bh6RR.useRef([]);
    const addNode = $bh6RR.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $bh6RR.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $bh6RR.useState(()=>$7533984aa684428c$var$createPubSub())[0];
    return /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$FloatingTreeContext.Provider, {
        value: $bh6RR.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $7533984aa684428c$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $7533984aa684428c$var$useLatestRef(value) {
    const ref = (0, $bh6RR.useRef)(value);
    $7533984aa684428c$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $7533984aa684428c$var$safePolygonIdentifier = /*#__PURE__*/ $7533984aa684428c$var$createAttribute("safe-polygon");
function $7533984aa684428c$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $4ee6ff8059878997$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $7533984aa684428c$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $7533984aa684428c$export$db0c2a7c7a2a4f69();
    const parentId = $7533984aa684428c$export$165209eae06d3488();
    const handleCloseRef = $7533984aa684428c$var$useLatestRef(handleClose);
    const delayRef = $7533984aa684428c$var$useLatestRef(delay);
    const openRef = $7533984aa684428c$var$useLatestRef(open);
    const pointerTypeRef = $bh6RR.useRef();
    const timeoutRef = $bh6RR.useRef(-1);
    const handlerRef = $bh6RR.useRef();
    const restTimeoutRef = $bh6RR.useRef(-1);
    const blockMouseMoveRef = $bh6RR.useRef(true);
    const performedPointerEventsMutationRef = $bh6RR.useRef(false);
    const unbindMouseMoveRef = $bh6RR.useRef(()=>{});
    const restTimeoutPendingRef = $bh6RR.useRef(false);
    const isHoverOpen = $bh6RR.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $bh6RR.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $bh6RR.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        }
        const html = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $bh6RR.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        const closeDelay = $7533984aa684428c$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $7533984aa684428c$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $7533984aa684428c$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute($7533984aa684428c$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $bh6RR.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                "click",
                "mousedown"
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $4ee6ff8059878997$export$81cf264172d31e51)(pointerTypeRef.current) || restMs > 0 && !$7533984aa684428c$var$getDelay(delayRef.current, "open")) return;
            const openDelay = $7533984aa684428c$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, "hover");
            }, openDelay);
            else onOpenChange(true, event, "hover");
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, "safe-polygon");
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !(0, $4ee6ff8059878997$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $7533984aa684428c$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($7533984aa684428c$var$safePolygonIdentifier, "");
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body.style.pointerEvents = "none";
                ref.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return ()=>{
                    body.style.pointerEvents = "";
                    ref.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $7533984aa684428c$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $bh6RR.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $bh6RR.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !(0, $4ee6ff8059878997$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $bh6RR.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay
    ]);
    return $bh6RR.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $7533984aa684428c$var$NOOP = ()=>{};
const $7533984aa684428c$var$FloatingDelayGroupContext = /*#__PURE__*/ $bh6RR.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $7533984aa684428c$var$NOOP,
    setState: $7533984aa684428c$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $7533984aa684428c$export$e2411914b150383d = ()=>$bh6RR.useContext($7533984aa684428c$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $7533984aa684428c$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $bh6RR.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $bh6RR.useRef(null);
    const setCurrentId = $bh6RR.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $7533984aa684428c$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$FloatingDelayGroupContext.Provider, {
        value: $bh6RR.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $7533984aa684428c$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $7533984aa684428c$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $7533984aa684428c$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $7533984aa684428c$var$getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $7533984aa684428c$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $7533984aa684428c$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $7533984aa684428c$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function $7533984aa684428c$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $7533984aa684428c$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $7533984aa684428c$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $7533984aa684428c$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $7533984aa684428c$var$counterMap = /*#__PURE__*/ new WeakMap();
let $7533984aa684428c$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $7533984aa684428c$var$markerMap = {};
let $7533984aa684428c$var$lockCount$1 = 0;
const $7533984aa684428c$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
const $7533984aa684428c$var$unwrapHost = (node)=>node && (node.host || $7533984aa684428c$var$unwrapHost(node.parentNode));
const $7533984aa684428c$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $7533984aa684428c$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $7533984aa684428c$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    const avoidElements = $7533984aa684428c$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$7533984aa684428c$var$markerMap[markerName]) $7533984aa684428c$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $7533984aa684428c$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $8da4680c6d092b5b$export$651544f548703224)(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== "false";
                const counterValue = ($7533984aa684428c$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $7533984aa684428c$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $7533984aa684428c$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    $7533984aa684428c$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($7533984aa684428c$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $7533984aa684428c$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$7533984aa684428c$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $7533984aa684428c$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $7533984aa684428c$var$lockCount$1--;
        if (!$7533984aa684428c$var$lockCount$1) {
            $7533984aa684428c$var$counterMap = new WeakMap();
            $7533984aa684428c$var$counterMap = new WeakMap();
            $7533984aa684428c$var$uncontrolledElementsSet = new WeakSet();
            $7533984aa684428c$var$markerMap = {};
        }
    };
}
function $7533984aa684428c$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(avoidElements[0]).body;
    return $7533984aa684428c$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
const $7533984aa684428c$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $7533984aa684428c$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $7b28c9bd65463003$export$17100aea90429aa7)(container, $7533984aa684428c$var$getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $4ee6ff8059878997$export$da980962bd2147a4)((0, $4ee6ff8059878997$export$f65ca476c09acec0)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $7533984aa684428c$var$getNextTabbable() {
    return $7533984aa684428c$var$getTabbableIn(document.body, "next");
}
function $7533984aa684428c$var$getPreviousTabbable() {
    return $7533984aa684428c$var$getTabbableIn(document.body, "prev");
}
function $7533984aa684428c$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $4ee6ff8059878997$export$2344b14b097df817)(containerElement, relatedTarget);
}
function $7533984aa684428c$var$disableFocusInside(container) {
    const tabbableElements = (0, $7b28c9bd65463003$export$17100aea90429aa7)(container, $7533984aa684428c$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $7533984aa684428c$var$enableFocusInside(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $7533984aa684428c$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let $7533984aa684428c$var$timeoutId;
function $7533984aa684428c$var$setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout($7533984aa684428c$var$timeoutId);
    }
}
const $7533984aa684428c$var$FocusGuard = /*#__PURE__*/ $bh6RR.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $bh6RR.useState();
    $7533984aa684428c$var$index(()=>{
        if ((0, $4ee6ff8059878997$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", $7533984aa684428c$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", $7533984aa684428c$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$7533984aa684428c$var$createAttribute("focus-guard")]: "",
        style: $7533984aa684428c$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $bh6RR.createElement("span", $7533984aa684428c$var$_extends({}, props, restProps));
});
const $7533984aa684428c$var$PortalContext = /*#__PURE__*/ $bh6RR.createContext(null);
const $7533984aa684428c$var$attr = /*#__PURE__*/ $7533984aa684428c$var$createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $7533984aa684428c$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $7533984aa684428c$export$f680877a34711e37();
    const portalContext = $7533984aa684428c$var$usePortalContext();
    const [portalNode, setPortalNode] = $bh6RR.useState(null);
    const portalNodeRef = $bh6RR.useRef(null);
    $7533984aa684428c$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $7533984aa684428c$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($7533984aa684428c$var$attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $7533984aa684428c$var$index(()=>{
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($7533984aa684428c$var$attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $7533984aa684428c$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root = null, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $7533984aa684428c$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $bh6RR.useState(null);
    const beforeOutsideRef = $bh6RR.useRef(null);
    const afterOutsideRef = $bh6RR.useRef(null);
    const beforeInsideRef = $bh6RR.useRef(null);
    const afterInsideRef = $bh6RR.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $bh6RR.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $7533984aa684428c$var$isOutsideEvent(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? $7533984aa684428c$var$enableFocusInside : $7533984aa684428c$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $bh6RR.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $7533984aa684428c$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$PortalContext.Provider, {
        value: $bh6RR.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($7533984aa684428c$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $7533984aa684428c$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $bh6RR.createElement("span", {
        "aria-owns": portalNode.id,
        style: $7533984aa684428c$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $47cfd4084854a574$exports.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($7533984aa684428c$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $7533984aa684428c$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
            }
        }
    }));
}
const $7533984aa684428c$var$usePortalContext = ()=>$bh6RR.useContext($7533984aa684428c$var$PortalContext);
const $7533984aa684428c$var$FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function $7533984aa684428c$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($7533984aa684428c$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $7533984aa684428c$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $7533984aa684428c$var$LIST_LIMIT = 20;
let $7533984aa684428c$var$previouslyFocusedElements = [];
function $7533984aa684428c$var$addPreviouslyFocusedElement(element) {
    $7533984aa684428c$var$previouslyFocusedElements = $7533984aa684428c$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $8da4680c6d092b5b$export$651544f548703224)(tabbableEl) === "body") return;
    if (!(0, $7b28c9bd65463003$export$bebd5a1431fec25d)(tabbableEl, $7533984aa684428c$var$getTabbableOptions())) {
        const tabbableChild = (0, $7b28c9bd65463003$export$17100aea90429aa7)(tabbableEl, $7533984aa684428c$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $7533984aa684428c$var$previouslyFocusedElements.push(tabbableEl);
    if ($7533984aa684428c$var$previouslyFocusedElements.length > $7533984aa684428c$var$LIST_LIMIT) $7533984aa684428c$var$previouslyFocusedElements = $7533984aa684428c$var$previouslyFocusedElements.slice(-$7533984aa684428c$var$LIST_LIMIT);
}
function $7533984aa684428c$var$getPreviouslyFocusedElement() {
    return $7533984aa684428c$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $7533984aa684428c$var$VisuallyHiddenDismiss = /*#__PURE__*/ $bh6RR.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $bh6RR.createElement("button", $7533984aa684428c$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $7533984aa684428c$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $7533984aa684428c$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        "content"
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $4ee6ff8059878997$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $7533984aa684428c$var$supportsInert() ? _guards : true;
    const orderRef = $7533984aa684428c$var$useLatestRef(order);
    const initialFocusRef = $7533984aa684428c$var$useLatestRef(initialFocus);
    const returnFocusRef = $7533984aa684428c$var$useLatestRef(returnFocus);
    const tree = $7533984aa684428c$export$db0c2a7c7a2a4f69();
    const portalContext = $7533984aa684428c$var$usePortalContext();
    const startDismissButtonRef = $bh6RR.useRef(null);
    const endDismissButtonRef = $bh6RR.useRef(null);
    const preventReturnFocusRef = $bh6RR.useRef(false);
    const isPointerDownRef = $bh6RR.useRef(false);
    const tabbableIndexRef = $bh6RR.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $7533984aa684428c$var$getFloatingFocusElement(floating);
    const getTabbableContent = $7533984aa684428c$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $7b28c9bd65463003$export$17100aea90429aa7)(container, $7533984aa684428c$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $7533984aa684428c$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floatingFocusElement && type === "floating") return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $bh6RR.useEffect(()=>{
        preventReturnFocusRef.current = false;
    }, [
        disabled
    ]);
    $bh6RR.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $4ee6ff8059878997$export$2344b14b097df817)(floatingFocusElement, (0, $4ee6ff8059878997$export$da980962bd2147a4)((0, $4ee6ff8059878997$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $7533984aa684428c$var$enqueueFocus(els[els.length - 1]);
                    else $7533984aa684428c$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
                    (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
                    $7533984aa684428c$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $bh6RR.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener("focusin", handleFocusIn);
        return ()=>{
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $bh6RR.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $4ee6ff8059878997$export$2344b14b097df817)(domReference, relatedTarget) || (0, $4ee6ff8059878997$export$2344b14b097df817)(floating, relatedTarget) || (0, $4ee6ff8059878997$export$2344b14b097df817)(relatedTarget, floating) || (0, $4ee6ff8059878997$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($7533984aa684428c$var$createAttribute("focus-guard")) || tree && ($7533984aa684428c$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $4ee6ff8059878997$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $4ee6ff8059878997$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $7533984aa684428c$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $4ee6ff8059878997$export$da980962bd2147a4)((0, $4ee6ff8059878997$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $4ee6ff8059878997$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $7533984aa684428c$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, "focus-out");
                }
            });
        }
        if (floating && (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $bh6RR.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $7533984aa684428c$var$createAttribute("portal") + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $7533984aa684428c$var$markOthers(insideElements, guards, !guards) : $7533984aa684428c$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $7533984aa684428c$var$index(()=>{
        if (disabled || !(0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $4ee6ff8059878997$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $4ee6ff8059878997$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $7533984aa684428c$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $7533984aa684428c$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $4ee6ff8059878997$export$da980962bd2147a4)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $7533984aa684428c$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === "escape-key" && refs.domReference.current) $7533984aa684428c$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === "hover" && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $4ee6ff8059878997$export$60278871457622de)(event) || (0, $4ee6ff8059878997$export$29bf1b5f2c56cf63)(event));
        }
        events.on("openchange", onOpenChange);
        const fallbackEl = doc.createElement("span");
        fallbackEl.setAttribute("tabindex", "-1");
        fallbackEl.setAttribute("aria-hidden", "true");
        Object.assign(fallbackEl.style, $7533984aa684428c$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement("afterend", fallbackEl);
        return ()=>{
            events.off("openchange", onOpenChange);
            const activeEl = (0, $4ee6ff8059878997$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $4ee6ff8059878997$export$2344b14b097df817)(floating, activeEl) || tree && $7533984aa684428c$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $4ee6ff8059878997$export$2344b14b097df817)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $7533984aa684428c$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = $7533984aa684428c$var$getPreviouslyFocusedElement() || fallbackEl;
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $7533984aa684428c$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $7533984aa684428c$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== "function") return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute("tabindex");
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $4ee6ff8059878997$export$da980962bd2147a4)((0, $4ee6ff8059878997$export$f65ca476c09acec0)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes("floating") || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floatingFocusElement.setAttribute("tabindex", "-1");
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $7533984aa684428c$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($7533984aa684428c$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $7533984aa684428c$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ $bh6RR.createElement($7533984aa684428c$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $7533984aa684428c$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($7533984aa684428c$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $7533984aa684428c$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $7533984aa684428c$var$lockCount = 0;
function $7533984aa684428c$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $4ee6ff8059878997$export$867a782338812cb4)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = "hidden";
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: "fixed",
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: "0"
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: "",
            [paddingProp]: ""
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: "",
                top: "",
                left: "",
                right: ""
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $7533984aa684428c$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $7533984aa684428c$export$a35954495955337b = /*#__PURE__*/ $bh6RR.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $7533984aa684428c$var$index(()=>{
        if (!lockScroll) return;
        $7533984aa684428c$var$lockCount++;
        if ($7533984aa684428c$var$lockCount === 1) $7533984aa684428c$var$cleanup = $7533984aa684428c$var$enableScrollLock();
        return ()=>{
            $7533984aa684428c$var$lockCount--;
            if ($7533984aa684428c$var$lockCount === 0) $7533984aa684428c$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $bh6RR.createElement("div", $7533984aa684428c$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $7533984aa684428c$var$isButtonTarget(event) {
    return (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === "BUTTON";
}
function $7533984aa684428c$var$isSpaceIgnored(element) {
    return (0, $4ee6ff8059878997$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $7533984aa684428c$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = "click", toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $bh6RR.useRef();
    const didKeyDownRef = $bh6RR.useRef(false);
    const reference = $bh6RR.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === "click") return;
                if ((0, $4ee6ff8059878997$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $4ee6ff8059878997$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                else onOpenChange(true, event.nativeEvent, "click");
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $7533984aa684428c$var$isButtonTarget(event)) return;
                if (event.key === " " && !$7533984aa684428c$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === "Enter") {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $7533984aa684428c$var$isButtonTarget(event) || $7533984aa684428c$var$isSpaceIgnored(domReference)) return;
                if (event.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        toggle
    ]);
    return $bh6RR.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $7533984aa684428c$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $7533984aa684428c$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $7533984aa684428c$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = "both", x: x = null, y: y = null } = props;
    const initialRef = $bh6RR.useRef(false);
    const cleanupListenerRef = $bh6RR.useRef(null);
    const [pointerType, setPointerType] = $bh6RR.useState();
    const [reactive, setReactive] = $bh6RR.useState([]);
    const setReference = $7533984aa684428c$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$7533984aa684428c$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($7533984aa684428c$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $7533984aa684428c$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $4ee6ff8059878997$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $bh6RR.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event);
            if (!(0, $4ee6ff8059878997$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $7533984aa684428c$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $bh6RR.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $bh6RR.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $bh6RR.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $7533984aa684428c$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $bh6RR.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $bh6RR.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $7533984aa684428c$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $7533984aa684428c$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $7533984aa684428c$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $7533984aa684428c$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = "pointerdown", referencePress: referencePress = false, referencePressEvent: referencePressEvent = "pointerdown", ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $7533984aa684428c$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $7533984aa684428c$var$useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $bh6RR.useRef(false);
    const endedOrStartedInsideRef = $bh6RR.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $7533984aa684428c$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $7533984aa684428c$var$normalizeProp(capture);
    const isComposingRef = $bh6RR.useRef(false);
    const closeOnEscapeKeyDown = $7533984aa684428c$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $7533984aa684428c$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $4ee6ff8059878997$export$94781ce41a161222)(event) ? event.nativeEvent : event, "escape-key");
    });
    const closeOnEscapeKeyDownCapture = $7533984aa684428c$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    const closeOnPressOutside = $7533984aa684428c$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $7533984aa684428c$var$createAttribute("inert") + "]";
        const markers = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $8da4680c6d092b5b$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $8da4680c6d092b5b$export$d1162fb0b6d4cd51)(nextParent) || !(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(target) && !(0, $4ee6ff8059878997$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $4ee6ff8059878997$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $4ee6ff8059878997$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $8da4680c6d092b5b$export$3735103072e4a80)(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $7533984aa684428c$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $4ee6ff8059878997$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $4ee6ff8059878997$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $4ee6ff8059878997$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $7533984aa684428c$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    const closeOnPressOutsideCapture = $7533984aa684428c$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $bh6RR.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $8da4680c6d092b5b$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $4ee6ff8059878997$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener("compositionstart", handleCompositionStart);
            doc.addEventListener("compositionend", handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $8da4680c6d092b5b$export$3b57c1601291186b)(elements.domReference);
            if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $8da4680c6d092b5b$export$3b57c1601291186b)(elements.floating));
            if (!(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $8da4680c6d092b5b$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener("compositionstart", handleCompositionStart);
                doc.removeEventListener("compositionend", handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $bh6RR.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $bh6RR.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$7533984aa684428c$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, "reference-press");
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $bh6RR.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$7533984aa684428c$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $bh6RR.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $7533984aa684428c$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $7533984aa684428c$export$f680877a34711e37();
    const dataRef = $bh6RR.useRef({});
    const [events] = $bh6RR.useState(()=>$7533984aa684428c$var$createPubSub());
    const nested = $7533984aa684428c$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $bh6RR.useState(elementsProp.reference);
    const onOpenChange = $7533984aa684428c$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $bh6RR.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $bh6RR.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $bh6RR.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $7533984aa684428c$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $7533984aa684428c$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $bh6RR.useState(null);
    const [positionReference, _setPositionReference] = $bh6RR.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.reference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $bh6RR.useRef(null);
    const tree = $7533984aa684428c$export$db0c2a7c7a2a4f69();
    $7533984aa684428c$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $f0eb2bc09271deae$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $bh6RR.useCallback((node)=>{
        const computedPositionReference = (0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $bh6RR.useCallback((node)=>{
        if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $bh6RR.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $bh6RR.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $bh6RR.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $7533984aa684428c$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $bh6RR.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $7533984aa684428c$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $bh6RR.useRef(false);
    const timeoutRef = $bh6RR.useRef();
    const keyboardModalityRef = $bh6RR.useRef(true);
    $bh6RR.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $8da4680c6d092b5b$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $4ee6ff8059878997$export$da980962bd2147a4)((0, $4ee6ff8059878997$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $bh6RR.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $bh6RR.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $bh6RR.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $4ee6ff8059878997$export$29bf1b5f2c56cf63)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $4ee6ff8059878997$export$95df08bae54cb4df)() && (0, $4ee6ff8059878997$export$9ac100e40613ea10)()) throw Error();
                    if (!target.matches(":focus-visible")) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $4ee6ff8059878997$export$42ad131c32f0fb8d)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, "focus");
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($7533984aa684428c$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $4ee6ff8059878997$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $4ee6ff8059878997$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $4ee6ff8059878997$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $bh6RR.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $7533984aa684428c$var$ACTIVE_KEY = "active";
const $7533984aa684428c$var$SELECTED_KEY = "selected";
function $7533984aa684428c$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === "item";
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$7533984aa684428c$var$ACTIVE_KEY]: _, [$7533984aa684428c$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === "floating" && {
            tabIndex: -1,
            [$7533984aa684428c$var$FOCUSABLE_ATTRIBUTE]: ""
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $7533984aa684428c$var$ACTIVE_KEY,
                    $7533984aa684428c$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $7533984aa684428c$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $bh6RR.useCallback((userProps)=>$7533984aa684428c$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $bh6RR.useCallback((userProps)=>$7533984aa684428c$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $bh6RR.useCallback((userProps)=>$7533984aa684428c$var$mergeProps(userProps, propsList, "item"), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $bh6RR.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $7533984aa684428c$var$isPreventScrollSupported = false;
function $7533984aa684428c$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $7533984aa684428c$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $7533984aa684428c$var$ARROW_UP || key === $7533984aa684428c$var$ARROW_DOWN;
    const horizontal = key === $7533984aa684428c$var$ARROW_LEFT || key === $7533984aa684428c$var$ARROW_RIGHT;
    return $7533984aa684428c$var$doSwitch(orientation, vertical, horizontal);
}
function $7533984aa684428c$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $7533984aa684428c$var$ARROW_DOWN;
    const horizontal = rtl ? key === $7533984aa684428c$var$ARROW_LEFT : key === $7533984aa684428c$var$ARROW_RIGHT;
    return $7533984aa684428c$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function $7533984aa684428c$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $7533984aa684428c$var$ARROW_LEFT : key === $7533984aa684428c$var$ARROW_RIGHT;
    const horizontal = key === $7533984aa684428c$var$ARROW_DOWN;
    return $7533984aa684428c$var$doSwitch(orientation, vertical, horizontal);
}
function $7533984aa684428c$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $7533984aa684428c$var$ARROW_RIGHT : key === $7533984aa684428c$var$ARROW_LEFT;
    const horizontal = key === $7533984aa684428c$var$ARROW_UP;
    return $7533984aa684428c$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $7533984aa684428c$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = "auto", focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = "vertical", cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $7533984aa684428c$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $7533984aa684428c$var$useLatestRef(floatingFocusElement);
    const parentId = $7533984aa684428c$export$165209eae06d3488();
    const tree = $7533984aa684428c$export$db0c2a7c7a2a4f69();
    const onNavigate = $7533984aa684428c$var$useEffectEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $bh6RR.useRef(focusItemOnOpen);
    const indexRef = $bh6RR.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $bh6RR.useRef(null);
    const isPointerModalityRef = $bh6RR.useRef(true);
    const previousOnNavigateRef = $bh6RR.useRef(onNavigate);
    const previousMountedRef = $bh6RR.useRef(!!elements.floating);
    const previousOpenRef = $bh6RR.useRef(open);
    const forceSyncFocus = $bh6RR.useRef(false);
    const forceScrollIntoViewRef = $bh6RR.useRef(false);
    const disabledIndicesRef = $7533984aa684428c$var$useLatestRef(disabledIndices);
    const latestOpenRef = $7533984aa684428c$var$useLatestRef(open);
    const scrollItemIntoViewRef = $7533984aa684428c$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $7533984aa684428c$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $bh6RR.useState();
    const [virtualId, setVirtualId] = $bh6RR.useState();
    const focusItem = $7533984aa684428c$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit("virtualfocus", item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $7533984aa684428c$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $4ee6ff8059878997$export$9ac100e40613ea10)() && (0, $4ee6ff8059878997$export$95df08bae54cb4df)() ? $7533984aa684428c$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    $7533984aa684428c$var$index(()=>{
        document.createElement("div").focus({
            get preventScroll () {
                $7533984aa684428c$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $7533984aa684428c$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $7533984aa684428c$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $7533984aa684428c$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $7533984aa684428c$var$getMinIndex(listRef, disabledIndicesRef.current) : $7533984aa684428c$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$7533984aa684428c$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $7533984aa684428c$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $4ee6ff8059878997$export$da980962bd2147a4)((0, $4ee6ff8059878997$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $4ee6ff8059878997$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $7533984aa684428c$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $7533984aa684428c$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $7533984aa684428c$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $7533984aa684428c$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $bh6RR.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $7533984aa684428c$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $7533984aa684428c$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $7533984aa684428c$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, "list-navigation");
            if ((0, $8da4680c6d092b5b$export$1b3bfaa9684536aa)(elements.domReference) && !virtual) elements.domReference.focus();
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $7533984aa684428c$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $7533984aa684428c$var$getMaxIndex(listRef, disabledIndices);
        if (event.key === "Home") {
            (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
            indexRef.current = minIndex;
            onNavigate(indexRef.current);
        }
        if (event.key === "End") {
            (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
            indexRef.current = maxIndex;
            onNavigate(indexRef.current);
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $7533984aa684428c$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$7533984aa684428c$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$7533984aa684428c$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$7533984aa684428c$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $7533984aa684428c$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$7533984aa684428c$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $7533984aa684428c$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $7533984aa684428c$var$ARROW_DOWN ? "bl" : event.key === $7533984aa684428c$var$ARROW_RIGHT ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === "both") return;
        }
        if ($7533984aa684428c$var$isMainOrientationKey(event.key, orientation)) {
            (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $4ee6ff8059878997$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $7533984aa684428c$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($7533984aa684428c$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $7533984aa684428c$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $7533984aa684428c$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $7533984aa684428c$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $7533984aa684428c$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($7533984aa684428c$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $bh6RR.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $bh6RR.useMemo(()=>{
        return {
            "aria-orientation": orientation === "both" ? undefined : orientation,
            ...!(0, $4ee6ff8059878997$export$259ba5ae38188551)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $bh6RR.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, $4ee6ff8059878997$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, $4ee6ff8059878997$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith("Arrow");
                const isHomeOrEndKey = [
                    "Home",
                    "End"
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $7533984aa684428c$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $7533984aa684428c$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $7533984aa684428c$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $7533984aa684428c$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = $7533984aa684428c$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $bh6RR.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $7533984aa684428c$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $7533984aa684428c$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = "dialog" } = props;
    const ariaRole = (_componentRoleToAriaR = $7533984aa684428c$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $7533984aa684428c$export$f680877a34711e37();
    const parentId = $7533984aa684428c$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $bh6RR.useMemo(()=>{
        if (ariaRole === "tooltip" || role === "label") return {
            ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : undefined
        };
        return {
            "aria-expanded": open ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open ? floatingId : undefined,
            ...ariaRole === "listbox" && {
                role: "combobox"
            },
            ...ariaRole === "menu" && {
                id: referenceId
            },
            ...ariaRole === "menu" && isNested && {
                role: "menuitem"
            },
            ...role === "select" && {
                "aria-autocomplete": "none"
            },
            ...role === "combobox" && {
                "aria-autocomplete": "list"
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $bh6RR.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === "menu" && {
                "aria-labelledby": referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $bh6RR.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: "option",
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case "select":
                return {
                    ...commonProps,
                    "aria-selected": active && selected
                };
            case "combobox":
                return {
                    ...commonProps,
                    ...active && {
                        "aria-selected": true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $bh6RR.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $7533984aa684428c$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $7533984aa684428c$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $7533984aa684428c$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $bh6RR.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $bh6RR.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $7533984aa684428c$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $bh6RR.useState("unmounted");
    const isMounted = $7533984aa684428c$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    $7533984aa684428c$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $7533984aa684428c$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $bh6RR.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $bh6RR.useState(()=>({
            ...$7533984aa684428c$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$7533984aa684428c$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $7533984aa684428c$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $7533984aa684428c$var$useLatestRef(unstable_initial);
    const openRef = $7533984aa684428c$var$useLatestRef(unstable_open);
    const closeRef = $7533984aa684428c$var$useLatestRef(unstable_close);
    const commonRef = $7533984aa684428c$var$useLatestRef(unstable_common);
    $7533984aa684428c$var$index(()=>{
        const initialStyles = $7533984aa684428c$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $7533984aa684428c$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $7533984aa684428c$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $7533984aa684428c$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($7533984aa684428c$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($7533984aa684428c$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $7533984aa684428c$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $bh6RR.useRef();
    const stringRef = $bh6RR.useRef("");
    const prevIndexRef = $bh6RR.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $bh6RR.useRef(null);
    const onMatch = $7533984aa684428c$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $7533984aa684428c$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $7533984aa684428c$var$useLatestRef(findMatch);
    const ignoreKeysRef = $7533984aa684428c$var$useLatestRef(ignoreKeys);
    $7533984aa684428c$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    $7533984aa684428c$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $7533984aa684428c$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $7533984aa684428c$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === " ") (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            (0, $4ee6ff8059878997$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    const reference = $bh6RR.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $bh6RR.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === " ") setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $bh6RR.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $7533984aa684428c$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $7533984aa684428c$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $f0eb2bc09271deae$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $985fd6054d85832a$export$37b6bde19b108ecc)($7533984aa684428c$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $985fd6054d85832a$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = (0, $168a40e325c04e1b$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $168a40e325c04e1b$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $168a40e325c04e1b$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $168a40e325c04e1b$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = isScrollable && scrollEl.offsetHeight < item.offsetHeight * minItemsVisible - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $47cfd4084854a574$exports.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $985fd6054d85832a$export$37b6bde19b108ecc)($7533984aa684428c$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $7533984aa684428c$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $7533984aa684428c$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $bh6RR.useRef(false);
    const prevScrollTopRef = $bh6RR.useRef(null);
    const initialOverflowRef = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $47cfd4084854a574$exports.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $4ee6ff8059878997$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $bh6RR.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $47cfd4084854a574$exports.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $bh6RR.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $7533984aa684428c$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $7533984aa684428c$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $7533984aa684428c$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $4ee6ff8059878997$export$c22522a4dfa48e9c)(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = (0, $4ee6ff8059878997$export$2344b14b097df817)(elements.floating, target);
            const isOverReferenceEl = (0, $4ee6ff8059878997$export$2344b14b097df817)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $7533984aa684428c$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $8da4680c6d092b5b$export$45a5e7f76e0caa8d)(event.relatedTarget) && (0, $4ee6ff8059878997$export$2344b14b097df817)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $7533984aa684428c$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($7533984aa684428c$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$7533984aa684428c$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



const $0995999c086f389b$var$Emoji = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  filter: drop-shadow(4px 4px);
`;
var $0995999c086f389b$export$2e2bcd8739ae039 = $0995999c086f389b$var$Emoji;


const $fac324485bf7379a$var$Dialogue = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span`
  background-color: white;
  box-shadow: 4px 4px #5d1f47;
  border: 3px solid #5d1f47;
  padding: 4px 8px;
  font-size: 1.5rem;
`;
const $fac324485bf7379a$var$Tile = ({ icon: icon, text: text })=>{
    const { refs: refs, floatingStyles: floatingStyles } = (0, $7533984aa684428c$export$4e02a5c1d08bac65)({
        placement: "top",
        middleware: [
            (0, $f0eb2bc09271deae$export$cc800923e997bb8)(8),
            (0, $f0eb2bc09271deae$export$fba63a578e423eb)({
                padding: 8
            }),
            (0, $f0eb2bc09271deae$export$8a83211c878a3f1f)()
        ]
    });
    if (icon !== ".") return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            text && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7533984aa684428c$export$31fa5d718fa2ac09), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($fac324485bf7379a$var$Dialogue, {
                    ref: refs.setFloating,
                    style: floatingStyles,
                    children: text
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0995999c086f389b$export$2e2bcd8739ae039), {
                className: "animate__animated animate__tada",
                ref: refs.setReference,
                children: icon
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: icon
    });
};
var $fac324485bf7379a$export$2e2bcd8739ae039 = $fac324485bf7379a$var$Tile;



var $3a2d160fa2e8a793$exports = {};
$3a2d160fa2e8a793$exports = "🪨 🛸 . 🌳 🌳 🌳 🌳 🪨 🪨 🪨 🎂\n🪨 . . 🐿️ 🌳 . 🗡️ 🌳 🪨 . .\n📻 . 👽 . 🦜 🌳 🌳 🌳 🌳 🐻 .\n🌱 🌱 . . . 🪨 🐉 🚁 🪨 . 🪨\n🌳 . 🌱 🌳 🪨 . . 🪨 🎛️ . .\n🦫 . . . 🧌 . 🗡️ 🪨 . . .\n. . 🧑‍🚒 . 🪨 . . . 🪨 🪨 .\n🐝 🌲 🌲 🌲 🤖 . . 🤺 🪫 🪨 🪨\n. . 🌲 🌲 🌲 🐝 🌲 🌲 🪨 🌲 .\n. . 🍰 🌲 . . . 🍰 🌲 🌲 ⚙️\n💰 . . 👹 . 🌋 . . 💰 🌲 .";




const $c4726dbc38e8cfb5$var$Center = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
`;
var $c4726dbc38e8cfb5$export$2e2bcd8739ae039 = $c4726dbc38e8cfb5$var$Center;



const $16e924f086a574be$var$initialTiles = (0, $eade4dc275f59634$exports.constructMatrixFromTemplate)((character)=>{
    return character;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3a2d160fa2e8a793$exports))));
const { width: $16e924f086a574be$var$width, height: $16e924f086a574be$var$height } = (0, $eade4dc275f59634$exports.getDimensions)($16e924f086a574be$var$initialTiles);
const $16e924f086a574be$var$GlobalStyle = (0, $e484c752f3f06549$export$f0f03736edb61697)`
  body {
    background-color: #c583ad;
    color: #5d1f47;

    margin: 0;

    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

    &:before {
      content: ' ';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.2;
      background-image: url(${(0, (/*@__PURE__*/$parcel$interopDefault($744ad2585e553435$exports)))});
      background-repeat: no-repeat;
      background-position: 50% 0;
      background-size: cover;
      z-index: -1;
    }
  }
`;
const $16e924f086a574be$var$ItemRow = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  gap: 6px;

  flex-wrap: wrap;

  & > * {
    width: ${(props)=>props.$tileSize}px;
    height: ${(props)=>props.$tileSize}px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${(props)=>props.$tileSize}px;
    line-height: ${(props)=>props.$tileSize}px;
  }
`;
const $16e924f086a574be$var$ResetButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button`
  font-weight: bold;
  font-size: 1.5rem;
  color: #5d1f47;
  border: 2px solid #5d1f47;
  box-shadow: 4px 4px #5d1f47;
  cursor: pointer;
`;
const $16e924f086a574be$var$App = ()=>{
    const [tiles, setTiles] = (0, $bh6RR.useState)($16e924f086a574be$var$initialTiles);
    const { entities: entities, setTextForEntity: setTextForEntity, clearAllEntityText: clearAllEntityText, deleteEntity: deleteEntity, replaceEntity: replaceEntity, addEntity: addEntity } = (0, $c1e266851bb578a1$export$2e2bcd8739ae039)({
        tiles: tiles
    });
    const { playerLocation: playerLocation, health: health, items: items, reset: resetPlayer } = (0, $7880a450eedd8f39$export$2e2bcd8739ae039)({
        tiles: tiles,
        entities: entities,
        setTextForEntity: setTextForEntity,
        clearAllEntityText: clearAllEntityText,
        deleteEntity: deleteEntity,
        replaceEntity: replaceEntity,
        addEntity: addEntity
    });
    const isShipRepaired = (0, $bh6RR.useMemo)(()=>{
        const ship = entities.find((entity)=>entity.icon === "\uD83D\uDEF8");
        if (!ship) {
            console.error(`App cannot find a ship on the map.`);
            return;
        }
        if (ship.behavior.type !== "ship") {
            console.error(`Ship has incorrect behavior.`);
            return;
        }
        return ship.behavior.isRepaired;
    }, [
        entities
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($16e924f086a574be$var$GlobalStyle, {}),
            health <= 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $413f87cd271595bb$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        children: "YOU HAVE SUCCUMBED TO ZOLDATH"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($16e924f086a574be$var$ResetButton, {
                        onClick: ()=>{
                            resetPlayer();
                            setTiles([
                                ...$16e924f086a574be$var$initialTiles
                            ]);
                        },
                        style: {
                            marginLeft: "1rem"
                        },
                        children: "Reset"
                    })
                ]
            }) : null,
            isShipRepaired ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $413f87cd271595bb$export$2e2bcd8739ae039), {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        children: "YOU HAVE ESCAPED FROM ZOLDATH"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($16e924f086a574be$var$ResetButton, {
                        onClick: ()=>{
                            resetPlayer();
                            setTiles([
                                ...$16e924f086a574be$var$initialTiles
                            ]);
                        },
                        style: {
                            marginLeft: "1rem"
                        },
                        children: "Reset"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c4726dbc38e8cfb5$export$2e2bcd8739ae039), {
                style: {
                    flexDirection: "column"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            style: {
                                marginBottom: "16px"
                            },
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $73652c70b38c91ed$export$2e2bcd8739ae039), {
                                tileSize: 48,
                                tiles: tiles,
                                renderTile: (tile, location)=>{
                                    if ((0, $eade4dc275f59634$exports.compareLocations)(location, playerLocation)) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fac324485bf7379a$export$2e2bcd8739ae039), {
                                        icon: "\uD83D\uDC68\u200D\uD83D\uDE80"
                                    });
                                    const entityAtLocation = entities.find((entity)=>(0, $eade4dc275f59634$exports.compareLocations)(entity.location, location));
                                    if (entityAtLocation) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fac324485bf7379a$export$2e2bcd8739ae039), {
                                        icon: entityAtLocation.icon,
                                        text: entityAtLocation.text
                                    });
                                    // Hard code always return "."
                                    // We might want to change this if
                                    // we want other empty tiles in the
                                    // future.
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fac324485bf7379a$export$2e2bcd8739ae039), {
                                        icon: "."
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($16e924f086a574be$var$ItemRow, {
                                    $tileSize: 48,
                                    children: new Array((0, $35eae0f67d801c79$export$2e2bcd8739ae039)(health, 0, 10)).fill("\u2764\uFE0F").map((char, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0995999c086f389b$export$2e2bcd8739ae039), {
                                            children: char
                                        }, index))
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($16e924f086a574be$var$ResetButton, {
                                    onClick: ()=>{
                                        resetPlayer();
                                        setTiles([
                                            ...$16e924f086a574be$var$initialTiles
                                        ]);
                                    },
                                    style: {
                                        marginLeft: "1rem"
                                    },
                                    children: "Reset"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($16e924f086a574be$var$ItemRow, {
                            $tileSize: 48,
                            style: {
                                minHeight: 102,
                                maxWidth: 48 * $16e924f086a574be$var$width + 12 * ($16e924f086a574be$var$width - 1)
                            },
                            children: items.map((item)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0995999c086f389b$export$2e2bcd8739ae039), {
                                    className: "animate__animated animate__tada",
                                    children: item.icon
                                }, item.id))
                        })
                    ]
                })
            })
        ]
    });
};
var $16e924f086a574be$export$2e2bcd8739ae039 = $16e924f086a574be$var$App;


const $d0bb92445f8cf837$var$container = document.getElementById("root");
const $d0bb92445f8cf837$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)($d0bb92445f8cf837$var$container);
$d0bb92445f8cf837$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $16e924f086a574be$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.deeba5b3.js.map
